export const douyinData = [
  {
    平台: "抖音",
    dealer_name: "临沂星光",
    company_name: "临沂星光汽车销售服务有限公司",
    store_code: "NSD624",
    大区: "东北区",
    "省份-城市": "山东省-临沂市",
    "所选分组编号/分组名称": "-",
    fans_count: "-708",
    fans_count_total: "115054",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "31",
    aweme_like_count: "56",
    aweme_comment_count: "4",
    aweme_share_count: "5",
    aweme_play_count: "15447",
    aweme_activation: 0.6333,
    live_count: "45",
    live_time: "2721",
    live_watch_count: 4928,
    live_watch_time: 5475,
    live_like_count: "11685",
    live_comment_count: "3076",
    live_activation: 0.8,
    live_fans_add: "9",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "广州红升",
    company_name: "广州红升",
    store_code: "SGD652",
    大区: "华南区",
    "省份-城市": "广东省-广州市",
    "所选分组编号/分组名称": "-",
    fans_count: "109",
    fans_count_total: "11822",
    fans_tt_count: "6",
    fans_hs_count: 0,
    aweme_count: "49",
    aweme_like_count: "285",
    aweme_comment_count: "14",
    aweme_share_count: "15",
    aweme_play_count: "48057",
    aweme_activation: 0.8,
    live_count: "65",
    live_time: "5711",
    live_watch_count: 16944,
    live_watch_time: 18826,
    live_like_count: "125403",
    live_comment_count: "1877",
    live_activation: 0.8333,
    live_fans_add: "273",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "上海建国弘旗",
    company_name: "上海建国弘旗汽车销售服务有限公司",
    store_code: "ESH612",
    大区: "华东区",
    "省份-城市": "上海市-上海市",
    "所选分组编号/分组名称": "-",
    fans_count: "1558",
    fans_count_total: "20211",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "25",
    aweme_like_count: "3787",
    aweme_comment_count: "137",
    aweme_share_count: "202",
    aweme_play_count: "145946",
    aweme_activation: 0.9667,
    live_count: "33",
    live_time: "1910",
    live_watch_count: 278427,
    live_watch_time: 309363,
    live_like_count: "189990",
    live_comment_count: "14241",
    live_activation: 0.6333,
    live_fans_add: "1637",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "武汉岳宏泰",
    company_name: "武汉岳宏泰汽车销售服务有限公司",
    store_code: "CHB617",
    大区: "中南区",
    "省份-城市": "湖北省-武汉市",
    "所选分组编号/分组名称": "-",
    fans_count: "170",
    fans_count_total: "10722",
    fans_tt_count: "23",
    fans_hs_count: 0,
    aweme_count: "44",
    aweme_like_count: "571",
    aweme_comment_count: "102",
    aweme_share_count: "58",
    aweme_play_count: "138390",
    aweme_activation: 0.7667,
    live_count: "40",
    live_time: "2369",
    live_watch_count: 13591,
    live_watch_time: 15101,
    live_like_count: "64520",
    live_comment_count: "3066",
    live_activation: 0.8,
    live_fans_add: "162",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "重庆大雍广峻",
    company_name: "重庆大雍广峻",
    store_code: "WCQ603",
    大区: "西部区",
    "省份-城市": "重庆市-重庆市",
    "所选分组编号/分组名称": "-",
    fans_count: "-2",
    fans_count_total: "16645",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "27",
    aweme_like_count: "348",
    aweme_comment_count: "39",
    aweme_share_count: "24",
    aweme_play_count: "106253",
    aweme_activation: 0.7,
    live_count: "49",
    live_time: "3041",
    live_watch_count: 6448,
    live_watch_time: 7164,
    live_like_count: "70779",
    live_comment_count: "5901",
    live_activation: 0.8,
    live_fans_add: "66",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "常熟伟杰红旗",
    company_name: "常熟伟杰红旗汽车销售服务有限公司",
    store_code: "EJS628",
    大区: "华东区",
    "省份-城市": "江苏省-苏州市",
    "所选分组编号/分组名称": "-",
    fans_count: "74",
    fans_count_total: "5577",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "22",
    aweme_like_count: "193",
    aweme_comment_count: "14",
    aweme_share_count: "1",
    aweme_play_count: "4145",
    aweme_activation: 0.6,
    live_count: "41",
    live_time: "2404",
    live_watch_count: 5742,
    live_watch_time: 6380,
    live_like_count: "73110",
    live_comment_count: "1231",
    live_activation: 0.7667,
    live_fans_add: "115",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "抚顺千乘",
    company_name: "抚顺千乘汽车销售有限公司",
    store_code: "DLN615",
    大区: "东北区",
    "省份-城市": "辽宁省-抚顺市",
    "所选分组编号/分组名称": "-",
    fans_count: "-4",
    fans_count_total: "1087",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "21",
    aweme_like_count: "107",
    aweme_comment_count: "9",
    aweme_share_count: "1",
    aweme_play_count: "4869",
    aweme_activation: 0.6333,
    live_count: "26",
    live_time: "1654",
    live_watch_count: 457,
    live_watch_time: 507,
    live_like_count: "1949",
    live_comment_count: "312",
    live_activation: 0.8667,
    live_fans_add: "42",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "通利华红旗（光明）",
    company_name: "通利华红旗（光明）",
    store_code: "SGD644",
    大区: "华南区",
    "省份-城市": "广东省-深圳市",
    "所选分组编号/分组名称": "-",
    fans_count: "499",
    fans_count_total: "23629",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "136",
    aweme_like_count: "3408",
    aweme_comment_count: "132",
    aweme_share_count: "335",
    aweme_play_count: "275839",
    aweme_activation: 1,
    live_count: "217",
    live_time: "15241",
    live_watch_count: 72424,
    live_watch_time: 80471,
    live_like_count: "11695",
    live_comment_count: "3120",
    live_activation: 1,
    live_fans_add: "442",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "山西大昌浩瑞",
    company_name: "山西大昌浩瑞汽车销售服务有限公司",
    store_code: "NJN614",
    大区: "华北区",
    "省份-城市": "山西省-太原市",
    "所选分组编号/分组名称": "-",
    fans_count: "197",
    fans_count_total: "5098",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "28",
    aweme_like_count: "123",
    aweme_comment_count: "12",
    aweme_share_count: "9",
    aweme_play_count: "10176",
    aweme_activation: 0.8667,
    live_count: "37",
    live_time: "2272",
    live_watch_count: 142104,
    live_watch_time: 157893,
    live_like_count: "100409",
    live_comment_count: "2052",
    live_activation: 0.8667,
    live_fans_add: "230",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "乐清红通",
    company_name: "乐清红通汽车销售服务有限公司",
    store_code: "EZJ630",
    大区: "华东区",
    "省份-城市": "浙江省-温州市",
    "所选分组编号/分组名称": "-",
    fans_count: "581",
    fans_count_total: "26459",
    fans_tt_count: "48",
    fans_hs_count: 0,
    aweme_count: "30",
    aweme_like_count: "284",
    aweme_comment_count: "31",
    aweme_share_count: "45",
    aweme_play_count: "44735",
    aweme_activation: 0.4333,
    live_count: "88",
    live_time: "6016",
    live_watch_count: 63105,
    live_watch_time: 70116,
    live_like_count: "107677",
    live_comment_count: "15545",
    live_activation: 0.8667,
    live_fans_add: "1179",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "宜兴天诚",
    company_name: "宜兴天诚汽车销售服务有限公司",
    store_code: "EJS630",
    大区: "华东区",
    "省份-城市": "江苏省-无锡市",
    "所选分组编号/分组名称": "-",
    fans_count: "165",
    fans_count_total: "2526",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "40",
    aweme_like_count: "960",
    aweme_comment_count: "100",
    aweme_share_count: "71",
    aweme_play_count: "251647",
    aweme_activation: 0.7333,
    live_count: "55",
    live_time: "3424",
    live_watch_count: 3381,
    live_watch_time: 3756,
    live_like_count: "47051",
    live_comment_count: "1324",
    live_activation: 0.8333,
    live_fans_add: "60",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "贵阳万达汽车红旗体验中心",
    company_name: "贵阳万达汽车科技服务有限公司",
    store_code: "WGZ501",
    大区: "西部区",
    "省份-城市": "贵州省-贵阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "-63",
    fans_count_total: "3170",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: 0,
    aweme_like_count: 0,
    aweme_comment_count: 0,
    aweme_share_count: 0,
    aweme_play_count: "65",
    aweme_activation: 0,
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: 0,
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "长春泰岳红旗",
    company_name: "长春泰岳红旗",
    store_code: "DJL501",
    大区: "东北区",
    "省份-城市": "吉林省-长春市",
    "所选分组编号/分组名称": "-",
    fans_count: "268",
    fans_count_total: "8191",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "72",
    aweme_like_count: "885",
    aweme_comment_count: "119",
    aweme_share_count: "156",
    aweme_play_count: "532860",
    aweme_activation: 0.6333,
    live_count: "43",
    live_time: "3677",
    live_watch_count: 7684,
    live_watch_time: 8537,
    live_like_count: "34201",
    live_comment_count: "2469",
    live_activation: 0.8,
    live_fans_add: "184",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "广州路易通",
    company_name: "广州路易通汽车销售服务有限公司",
    store_code: "SGD645",
    大区: "华南区",
    "省份-城市": "广东省-广州市",
    "所选分组编号/分组名称": "-",
    fans_count: "848",
    fans_count_total: "5329",
    fans_tt_count: "1",
    fans_hs_count: 0,
    aweme_count: "156",
    aweme_like_count: "1160",
    aweme_comment_count: "178",
    aweme_share_count: "55",
    aweme_play_count: "130585",
    aweme_activation: 0.9,
    live_count: "61",
    live_time: "3837",
    live_watch_count: 33455,
    live_watch_time: 37172,
    live_like_count: "20150",
    live_comment_count: "6020",
    live_activation: 0.9333,
    live_fans_add: "464",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "太原泰岳红旗",
    company_name: "太原泰岳红旗",
    store_code: "NJN501",
    大区: "华北区",
    "省份-城市": "山西省-太原市",
    "所选分组编号/分组名称": "-",
    fans_count: "-44",
    fans_count_total: "6498",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "94",
    aweme_like_count: "336",
    aweme_comment_count: "35",
    aweme_share_count: "3",
    aweme_play_count: "19499",
    aweme_activation: 0.9667,
    live_count: "15",
    live_time: "911",
    live_watch_count: 576,
    live_watch_time: 640,
    live_like_count: "11101",
    live_comment_count: "326",
    live_activation: 0.4,
    live_fans_add: "1",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "银川岳宏泰",
    company_name: "银川岳宏泰",
    store_code: "XNX501",
    大区: "西部区",
    "省份-城市": "宁夏回族自治区-银川市",
    "所选分组编号/分组名称": "-",
    fans_count: "12",
    fans_count_total: "3386",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "155",
    aweme_like_count: "946",
    aweme_comment_count: "146",
    aweme_share_count: "83",
    aweme_play_count: "300078",
    aweme_activation: 1,
    live_count: "78",
    live_time: "4766",
    live_watch_count: 1777,
    live_watch_time: 1974,
    live_like_count: "75006",
    live_comment_count: "1879",
    live_activation: 0.9,
    live_fans_add: "35",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "深圳奥吉通",
    company_name: "深圳奥吉通汽车销售服务有限公司",
    store_code: "SGD646",
    大区: "华南区",
    "省份-城市": "广东省-深圳市",
    "所选分组编号/分组名称": "-",
    fans_count: "71",
    fans_count_total: "2331",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "27",
    aweme_like_count: "161",
    aweme_comment_count: "13",
    aweme_share_count: "3",
    aweme_play_count: "7071",
    aweme_activation: 0.6,
    live_count: "55",
    live_time: "3412",
    live_watch_count: 8015,
    live_watch_time: 8905,
    live_like_count: "8330",
    live_comment_count: "2250",
    live_activation: 0.8667,
    live_fans_add: "97",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "慈溪中基",
    company_name: "慈溪中基汽车销售服务有限公司",
    store_code: "EZJ632",
    大区: "华东区",
    "省份-城市": "浙江省-宁波市",
    "所选分组编号/分组名称": "-",
    fans_count: "103",
    fans_count_total: "16168",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "92",
    aweme_like_count: "512",
    aweme_comment_count: "122",
    aweme_share_count: "46",
    aweme_play_count: "197737",
    aweme_activation: 0.8667,
    live_count: "55",
    live_time: "4633",
    live_watch_count: 25921,
    live_watch_time: 28801,
    live_like_count: "155126",
    live_comment_count: "7260",
    live_activation: 0.9,
    live_fans_add: "250",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "南阳英驰",
    company_name: "南阳英驰汽车销售有限公司",
    store_code: "NYU621",
    大区: "华北区",
    "省份-城市": "河南省-南阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "-893",
    fans_count_total: "101519",
    fans_tt_count: "2192",
    fans_hs_count: 0,
    aweme_count: "35",
    aweme_like_count: "983",
    aweme_comment_count: "96",
    aweme_share_count: "67",
    aweme_play_count: "40975",
    aweme_activation: 0.8333,
    live_count: "58",
    live_time: "3555",
    live_watch_count: 275901,
    live_watch_time: 306556,
    live_like_count: "88591",
    live_comment_count: "2579",
    live_activation: 0.8333,
    live_fans_add: "1930",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "北京博瑞祥浓",
    company_name: "北京博瑞祥浓汽车销售服务有限公司",
    store_code: "NBJ612",
    大区: "华北区",
    "省份-城市": "北京市-北京市",
    "所选分组编号/分组名称": "-",
    fans_count: "905",
    fans_count_total: "17951",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "38",
    aweme_like_count: "1132",
    aweme_comment_count: "114",
    aweme_share_count: "84",
    aweme_play_count: "54890",
    aweme_activation: 0.6,
    live_count: "27",
    live_time: "1639",
    live_watch_count: 55849,
    live_watch_time: 62054,
    live_like_count: "189108",
    live_comment_count: "3736",
    live_activation: 0.5667,
    live_fans_add: "483",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "淮安宏众万晟汽",
    company_name: "淮安市宏众万晟汽车销售服务有限公司",
    store_code: "EJS631",
    大区: "华东区",
    "省份-城市": "江苏省-淮安市",
    "所选分组编号/分组名称": "-",
    fans_count: "662",
    fans_count_total: "86808",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "47",
    aweme_like_count: "827",
    aweme_comment_count: "88",
    aweme_share_count: "93",
    aweme_play_count: "97367",
    aweme_activation: 0.8333,
    live_count: "70",
    live_time: "4654",
    live_watch_count: 68212,
    live_watch_time: 75791,
    live_like_count: "43375",
    live_comment_count: "7884",
    live_activation: 0.8667,
    live_fans_add: "1063",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "白城致诚红旗体验中心",
    company_name: "白城市致诚汽车销售服务有限公司",
    store_code: "DJL616",
    大区: "东北区",
    "省份-城市": "吉林省-白城市",
    "所选分组编号/分组名称": "-",
    fans_count: "280",
    fans_count_total: "8861",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "33",
    aweme_like_count: "88",
    aweme_comment_count: "7",
    aweme_share_count: "4",
    aweme_play_count: "9667",
    aweme_activation: 0.4333,
    live_count: "64",
    live_time: "4803",
    live_watch_count: 18766,
    live_watch_time: 20851,
    live_like_count: "303060",
    live_comment_count: "5110",
    live_activation: 0.9333,
    live_fans_add: "346",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "江门中升红旗体验中心",
    company_name: "江门市中升汽车销售服务有限公司",
    store_code: "SGD649",
    大区: "华南区",
    "省份-城市": "广东省-江门市",
    "所选分组编号/分组名称": "-",
    fans_count: "3",
    fans_count_total: "24897",
    fans_tt_count: "50",
    fans_hs_count: 0,
    aweme_count: "41",
    aweme_like_count: "592",
    aweme_comment_count: "65",
    aweme_share_count: "108",
    aweme_play_count: "139414",
    aweme_activation: 0.8333,
    live_count: "42",
    live_time: "2603",
    live_watch_count: 7998,
    live_watch_time: 8886,
    live_like_count: "3121",
    live_comment_count: "2108",
    live_activation: 0.7333,
    live_fans_add: "114",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "泰州同悦汽车",
    company_name: "泰州同悦汽车销售服务有限公司",
    store_code: "EJS633",
    大区: "华东区",
    "省份-城市": "江苏省-泰州市",
    "所选分组编号/分组名称": "-",
    fans_count: "-8",
    fans_count_total: "1793",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "22",
    aweme_like_count: "95",
    aweme_comment_count: "9",
    aweme_share_count: "10",
    aweme_play_count: "6101",
    aweme_activation: 0.5667,
    live_count: "21",
    live_time: "1517",
    live_watch_count: 749,
    live_watch_time: 832,
    live_like_count: "3568",
    live_comment_count: "1618",
    live_activation: 0.5333,
    live_fans_add: "16",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "徐州天扬",
    company_name: "徐州天扬",
    store_code: "EJS632",
    大区: "华东区",
    "省份-城市": "江苏省-徐州市",
    "所选分组编号/分组名称": "-",
    fans_count: "365",
    fans_count_total: "6939",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "87",
    aweme_like_count: "1064",
    aweme_comment_count: "81",
    aweme_share_count: "91",
    aweme_play_count: "164133",
    aweme_activation: 0.9667,
    live_count: "65",
    live_time: "4104",
    live_watch_count: 125413,
    live_watch_time: 139347,
    live_like_count: "139760",
    live_comment_count: "4953",
    live_activation: 0.9333,
    live_fans_add: "242",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "贵阳通源源旗",
    company_name: "贵阳通源源旗汽车销售服务有限公司",
    store_code: "WGZ614",
    大区: "西部区",
    "省份-城市": "贵州省-贵阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "208",
    fans_count_total: "19708",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "25",
    aweme_like_count: "1228",
    aweme_comment_count: "229",
    aweme_share_count: "104",
    aweme_play_count: "444699",
    aweme_activation: 0.4667,
    live_count: "27",
    live_time: "1819",
    live_watch_count: 2483,
    live_watch_time: 2758,
    live_like_count: "11201",
    live_comment_count: "1453",
    live_activation: 0.5333,
    live_fans_add: "32",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "重庆博行大展",
    company_name: "重庆博行大展汽车销售有限公司",
    store_code: "WCQ604",
    大区: "西部区",
    "省份-城市": "重庆市-重庆市",
    "所选分组编号/分组名称": "-",
    fans_count: "188",
    fans_count_total: "24901",
    fans_tt_count: "98",
    fans_hs_count: 0,
    aweme_count: "32",
    aweme_like_count: "1071",
    aweme_comment_count: "166",
    aweme_share_count: "65",
    aweme_play_count: "497896",
    aweme_activation: 0.6333,
    live_count: "33",
    live_time: "2005",
    live_watch_count: 23850,
    live_watch_time: 26500,
    live_like_count: "121631",
    live_comment_count: "6441",
    live_activation: 0.8,
    live_fans_add: "297",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "珠海宝旗",
    company_name: "珠海市宝旗汽车销售服务有限公司",
    store_code: "SGD648",
    大区: "华南区",
    "省份-城市": "广东省-珠海市",
    "所选分组编号/分组名称": "-",
    fans_count: "-83",
    fans_count_total: "6309",
    fans_tt_count: "13",
    fans_hs_count: 0,
    aweme_count: "24",
    aweme_like_count: "49",
    aweme_comment_count: "4",
    aweme_share_count: "1",
    aweme_play_count: "4550",
    aweme_activation: 0.4667,
    live_count: "53",
    live_time: "3270",
    live_watch_count: 5240,
    live_watch_time: 5822,
    live_like_count: "8589",
    live_comment_count: "384",
    live_activation: 0.7333,
    live_fans_add: "3",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "广东荣洲",
    company_name: "广东荣洲汽车销售服务有限公司",
    store_code: "SGD647",
    大区: "华南区",
    "省份-城市": "广东省-东莞市",
    "所选分组编号/分组名称": "-",
    fans_count: "88",
    fans_count_total: "10745",
    fans_tt_count: "42",
    fans_hs_count: 0,
    aweme_count: "103",
    aweme_like_count: "384",
    aweme_comment_count: "28",
    aweme_share_count: "16",
    aweme_play_count: "21636",
    aweme_activation: 0.9333,
    live_count: "48",
    live_time: "3070",
    live_watch_count: 29948,
    live_watch_time: 33275,
    live_like_count: "270221",
    live_comment_count: "2981",
    live_activation: 0.7333,
    live_fans_add: "165",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "济宁星光",
    company_name: "济宁星光",
    store_code: "NSD626",
    大区: "东北区",
    "省份-城市": "山东省-济宁市",
    "所选分组编号/分组名称": "-",
    fans_count: "-26",
    fans_count_total: "3603",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "20",
    aweme_like_count: "67",
    aweme_comment_count: "4",
    aweme_share_count: "3",
    aweme_play_count: "4198",
    aweme_activation: 0.4667,
    live_count: "9",
    live_time: "508",
    live_watch_count: 461,
    live_watch_time: 512,
    live_like_count: "12106",
    live_comment_count: "166",
    live_activation: 0.4,
    live_fans_add: "5",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "遵义通源源旗",
    company_name: "遵义通源源旗汽车销售服务有限公司",
    store_code: "WGZ615",
    大区: "西部区",
    "省份-城市": "贵州省-遵义市",
    "所选分组编号/分组名称": "-",
    fans_count: "-11",
    fans_count_total: "6231",
    fans_tt_count: "1",
    fans_hs_count: 0,
    aweme_count: "35",
    aweme_like_count: "245",
    aweme_comment_count: "19",
    aweme_share_count: "15",
    aweme_play_count: "57416",
    aweme_activation: 0.5667,
    live_count: "45",
    live_time: "2777",
    live_watch_count: 3969,
    live_watch_time: 4410,
    live_like_count: "96650",
    live_comment_count: "1855",
    live_activation: 0.8333,
    live_fans_add: "33",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "菏泽顺祺",
    company_name: "菏泽顺祺",
    store_code: "NSD627",
    大区: "东北区",
    "省份-城市": "山东省-菏泽市",
    "所选分组编号/分组名称": "-",
    fans_count: "569",
    fans_count_total: "19721",
    fans_tt_count: "191",
    fans_hs_count: 0,
    aweme_count: "87",
    aweme_like_count: "2597",
    aweme_comment_count: "300",
    aweme_share_count: "409",
    aweme_play_count: "467872",
    aweme_activation: 0.6,
    live_count: "110",
    live_time: "6673",
    live_watch_count: 24731,
    live_watch_time: 27478,
    live_like_count: "35290",
    live_comment_count: "8221",
    live_activation: 0.9,
    live_fans_add: "391",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "湖南兰天嘉旗",
    company_name: "湖南兰天嘉旗汽车销售有限公司",
    store_code: "CHN620",
    大区: "中南区",
    "省份-城市": "湖南省-长沙市",
    "所选分组编号/分组名称": "-",
    fans_count: "102",
    fans_count_total: "1618",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "44",
    aweme_like_count: "434",
    aweme_comment_count: "69",
    aweme_share_count: "43",
    aweme_play_count: "221177",
    aweme_activation: 0.8333,
    live_count: "62",
    live_time: "3672",
    live_watch_count: 7766,
    live_watch_time: 8628,
    live_like_count: "75059",
    live_comment_count: "5888",
    live_activation: 0.8333,
    live_fans_add: "41",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "云南宏胜瑞达",
    company_name: "云南宏胜瑞达汽车销售服务有限公司",
    store_code: "WYN617",
    大区: "西部区",
    "省份-城市": "云南省-昆明市",
    "所选分组编号/分组名称": "-",
    fans_count: "63",
    fans_count_total: "40440",
    fans_tt_count: "9",
    fans_hs_count: 0,
    aweme_count: "31",
    aweme_like_count: "234",
    aweme_comment_count: "68",
    aweme_share_count: "6",
    aweme_play_count: "63076",
    aweme_activation: 0.6333,
    live_count: "48",
    live_time: "2991",
    live_watch_count: 131329,
    live_watch_time: 145921,
    live_like_count: "170667",
    live_comment_count: "4538",
    live_activation: 0.8333,
    live_fans_add: "382",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "阜阳华奥",
    company_name: "阜阳华奥汽车销售服务有限公司",
    store_code: "EAH621",
    大区: "华东区",
    "省份-城市": "安徽省-阜阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "396",
    fans_count_total: "5860",
    fans_tt_count: "6",
    fans_hs_count: 0,
    aweme_count: "108",
    aweme_like_count: "1372",
    aweme_comment_count: "114",
    aweme_share_count: "142",
    aweme_play_count: "227728",
    aweme_activation: 1,
    live_count: "73",
    live_time: "4227",
    live_watch_count: 183966,
    live_watch_time: 204406,
    live_like_count: "91281",
    live_comment_count: "5152",
    live_activation: 0.9,
    live_fans_add: "387",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "长春凯胜",
    company_name: "长春凯胜汽车销售服务有限公司",
    store_code: "DJL615",
    大区: "东北区",
    "省份-城市": "吉林省-长春市",
    "所选分组编号/分组名称": "-",
    fans_count: "186",
    fans_count_total: "46181",
    fans_tt_count: "378",
    fans_hs_count: 0,
    aweme_count: "55",
    aweme_like_count: "1175",
    aweme_comment_count: "198",
    aweme_share_count: "100",
    aweme_play_count: "647046",
    aweme_activation: 0.6333,
    live_count: "19",
    live_time: "1339",
    live_watch_count: 22129,
    live_watch_time: 24587,
    live_like_count: "84124",
    live_comment_count: "3999",
    live_activation: 0.5,
    live_fans_add: "421",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "成都泰岳宏旗",
    company_name: "成都泰岳宏旗汽车销售服务有限公司",
    store_code: "WSC627",
    大区: "西部区",
    "省份-城市": "四川省-成都市",
    "所选分组编号/分组名称": "-",
    fans_count: "446",
    fans_count_total: "27378",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "72",
    aweme_like_count: "1248",
    aweme_comment_count: "164",
    aweme_share_count: "125",
    aweme_play_count: "529010",
    aweme_activation: 1,
    live_count: "71",
    live_time: "4514",
    live_watch_count: 534495,
    live_watch_time: 593883,
    live_like_count: "299740",
    live_comment_count: "7333",
    live_activation: 0.8,
    live_fans_add: "619",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "邯郸坤铂",
    company_name: "邯郸市坤铂汽车销售服务有限公司",
    store_code: "NJI615",
    大区: "华北区",
    "省份-城市": "河北省-邯郸市",
    "所选分组编号/分组名称": "-",
    fans_count: "638",
    fans_count_total: "22326",
    fans_tt_count: "397",
    fans_hs_count: 0,
    aweme_count: "58",
    aweme_like_count: "2001",
    aweme_comment_count: "302",
    aweme_share_count: "367",
    aweme_play_count: "574117",
    aweme_activation: 0.7667,
    live_count: "107",
    live_time: "6149",
    live_watch_count: 64380,
    live_watch_time: 71533,
    live_like_count: "183963",
    live_comment_count: "8484",
    live_activation: 0.9,
    live_fans_add: "551",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "天津海润达",
    company_name: "天津海润达",
    store_code: "NTJ605",
    大区: "华北区",
    "省份-城市": "天津市-天津市",
    "所选分组编号/分组名称": "-",
    fans_count: "558",
    fans_count_total: "9235",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "53",
    aweme_like_count: "897",
    aweme_comment_count: "141",
    aweme_share_count: "169",
    aweme_play_count: "237192",
    aweme_activation: 0.5333,
    live_count: "108",
    live_time: "10478",
    live_watch_count: 183048,
    live_watch_time: 203386,
    live_like_count: "206055",
    live_comment_count: "5305",
    live_activation: 0.8,
    live_fans_add: "618",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "淄博泰岳红旗体验中心",
    company_name: "淄博泰岳宏旗汽车销售服务有限公司",
    store_code: "NSD629",
    大区: "东北区",
    "省份-城市": "山东省-淄博市",
    "所选分组编号/分组名称": "-",
    fans_count: "755",
    fans_count_total: "41582",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "45",
    aweme_like_count: "1490",
    aweme_comment_count: "479",
    aweme_share_count: "181",
    aweme_play_count: "273120",
    aweme_activation: 0.7333,
    live_count: "26",
    live_time: "1686",
    live_watch_count: 383648,
    live_watch_time: 426275,
    live_like_count: "156133",
    live_comment_count: "6489",
    live_activation: 0.7667,
    live_fans_add: "866",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "青岛岳宏泰红旗体验中心",
    company_name: "青岛岳宏泰汽车销售服务有限公司",
    store_code: "NSD628",
    大区: "东北区",
    "省份-城市": "山东省-青岛市",
    "所选分组编号/分组名称": "-",
    fans_count: "225",
    fans_count_total: "6745",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "83",
    aweme_like_count: "1001",
    aweme_comment_count: "88",
    aweme_share_count: "78",
    aweme_play_count: "333902",
    aweme_activation: 0.5333,
    live_count: "47",
    live_time: "2929",
    live_watch_count: 3547,
    live_watch_time: 3941,
    live_like_count: "76982",
    live_comment_count: "3199",
    live_activation: 0.6667,
    live_fans_add: "37",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "郑州大展红旗汽车",
    company_name: "郑州大展红旗汽车",
    store_code: "NYU172",
    大区: "华北区",
    "省份-城市": "河南省-郑州市",
    "所选分组编号/分组名称": "-",
    fans_count: "-162",
    fans_count_total: "386019",
    fans_tt_count: "5140",
    fans_hs_count: 0,
    aweme_count: "46",
    aweme_like_count: "3709",
    aweme_comment_count: "306",
    aweme_share_count: "735",
    aweme_play_count: "1667801",
    aweme_activation: 0.5333,
    live_count: "168",
    live_time: "11779",
    live_watch_count: 68041,
    live_watch_time: 75601,
    live_like_count: "144674",
    live_comment_count: "8963",
    live_activation: 0.8333,
    live_fans_add: "822",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "银川大世界红旗汽车",
    company_name: "银川大世界红旗汽车销售有限公司",
    store_code: "XNX109",
    大区: "西部区",
    "省份-城市": "宁夏回族自治区-银川市",
    "所选分组编号/分组名称": "-",
    fans_count: "-1053",
    fans_count_total: "455606",
    fans_tt_count: "40252",
    fans_hs_count: 0,
    aweme_count: "74",
    aweme_like_count: "1163",
    aweme_comment_count: "96",
    aweme_share_count: "61",
    aweme_play_count: "345723",
    aweme_activation: 0.9667,
    live_count: "78",
    live_time: "4875",
    live_watch_count: 7418,
    live_watch_time: 8242,
    live_like_count: "26207",
    live_comment_count: "2994",
    live_activation: 1,
    live_fans_add: "43",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "石家庄庞大华旗",
    company_name: "石家庄庞大华旗汽车销售有限公司",
    store_code: "NJI162",
    大区: "华北区",
    "省份-城市": "河北省-石家庄市",
    "所选分组编号/分组名称": "-",
    fans_count: "-3870",
    fans_count_total: "76028",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "23",
    aweme_like_count: "7863",
    aweme_comment_count: "362",
    aweme_share_count: "502",
    aweme_play_count: "382478",
    aweme_activation: 0.6,
    live_count: "24",
    live_time: "1560",
    live_watch_count: 199438,
    live_watch_time: 221597,
    live_like_count: "340918",
    live_comment_count: "29732",
    live_activation: 0.5333,
    live_fans_add: "627",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "天津奥吉通红韵",
    company_name: "天津奥吉通红韵汽车销售有限公司",
    store_code: "NTJ025",
    大区: "华北区",
    "省份-城市": "天津市-天津市",
    "所选分组编号/分组名称": "-",
    fans_count: "2225",
    fans_count_total: "120024",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "30",
    aweme_like_count: "1350",
    aweme_comment_count: "72",
    aweme_share_count: "135",
    aweme_play_count: "264330",
    aweme_activation: 0.4,
    live_count: "73",
    live_time: "4418",
    live_watch_count: 666106,
    live_watch_time: 740117,
    live_like_count: "193675",
    live_comment_count: "10566",
    live_activation: 0.6,
    live_fans_add: "3306",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "重庆万家红旗",
    company_name: "重庆万家红旗",
    store_code: "WCQ018",
    大区: "西部区",
    "省份-城市": "重庆市-重庆市",
    "所选分组编号/分组名称": "-",
    fans_count: "54",
    fans_count_total: "184664",
    fans_tt_count: "1368",
    fans_hs_count: 0,
    aweme_count: "73",
    aweme_like_count: "1189",
    aweme_comment_count: "192",
    aweme_share_count: "225",
    aweme_play_count: "564947",
    aweme_activation: 0.9,
    live_count: "123",
    live_time: "7591",
    live_watch_count: 177234,
    live_watch_time: 196926,
    live_like_count: "96425",
    live_comment_count: "5409",
    live_activation: 0.8667,
    live_fans_add: "655",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "南昌龙和",
    company_name: "南昌龙和",
    store_code: "CJX600",
    大区: "中南区",
    "省份-城市": "江西省-南昌市",
    "所选分组编号/分组名称": "-",
    fans_count: "711",
    fans_count_total: "24584",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "39",
    aweme_like_count: "1008",
    aweme_comment_count: "79",
    aweme_share_count: "102",
    aweme_play_count: "230970",
    aweme_activation: 0.5667,
    live_count: "36",
    live_time: "2218",
    live_watch_count: 165146,
    live_watch_time: 183495,
    live_like_count: "141250",
    live_comment_count: "4444",
    live_activation: 0.9,
    live_fans_add: "670",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "长春通立红旗",
    company_name: "长春通立红旗汽车销售服务有限公司",
    store_code: "DJL603",
    大区: "东北区",
    "省份-城市": "吉林省-长春市",
    "所选分组编号/分组名称": "-",
    fans_count: "-61",
    fans_count_total: "74084",
    fans_tt_count: "1414",
    fans_hs_count: 0,
    aweme_count: "57",
    aweme_like_count: "303",
    aweme_comment_count: "71",
    aweme_share_count: "6",
    aweme_play_count: "32915",
    aweme_activation: 0.9667,
    live_count: "57",
    live_time: "3586",
    live_watch_count: 16125,
    live_watch_time: 17916,
    live_like_count: "556923",
    live_comment_count: "2349",
    live_activation: 0.8333,
    live_fans_add: "208",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "福建华奥红旗",
    company_name: "福建华奥红旗汽车销售有限公司",
    store_code: "SFJ601",
    大区: "华南区",
    "省份-城市": "福建省-福州市",
    "所选分组编号/分组名称": "-",
    fans_count: "-41",
    fans_count_total: "41086",
    fans_tt_count: "46",
    fans_hs_count: 0,
    aweme_count: "82",
    aweme_like_count: "695",
    aweme_comment_count: "33",
    aweme_share_count: "31",
    aweme_play_count: "98347",
    aweme_activation: 1,
    live_count: "49",
    live_time: "2960",
    live_watch_count: 38232,
    live_watch_time: 42480,
    live_like_count: "29136",
    live_comment_count: "1304",
    live_activation: 0.8667,
    live_fans_add: "132",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "成都新元素红旗",
    company_name: "成都新元素红旗汽车销售服务有限公司",
    store_code: "WSC600",
    大区: "西部区",
    "省份-城市": "四川省-成都市",
    "所选分组编号/分组名称": "-",
    fans_count: "-702",
    fans_count_total: "361343",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "37",
    aweme_like_count: "1082",
    aweme_comment_count: "190",
    aweme_share_count: "124",
    aweme_play_count: "547940",
    aweme_activation: 0.3667,
    live_count: "109",
    live_time: "6411",
    live_watch_count: 78545,
    live_watch_time: 87272,
    live_like_count: "156254",
    live_comment_count: "5853",
    live_activation: 1,
    live_fans_add: "755",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "北京中润发汽车",
    company_name: "北京中润发汽车",
    store_code: "NBJ601",
    大区: "华北区",
    "省份-城市": "北京市-北京市",
    "所选分组编号/分组名称": "-",
    fans_count: "-152",
    fans_count_total: "115402",
    fans_tt_count: "27630",
    fans_hs_count: 0,
    aweme_count: "47",
    aweme_like_count: "831",
    aweme_comment_count: "32",
    aweme_share_count: "58",
    aweme_play_count: "81679",
    aweme_activation: 0.8333,
    live_count: "32",
    live_time: "1982",
    live_watch_count: 3166,
    live_watch_time: 3517,
    live_like_count: "14534",
    live_comment_count: "436",
    live_activation: 0.7667,
    live_fans_add: "16",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "上海旗泽",
    company_name: "上海旗泽汽车销售服务有限公司",
    store_code: "ESH607",
    大区: "华东区",
    "省份-城市": "上海市-上海市",
    "所选分组编号/分组名称": "-",
    fans_count: "80",
    fans_count_total: "15289",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "25",
    aweme_like_count: "240",
    aweme_comment_count: "23",
    aweme_share_count: "16",
    aweme_play_count: "50466",
    aweme_activation: 0.4333,
    live_count: "37",
    live_time: "2214",
    live_watch_count: 3237,
    live_watch_time: 3596,
    live_like_count: "159231",
    live_comment_count: "2115",
    live_activation: 0.8,
    live_fans_add: "70",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "湖北长泽红旗",
    company_name: "湖北长泽汽车销售服务有限公司",
    store_code: "CHB600",
    大区: "中南区",
    "省份-城市": "湖北省-武汉市",
    "所选分组编号/分组名称": "-",
    fans_count: "-51",
    fans_count_total: "21668",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "30",
    aweme_like_count: "128",
    aweme_comment_count: "26",
    aweme_share_count: "19",
    aweme_play_count: "33962",
    aweme_activation: 0.6667,
    live_count: "41",
    live_time: "2448",
    live_watch_count: 4979,
    live_watch_time: 5532,
    live_like_count: "274762",
    live_comment_count: "2350",
    live_activation: 0.8667,
    live_fans_add: "32",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "南通百恒红旗",
    company_name: "南通百恒汽车销售服务有限公司",
    store_code: "EJS602",
    大区: "华东区",
    "省份-城市": "江苏省-南通市",
    "所选分组编号/分组名称": "-",
    fans_count: "-77",
    fans_count_total: "102582",
    fans_tt_count: "3254",
    fans_hs_count: 0,
    aweme_count: "44",
    aweme_like_count: "936",
    aweme_comment_count: "203",
    aweme_share_count: "96",
    aweme_play_count: "369076",
    aweme_activation: 0.7667,
    live_count: "35",
    live_time: "2309",
    live_watch_count: 55959,
    live_watch_time: 62176,
    live_like_count: "31798",
    live_comment_count: "3902",
    live_activation: 0.7,
    live_fans_add: "197",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "南充明云红旗4S店",
    company_name: "南充明云日月宏新车业有限公司",
    store_code: "WSC603",
    大区: "西部区",
    "省份-城市": "四川省-南充市",
    "所选分组编号/分组名称": "-",
    fans_count: "86",
    fans_count_total: "37757",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "48",
    aweme_like_count: "1064",
    aweme_comment_count: "149",
    aweme_share_count: "78",
    aweme_play_count: "600991",
    aweme_activation: 0.7,
    live_count: "29",
    live_time: "1773",
    live_watch_count: 4775,
    live_watch_time: 5305,
    live_like_count: "5511",
    live_comment_count: "295",
    live_activation: 0.5667,
    live_fans_add: "20",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "兰州金岛红旗",
    company_name: "兰州金岛红旗汽车销售服务有限公司",
    store_code: "XGS600",
    大区: "西部区",
    "省份-城市": "甘肃省-兰州市",
    "所选分组编号/分组名称": "-",
    fans_count: "838",
    fans_count_total: "32349",
    fans_tt_count: "1818",
    fans_hs_count: 0,
    aweme_count: "113",
    aweme_like_count: "2452",
    aweme_comment_count: "181",
    aweme_share_count: "343",
    aweme_play_count: "890645",
    aweme_activation: 1,
    live_count: "135",
    live_time: "11352",
    live_watch_count: 102444,
    live_watch_time: 113826,
    live_like_count: "124308",
    live_comment_count: "8366",
    live_activation: 1,
    live_fans_add: "882",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "临汾荣翔",
    company_name: "临汾荣翔",
    store_code: "NJN602",
    大区: "华北区",
    "省份-城市": "山西省-临汾市",
    "所选分组编号/分组名称": "-",
    fans_count: "43",
    fans_count_total: "6483",
    fans_tt_count: "358",
    fans_hs_count: 0,
    aweme_count: "35",
    aweme_like_count: "227",
    aweme_comment_count: "32",
    aweme_share_count: "22",
    aweme_play_count: "38165",
    aweme_activation: 0.7333,
    live_count: "34",
    live_time: "1973",
    live_watch_count: 1448,
    live_watch_time: 1608,
    live_like_count: "51074",
    live_comment_count: "522",
    live_activation: 0.5,
    live_fans_add: "40",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "达州天裕",
    company_name: "达州天裕汽车服务有限公司",
    store_code: "WSC601",
    大区: "西部区",
    "省份-城市": "四川省-达州市",
    "所选分组编号/分组名称": "-",
    fans_count: "217",
    fans_count_total: "37638",
    fans_tt_count: "104",
    fans_hs_count: 0,
    aweme_count: "30",
    aweme_like_count: "491",
    aweme_comment_count: "49",
    aweme_share_count: "21",
    aweme_play_count: "81602",
    aweme_activation: 0.7333,
    live_count: "45",
    live_time: "2916",
    live_watch_count: 124072,
    live_watch_time: 137857,
    live_like_count: "149581",
    live_comment_count: "3303",
    live_activation: 0.8667,
    live_fans_add: "231",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "重庆璐菲",
    company_name: "重庆璐菲汽车销售服务有限公司",
    store_code: "WCQ601",
    大区: "西部区",
    "省份-城市": "重庆市-重庆市",
    "所选分组编号/分组名称": "-",
    fans_count: "-4",
    fans_count_total: "2847",
    fans_tt_count: "73",
    fans_hs_count: 0,
    aweme_count: "21",
    aweme_like_count: "97",
    aweme_comment_count: "13",
    aweme_share_count: "6",
    aweme_play_count: "3278",
    aweme_activation: 0.5667,
    live_count: "20",
    live_time: "1315",
    live_watch_count: 1087,
    live_watch_time: 1207,
    live_like_count: "147",
    live_comment_count: "110",
    live_activation: 0.5667,
    live_fans_add: "4",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "驻马店祥诚红旗体验中心",
    company_name: "驻马店祥诚红旗体验中心",
    store_code: "NYU603",
    大区: "华北区",
    "省份-城市": "河南省-驻马店市",
    "所选分组编号/分组名称": "-",
    fans_count: "101",
    fans_count_total: "14076",
    fans_tt_count: "385",
    fans_hs_count: 0,
    aweme_count: "20",
    aweme_like_count: "480",
    aweme_comment_count: "52",
    aweme_share_count: "42",
    aweme_play_count: "152371",
    aweme_activation: 0.8,
    live_count: "24",
    live_time: "1443",
    live_watch_count: 3035,
    live_watch_time: 3372,
    live_like_count: "8040",
    live_comment_count: "871",
    live_activation: 0.5667,
    live_fans_add: "41",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "昆山联合红旗",
    company_name: "昆山联合红旗汽车销售有限公司",
    store_code: "EJS605",
    大区: "华东区",
    "省份-城市": "江苏省-苏州市",
    "所选分组编号/分组名称": "-",
    fans_count: "400",
    fans_count_total: "27067",
    fans_tt_count: "434",
    fans_hs_count: 0,
    aweme_count: "41",
    aweme_like_count: "1678",
    aweme_comment_count: "328",
    aweme_share_count: "177",
    aweme_play_count: "419432",
    aweme_activation: 1,
    live_count: "41",
    live_time: "2543",
    live_watch_count: 54543,
    live_watch_time: 60603,
    live_like_count: "71204",
    live_comment_count: "4096",
    live_activation: 0.8333,
    live_fans_add: "377",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "陕西奥诚红旗",
    company_name: "陕西奥诚红旗汽车销售服务有限公司",
    store_code: "XSS601",
    大区: "西部区",
    "省份-城市": "陕西省-西安市",
    "所选分组编号/分组名称": "-",
    fans_count: "1304",
    fans_count_total: "11308",
    fans_tt_count: "4",
    fans_hs_count: 0,
    aweme_count: "101",
    aweme_like_count: "2221",
    aweme_comment_count: "260",
    aweme_share_count: "291",
    aweme_play_count: "888414",
    aweme_activation: 0.8667,
    live_count: "84",
    live_time: "5222",
    live_watch_count: 54686,
    live_watch_time: 60762,
    live_like_count: "16842",
    live_comment_count: "4083",
    live_activation: 0.9,
    live_fans_add: "499",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "怀化旗通",
    company_name: "怀化市旗通汽车贸易有限公司",
    store_code: "CHN602",
    大区: "中南区",
    "省份-城市": "湖南省-怀化市",
    "所选分组编号/分组名称": "-",
    fans_count: "534",
    fans_count_total: "22696",
    fans_tt_count: "302",
    fans_hs_count: 0,
    aweme_count: "92",
    aweme_like_count: "1781",
    aweme_comment_count: "297",
    aweme_share_count: "73",
    aweme_play_count: "414866",
    aweme_activation: 0.7333,
    live_count: "63",
    live_time: "5721",
    live_watch_count: 204856,
    live_watch_time: 227617,
    live_like_count: "98636",
    live_comment_count: "3231",
    live_activation: 0.9333,
    live_fans_add: "622",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "巴中先锋恒远",
    company_name: "巴中先锋恒远汽车服务有限公司",
    store_code: "WSC604",
    大区: "西部区",
    "省份-城市": "四川省-巴中市",
    "所选分组编号/分组名称": "-",
    fans_count: "332",
    fans_count_total: "28894",
    fans_tt_count: "52",
    fans_hs_count: 0,
    aweme_count: "33",
    aweme_like_count: "1860",
    aweme_comment_count: "513",
    aweme_share_count: "110",
    aweme_play_count: "976169",
    aweme_activation: 0.8333,
    live_count: "43",
    live_time: "2432",
    live_watch_count: 40540,
    live_watch_time: 45044,
    live_like_count: "31530",
    live_comment_count: "8062",
    live_activation: 0.8667,
    live_fans_add: "304",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "济南泊思",
    company_name: "济南泊思",
    store_code: "NSD601",
    大区: "东北区",
    "省份-城市": "山东省-济南市",
    "所选分组编号/分组名称": "-",
    fans_count: "261",
    fans_count_total: "15041",
    fans_tt_count: "464",
    fans_hs_count: 0,
    aweme_count: "49",
    aweme_like_count: "766",
    aweme_comment_count: "87",
    aweme_share_count: "96",
    aweme_play_count: "293400",
    aweme_activation: 0.6333,
    live_count: "45",
    live_time: "2267",
    live_watch_count: 24764,
    live_watch_time: 27515,
    live_like_count: "35448",
    live_comment_count: "2219",
    live_activation: 0.6,
    live_fans_add: "254",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "山西大昌宏源红旗体验中心",
    company_name: "山西大昌宏源红旗体验中心",
    store_code: "NJN603",
    大区: "华北区",
    "省份-城市": "山西省-太原市",
    "所选分组编号/分组名称": "-",
    fans_count: "303",
    fans_count_total: "28097",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "86",
    aweme_like_count: "744",
    aweme_comment_count: "100",
    aweme_share_count: "88",
    aweme_play_count: "197148",
    aweme_activation: 0.6667,
    live_count: "54",
    live_time: "3356",
    live_watch_count: 97129,
    live_watch_time: 107921,
    live_like_count: "70735",
    live_comment_count: "2283",
    live_activation: 0.5333,
    live_fans_add: "220",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "义乌市正通",
    company_name: "义乌市正通汽车销售服务有限公司",
    store_code: "EZJ602",
    大区: "华东区",
    "省份-城市": "浙江省-金华市",
    "所选分组编号/分组名称": "-",
    fans_count: "-1567",
    fans_count_total: "643122",
    fans_tt_count: "46",
    fans_hs_count: 0,
    aweme_count: "21",
    aweme_like_count: "340",
    aweme_comment_count: "51",
    aweme_share_count: "17",
    aweme_play_count: "115726",
    aweme_activation: 0.2667,
    live_count: "13",
    live_time: "803",
    live_watch_count: 2548,
    live_watch_time: 2831,
    live_like_count: "34090",
    live_comment_count: "1477",
    live_activation: 0.3333,
    live_fans_add: "35",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "常州外汽红豪",
    company_name: "常州外汽红豪汽车销售服务有限公司",
    store_code: "EJS604",
    大区: "华东区",
    "省份-城市": "江苏省-常州市",
    "所选分组编号/分组名称": "-",
    fans_count: "55",
    fans_count_total: "12368",
    fans_tt_count: "19",
    fans_hs_count: 0,
    aweme_count: "58",
    aweme_like_count: "644",
    aweme_comment_count: "95",
    aweme_share_count: "48",
    aweme_play_count: "276545",
    aweme_activation: 0.8,
    live_count: "59",
    live_time: "3808",
    live_watch_count: 9086,
    live_watch_time: 10095,
    live_like_count: "84933",
    live_comment_count: "2305",
    live_activation: 0.9333,
    live_fans_add: "90",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "烟台鸿旗",
    company_name: "烟台鸿旗汽车销售服务有限公司",
    store_code: "NSD603",
    大区: "东北区",
    "省份-城市": "山东省-烟台市",
    "所选分组编号/分组名称": "-",
    fans_count: "292",
    fans_count_total: "45876",
    fans_tt_count: "13826",
    fans_hs_count: 0,
    aweme_count: "44",
    aweme_like_count: "581",
    aweme_comment_count: "57",
    aweme_share_count: "54",
    aweme_play_count: "253589",
    aweme_activation: 0.6667,
    live_count: "54",
    live_time: "3272",
    live_watch_count: 20188,
    live_watch_time: 22431,
    live_like_count: "9828",
    live_comment_count: "2571",
    live_activation: 0.7667,
    live_fans_add: "337",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "武汉东瑞红旗体验中心",
    company_name: "武汉市东瑞汽车销售服务有限公司",
    store_code: "CHB604",
    大区: "中南区",
    "省份-城市": "湖北省-武汉市",
    "所选分组编号/分组名称": "-",
    fans_count: "249",
    fans_count_total: "28034",
    fans_tt_count: "8878",
    fans_hs_count: 0,
    aweme_count: "37",
    aweme_like_count: "1029",
    aweme_comment_count: "380",
    aweme_share_count: "180",
    aweme_play_count: "461222",
    aweme_activation: 0.7333,
    live_count: "43",
    live_time: "2658",
    live_watch_count: 12092,
    live_watch_time: 13435,
    live_like_count: "64623",
    live_comment_count: "2905",
    live_activation: 0.8667,
    live_fans_add: "301",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "宜宾吉茂",
    company_name: "宜宾吉茂汽车销售服务有限公司",
    store_code: "WSC606",
    大区: "西部区",
    "省份-城市": "四川省-宜宾市",
    "所选分组编号/分组名称": "-",
    fans_count: "42",
    fans_count_total: "24560",
    fans_tt_count: "67",
    fans_hs_count: 0,
    aweme_count: "63",
    aweme_like_count: "955",
    aweme_comment_count: "217",
    aweme_share_count: "18",
    aweme_play_count: "115943",
    aweme_activation: 0.5333,
    live_count: "51",
    live_time: "2929",
    live_watch_count: 9139,
    live_watch_time: 10154,
    live_like_count: "23669",
    live_comment_count: "2065",
    live_activation: 0.5667,
    live_fans_add: "47",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "惠州市通利华",
    company_name: "惠州市通利华实业有限公司",
    store_code: "SGD606",
    大区: "华南区",
    "省份-城市": "广东省-惠州市",
    "所选分组编号/分组名称": "-",
    fans_count: "-769",
    fans_count_total: "259700",
    fans_tt_count: "38491",
    fans_hs_count: 0,
    aweme_count: "31",
    aweme_like_count: "348",
    aweme_comment_count: "26",
    aweme_share_count: "34",
    aweme_play_count: "47480",
    aweme_activation: 0.6333,
    live_count: "74",
    live_time: "5093",
    live_watch_count: 8561,
    live_watch_time: 9512,
    live_like_count: "64632",
    live_comment_count: "2433",
    live_activation: 1,
    live_fans_add: "54",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "中山市中升红旗",
    company_name: "中山市中升汽车销售服务有限公司",
    store_code: "SGD604",
    大区: "华南区",
    "省份-城市": "广东省-中山市",
    "所选分组编号/分组名称": "-",
    fans_count: "166",
    fans_count_total: "38605",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "58",
    aweme_like_count: "672",
    aweme_comment_count: "40",
    aweme_share_count: "81",
    aweme_play_count: "51610",
    aweme_activation: 0.8,
    live_count: "37",
    live_time: "2344",
    live_watch_count: 33155,
    live_watch_time: 36838,
    live_like_count: "12692",
    live_comment_count: "3846",
    live_activation: 0.8333,
    live_fans_add: "377",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "昆明海伟宏亦",
    company_name: "昆明海伟宏亦汽车销售有限公司",
    store_code: "WYN603",
    大区: "西部区",
    "省份-城市": "云南省-昆明市",
    "所选分组编号/分组名称": "-",
    fans_count: "599",
    fans_count_total: "146780",
    fans_tt_count: "1940",
    fans_hs_count: 0,
    aweme_count: "44",
    aweme_like_count: "2469",
    aweme_comment_count: "266",
    aweme_share_count: "171",
    aweme_play_count: "595243",
    aweme_activation: 0.6333,
    live_count: "49",
    live_time: "2883",
    live_watch_count: 216033,
    live_watch_time: 240036,
    live_like_count: "307522",
    live_comment_count: "9016",
    live_activation: 0.6667,
    live_fans_add: "1041",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "赣州凯迪红旗体验中心",
    company_name: "赣州凯迪红旗体验中心",
    store_code: "CJX601",
    大区: "中南区",
    "省份-城市": "江西省-赣州市",
    "所选分组编号/分组名称": "-",
    fans_count: "232",
    fans_count_total: "24205",
    fans_tt_count: "298",
    fans_hs_count: 0,
    aweme_count: "47",
    aweme_like_count: "2092",
    aweme_comment_count: "118",
    aweme_share_count: "155",
    aweme_play_count: "207577",
    aweme_activation: 0.8333,
    live_count: "72",
    live_time: "4584",
    live_watch_count: 10554,
    live_watch_time: 11726,
    live_like_count: "244159",
    live_comment_count: "14364",
    live_activation: 0.7333,
    live_fans_add: "108",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "贵州大雍峻辰",
    company_name: "贵州大雍峻辰汽车销售有限公司",
    store_code: "WGZ602",
    大区: "西部区",
    "省份-城市": "贵州省-贵阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "485",
    fans_count_total: "67188",
    fans_tt_count: "1591",
    fans_hs_count: 0,
    aweme_count: "73",
    aweme_like_count: "4146",
    aweme_comment_count: "1299",
    aweme_share_count: "1173",
    aweme_play_count: "1342321",
    aweme_activation: 0.7667,
    live_count: "46",
    live_time: "3020",
    live_watch_count: 204754,
    live_watch_time: 227504,
    live_like_count: "351851",
    live_comment_count: "11285",
    live_activation: 0.8667,
    live_fans_add: "882",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "宁波鑫之旗",
    company_name: "宁波鑫之旗",
    store_code: "EZJ603",
    大区: "华东区",
    "省份-城市": "浙江省-宁波市",
    "所选分组编号/分组名称": "-",
    fans_count: "-36",
    fans_count_total: "152607",
    fans_tt_count: "101",
    fans_hs_count: 0,
    aweme_count: "139",
    aweme_like_count: "1997",
    aweme_comment_count: "508",
    aweme_share_count: "176",
    aweme_play_count: "2009680",
    aweme_activation: 0.7,
    live_count: "30",
    live_time: "1882",
    live_watch_count: 44413,
    live_watch_time: 49347,
    live_like_count: "62764",
    live_comment_count: "4984",
    live_activation: 0.6333,
    live_fans_add: "244",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "上海东昌宏旗",
    company_name: "上海东昌宏旗",
    store_code: "ESH608",
    大区: "华东区",
    "省份-城市": "上海市-上海市",
    "所选分组编号/分组名称": "-",
    fans_count: "-252",
    fans_count_total: "38189",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "34",
    aweme_like_count: "357",
    aweme_comment_count: "37",
    aweme_share_count: "26",
    aweme_play_count: "104396",
    aweme_activation: 0.9,
    live_count: "27",
    live_time: "1691",
    live_watch_count: 6754,
    live_watch_time: 7504,
    live_like_count: "125859",
    live_comment_count: "4943",
    live_activation: 0.6,
    live_fans_add: "53",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "遂宁清巍瑞祥",
    company_name: "遂宁清巍瑞祥汽车销售服务有限公司",
    store_code: "WSC608",
    大区: "西部区",
    "省份-城市": "四川省-遂宁市",
    "所选分组编号/分组名称": "-",
    fans_count: "164",
    fans_count_total: "7081",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "30",
    aweme_like_count: "1022",
    aweme_comment_count: "241",
    aweme_share_count: "73",
    aweme_play_count: "382556",
    aweme_activation: 0.6667,
    live_count: "39",
    live_time: "2418",
    live_watch_count: 15343,
    live_watch_time: 17047,
    live_like_count: "19015",
    live_comment_count: "1420",
    live_activation: 0.8,
    live_fans_add: "54",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "福建赢宸",
    company_name: "福建赢宸汽车销售服务有限公司",
    store_code: "SFJ602",
    大区: "华南区",
    "省份-城市": "福建省-南平市",
    "所选分组编号/分组名称": "-",
    fans_count: "-69",
    fans_count_total: "17731",
    fans_tt_count: "14",
    fans_hs_count: 0,
    aweme_count: "49",
    aweme_like_count: "99",
    aweme_comment_count: "34",
    aweme_share_count: "15",
    aweme_play_count: "18386",
    aweme_activation: 0.7667,
    live_count: "47",
    live_time: "2757",
    live_watch_count: 1754,
    live_watch_time: 1948,
    live_like_count: "3407",
    live_comment_count: "744",
    live_activation: 0.8667,
    live_fans_add: "11",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "西宁金岛红旗",
    company_name: "西宁金岛红旗汽车销售服务有限公司",
    store_code: "XQH600",
    大区: "西部区",
    "省份-城市": "青海省-西宁市",
    "所选分组编号/分组名称": "-",
    fans_count: "330",
    fans_count_total: "4580",
    fans_tt_count: "70",
    fans_hs_count: 0,
    aweme_count: "155",
    aweme_like_count: "1509",
    aweme_comment_count: "115",
    aweme_share_count: "127",
    aweme_play_count: "333432",
    aweme_activation: 0.8,
    live_count: "44",
    live_time: "2943",
    live_watch_count: 8857,
    live_watch_time: 9841,
    live_like_count: "286643",
    live_comment_count: "15255",
    live_activation: 0.8333,
    live_fans_add: "306",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "安徽博融众旗",
    company_name: "安徽博融众旗汽车销售服务有限公司",
    store_code: "EAH602",
    大区: "华东区",
    "省份-城市": "安徽省-合肥市",
    "所选分组编号/分组名称": "-",
    fans_count: "-80",
    fans_count_total: "54544",
    fans_tt_count: "1",
    fans_hs_count: 0,
    aweme_count: "68",
    aweme_like_count: "692",
    aweme_comment_count: "48",
    aweme_share_count: "62",
    aweme_play_count: "191714",
    aweme_activation: 0.8333,
    live_count: "106",
    live_time: "6462",
    live_watch_count: 39354,
    live_watch_time: 43726,
    live_like_count: "10322",
    live_comment_count: "4563",
    live_activation: 1,
    live_fans_add: "203",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "广东鸿粤益嘉店",
    company_name: "广东鸿粤益嘉汽车销售服务有限公司",
    store_code: "SGD603",
    大区: "华南区",
    "省份-城市": "广东省-广州市",
    "所选分组编号/分组名称": "-",
    fans_count: "280",
    fans_count_total: "53218",
    fans_tt_count: "28041",
    fans_hs_count: 0,
    aweme_count: "48",
    aweme_like_count: "1924",
    aweme_comment_count: "231",
    aweme_share_count: "199",
    aweme_play_count: "800364",
    aweme_activation: 0.5,
    live_count: "56",
    live_time: "3423",
    live_watch_count: 19100,
    live_watch_time: 21222,
    live_like_count: "178077",
    live_comment_count: "4874",
    live_activation: 0.8,
    live_fans_add: "165",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "济宁天禧",
    company_name: "济宁天禧",
    store_code: "NSD600",
    大区: "东北区",
    "省份-城市": "山东省-济宁市",
    "所选分组编号/分组名称": "-",
    fans_count: "-684",
    fans_count_total: "297305",
    fans_tt_count: "1071",
    fans_hs_count: 0,
    aweme_count: "67",
    aweme_like_count: "354",
    aweme_comment_count: "22",
    aweme_share_count: "28",
    aweme_play_count: "77408",
    aweme_activation: 0.9,
    live_count: "41",
    live_time: "2589",
    live_watch_count: 6671,
    live_watch_time: 7412,
    live_like_count: "46558",
    live_comment_count: "1087",
    live_activation: 0.8333,
    live_fans_add: "80",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "宜昌市华健晟旗",
    company_name: "宜昌市华健晟旗汽车销售服务有限责任公司",
    store_code: "CHB605",
    大区: "中南区",
    "省份-城市": "湖北省-宜昌市",
    "所选分组编号/分组名称": "-",
    fans_count: "20",
    fans_count_total: "33731",
    fans_tt_count: "1500",
    fans_hs_count: 0,
    aweme_count: "28",
    aweme_like_count: "684",
    aweme_comment_count: "129",
    aweme_share_count: "46",
    aweme_play_count: "168955",
    aweme_activation: 1,
    live_count: "25",
    live_time: "1598",
    live_watch_count: 1495,
    live_watch_time: 1661,
    live_like_count: "13654",
    live_comment_count: "594",
    live_activation: 0.8667,
    live_fans_add: "20",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "许昌恒旭红旗4s店",
    company_name: "许昌市恒旭汽车销售服务有限公司",
    store_code: "NYU604",
    大区: "华北区",
    "省份-城市": "河南省-许昌市",
    "所选分组编号/分组名称": "-",
    fans_count: "-227",
    fans_count_total: "145575",
    fans_tt_count: "2426",
    fans_hs_count: 0,
    aweme_count: "40",
    aweme_like_count: "345",
    aweme_comment_count: "43",
    aweme_share_count: "33",
    aweme_play_count: "54683",
    aweme_activation: 0.7667,
    live_count: "48",
    live_time: "2791",
    live_watch_count: 49660,
    live_watch_time: 55177,
    live_like_count: "25079",
    live_comment_count: "2041",
    live_activation: 0.8333,
    live_fans_add: "437",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "保定中冀华达红旗体验中心",
    company_name: "保定市华达汽车销售服务有限公司",
    store_code: "NJI600",
    大区: "华北区",
    "省份-城市": "河北省-保定市",
    "所选分组编号/分组名称": "-",
    fans_count: "265",
    fans_count_total: "37874",
    fans_tt_count: "28637",
    fans_hs_count: 0,
    aweme_count: "70",
    aweme_like_count: "552",
    aweme_comment_count: "36",
    aweme_share_count: "14",
    aweme_play_count: "49474",
    aweme_activation: 0.5333,
    live_count: "169",
    live_time: "14501",
    live_watch_count: 58976,
    live_watch_time: 65528,
    live_like_count: "102123",
    live_comment_count: "8134",
    live_activation: 0.8333,
    live_fans_add: "382",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "临沂美华红旗",
    company_name: "临沂美华汽车销售服务有限公司",
    store_code: "HSD603",
    大区: "东北区",
    "省份-城市": "山东省-临沂市",
    "所选分组编号/分组名称": "-",
    fans_count: "-422",
    fans_count_total: "192034",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "42",
    aweme_like_count: "1584",
    aweme_comment_count: "181",
    aweme_share_count: "186",
    aweme_play_count: "517615",
    aweme_activation: 0.6,
    live_count: "32",
    live_time: "2027",
    live_watch_count: 4463,
    live_watch_time: 4958,
    live_like_count: "22288",
    live_comment_count: "1554",
    live_activation: 0.6,
    live_fans_add: "73",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "重庆九禾缘红旗",
    company_name: "重庆九禾缘汽车销售服务有限公司",
    store_code: "WCQ600",
    大区: "西部区",
    "省份-城市": "重庆市-重庆市",
    "所选分组编号/分组名称": "-",
    fans_count: "358",
    fans_count_total: "8219",
    fans_tt_count: "14",
    fans_hs_count: 0,
    aweme_count: "41",
    aweme_like_count: "576",
    aweme_comment_count: "57",
    aweme_share_count: "10",
    aweme_play_count: "201108",
    aweme_activation: 0.7667,
    live_count: "49",
    live_time: "3123",
    live_watch_count: 8614,
    live_watch_time: 9571,
    live_like_count: "145889",
    live_comment_count: "3924",
    live_activation: 0.8333,
    live_fans_add: "140",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "湖北英驰红旗",
    company_name: "湖北英驰汽车集团有限公司",
    store_code: "CHB601",
    大区: "中南区",
    "省份-城市": "湖北省-襄阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "293",
    fans_count_total: "27709",
    fans_tt_count: "411",
    fans_hs_count: 0,
    aweme_count: "108",
    aweme_like_count: "1255",
    aweme_comment_count: "225",
    aweme_share_count: "139",
    aweme_play_count: "398438",
    aweme_activation: 0.6,
    live_count: "86",
    live_time: "5501",
    live_watch_count: 28222,
    live_watch_time: 31357,
    live_like_count: "76327",
    live_comment_count: "4830",
    live_activation: 0.8667,
    live_fans_add: "265",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "宝鸡威凯红旗",
    company_name: "宝鸡威凯红旗汽车销售服务有限公司",
    store_code: "XSS604",
    大区: "西部区",
    "省份-城市": "陕西省-宝鸡市",
    "所选分组编号/分组名称": "-",
    fans_count: "174",
    fans_count_total: "7627",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "150",
    aweme_like_count: "1651",
    aweme_comment_count: "65",
    aweme_share_count: "42",
    aweme_play_count: "269639",
    aweme_activation: 0.9,
    live_count: "58",
    live_time: "3243",
    live_watch_count: 11783,
    live_watch_time: 13092,
    live_like_count: "75819",
    live_comment_count: "1641",
    live_activation: 0.8667,
    live_fans_add: "73",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "云南宏通达红旗体验中心",
    company_name: "云南宏通达汽车销售服务有限公司",
    store_code: "WYN600",
    大区: "西部区",
    "省份-城市": "云南省-昆明市",
    "所选分组编号/分组名称": "-",
    fans_count: "138",
    fans_count_total: "35960",
    fans_tt_count: "28",
    fans_hs_count: 0,
    aweme_count: "54",
    aweme_like_count: "747",
    aweme_comment_count: "54",
    aweme_share_count: "66",
    aweme_play_count: "184738",
    aweme_activation: 1,
    live_count: "45",
    live_time: "2786",
    live_watch_count: 111908,
    live_watch_time: 124342,
    live_like_count: "65285",
    live_comment_count: "1723",
    live_activation: 0.8,
    live_fans_add: "189",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "东莞德现",
    company_name: "东莞德现汽车销售服务有限公司",
    store_code: "SGD607",
    大区: "华南区",
    "省份-城市": "广东省-东莞市",
    "所选分组编号/分组名称": "-",
    fans_count: "78",
    fans_count_total: "52231",
    fans_tt_count: "16899",
    fans_hs_count: 0,
    aweme_count: "63",
    aweme_like_count: "870",
    aweme_comment_count: "44",
    aweme_share_count: "60",
    aweme_play_count: "55180",
    aweme_activation: 0.7,
    live_count: "27",
    live_time: "1637",
    live_watch_count: 8933,
    live_watch_time: 9925,
    live_like_count: "30880",
    live_comment_count: "2415",
    live_activation: 0.8333,
    live_fans_add: "126",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "商丘市恒美红旗体验中心",
    company_name: "商丘市恒美红旗体验中心",
    store_code: "NYU606",
    大区: "华北区",
    "省份-城市": "河南省-商丘市",
    "所选分组编号/分组名称": "-",
    fans_count: "-31",
    fans_count_total: "19158",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "38",
    aweme_like_count: "332",
    aweme_comment_count: "37",
    aweme_share_count: "20",
    aweme_play_count: "43574",
    aweme_activation: 0.8,
    live_count: "23",
    live_time: "1450",
    live_watch_count: 3583,
    live_watch_time: 3981,
    live_like_count: "63730",
    live_comment_count: "2434",
    live_activation: 0.7333,
    live_fans_add: "41",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "浙江裕旗",
    company_name: "浙江裕旗汽车有限公司",
    store_code: "EZJ606",
    大区: "华东区",
    "省份-城市": "浙江省-杭州市",
    "所选分组编号/分组名称": "-",
    fans_count: "-616",
    fans_count_total: "305968",
    fans_tt_count: "10451",
    fans_hs_count: 0,
    aweme_count: "63",
    aweme_like_count: "965",
    aweme_comment_count: "67",
    aweme_share_count: "55",
    aweme_play_count: "178951",
    aweme_activation: 0.9667,
    live_count: "73",
    live_time: "4984",
    live_watch_count: 72765,
    live_watch_time: 80850,
    live_like_count: "29623",
    live_comment_count: "5045",
    live_activation: 0.8333,
    live_fans_add: "467",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "运城大昌红旗体验中心",
    company_name: "运城大昌宏源汽车销售服务有限公司",
    store_code: "NJN604",
    大区: "华北区",
    "省份-城市": "山西省-运城市",
    "所选分组编号/分组名称": "-",
    fans_count: "14",
    fans_count_total: "6392",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "32",
    aweme_like_count: "218",
    aweme_comment_count: "20",
    aweme_share_count: "21",
    aweme_play_count: "35204",
    aweme_activation: 0.8333,
    live_count: "24",
    live_time: "1420",
    live_watch_count: 110063,
    live_watch_time: 122292,
    live_like_count: "103471",
    live_comment_count: "4349",
    live_activation: 0.9,
    live_fans_add: "146",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "湖南兰天天旗",
    company_name: "湖南兰天天旗",
    store_code: "CHN603",
    大区: "中南区",
    "省份-城市": "湖南省-长沙市",
    "所选分组编号/分组名称": "-",
    fans_count: "670",
    fans_count_total: "12922",
    fans_tt_count: "143",
    fans_hs_count: 0,
    aweme_count: "36",
    aweme_like_count: "662",
    aweme_comment_count: "141",
    aweme_share_count: "122",
    aweme_play_count: "193129",
    aweme_activation: 0.6,
    live_count: "40",
    live_time: "2572",
    live_watch_count: 30451,
    live_watch_time: 33834,
    live_like_count: "108782",
    live_comment_count: "4343",
    live_activation: 0.8667,
    live_fans_add: "353",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "内蒙古思旗红旗体验中心",
    company_name: "内蒙古思旗汽车销售有限责任公司",
    store_code: "DNM601",
    大区: "华北区",
    "省份-城市": "内蒙古自治区-呼和浩特市",
    "所选分组编号/分组名称": "-",
    fans_count: "159",
    fans_count_total: "89064",
    fans_tt_count: "507",
    fans_hs_count: 0,
    aweme_count: "76",
    aweme_like_count: "4394",
    aweme_comment_count: "3714",
    aweme_share_count: "2018",
    aweme_play_count: "677848",
    aweme_activation: 1,
    live_count: "55",
    live_time: "3720",
    live_watch_count: 312465,
    live_watch_time: 347183,
    live_like_count: "169754",
    live_comment_count: "4722",
    live_activation: 0.8333,
    live_fans_add: "356",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "远达红旗",
    company_name: "聊城远达汽车销售服务有限公司",
    store_code: "NSD602",
    大区: "东北区",
    "省份-城市": "山东省-聊城市",
    "所选分组编号/分组名称": "-",
    fans_count: "-17",
    fans_count_total: "2267",
    fans_tt_count: "38",
    fans_hs_count: 0,
    aweme_count: "33",
    aweme_like_count: "417",
    aweme_comment_count: "25",
    aweme_share_count: "71",
    aweme_play_count: "42207",
    aweme_activation: 0.8333,
    live_count: "13",
    live_time: "808",
    live_watch_count: 266,
    live_watch_time: 295,
    live_like_count: "194",
    live_comment_count: "34",
    live_activation: 0.5,
    live_fans_add: "1",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "衡阳恒宇红旗",
    company_name: "衡阳市恒宇汽车销售服务有限公司",
    store_code: "CHN604",
    大区: "中南区",
    "省份-城市": "湖南省-衡阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "598",
    fans_count_total: "21728",
    fans_tt_count: "333",
    fans_hs_count: 0,
    aweme_count: "147",
    aweme_like_count: "1274",
    aweme_comment_count: "418",
    aweme_share_count: "175",
    aweme_play_count: "189948",
    aweme_activation: 0.7667,
    live_count: "50",
    live_time: "3113",
    live_watch_count: 136523,
    live_watch_time: 151692,
    live_like_count: "173396",
    live_comment_count: "4022",
    live_activation: 0.9,
    live_fans_add: "447",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "长治大昌红旗体验中心",
    company_name: "长治市大昌汽车销售服务有限公司",
    store_code: "NJN605",
    大区: "华北区",
    "省份-城市": "山西省-长治市",
    "所选分组编号/分组名称": "-",
    fans_count: "308",
    fans_count_total: "25617",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "95",
    aweme_like_count: "1006",
    aweme_comment_count: "160",
    aweme_share_count: "96",
    aweme_play_count: "253597",
    aweme_activation: 0.6667,
    live_count: "56",
    live_time: "3538",
    live_watch_count: 104189,
    live_watch_time: 115765,
    live_like_count: "108912",
    live_comment_count: "3882",
    live_activation: 0.8333,
    live_fans_add: "209",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "邢台邦华",
    company_name: "邢台邦华汽车销售服务有限公司",
    store_code: "NJI601",
    大区: "华北区",
    "省份-城市": "河北省-邢台市",
    "所选分组编号/分组名称": "-",
    fans_count: "465",
    fans_count_total: "17476",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "59",
    aweme_like_count: "1389",
    aweme_comment_count: "165",
    aweme_share_count: "175",
    aweme_play_count: "191783",
    aweme_activation: 0.7,
    live_count: "149",
    live_time: "12536",
    live_watch_count: 25928,
    live_watch_time: 28808,
    live_like_count: "91979",
    live_comment_count: "9594",
    live_activation: 0.9333,
    live_fans_add: "292",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "大连通洲",
    company_name: "大连通洲",
    store_code: "DLN601",
    大区: "东北区",
    "省份-城市": "辽宁省-大连市",
    "所选分组编号/分组名称": "-",
    fans_count: "-44",
    fans_count_total: "34418",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "56",
    aweme_like_count: "170",
    aweme_comment_count: "9",
    aweme_share_count: "6",
    aweme_play_count: "12454",
    aweme_activation: 0.7333,
    live_count: "42",
    live_time: "2610",
    live_watch_count: 13685,
    live_watch_time: 15205,
    live_like_count: "36615",
    live_comment_count: "1659",
    live_activation: 0.7667,
    live_fans_add: "92",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "包头市宏腾红旗体验中心",
    company_name: "包头市宏腾汽车销售服务有限公司",
    store_code: "DNM602",
    大区: "华北区",
    "省份-城市": "内蒙古自治区-包头市",
    "所选分组编号/分组名称": "-",
    fans_count: "320",
    fans_count_total: "3079",
    fans_tt_count: "4",
    fans_hs_count: 0,
    aweme_count: "39",
    aweme_like_count: "812",
    aweme_comment_count: "62",
    aweme_share_count: "75",
    aweme_play_count: "336308",
    aweme_activation: 0.7333,
    live_count: "54",
    live_time: "3461",
    live_watch_count: 12427,
    live_watch_time: 13807,
    live_like_count: "11223",
    live_comment_count: "4109",
    live_activation: 0.9333,
    live_fans_add: "146",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "兴安盟华盛",
    company_name: "兴安盟华盛汽车销售服务有限公司",
    store_code: "DNM603",
    大区: "东北区",
    "省份-城市": "内蒙古自治区-兴安盟",
    "所选分组编号/分组名称": "-",
    fans_count: "93",
    fans_count_total: "17553",
    fans_tt_count: "3227",
    fans_hs_count: 0,
    aweme_count: "54",
    aweme_like_count: "630",
    aweme_comment_count: "105",
    aweme_share_count: "59",
    aweme_play_count: "219816",
    aweme_activation: 0.8667,
    live_count: "41",
    live_time: "2017",
    live_watch_count: 2629,
    live_watch_time: 2921,
    live_like_count: "49324",
    live_comment_count: "469",
    live_activation: 0.7667,
    live_fans_add: "24",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "大同大昌宏源",
    company_name: "大同大昌宏源汽车销售服务有限公司",
    store_code: "NJN606",
    大区: "华北区",
    "省份-城市": "山西省-大同市",
    "所选分组编号/分组名称": "-",
    fans_count: "221",
    fans_count_total: "8505",
    fans_tt_count: "72",
    fans_hs_count: "1",
    aweme_count: "32",
    aweme_like_count: "238",
    aweme_comment_count: "20",
    aweme_share_count: "18",
    aweme_play_count: "108016",
    aweme_activation: 0.9667,
    live_count: "42",
    live_time: "2611",
    live_watch_count: 137906,
    live_watch_time: 153228,
    live_like_count: "103737",
    live_comment_count: "2202",
    live_activation: 0.8,
    live_fans_add: "221",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "辽阳红兴红旗4S店",
    company_name: "辽阳红兴汽车销售服务有限公司",
    store_code: "DLN602",
    大区: "东北区",
    "省份-城市": "辽宁省-辽阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "244",
    fans_count_total: "943",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "20",
    aweme_like_count: "178",
    aweme_comment_count: "6",
    aweme_share_count: "15",
    aweme_play_count: "10848",
    aweme_activation: 0.5,
    live_count: "26",
    live_time: "1492",
    live_watch_count: 620,
    live_watch_time: 688,
    live_like_count: "3571",
    live_comment_count: "91",
    live_activation: 0.7,
    live_fans_add: "17",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "新疆天汇华辉",
    company_name: "新疆天汇华辉汽车销售服务有限公司",
    store_code: "XXJ600",
    大区: "西部区",
    "省份-城市": "新疆维吾尔自治区-乌鲁木齐市",
    "所选分组编号/分组名称": "-",
    fans_count: "-1146",
    fans_count_total: "269186",
    fans_tt_count: "9455",
    fans_hs_count: 0,
    aweme_count: "32",
    aweme_like_count: "268",
    aweme_comment_count: "12",
    aweme_share_count: "10",
    aweme_play_count: "43886",
    aweme_activation: 0.5333,
    live_count: "33",
    live_time: "2041",
    live_watch_count: 2834,
    live_watch_time: 3148,
    live_like_count: "9088",
    live_comment_count: "93",
    live_activation: 0.7,
    live_fans_add: "6",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "秦皇岛瑞通嘉禾",
    company_name: "秦皇岛瑞通嘉禾汽车销售服务有限公司",
    store_code: "NJI602",
    大区: "华北区",
    "省份-城市": "河北省-秦皇岛市",
    "所选分组编号/分组名称": "-",
    fans_count: "391",
    fans_count_total: "84684",
    fans_tt_count: "85",
    fans_hs_count: 0,
    aweme_count: "16",
    aweme_like_count: "95",
    aweme_comment_count: "4",
    aweme_share_count: "3",
    aweme_play_count: "10791",
    aweme_activation: 0.3,
    live_count: "49",
    live_time: "2965",
    live_watch_count: 97665,
    live_watch_time: 108516,
    live_like_count: "683989",
    live_comment_count: "18342",
    live_activation: 0.7,
    live_fans_add: "838",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "安庆市天位",
    company_name: "安庆市天位汽车销售服务有限公司",
    store_code: "EAH605",
    大区: "华东区",
    "省份-城市": "安徽省-安庆市",
    "所选分组编号/分组名称": "-",
    fans_count: "-340",
    fans_count_total: "482085",
    fans_tt_count: "8519",
    fans_hs_count: 0,
    aweme_count: "55",
    aweme_like_count: "659",
    aweme_comment_count: "81",
    aweme_share_count: "56",
    aweme_play_count: "257126",
    aweme_activation: 0.6333,
    live_count: "22",
    live_time: "1095",
    live_watch_count: 2467,
    live_watch_time: 2741,
    live_like_count: "3517",
    live_comment_count: "89",
    live_activation: 0.4667,
    live_fans_add: "9",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "泉州同行红旗",
    company_name: "泉州同行红旗",
    store_code: "SFJ603",
    大区: "华南区",
    "省份-城市": "福建省-泉州市",
    "所选分组编号/分组名称": "-",
    fans_count: "260",
    fans_count_total: "69597",
    fans_tt_count: "151",
    fans_hs_count: 0,
    aweme_count: "57",
    aweme_like_count: "2138",
    aweme_comment_count: "409",
    aweme_share_count: "316",
    aweme_play_count: "924193",
    aweme_activation: 0.5,
    live_count: "44",
    live_time: "2838",
    live_watch_count: 36059,
    live_watch_time: 40065,
    live_like_count: "21964",
    live_comment_count: "3781",
    live_activation: 0.8667,
    live_fans_add: "248",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "宁波中基明瑞",
    company_name: "宁波中基明瑞汽车销售服务有限公司",
    store_code: "EZJ607",
    大区: "华东区",
    "省份-城市": "浙江省-宁波市",
    "所选分组编号/分组名称": "-",
    fans_count: "460",
    fans_count_total: "17687",
    fans_tt_count: "65",
    fans_hs_count: 0,
    aweme_count: "49",
    aweme_like_count: "1123",
    aweme_comment_count: "232",
    aweme_share_count: "76",
    aweme_play_count: "307797",
    aweme_activation: 0.5667,
    live_count: "31",
    live_time: "1941",
    live_watch_count: 134844,
    live_watch_time: 149826,
    live_like_count: "131672",
    live_comment_count: "3001",
    live_activation: 0.5333,
    live_fans_add: "233",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "杭州广旗",
    company_name: "杭州广旗汽车有限公司",
    store_code: "EZJ609",
    大区: "华东区",
    "省份-城市": "浙江省-杭州市",
    "所选分组编号/分组名称": "-",
    fans_count: "44",
    fans_count_total: "35827",
    fans_tt_count: "33",
    fans_hs_count: 0,
    aweme_count: "67",
    aweme_like_count: "533",
    aweme_comment_count: "41",
    aweme_share_count: "56",
    aweme_play_count: "119266",
    aweme_activation: 0.8,
    live_count: "88",
    live_time: "5490",
    live_watch_count: 10909,
    live_watch_time: 12121,
    live_like_count: "27252",
    live_comment_count: "4766",
    live_activation: 0.9,
    live_fans_add: "72",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "广西钜荣红旗",
    company_name: "广西钜荣红旗汽车销售服务有限公司",
    store_code: "SGX601",
    大区: "华南区",
    "省份-城市": "广西壮族自治区-南宁市",
    "所选分组编号/分组名称": "-",
    fans_count: "-136",
    fans_count_total: "21949",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "19",
    aweme_like_count: "106",
    aweme_comment_count: "5",
    aweme_share_count: "1",
    aweme_play_count: "8432",
    aweme_activation: 0.6667,
    live_count: "24",
    live_time: "1819",
    live_watch_count: 2533,
    live_watch_time: 2814,
    live_like_count: "14145",
    live_comment_count: "741",
    live_activation: 0.6667,
    live_fans_add: "4",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "北京龙泽百旺红旗",
    company_name: "北京龙泽百旺销售服务有限公司",
    store_code: "NBJ123",
    大区: "华北区",
    "省份-城市": "北京市-北京市",
    "所选分组编号/分组名称": "-",
    fans_count: "4",
    fans_count_total: "3020",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "33",
    aweme_like_count: "52",
    aweme_comment_count: 0,
    aweme_share_count: "1",
    aweme_play_count: "21021",
    aweme_activation: 0.4,
    live_count: "27",
    live_time: "1625",
    live_watch_count: 5214,
    live_watch_time: 5793,
    live_like_count: "2063",
    live_comment_count: "83",
    live_activation: 0.9333,
    live_fans_add: "3",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "河南圆诺",
    company_name: "河南圆诺汽车销售有限公司",
    store_code: "NYU607",
    大区: "华北区",
    "省份-城市": "河南省-开封市",
    "所选分组编号/分组名称": "-",
    fans_count: "163",
    fans_count_total: "21712",
    fans_tt_count: "660",
    fans_hs_count: 0,
    aweme_count: "86",
    aweme_like_count: "1458",
    aweme_comment_count: "199",
    aweme_share_count: "141",
    aweme_play_count: "642160",
    aweme_activation: 0.8667,
    live_count: "28",
    live_time: "1634",
    live_watch_count: 4698,
    live_watch_time: 5220,
    live_like_count: "21145",
    live_comment_count: "882",
    live_activation: 0.7333,
    live_fans_add: "22",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "济南快爱特红旗",
    company_name: "济南快爱特有限公司",
    store_code: "NSD608",
    大区: "东北区",
    "省份-城市": "山东省-济南市",
    "所选分组编号/分组名称": "-",
    fans_count: "1002",
    fans_count_total: "67842",
    fans_tt_count: "445",
    fans_hs_count: 0,
    aweme_count: "48",
    aweme_like_count: "3236",
    aweme_comment_count: "471",
    aweme_share_count: "378",
    aweme_play_count: "463616",
    aweme_activation: 0.9,
    live_count: "56",
    live_time: "3555",
    live_watch_count: 330003,
    live_watch_time: 366670,
    live_like_count: "156545",
    live_comment_count: "29709",
    live_activation: 0.8,
    live_fans_add: "1267",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "成都建国红旗",
    company_name: "成都建国汽车贸易有限公司",
    store_code: "WSC609",
    大区: "西部区",
    "省份-城市": "四川省-成都市",
    "所选分组编号/分组名称": "-",
    fans_count: "2702",
    fans_count_total: "62402",
    fans_tt_count: "110",
    fans_hs_count: 0,
    aweme_count: "42",
    aweme_like_count: "1681",
    aweme_comment_count: "320",
    aweme_share_count: "130",
    aweme_play_count: "345800",
    aweme_activation: 0.6333,
    live_count: "201",
    live_time: "13634",
    live_watch_count: 684757,
    live_watch_time: 760841,
    live_like_count: "501340",
    live_comment_count: "185419",
    live_activation: 1,
    live_fans_add: "2906",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "东莞鸿粤益嘉",
    company_name: "东莞鸿粤益嘉汽车销售服务有限公司",
    store_code: "SGD609",
    大区: "华南区",
    "省份-城市": "广东省-东莞市",
    "所选分组编号/分组名称": "-",
    fans_count: "-369",
    fans_count_total: "206942",
    fans_tt_count: "41876",
    fans_hs_count: 0,
    aweme_count: "50",
    aweme_like_count: "1231",
    aweme_comment_count: "225",
    aweme_share_count: "77",
    aweme_play_count: "521731",
    aweme_activation: 0.6333,
    live_count: "54",
    live_time: "3357",
    live_watch_count: 4255,
    live_watch_time: 4727,
    live_like_count: "84780",
    live_comment_count: "5647",
    live_activation: 0.8,
    live_fans_add: "55",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "海南优之杰红旗",
    company_name: "海南优之杰商贸有限公司",
    store_code: "SHN600",
    大区: "华南区",
    "省份-城市": "海南省-海口市",
    "所选分组编号/分组名称": "-",
    fans_count: "-401",
    fans_count_total: "112251",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "35",
    aweme_like_count: "1125",
    aweme_comment_count: "136",
    aweme_share_count: "289",
    aweme_play_count: "249087",
    aweme_activation: 0.8667,
    live_count: "59",
    live_time: "3602",
    live_watch_count: 55699,
    live_watch_time: 61887,
    live_like_count: "99878",
    live_comment_count: "3931",
    live_activation: 0.8333,
    live_fans_add: "197",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "天津汇裕永达",
    company_name: "天津汇裕永达汽车贸易有限公司",
    store_code: "NTJ603",
    大区: "华北区",
    "省份-城市": "天津市-天津市",
    "所选分组编号/分组名称": "-",
    fans_count: "-125",
    fans_count_total: "108666",
    fans_tt_count: "6814",
    fans_hs_count: 0,
    aweme_count: "61",
    aweme_like_count: "742",
    aweme_comment_count: "84",
    aweme_share_count: "126",
    aweme_play_count: "305792",
    aweme_activation: 0.8667,
    live_count: "72",
    live_time: "4351",
    live_watch_count: 5154,
    live_watch_time: 5726,
    live_like_count: "53142",
    live_comment_count: "541",
    live_activation: 0.8667,
    live_fans_add: "65",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "日照晟瑞红旗",
    company_name: "日照晟瑞汽车销售服务有限公司",
    store_code: "NSD609",
    大区: "东北区",
    "省份-城市": "山东省-日照市",
    "所选分组编号/分组名称": "-",
    fans_count: "27",
    fans_count_total: "4544",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "59",
    aweme_like_count: "637",
    aweme_comment_count: "45",
    aweme_share_count: "68",
    aweme_play_count: "29926",
    aweme_activation: 0.9333,
    live_count: "129",
    live_time: "8489",
    live_watch_count: 9510,
    live_watch_time: 10566,
    live_like_count: "209945",
    live_comment_count: "6535",
    live_activation: 0.9,
    live_fans_add: "37",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "菏泽兴邦红旗汽车体验中心",
    company_name: "菏泽兴邦汽车销售服务有限公司",
    store_code: "NSD610",
    大区: "东北区",
    "省份-城市": "山东省-菏泽市",
    "所选分组编号/分组名称": "-",
    fans_count: "-378",
    fans_count_total: "153025",
    fans_tt_count: "29968",
    fans_hs_count: 0,
    aweme_count: "28",
    aweme_like_count: "3905",
    aweme_comment_count: "16",
    aweme_share_count: "129",
    aweme_play_count: "120192",
    aweme_activation: 0.9,
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: 0,
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "河北华美红旗体验中心",
    company_name: "河北华美红旗体验中心",
    store_code: "NJI603",
    大区: "华北区",
    "省份-城市": "河北省-石家庄市",
    "所选分组编号/分组名称": "-",
    fans_count: "-54",
    fans_count_total: "70184",
    fans_tt_count: "4106",
    fans_hs_count: 0,
    aweme_count: "36",
    aweme_like_count: "551",
    aweme_comment_count: "31",
    aweme_share_count: "37",
    aweme_play_count: "188573",
    aweme_activation: 0.5,
    live_count: "42",
    live_time: "2593",
    live_watch_count: 13001,
    live_watch_time: 14445,
    live_like_count: "59121",
    live_comment_count: "4219",
    live_activation: 0.7333,
    live_fans_add: "138",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "大理国源",
    company_name: "大理国源汽车销售服务有限公司",
    store_code: "WYN604",
    大区: "西部区",
    "省份-城市": "云南省-大理白族自治州",
    "所选分组编号/分组名称": "-",
    fans_count: "-139",
    fans_count_total: "28555",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "37",
    aweme_like_count: "214",
    aweme_comment_count: "57",
    aweme_share_count: "7",
    aweme_play_count: "16589",
    aweme_activation: 0.5333,
    live_count: "91",
    live_time: "6026",
    live_watch_count: 6552,
    live_watch_time: 7280,
    live_like_count: "119116",
    live_comment_count: "3280",
    live_activation: 0.7333,
    live_fans_add: "21",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "北京祥龙博瑞红旗体验中心",
    company_name: "北京祥龙博瑞汽车服务(集团)有限公司一分公司",
    store_code: "NBJ603",
    大区: "华北区",
    "省份-城市": "北京市-北京市",
    "所选分组编号/分组名称": "-",
    fans_count: "932",
    fans_count_total: "29373",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "30",
    aweme_like_count: "4428",
    aweme_comment_count: "170",
    aweme_share_count: "352",
    aweme_play_count: "344324",
    aweme_activation: 0.4333,
    live_count: "37",
    live_time: "2382",
    live_watch_count: 110914,
    live_watch_time: 123237,
    live_like_count: "141217",
    live_comment_count: "5387",
    live_activation: 0.5333,
    live_fans_add: "481",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "无锡红博红旗",
    company_name: "无锡红博汽车销售有限公司",
    store_code: "EJS609",
    大区: "华东区",
    "省份-城市": "江苏省-无锡市",
    "所选分组编号/分组名称": "-",
    fans_count: "97",
    fans_count_total: "8486",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "62",
    aweme_like_count: "640",
    aweme_comment_count: "79",
    aweme_share_count: "46",
    aweme_play_count: "201481",
    aweme_activation: 0.7333,
    live_count: "76",
    live_time: "4401",
    live_watch_count: 4922,
    live_watch_time: 5468,
    live_like_count: "67903",
    live_comment_count: "3544",
    live_activation: 0.8,
    live_fans_add: "96",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "黔西南州星尊程领航",
    company_name: "黔西南州星尊程领航汽车销售服务有限公司",
    store_code: "WGZ604",
    大区: "西部区",
    "省份-城市": "贵州省-黔西南布依族苗族自治州",
    "所选分组编号/分组名称": "-",
    fans_count: "147",
    fans_count_total: "3692",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "22",
    aweme_like_count: "754",
    aweme_comment_count: "102",
    aweme_share_count: "264",
    aweme_play_count: "212077",
    aweme_activation: 0.7667,
    live_count: "20",
    live_time: "1266",
    live_watch_count: 871,
    live_watch_time: 967,
    live_like_count: "1487",
    live_comment_count: "172",
    live_activation: 0.6,
    live_fans_add: "11",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "德阳冠仑",
    company_name: "德阳冠仑",
    store_code: "WSC613",
    大区: "西部区",
    "省份-城市": "四川省-德阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "34",
    fans_count_total: "29714",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "42",
    aweme_like_count: "1130",
    aweme_comment_count: "232",
    aweme_share_count: "30",
    aweme_play_count: "621733",
    aweme_activation: 0.9667,
    live_count: "38",
    live_time: "2339",
    live_watch_count: 2240,
    live_watch_time: 2488,
    live_like_count: "51685",
    live_comment_count: "690",
    live_activation: 0.7667,
    live_fans_add: "16",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "温州宝旗红旗",
    company_name: "温州宝旗汽车服务有限公司",
    store_code: "EZJ611",
    大区: "华东区",
    "省份-城市": "浙江省-温州市",
    "所选分组编号/分组名称": "-",
    fans_count: "-56",
    fans_count_total: "146012",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "65",
    aweme_like_count: "2342",
    aweme_comment_count: "250",
    aweme_share_count: "187",
    aweme_play_count: "1003411",
    aweme_activation: 0.9333,
    live_count: "109",
    live_time: "6812",
    live_watch_count: 46522,
    live_watch_time: 51691,
    live_like_count: "86180",
    live_comment_count: "5252",
    live_activation: 1,
    live_fans_add: "265",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "曲靖开源红旗体验中心",
    company_name: "曲靖开源汽车销售服务有限公司",
    store_code: "WYN605",
    大区: "西部区",
    "省份-城市": "云南省-曲靖市",
    "所选分组编号/分组名称": "-",
    fans_count: "-162",
    fans_count_total: "51051",
    fans_tt_count: "58",
    fans_hs_count: 0,
    aweme_count: "63",
    aweme_like_count: "273",
    aweme_comment_count: "25",
    aweme_share_count: "13",
    aweme_play_count: "23759",
    aweme_activation: 0.9,
    live_count: "61",
    live_time: "3808",
    live_watch_count: 4730,
    live_watch_time: 5255,
    live_like_count: "86573",
    live_comment_count: "1927",
    live_activation: 0.8333,
    live_fans_add: "76",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "厦门亿海红祺",
    company_name: "厦门亿海红祺汽车服务有限公司",
    store_code: "SFJ604",
    大区: "华南区",
    "省份-城市": "福建省-厦门市",
    "所选分组编号/分组名称": "-",
    fans_count: "275",
    fans_count_total: "5603",
    fans_tt_count: "51",
    fans_hs_count: 0,
    aweme_count: "72",
    aweme_like_count: "800",
    aweme_comment_count: "115",
    aweme_share_count: "94",
    aweme_play_count: "391008",
    aweme_activation: 0.7,
    live_count: "81",
    live_time: "4865",
    live_watch_count: 156562,
    live_watch_time: 173957,
    live_like_count: "39006",
    live_comment_count: "1188",
    live_activation: 0.8667,
    live_fans_add: "149",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "德州润吉汽车",
    company_name: "德州润吉汽车销售服务有限公司",
    store_code: "NSD611",
    大区: "东北区",
    "省份-城市": "山东省-德州市",
    "所选分组编号/分组名称": "-",
    fans_count: "245",
    fans_count_total: "31998",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "56",
    aweme_like_count: "1954",
    aweme_comment_count: "308",
    aweme_share_count: "176",
    aweme_play_count: "546551",
    aweme_activation: 0.7,
    live_count: "62",
    live_time: "4133",
    live_watch_count: 56427,
    live_watch_time: 62696,
    live_like_count: "195295",
    live_comment_count: "4550",
    live_activation: 0.9667,
    live_fans_add: "328",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "陕西汉中天汉旗胜",
    company_name: "陕西汉中天汉旗胜",
    store_code: "XSS606",
    大区: "西部区",
    "省份-城市": "陕西省-汉中市",
    "所选分组编号/分组名称": "-",
    fans_count: "234",
    fans_count_total: "27482",
    fans_tt_count: "49",
    fans_hs_count: 0,
    aweme_count: "107",
    aweme_like_count: "1709",
    aweme_comment_count: "225",
    aweme_share_count: "146",
    aweme_play_count: "485136",
    aweme_activation: 0.9333,
    live_count: "110",
    live_time: "9345",
    live_watch_count: 25590,
    live_watch_time: 28433,
    live_like_count: "283644",
    live_comment_count: "4040",
    live_activation: 0.9667,
    live_fans_add: "133",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "泸州明云华盛红旗体验中心",
    company_name: "泸州明云华盛红旗体验中心",
    store_code: "WSC616",
    大区: "西部区",
    "省份-城市": "四川省-泸州市",
    "所选分组编号/分组名称": "-",
    fans_count: "564",
    fans_count_total: "25906",
    fans_tt_count: "32",
    fans_hs_count: "1",
    aweme_count: "56",
    aweme_like_count: "803",
    aweme_comment_count: "118",
    aweme_share_count: "5",
    aweme_play_count: "66645",
    aweme_activation: 0.9,
    live_count: "40",
    live_time: "2910",
    live_watch_count: 14993,
    live_watch_time: 16658,
    live_like_count: "230167",
    live_comment_count: "9999",
    live_activation: 0.7667,
    live_fans_add: "710",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "吉林长春神州红旗",
    company_name: "吉林省神州红旗汽车销售服务有限公司",
    store_code: "DJL606",
    大区: "东北区",
    "省份-城市": "吉林省-长春市",
    "所选分组编号/分组名称": "-",
    fans_count: "-571",
    fans_count_total: "376973",
    fans_tt_count: "1406",
    fans_hs_count: 0,
    aweme_count: "63",
    aweme_like_count: "1028",
    aweme_comment_count: "147",
    aweme_share_count: "111",
    aweme_play_count: "369380",
    aweme_activation: 0.6667,
    live_count: "141",
    live_time: "12978",
    live_watch_count: 37336,
    live_watch_time: 41484,
    live_like_count: "916202",
    live_comment_count: "5652",
    live_activation: 0.9667,
    live_fans_add: "325",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "广元峰帆红旗体验中心",
    company_name: "广元市峰帆汽车商贸有限公司",
    store_code: "WSC612",
    大区: "西部区",
    "省份-城市": "四川省-广元市",
    "所选分组编号/分组名称": "-",
    fans_count: "-4",
    fans_count_total: "49035",
    fans_tt_count: "229",
    fans_hs_count: 0,
    aweme_count: "38",
    aweme_like_count: "406",
    aweme_comment_count: "36",
    aweme_share_count: "24",
    aweme_play_count: "59009",
    aweme_activation: 0.9333,
    live_count: "25",
    live_time: "1604",
    live_watch_count: 3438,
    live_watch_time: 3820,
    live_like_count: "23757",
    live_comment_count: "967",
    live_activation: 0.7667,
    live_fans_add: "23",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "长春金山红旗",
    company_name: "长春金山红旗汽车销售服务有限公司",
    store_code: "DJL605",
    大区: "东北区",
    "省份-城市": "吉林省-长春市",
    "所选分组编号/分组名称": "-",
    fans_count: "990",
    fans_count_total: "17972",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "37",
    aweme_like_count: "1096",
    aweme_comment_count: "122",
    aweme_share_count: "73",
    aweme_play_count: "204044",
    aweme_activation: 0.5333,
    live_count: "55",
    live_time: "3953",
    live_watch_count: 56803,
    live_watch_time: 63114,
    live_like_count: "379919",
    live_comment_count: "10828",
    live_activation: 0.8,
    live_fans_add: "1031",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "自贡新成红兴",
    company_name: "自贡新成红兴汽车销售服务有限责任公司",
    store_code: "WSC614",
    大区: "西部区",
    "省份-城市": "四川省-自贡市",
    "所选分组编号/分组名称": "-",
    fans_count: "13",
    fans_count_total: "2702",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "6",
    aweme_like_count: "13",
    aweme_comment_count: "2",
    aweme_share_count: 0,
    aweme_play_count: "1026",
    aweme_activation: 0.2,
    live_count: "16",
    live_time: "951",
    live_watch_count: 1201,
    live_watch_time: 1334,
    live_like_count: "1593",
    live_comment_count: "392",
    live_activation: 0.5667,
    live_fans_add: "18",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "郑州吉展红旗",
    company_name: "郑州吉展汽车销售服务有限公司",
    store_code: "NYU610",
    大区: "华北区",
    "省份-城市": "河南省-郑州市",
    "所选分组编号/分组名称": "-",
    fans_count: "3622",
    fans_count_total: "119545",
    fans_tt_count: "2505",
    fans_hs_count: 0,
    aweme_count: "63",
    aweme_like_count: "1475",
    aweme_comment_count: "128",
    aweme_share_count: "163",
    aweme_play_count: "257327",
    aweme_activation: 0.6,
    live_count: "177",
    live_time: "12682",
    live_watch_count: 381127,
    live_watch_time: 423474,
    live_like_count: "60323",
    live_comment_count: "28069",
    live_activation: 0.9,
    live_fans_add: "5538",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "信阳天泓",
    company_name: "信阳天泓汽车销售服务有限公司",
    store_code: "NYU608",
    大区: "华北区",
    "省份-城市": "河南省-信阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "-702",
    fans_count_total: "241542",
    fans_tt_count: "8527",
    fans_hs_count: 0,
    aweme_count: "74",
    aweme_like_count: "3133",
    aweme_comment_count: "289",
    aweme_share_count: "124",
    aweme_play_count: "384873",
    aweme_activation: 0.8333,
    live_count: "41",
    live_time: "2486",
    live_watch_count: 49503,
    live_watch_time: 55003,
    live_like_count: "28627",
    live_comment_count: "4442",
    live_activation: 0.8667,
    live_fans_add: "355",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "青岛泰岳宏旗",
    company_name: "青岛泰岳宏旗",
    store_code: "NSD613",
    大区: "东北区",
    "省份-城市": "山东省-青岛市",
    "所选分组编号/分组名称": "-",
    fans_count: "-170",
    fans_count_total: "230695",
    fans_tt_count: "10140",
    fans_hs_count: 0,
    aweme_count: "94",
    aweme_like_count: "407",
    aweme_comment_count: "36",
    aweme_share_count: "60",
    aweme_play_count: "177562",
    aweme_activation: 0.3,
    live_count: "132",
    live_time: "7930",
    live_watch_count: 143658,
    live_watch_time: 159620,
    live_like_count: "51180",
    live_comment_count: "2375",
    live_activation: 0.9333,
    live_fans_add: "494",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "潍坊旗胜红旗4S店",
    company_name: "潍坊广潍旗胜汽车销售服务有限公司",
    store_code: "NSD614",
    大区: "东北区",
    "省份-城市": "山东省-潍坊市",
    "所选分组编号/分组名称": "-",
    fans_count: "-84",
    fans_count_total: "132775",
    fans_tt_count: "5246",
    fans_hs_count: 0,
    aweme_count: "16",
    aweme_like_count: "574",
    aweme_comment_count: "107",
    aweme_share_count: "51",
    aweme_play_count: "222553",
    aweme_activation: 0.2667,
    live_count: "62",
    live_time: "3753",
    live_watch_count: 55734,
    live_watch_time: 61926,
    live_like_count: "125638",
    live_comment_count: "4875",
    live_activation: 0.9,
    live_fans_add: "432",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "吉安凯迪红旗",
    company_name: "吉安市凯迪汽车销售服务有限公司",
    store_code: "CJX602",
    大区: "中南区",
    "省份-城市": "江西省-吉安市",
    "所选分组编号/分组名称": "-",
    fans_count: "241",
    fans_count_total: "19181",
    fans_tt_count: "44",
    fans_hs_count: 0,
    aweme_count: "61",
    aweme_like_count: "2864",
    aweme_comment_count: "575",
    aweme_share_count: "182",
    aweme_play_count: "235438",
    aweme_activation: 0.9667,
    live_count: "59",
    live_time: "4416",
    live_watch_count: 34021,
    live_watch_time: 37801,
    live_like_count: "289801",
    live_comment_count: "8449",
    live_activation: 0.9,
    live_fans_add: "245",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "湖州湖旗红旗",
    company_name: "湖州湖旗汽车有限公司",
    store_code: "EZJ615",
    大区: "华东区",
    "省份-城市": "浙江省-湖州市",
    "所选分组编号/分组名称": "-",
    fans_count: "201",
    fans_count_total: "5510",
    fans_tt_count: "36",
    fans_hs_count: 0,
    aweme_count: "70",
    aweme_like_count: "563",
    aweme_comment_count: "33",
    aweme_share_count: "79",
    aweme_play_count: "91838",
    aweme_activation: 0.8667,
    live_count: "67",
    live_time: "4075",
    live_watch_count: 113585,
    live_watch_time: 126205,
    live_like_count: "32543",
    live_comment_count: "1343",
    live_activation: 0.8667,
    live_fans_add: "141",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "沧州华泽红旗店",
    company_name: "沧州市华泽汽车贸易有限公司",
    store_code: "NJI604",
    大区: "华北区",
    "省份-城市": "河北省-沧州市",
    "所选分组编号/分组名称": "-",
    fans_count: "633",
    fans_count_total: "7464",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "49",
    aweme_like_count: "445",
    aweme_comment_count: "28",
    aweme_share_count: "41",
    aweme_play_count: "250021",
    aweme_activation: 0.6333,
    live_count: "59",
    live_time: "3794",
    live_watch_count: 259788,
    live_watch_time: 288653,
    live_like_count: "120480",
    live_comment_count: "5298",
    live_activation: 0.7333,
    live_fans_add: "539",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "潍坊泰岳红旗4S店",
    company_name: "潍坊泰岳宏旗汽车销售服务有限公司",
    store_code: "NSD617",
    大区: "东北区",
    "省份-城市": "山东省-潍坊市",
    "所选分组编号/分组名称": "-",
    fans_count: "-240",
    fans_count_total: "167948",
    fans_tt_count: "11958",
    fans_hs_count: 0,
    aweme_count: "45",
    aweme_like_count: "1104",
    aweme_comment_count: "164",
    aweme_share_count: "90",
    aweme_play_count: "694677",
    aweme_activation: 0.8333,
    live_count: "33",
    live_time: "1852",
    live_watch_count: 89774,
    live_watch_time: 99748,
    live_like_count: "50491",
    live_comment_count: "2308",
    live_activation: 0.8333,
    live_fans_add: "109",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "广东容大红旗体验中心",
    company_name: "广东容大星旗汽车有限公司",
    store_code: "SGD614",
    大区: "华南区",
    "省份-城市": "广东省-揭阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "49",
    fans_count_total: "7860",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "19",
    aweme_like_count: "150",
    aweme_comment_count: "10",
    aweme_share_count: "15",
    aweme_play_count: "13376",
    aweme_activation: 0.5,
    live_count: "30",
    live_time: "1784",
    live_watch_count: 8010,
    live_watch_time: 8900,
    live_like_count: "161355",
    live_comment_count: "4293",
    live_activation: 0.5667,
    live_fans_add: "120",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "两江璐菲红旗",
    company_name: "重庆两江璐菲汽车销售服务有限公司",
    store_code: "WCQ602",
    大区: "西部区",
    "省份-城市": "重庆市-重庆市",
    "所选分组编号/分组名称": "-",
    fans_count: "-8",
    fans_count_total: "3025",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "10",
    aweme_like_count: "38",
    aweme_comment_count: 0,
    aweme_share_count: 0,
    aweme_play_count: "2231",
    aweme_activation: 0.3333,
    live_count: "12",
    live_time: "769",
    live_watch_count: 688,
    live_watch_time: 764,
    live_like_count: "6728",
    live_comment_count: "550",
    live_activation: 0.3667,
    live_fans_add: "16",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "珠海中升红旗",
    company_name: "珠海市中升汽车销售服务有限公司",
    store_code: "SGD611",
    大区: "华南区",
    "省份-城市": "广东省-珠海市",
    "所选分组编号/分组名称": "-",
    fans_count: "-98",
    fans_count_total: "30666",
    fans_tt_count: "822",
    fans_hs_count: 0,
    aweme_count: "26",
    aweme_like_count: "244",
    aweme_comment_count: "29",
    aweme_share_count: "11",
    aweme_play_count: "12542",
    aweme_activation: 0.8,
    live_count: "55",
    live_time: "3428",
    live_watch_count: 7952,
    live_watch_time: 8835,
    live_like_count: "65796",
    live_comment_count: "4102",
    live_activation: 0.9,
    live_fans_add: "44",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "衢州君悦宏旗",
    company_name: "衢州君悦宏旗",
    store_code: "EZJ612",
    大区: "华东区",
    "省份-城市": "浙江省-衢州市",
    "所选分组编号/分组名称": "-",
    fans_count: "219",
    fans_count_total: "4175",
    fans_tt_count: "48",
    fans_hs_count: 0,
    aweme_count: "59",
    aweme_like_count: "948",
    aweme_comment_count: "62",
    aweme_share_count: "80",
    aweme_play_count: "291130",
    aweme_activation: 1,
    live_count: "60",
    live_time: "3709",
    live_watch_count: 1980,
    live_watch_time: 2200,
    live_like_count: "41658",
    live_comment_count: "2547",
    live_activation: 0.9333,
    live_fans_add: "9",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "贵州铜仁市星尊程鑫航",
    company_name: "贵州铜仁市星尊程鑫航汽车销售服务有限公司",
    store_code: "WGZ605",
    大区: "西部区",
    "省份-城市": "贵州省-铜仁市",
    "所选分组编号/分组名称": "-",
    fans_count: "13",
    fans_count_total: "6205",
    fans_tt_count: "121",
    fans_hs_count: 0,
    aweme_count: "61",
    aweme_like_count: "421",
    aweme_comment_count: "21",
    aweme_share_count: "3",
    aweme_play_count: "16632",
    aweme_activation: 1,
    live_count: "74",
    live_time: "4464",
    live_watch_count: 5401,
    live_watch_time: 6001,
    live_like_count: "106904",
    live_comment_count: "1711",
    live_activation: 0.9,
    live_fans_add: "40",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "南京大道",
    company_name: "南京大道汽车销售服务有限公司",
    store_code: "EJS610",
    大区: "华东区",
    "省份-城市": "江苏省-南京市",
    "所选分组编号/分组名称": "-",
    fans_count: "225",
    fans_count_total: "91755",
    fans_tt_count: "2822",
    fans_hs_count: 0,
    aweme_count: "106",
    aweme_like_count: "765",
    aweme_comment_count: "107",
    aweme_share_count: "161",
    aweme_play_count: "229086",
    aweme_activation: 0.8333,
    live_count: "33",
    live_time: "1968",
    live_watch_count: 106538,
    live_watch_time: 118375,
    live_like_count: "13839",
    live_comment_count: "9025",
    live_activation: 0.6667,
    live_fans_add: "713",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "郑州泰岳宏旗",
    company_name: "郑州泰岳宏旗汽车销售服务有限公司",
    store_code: "NYU611",
    大区: "华北区",
    "省份-城市": "河南省-郑州市",
    "所选分组编号/分组名称": "-",
    fans_count: "592",
    fans_count_total: "110212",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "101",
    aweme_like_count: "1063",
    aweme_comment_count: "139",
    aweme_share_count: "121",
    aweme_play_count: "421750",
    aweme_activation: 0.7667,
    live_count: "101",
    live_time: "6144",
    live_watch_count: 85917,
    live_watch_time: 95463,
    live_like_count: "44180",
    live_comment_count: "12308",
    live_activation: 0.7667,
    live_fans_add: "1945",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "洛阳随诺",
    company_name: "洛阳随诺",
    store_code: "NYU609",
    大区: "华北区",
    "省份-城市": "河南省-洛阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "-17",
    fans_count_total: "49049",
    fans_tt_count: "865",
    fans_hs_count: 0,
    aweme_count: "87",
    aweme_like_count: "1152",
    aweme_comment_count: "68",
    aweme_share_count: "177",
    aweme_play_count: "521574",
    aweme_activation: 0.9667,
    live_count: "112",
    live_time: "9486",
    live_watch_count: 17750,
    live_watch_time: 19722,
    live_like_count: "25142",
    live_comment_count: "1785",
    live_activation: 0.9333,
    live_fans_add: "113",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "濮阳德源红旗体验中心",
    company_name: "濮阳德源红旗体验中心",
    store_code: "NYU613",
    大区: "华北区",
    "省份-城市": "河南省-濮阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "176",
    fans_count_total: "48841",
    fans_tt_count: "29",
    fans_hs_count: 0,
    aweme_count: "33",
    aweme_like_count: "594",
    aweme_comment_count: "65",
    aweme_share_count: "12",
    aweme_play_count: "49598",
    aweme_activation: 0.9333,
    live_count: "45",
    live_time: "2959",
    live_watch_count: 210314,
    live_watch_time: 233682,
    live_like_count: "93271",
    live_comment_count: "5527",
    live_activation: 0.6667,
    live_fans_add: "818",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "晋城中一",
    company_name: "晋城中一汽车有限公司",
    store_code: "NJN607",
    大区: "华北区",
    "省份-城市": "山西省-晋城市",
    "所选分组编号/分组名称": "-",
    fans_count: "189",
    fans_count_total: "26807",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "62",
    aweme_like_count: "650",
    aweme_comment_count: "38",
    aweme_share_count: "91",
    aweme_play_count: "78009",
    aweme_activation: 1,
    live_count: "41",
    live_time: "2555",
    live_watch_count: 4550,
    live_watch_time: 5055,
    live_like_count: "64158",
    live_comment_count: "1579",
    live_activation: 0.8333,
    live_fans_add: "48",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "六安之道红旗",
    company_name: "六安之道汽车销售服务有限公司",
    store_code: "EAH607",
    大区: "华东区",
    "省份-城市": "安徽省-六安市",
    "所选分组编号/分组名称": "-",
    fans_count: "-970",
    fans_count_total: "212656",
    fans_tt_count: "306",
    fans_hs_count: 0,
    aweme_count: "107",
    aweme_like_count: "1008",
    aweme_comment_count: "162",
    aweme_share_count: "36",
    aweme_play_count: "80702",
    aweme_activation: 0.8,
    live_count: "50",
    live_time: "3189",
    live_watch_count: 24046,
    live_watch_time: 26717,
    live_like_count: "136888",
    live_comment_count: "2100",
    live_activation: 0.8333,
    live_fans_add: "58",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "南阳宛骏",
    company_name: "南阳宛骏",
    store_code: "CHN605",
    大区: "华北区",
    "省份-城市": "河南省-南阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "1220",
    fans_count_total: "18094",
    fans_tt_count: "3",
    fans_hs_count: 0,
    aweme_count: "80",
    aweme_like_count: "617",
    aweme_comment_count: "81",
    aweme_share_count: "19",
    aweme_play_count: "25158",
    aweme_activation: 1,
    live_count: "90",
    live_time: "5884",
    live_watch_count: 11027,
    live_watch_time: 12252,
    live_like_count: "138457",
    live_comment_count: "4108",
    live_activation: 0.9,
    live_fans_add: "95",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "大汉集团红旗体验中心",
    company_name: "长沙美捷汽车贸易有限公司",
    store_code: "CHN606",
    大区: "中南区",
    "省份-城市": "湖南省-长沙市",
    "所选分组编号/分组名称": "-",
    fans_count: "-279",
    fans_count_total: "201345",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "45",
    aweme_like_count: "230",
    aweme_comment_count: "14",
    aweme_share_count: "25",
    aweme_play_count: "39022",
    aweme_activation: 0.8667,
    live_count: "80",
    live_time: "8052",
    live_watch_count: 6255,
    live_watch_time: 6950,
    live_like_count: "9563",
    live_comment_count: "699",
    live_activation: 0.8667,
    live_fans_add: "33",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "北京泰岳金港红旗体验中心",
    company_name: "北京泰岳宏旗汽车销售服务有限公司",
    store_code: "NBJ605",
    大区: "华北区",
    "省份-城市": "北京市-北京市",
    "所选分组编号/分组名称": "-",
    fans_count: "55",
    fans_count_total: "43928",
    fans_tt_count: "13795",
    fans_hs_count: 0,
    aweme_count: "96",
    aweme_like_count: "782",
    aweme_comment_count: "86",
    aweme_share_count: "39",
    aweme_play_count: "180430",
    aweme_activation: 1,
    live_count: "98",
    live_time: "6029",
    live_watch_count: 3198,
    live_watch_time: 3553,
    live_like_count: "14129",
    live_comment_count: "2908",
    live_activation: 0.9667,
    live_fans_add: "31",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "桂林弘帆红旗体验中心",
    company_name: "桂林弘帆桂仕汽车销售服务有限公司",
    store_code: "SGX603",
    大区: "华南区",
    "省份-城市": "广西壮族自治区-桂林市",
    "所选分组编号/分组名称": "-",
    fans_count: "-12",
    fans_count_total: "1512",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "51",
    aweme_like_count: "305",
    aweme_comment_count: "27",
    aweme_share_count: "1",
    aweme_play_count: "8989",
    aweme_activation: 0.8333,
    live_count: "51",
    live_time: "3107",
    live_watch_count: 8205,
    live_watch_time: 9116,
    live_like_count: "66854",
    live_comment_count: "995",
    live_activation: 0.8667,
    live_fans_add: "12",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "阜阳博融亚之旗",
    company_name: "阜阳博融亚之旗汽车销售服务有限公司",
    store_code: "EAH606",
    大区: "华东区",
    "省份-城市": "安徽省-阜阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "229",
    fans_count_total: "314831",
    fans_tt_count: "7213",
    fans_hs_count: 0,
    aweme_count: "74",
    aweme_like_count: "439",
    aweme_comment_count: "40",
    aweme_share_count: "39",
    aweme_play_count: "72649",
    aweme_activation: 0.7667,
    live_count: "82",
    live_time: "5013",
    live_watch_count: 69799,
    live_watch_time: 77554,
    live_like_count: "36735",
    live_comment_count: "8870",
    live_activation: 0.8333,
    live_fans_add: "1718",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "成都东创国城红旗",
    company_name: "成都东创国城实业有限公司",
    store_code: "WSC615",
    大区: "西部区",
    "省份-城市": "四川省-成都市",
    "所选分组编号/分组名称": "-",
    fans_count: "823",
    fans_count_total: "68874",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "49",
    aweme_like_count: "1473",
    aweme_comment_count: "1708",
    aweme_share_count: "59",
    aweme_play_count: "75846",
    aweme_activation: 1,
    live_count: "49",
    live_time: "3088",
    live_watch_count: 92710,
    live_watch_time: 103011,
    live_like_count: "282513",
    live_comment_count: "46139",
    live_activation: 0.7667,
    live_fans_add: "1295",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "南通百弘红旗",
    company_name: "南通百弘红旗",
    store_code: "EJS611",
    大区: "华东区",
    "省份-城市": "江苏省-南通市",
    "所选分组编号/分组名称": "-",
    fans_count: "22",
    fans_count_total: "23599",
    fans_tt_count: "2904",
    fans_hs_count: 0,
    aweme_count: "29",
    aweme_like_count: "185",
    aweme_comment_count: "24",
    aweme_share_count: "24",
    aweme_play_count: "77565",
    aweme_activation: 0.7333,
    live_count: "31",
    live_time: "1927",
    live_watch_count: 3093,
    live_watch_time: 3436,
    live_like_count: "31514",
    live_comment_count: "1066",
    live_activation: 0.6667,
    live_fans_add: "45",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "嘉兴禾旗",
    company_name: "嘉兴禾旗汽车销售服务有限公司",
    store_code: "EZJ616",
    大区: "华东区",
    "省份-城市": "浙江省-嘉兴市",
    "所选分组编号/分组名称": "-",
    fans_count: "302",
    fans_count_total: "18557",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "60",
    aweme_like_count: "644",
    aweme_comment_count: "261",
    aweme_share_count: "70",
    aweme_play_count: "376031",
    aweme_activation: 0.8,
    live_count: "35",
    live_time: "2181",
    live_watch_count: 26099,
    live_watch_time: 28998,
    live_like_count: "2509",
    live_comment_count: "1563",
    live_activation: 0.7667,
    live_fans_add: "199",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "新乡盛世红旗体验中心",
    company_name: "新乡市盛世汽车销售服务有限公司",
    store_code: "NYU615",
    大区: "华北区",
    "省份-城市": "河南省-新乡市",
    "所选分组编号/分组名称": "-",
    fans_count: "-1127",
    fans_count_total: "269243",
    fans_tt_count: "25882",
    fans_hs_count: 0,
    aweme_count: "26",
    aweme_like_count: "686",
    aweme_comment_count: "16",
    aweme_share_count: "57",
    aweme_play_count: "349745",
    aweme_activation: 0.7,
    live_count: "62",
    live_time: "3799",
    live_watch_count: 19068,
    live_watch_time: 21186,
    live_like_count: "23478",
    live_comment_count: "3963",
    live_activation: 0.8667,
    live_fans_add: "164",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "浙江金华裕旗",
    company_name: "浙江金华裕旗汽车有限公司",
    store_code: "EZJ613",
    大区: "华东区",
    "省份-城市": "浙江省-金华市",
    "所选分组编号/分组名称": "-",
    fans_count: "289",
    fans_count_total: "7938",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "102",
    aweme_like_count: "359",
    aweme_comment_count: "41",
    aweme_share_count: "17",
    aweme_play_count: "32259",
    aweme_activation: 0.9667,
    live_count: "57",
    live_time: "4141",
    live_watch_count: 33521,
    live_watch_time: 37245,
    live_like_count: "6968",
    live_comment_count: "4492",
    live_activation: 0.8667,
    live_fans_add: "188",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "青岛欣盛红旗中心店",
    company_name: "青岛欣盛汽车销售有限公司",
    store_code: "NSD615",
    大区: "东北区",
    "省份-城市": "山东省-青岛市",
    "所选分组编号/分组名称": "-",
    fans_count: "345",
    fans_count_total: "40708",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "32",
    aweme_like_count: "534",
    aweme_comment_count: "63",
    aweme_share_count: "33",
    aweme_play_count: "210461",
    aweme_activation: 0.5667,
    live_count: "43",
    live_time: "2703",
    live_watch_count: 29160,
    live_watch_time: 32400,
    live_like_count: "19806",
    live_comment_count: "2320",
    live_activation: 0.8667,
    live_fans_add: "229",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "东营鑫红红旗体验中心",
    company_name: "东营鑫红汽车销售服务有限公司",
    store_code: "NSD612",
    大区: "东北区",
    "省份-城市": "山东省-东营市",
    "所选分组编号/分组名称": "-",
    fans_count: "207",
    fans_count_total: "9331",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "124",
    aweme_like_count: "1409",
    aweme_comment_count: "234",
    aweme_share_count: "126",
    aweme_play_count: "245314",
    aweme_activation: 0.9667,
    live_count: "66",
    live_time: "4221",
    live_watch_count: 15547,
    live_watch_time: 17274,
    live_like_count: "152391",
    live_comment_count: "3903",
    live_activation: 0.8667,
    live_fans_add: "146",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "瑞安宝合",
    company_name: "瑞安市宝合汽车销售有限公司",
    store_code: "EZJ614",
    大区: "华东区",
    "省份-城市": "浙江省-温州市",
    "所选分组编号/分组名称": "-",
    fans_count: "1365",
    fans_count_total: "53517",
    fans_tt_count: "497",
    fans_hs_count: 0,
    aweme_count: "296",
    aweme_like_count: "3850",
    aweme_comment_count: "791",
    aweme_share_count: "456",
    aweme_play_count: "2714491",
    aweme_activation: 1,
    live_count: "192",
    live_time: "15029",
    live_watch_count: 99989,
    live_watch_time: 111098,
    live_like_count: "104828",
    live_comment_count: "9345",
    live_activation: 1,
    live_fans_add: "1093",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "贵州安晟",
    company_name: "贵州安晟汽车销售服务有限公司",
    store_code: "WGZ606",
    大区: "西部区",
    "省份-城市": "贵州省-安顺市",
    "所选分组编号/分组名称": "-",
    fans_count: "200",
    fans_count_total: "13226",
    fans_tt_count: "6559",
    fans_hs_count: 0,
    aweme_count: "35",
    aweme_like_count: "805",
    aweme_comment_count: "288",
    aweme_share_count: "40",
    aweme_play_count: "295815",
    aweme_activation: 1,
    live_count: "36",
    live_time: "2148",
    live_watch_count: 1838,
    live_watch_time: 2042,
    live_like_count: "5445",
    live_comment_count: "1175",
    live_activation: 0.8333,
    live_fans_add: "15",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "安阳世祥红旗体验中心",
    company_name: "安阳世祥汽车销售服务有限公司",
    store_code: "NYU616",
    大区: "华北区",
    "省份-城市": "河南省-安阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "23",
    fans_count_total: "14481",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "29",
    aweme_like_count: "270",
    aweme_comment_count: "40",
    aweme_share_count: "26",
    aweme_play_count: "71440",
    aweme_activation: 0.4333,
    live_count: "13",
    live_time: "793",
    live_watch_count: 592,
    live_watch_time: 657,
    live_like_count: "15882",
    live_comment_count: "514",
    live_activation: 0.5,
    live_fans_add: "10",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "泰州海沃",
    company_name: "泰州海沃汽车销售服务有限公司",
    store_code: "EJS612",
    大区: "华东区",
    "省份-城市": "江苏省-泰州市",
    "所选分组编号/分组名称": "-",
    fans_count: "-11",
    fans_count_total: "4235",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "61",
    aweme_like_count: "224",
    aweme_comment_count: "43",
    aweme_share_count: "7",
    aweme_play_count: "14543",
    aweme_activation: 0.8,
    live_count: "40",
    live_time: "2396",
    live_watch_count: 2225,
    live_watch_time: 2472,
    live_like_count: "32835",
    live_comment_count: "1926",
    live_activation: 0.6333,
    live_fans_add: "35",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "红河海伟宏亦红旗体验中心",
    company_name: "红河海伟宏亦红旗体验中心",
    store_code: "WYN606",
    大区: "西部区",
    "省份-城市": "云南省-红河哈尼族彝族自治州",
    "所选分组编号/分组名称": "-",
    fans_count: "-2102",
    fans_count_total: "28829",
    fans_tt_count: "102",
    fans_hs_count: 0,
    aweme_count: "51",
    aweme_like_count: "431",
    aweme_comment_count: "61",
    aweme_share_count: "17",
    aweme_play_count: "45075",
    aweme_activation: 0.8333,
    live_count: "45",
    live_time: "3021",
    live_watch_count: 4455,
    live_watch_time: 4950,
    live_like_count: "79743",
    live_comment_count: "738",
    live_activation: 0.7667,
    live_fans_add: "12",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "晋江同行红旗体验中心",
    company_name: "晋江同行红旗体验中心",
    store_code: "SFJ605",
    大区: "华南区",
    "省份-城市": "福建省-泉州市",
    "所选分组编号/分组名称": "-",
    fans_count: "-100",
    fans_count_total: "103588",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "43",
    aweme_like_count: "2620",
    aweme_comment_count: "810",
    aweme_share_count: "236",
    aweme_play_count: "559476",
    aweme_activation: 0.7667,
    live_count: "103",
    live_time: "8134",
    live_watch_count: 592717,
    live_watch_time: 658574,
    live_like_count: "636270",
    live_comment_count: "63775",
    live_activation: 0.9333,
    live_fans_add: "2085",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "贵阳冉丰",
    company_name: "贵阳冉丰汽车服务有限公司",
    store_code: "WGZ607",
    大区: "西部区",
    "省份-城市": "贵州省-贵阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "36",
    fans_count_total: "17198",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "16",
    aweme_like_count: "738",
    aweme_comment_count: "54",
    aweme_share_count: "8",
    aweme_play_count: "60732",
    aweme_activation: 0.6333,
    live_count: "33",
    live_time: "1857",
    live_watch_count: 101624,
    live_watch_time: 112915,
    live_like_count: "51992",
    live_comment_count: "2638",
    live_activation: 0.8,
    live_fans_add: "155",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "娄底宝盛",
    company_name: "娄底市宝盛汽车销售服务有限公司",
    store_code: "CHN608",
    大区: "中南区",
    "省份-城市": "湖南省-娄底市",
    "所选分组编号/分组名称": "-",
    fans_count: "161",
    fans_count_total: "7355",
    fans_tt_count: "3",
    fans_hs_count: 0,
    aweme_count: "73",
    aweme_like_count: "718",
    aweme_comment_count: "92",
    aweme_share_count: "36",
    aweme_play_count: "87062",
    aweme_activation: 1,
    live_count: "49",
    live_time: "3401",
    live_watch_count: 3961,
    live_watch_time: 4401,
    live_like_count: "93601",
    live_comment_count: "4455",
    live_activation: 0.9333,
    live_fans_add: "49",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "九江华宏一汽红旗",
    company_name: "九江华宏昇汽车有限公司",
    store_code: "CJX605",
    大区: "中南区",
    "省份-城市": "江西省-九江市",
    "所选分组编号/分组名称": "-",
    fans_count: "168",
    fans_count_total: "14358",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "83",
    aweme_like_count: "1048",
    aweme_comment_count: "81",
    aweme_share_count: "122",
    aweme_play_count: "348250",
    aweme_activation: 0.8667,
    live_count: "55",
    live_time: "3491",
    live_watch_count: 113285,
    live_watch_time: 125872,
    live_like_count: "17951",
    live_comment_count: "578",
    live_activation: 0.8667,
    live_fans_add: "89",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "泰安利华晟旗悦",
    company_name: "泰安利华晟旗悦汽车销售服务有限公司",
    store_code: "NSD619",
    大区: "东北区",
    "省份-城市": "山东省-泰安市",
    "所选分组编号/分组名称": "-",
    fans_count: "465",
    fans_count_total: "14445",
    fans_tt_count: "230",
    fans_hs_count: 0,
    aweme_count: "84",
    aweme_like_count: "1185",
    aweme_comment_count: "118",
    aweme_share_count: "170",
    aweme_play_count: "556318",
    aweme_activation: 1,
    live_count: "51",
    live_time: "3258",
    live_watch_count: 45168,
    live_watch_time: 50186,
    live_like_count: "7318",
    live_comment_count: "2963",
    live_activation: 0.8667,
    live_fans_add: "148",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "周口昱旗红旗4S店",
    company_name: "周口市昱旗汽车销售有限公司",
    store_code: "NYU612",
    大区: "华北区",
    "省份-城市": "河南省-周口市",
    "所选分组编号/分组名称": "-",
    fans_count: "45",
    fans_count_total: "13386",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "40",
    aweme_like_count: "141",
    aweme_comment_count: "39",
    aweme_share_count: "21",
    aweme_play_count: "16631",
    aweme_activation: 0.9333,
    live_count: "128",
    live_time: "9937",
    live_watch_count: 12991,
    live_watch_time: 14434,
    live_like_count: "7648",
    live_comment_count: "4535",
    live_activation: 0.9,
    live_fans_add: "348",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "红旗体验中心抚州龙旗店",
    company_name: "抚州市龙旗汽车销售有限公司",
    store_code: "CJX603",
    大区: "中南区",
    "省份-城市": "江西省-抚州市",
    "所选分组编号/分组名称": "-",
    fans_count: "-589",
    fans_count_total: "27342",
    fans_tt_count: "674",
    fans_hs_count: 0,
    aweme_count: "24",
    aweme_like_count: "285",
    aweme_comment_count: "76",
    aweme_share_count: "24",
    aweme_play_count: "20291",
    aweme_activation: 0.7333,
    live_count: "60",
    live_time: "3479",
    live_watch_count: 19677,
    live_watch_time: 21863,
    live_like_count: "80416",
    live_comment_count: "6271",
    live_activation: 0.8333,
    live_fans_add: "131",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "邵阳旗乐",
    company_name: "邵阳旗乐汽车销售服务有限公司",
    store_code: "CHN607",
    大区: "中南区",
    "省份-城市": "湖南省-邵阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "459",
    fans_count_total: "8908",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "407",
    aweme_like_count: "1289",
    aweme_comment_count: "100",
    aweme_share_count: "82",
    aweme_play_count: "271615",
    aweme_activation: 0.5667,
    live_count: "26",
    live_time: "1498",
    live_watch_count: 54808,
    live_watch_time: 60897,
    live_like_count: "156678",
    live_comment_count: "3405",
    live_activation: 0.7,
    live_fans_add: "268",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "玉溪国臻红旗体验中心",
    company_name: "玉溪国臻汽车销售服务有限公司",
    store_code: "WYN607",
    大区: "西部区",
    "省份-城市": "云南省-玉溪市",
    "所选分组编号/分组名称": "-",
    fans_count: "19",
    fans_count_total: "4882",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "32",
    aweme_like_count: "537",
    aweme_comment_count: "92",
    aweme_share_count: "73",
    aweme_play_count: "134616",
    aweme_activation: 0.9,
    live_count: "45",
    live_time: "2746",
    live_watch_count: 2763,
    live_watch_time: 3070,
    live_like_count: "74554",
    live_comment_count: "862",
    live_activation: 0.8,
    live_fans_add: "13",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "苏州华朔红旗体验中心",
    company_name: "苏州华朔汽车销售服务有限公司",
    store_code: "EJS613",
    大区: "华东区",
    "省份-城市": "江苏省-苏州市",
    "所选分组编号/分组名称": "-",
    fans_count: "737",
    fans_count_total: "12947",
    fans_tt_count: "39",
    fans_hs_count: 0,
    aweme_count: "39",
    aweme_like_count: "501",
    aweme_comment_count: "42",
    aweme_share_count: "52",
    aweme_play_count: "141863",
    aweme_activation: 0.5,
    live_count: "89",
    live_time: "11016",
    live_watch_count: 60082,
    live_watch_time: 66757,
    live_like_count: "51007",
    live_comment_count: "17889",
    live_activation: 0.8667,
    live_fans_add: "961",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "孝感祥沃红旗体验中心",
    company_name: "孝感祥沃汽车销售服务有限公司",
    store_code: "CHB606",
    大区: "中南区",
    "省份-城市": "湖北省-孝感市",
    "所选分组编号/分组名称": "-",
    fans_count: "-12",
    fans_count_total: "5624",
    fans_tt_count: "41",
    fans_hs_count: 0,
    aweme_count: "27",
    aweme_like_count: "167",
    aweme_comment_count: "22",
    aweme_share_count: "18",
    aweme_play_count: "10779",
    aweme_activation: 0.8,
    live_count: "30",
    live_time: "1891",
    live_watch_count: 2006,
    live_watch_time: 2228,
    live_like_count: "59476",
    live_comment_count: "2109",
    live_activation: 0.8667,
    live_fans_add: "12",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "西昌璞瑞一汽红旗店",
    company_name: "西昌璞瑞汽车销售服务有限责任公司",
    store_code: "WSC617",
    大区: "西部区",
    "省份-城市": "四川省-凉山彝族自治州",
    "所选分组编号/分组名称": "-",
    fans_count: "80",
    fans_count_total: "9080",
    fans_tt_count: "39",
    fans_hs_count: 0,
    aweme_count: "20",
    aweme_like_count: "691",
    aweme_comment_count: "79",
    aweme_share_count: "23",
    aweme_play_count: "296539",
    aweme_activation: 0.6333,
    live_count: "36",
    live_time: "2681",
    live_watch_count: 2413,
    live_watch_time: 2681,
    live_like_count: "25225",
    live_comment_count: "783",
    live_activation: 0.8667,
    live_fans_add: "14",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "扬州广成扬旗",
    company_name: "扬州广成扬旗汽车有限公司",
    store_code: "EJS614",
    大区: "华东区",
    "省份-城市": "江苏省-扬州市",
    "所选分组编号/分组名称": "-",
    fans_count: "269",
    fans_count_total: "5438",
    fans_tt_count: "835",
    fans_hs_count: 0,
    aweme_count: "70",
    aweme_like_count: "706",
    aweme_comment_count: "118",
    aweme_share_count: "99",
    aweme_play_count: "181633",
    aweme_activation: 0.6,
    live_count: "67",
    live_time: "4165",
    live_watch_count: 117725,
    live_watch_time: 130805,
    live_like_count: "84554",
    live_comment_count: "2327",
    live_activation: 0.9,
    live_fans_add: "173",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "上海岳宏泰红旗",
    company_name: "上海岳宏泰红旗",
    store_code: "ESH610",
    大区: "华东区",
    "省份-城市": "上海市-上海市",
    "所选分组编号/分组名称": "-",
    fans_count: "194",
    fans_count_total: "70201",
    fans_tt_count: "622",
    fans_hs_count: 0,
    aweme_count: "68",
    aweme_like_count: "849",
    aweme_comment_count: "330",
    aweme_share_count: "37",
    aweme_play_count: "162296",
    aweme_activation: 0.9333,
    live_count: "61",
    live_time: "4400",
    live_watch_count: 157023,
    live_watch_time: 174470,
    live_like_count: "517050",
    live_comment_count: "26305",
    live_activation: 0.8,
    live_fans_add: "391",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "平顶山盛大红旗体验中心",
    company_name: "平顶山市盛大汽车销售服务有限公司",
    store_code: "NYU617",
    大区: "华北区",
    "省份-城市": "河南省-平顶山市",
    "所选分组编号/分组名称": "-",
    fans_count: "-342",
    fans_count_total: "62860",
    fans_tt_count: "9164",
    fans_hs_count: 0,
    aweme_count: "36",
    aweme_like_count: "102",
    aweme_comment_count: "10",
    aweme_share_count: "5",
    aweme_play_count: "13112",
    aweme_activation: 0.7667,
    live_count: "58",
    live_time: "3734",
    live_watch_count: 5071,
    live_watch_time: 5634,
    live_like_count: "28322",
    live_comment_count: "1327",
    live_activation: 0.8,
    live_fans_add: "39",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "唐山岳泰宏旗",
    company_name: "唐山岳泰宏旗汽车销售服务有限公司",
    store_code: "NJI605",
    大区: "华北区",
    "省份-城市": "河北省-唐山市",
    "所选分组编号/分组名称": "-",
    fans_count: "539",
    fans_count_total: "43563",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "107",
    aweme_like_count: "1727",
    aweme_comment_count: "110",
    aweme_share_count: "164",
    aweme_play_count: "459423",
    aweme_activation: 1,
    live_count: "64",
    live_time: "3976",
    live_watch_count: 107957,
    live_watch_time: 119952,
    live_like_count: "691263",
    live_comment_count: "35456",
    live_activation: 0.8667,
    live_fans_add: "749",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "凯里凯通",
    company_name: "凯里市凯通汽车贸易有限公司",
    store_code: "WGZ610",
    大区: "西部区",
    "省份-城市": "贵州省-黔东南苗族侗族自治州",
    "所选分组编号/分组名称": "-",
    fans_count: "198",
    fans_count_total: "2015",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "33",
    aweme_like_count: "201",
    aweme_comment_count: "13",
    aweme_share_count: "7",
    aweme_play_count: "18438",
    aweme_activation: 0.8667,
    live_count: "47",
    live_time: "3311",
    live_watch_count: 112628,
    live_watch_time: 125142,
    live_like_count: "59872",
    live_comment_count: "1969",
    live_activation: 0.8667,
    live_fans_add: "190",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "常德时茂红旗",
    company_name: "常德时茂汽车销售服务有限公司",
    store_code: "CHN610",
    大区: "中南区",
    "省份-城市": "湖南省-常德市",
    "所选分组编号/分组名称": "-",
    fans_count: "-28",
    fans_count_total: "5614",
    fans_tt_count: "51",
    fans_hs_count: 0,
    aweme_count: "19",
    aweme_like_count: "64",
    aweme_comment_count: "6",
    aweme_share_count: 0,
    aweme_play_count: "4385",
    aweme_activation: 0.6,
    live_count: "14",
    live_time: "947",
    live_watch_count: 397,
    live_watch_time: 441,
    live_like_count: "268",
    live_comment_count: "28",
    live_activation: 0.5,
    live_fans_add: "1",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "十堰亨运红晟",
    company_name: "十堰亨运红晟汽车销售服务有限公司",
    store_code: "CHB609",
    大区: "中南区",
    "省份-城市": "湖北省-十堰市",
    "所选分组编号/分组名称": "-",
    fans_count: "44",
    fans_count_total: "3765",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "45",
    aweme_like_count: "511",
    aweme_comment_count: "47",
    aweme_share_count: "22",
    aweme_play_count: "133878",
    aweme_activation: 0.9,
    live_count: "44",
    live_time: "2706",
    live_watch_count: 3562,
    live_watch_time: 3957,
    live_like_count: "48357",
    live_comment_count: "3730",
    live_activation: 0.8667,
    live_fans_add: "34",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "南昌美乘红旗体验中心",
    company_name: "南昌美乘红旗体验中心",
    store_code: "CJX604",
    大区: "中南区",
    "省份-城市": "江西省-南昌市",
    "所选分组编号/分组名称": "-",
    fans_count: "-135",
    fans_count_total: "123574",
    fans_tt_count: "55",
    fans_hs_count: 0,
    aweme_count: "40",
    aweme_like_count: "1086",
    aweme_comment_count: "244",
    aweme_share_count: "305",
    aweme_play_count: "584899",
    aweme_activation: 0.9333,
    live_count: "41",
    live_time: "3440",
    live_watch_count: 559603,
    live_watch_time: 621781,
    live_like_count: "301115",
    live_comment_count: "8989",
    live_activation: 0.8,
    live_fans_add: "850",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "普洱海伟宏亦红旗体验中心",
    company_name: "普洱海伟宏亦汽车销售有限公司",
    store_code: "WYN608",
    大区: "西部区",
    "省份-城市": "云南省-普洱市",
    "所选分组编号/分组名称": "-",
    fans_count: "-10",
    fans_count_total: "12322",
    fans_tt_count: "455",
    fans_hs_count: 0,
    aweme_count: "48",
    aweme_like_count: "229",
    aweme_comment_count: "11",
    aweme_share_count: "23",
    aweme_play_count: "31460",
    aweme_activation: 0.4333,
    live_count: "26",
    live_time: "1721",
    live_watch_count: 868,
    live_watch_time: 964,
    live_like_count: "24102",
    live_comment_count: "946",
    live_activation: 0.7667,
    live_fans_add: "15",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "福州华奥红旗",
    company_name: "福州华奥鸿旗汽车销售有限公司",
    store_code: "SFJ607",
    大区: "华南区",
    "省份-城市": "福建省-福州市",
    "所选分组编号/分组名称": "-",
    fans_count: "8",
    fans_count_total: "15852",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "14",
    aweme_like_count: "245",
    aweme_comment_count: "41",
    aweme_share_count: "9",
    aweme_play_count: "69557",
    aweme_activation: 0.4,
    live_count: "36",
    live_time: "2111",
    live_watch_count: 3974,
    live_watch_time: 4415,
    live_like_count: "22933",
    live_comment_count: "1712",
    live_activation: 0.7667,
    live_fans_add: "30",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "株洲宏旗",
    company_name: "株洲宏旗汽车销售服务有限公司",
    store_code: "CHN609",
    大区: "中南区",
    "省份-城市": "湖南省-株洲市",
    "所选分组编号/分组名称": "-",
    fans_count: "97",
    fans_count_total: "7302",
    fans_tt_count: "967",
    fans_hs_count: 0,
    aweme_count: "36",
    aweme_like_count: "419",
    aweme_comment_count: "43",
    aweme_share_count: "68",
    aweme_play_count: "130688",
    aweme_activation: 0.4333,
    live_count: "34",
    live_time: "2046",
    live_watch_count: 1362,
    live_watch_time: 1513,
    live_like_count: "9031",
    live_comment_count: "922",
    live_activation: 0.4667,
    live_fans_add: "17",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "马鞍山金福联",
    company_name: "马鞍山金福联汽车销售服务有限公司",
    store_code: "EAH609",
    大区: "华东区",
    "省份-城市": "安徽省-马鞍山市",
    "所选分组编号/分组名称": "-",
    fans_count: "-131",
    fans_count_total: "63816",
    fans_tt_count: "4456",
    fans_hs_count: 0,
    aweme_count: "76",
    aweme_like_count: "642",
    aweme_comment_count: "56",
    aweme_share_count: "41",
    aweme_play_count: "206131",
    aweme_activation: 1,
    live_count: "52",
    live_time: "3291",
    live_watch_count: 8602,
    live_watch_time: 9557,
    live_like_count: "117675",
    live_comment_count: "3608",
    live_activation: 0.8333,
    live_fans_add: "75",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "黄冈旗胜",
    company_name: "黄冈旗胜汽车服务有限公司",
    store_code: "CHB607",
    大区: "中南区",
    "省份-城市": "湖北省-黄冈市",
    "所选分组编号/分组名称": "-",
    fans_count: "35",
    fans_count_total: "10685",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "71",
    aweme_like_count: "977",
    aweme_comment_count: "107",
    aweme_share_count: "20",
    aweme_play_count: "161427",
    aweme_activation: 1,
    live_count: "84",
    live_time: "6242",
    live_watch_count: 7962,
    live_watch_time: 8846,
    live_like_count: "53382",
    live_comment_count: "1208",
    live_activation: 1,
    live_fans_add: "19",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "牡丹江中信恒安",
    company_name: "牡丹江中信恒安汽车销售服务有限公司",
    store_code: "DHL602",
    大区: "东北区",
    "省份-城市": "黑龙江省-牡丹江市",
    "所选分组编号/分组名称": "-",
    fans_count: "14",
    fans_count_total: "5339",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "21",
    aweme_like_count: "130",
    aweme_comment_count: "5",
    aweme_share_count: "10",
    aweme_play_count: "11227",
    aweme_activation: 0.7,
    live_count: "27",
    live_time: "1619",
    live_watch_count: 4261,
    live_watch_time: 4734,
    live_like_count: "1442",
    live_comment_count: "503",
    live_activation: 1,
    live_fans_add: "20",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "漳州宏旗",
    company_name: "漳州市宏旗汽车销售服务有限公司",
    store_code: "SFJ606",
    大区: "华南区",
    "省份-城市": "福建省-漳州市",
    "所选分组编号/分组名称": "-",
    fans_count: "134",
    fans_count_total: "13785",
    fans_tt_count: "43",
    fans_hs_count: 0,
    aweme_count: "50",
    aweme_like_count: "494",
    aweme_comment_count: "53",
    aweme_share_count: "43",
    aweme_play_count: "165267",
    aweme_activation: 0.6667,
    live_count: "56",
    live_time: "3497",
    live_watch_count: 115605,
    live_watch_time: 128450,
    live_like_count: "29940",
    live_comment_count: "1488",
    live_activation: 0.8667,
    live_fans_add: "135",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "鄂尔多斯红旗",
    company_name: "鄂尔多斯市宏旗汽车销售有限公司",
    store_code: "DNM605",
    大区: "华北区",
    "省份-城市": "内蒙古自治区-鄂尔多斯市",
    "所选分组编号/分组名称": "-",
    fans_count: "-4",
    fans_count_total: "1085",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "50",
    aweme_like_count: "119",
    aweme_comment_count: "9",
    aweme_share_count: "10",
    aweme_play_count: "6822",
    aweme_activation: 1,
    live_count: "2",
    live_time: "147",
    live_watch_count: 389,
    live_watch_time: 432,
    live_like_count: "2791",
    live_comment_count: "10",
    live_activation: 0.1,
    live_fans_add: "1",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "诸暨悦旗",
    company_name: "诸暨悦旗汽车有限公司",
    store_code: "EZJ618",
    大区: "华东区",
    "省份-城市": "浙江省-绍兴市",
    "所选分组编号/分组名称": "-",
    fans_count: "193",
    fans_count_total: "18631",
    fans_tt_count: "9",
    fans_hs_count: 0,
    aweme_count: "82",
    aweme_like_count: "936",
    aweme_comment_count: "156",
    aweme_share_count: "50",
    aweme_play_count: "324495",
    aweme_activation: 1,
    live_count: "87",
    live_time: "5302",
    live_watch_count: 131545,
    live_watch_time: 146161,
    live_like_count: "116093",
    live_comment_count: "3751",
    live_activation: 0.8667,
    live_fans_add: "196",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "西藏泰立",
    company_name: "西藏泰立汽车销售服务有限公司",
    store_code: "WXZ601",
    大区: "西部区",
    "省份-城市": "西藏自治区-拉萨市",
    "所选分组编号/分组名称": "-",
    fans_count: "-4",
    fans_count_total: "4785",
    fans_tt_count: "171",
    fans_hs_count: 0,
    aweme_count: "33",
    aweme_like_count: "180",
    aweme_comment_count: "5",
    aweme_share_count: "6",
    aweme_play_count: "14673",
    aweme_activation: 0.8333,
    live_count: "44",
    live_time: "2948",
    live_watch_count: 1655,
    live_watch_time: 1838,
    live_like_count: "17102",
    live_comment_count: "757",
    live_activation: 0.8333,
    live_fans_add: "15",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "华奕衡水红旗体验中心",
    company_name: "华奕衡水红旗体验中心",
    store_code: "NJI606",
    大区: "华北区",
    "省份-城市": "河北省-衡水市",
    "所选分组编号/分组名称": "-",
    fans_count: "54",
    fans_count_total: "3873",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "26",
    aweme_like_count: "452",
    aweme_comment_count: "78",
    aweme_share_count: "94",
    aweme_play_count: "140916",
    aweme_activation: 0.7,
    live_count: "32",
    live_time: "1808",
    live_watch_count: 891,
    live_watch_time: 990,
    live_like_count: "4703",
    live_comment_count: "335",
    live_activation: 0.5667,
    live_fans_add: "15",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "济南民福红旗体验中心",
    company_name: "济南民福汽车服务有限公司",
    store_code: "NSD616",
    大区: "东北区",
    "省份-城市": "山东省-济南市",
    "所选分组编号/分组名称": "-",
    fans_count: "148",
    fans_count_total: "201879",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "66",
    aweme_like_count: "1861",
    aweme_comment_count: "88",
    aweme_share_count: "154",
    aweme_play_count: "477370",
    aweme_activation: 1,
    live_count: "53",
    live_time: "3444",
    live_watch_count: 33224,
    live_watch_time: 36915,
    live_like_count: "27140",
    live_comment_count: "4166",
    live_activation: 0.7,
    live_fans_add: "414",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "四平通立",
    company_name: "四平通立汽车销售服务有限公司",
    store_code: "DJL607",
    大区: "东北区",
    "省份-城市": "吉林省-四平市",
    "所选分组编号/分组名称": "-",
    fans_count: "20",
    fans_count_total: "4013",
    fans_tt_count: "1",
    fans_hs_count: 0,
    aweme_count: "33",
    aweme_like_count: "137",
    aweme_comment_count: "7",
    aweme_share_count: "19",
    aweme_play_count: "8477",
    aweme_activation: 0.8667,
    live_count: "46",
    live_time: "2926",
    live_watch_count: 2946,
    live_watch_time: 3273,
    live_like_count: "15890",
    live_comment_count: "658",
    live_activation: 0.8667,
    live_fans_add: "49",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "黔南州大雍汇盛",
    company_name: "黔南州大雍汇盛汽车销售服务有限公司",
    store_code: "WGZ609",
    大区: "西部区",
    "省份-城市": "贵州省-黔南布依族苗族自治州",
    "所选分组编号/分组名称": "-",
    fans_count: "-13",
    fans_count_total: "4302",
    fans_tt_count: "5",
    fans_hs_count: 0,
    aweme_count: "50",
    aweme_like_count: "287",
    aweme_comment_count: "34",
    aweme_share_count: "29",
    aweme_play_count: "26680",
    aweme_activation: 0.8,
    live_count: "59",
    live_time: "3929",
    live_watch_count: 1997,
    live_watch_time: 2218,
    live_like_count: "82351",
    live_comment_count: "524",
    live_activation: 0.9,
    live_fans_add: "7",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "广安祥龙",
    company_name: "广安祥龙车业有限公司",
    store_code: "WSC619",
    大区: "西部区",
    "省份-城市": "四川省-广安市",
    "所选分组编号/分组名称": "-",
    fans_count: "23",
    fans_count_total: "1399",
    fans_tt_count: "11",
    fans_hs_count: 0,
    aweme_count: "54",
    aweme_like_count: "341",
    aweme_comment_count: "76",
    aweme_share_count: "17",
    aweme_play_count: "7930",
    aweme_activation: 0.9667,
    live_count: "56",
    live_time: "4007",
    live_watch_count: 1895,
    live_watch_time: 2105,
    live_like_count: "81329",
    live_comment_count: "5844",
    live_activation: 0.7667,
    live_fans_add: "14",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "通辽大鹏泰达",
    company_name: "通辽市大鹏泰达汽车销售服务有限公司",
    store_code: "DNM606",
    大区: "东北区",
    "省份-城市": "内蒙古自治区-通辽市",
    "所选分组编号/分组名称": "-",
    fans_count: "2",
    fans_count_total: "693",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: 0,
    aweme_like_count: 0,
    aweme_comment_count: 0,
    aweme_share_count: 0,
    aweme_play_count: 0,
    aweme_activation: 0,
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: 0,
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "邯郸鸿博红旗体验中心",
    company_name: "邯郸市鸿博汽车销售服务有限公司",
    store_code: "NJI608",
    大区: "华北区",
    "省份-城市": "河北省-邯郸市",
    "所选分组编号/分组名称": "-",
    fans_count: "-106",
    fans_count_total: "75215",
    fans_tt_count: "2746",
    fans_hs_count: 0,
    aweme_count: "72",
    aweme_like_count: "1682",
    aweme_comment_count: "190",
    aweme_share_count: "137",
    aweme_play_count: "473264",
    aweme_activation: 0.7,
    live_count: "80",
    live_time: "4908",
    live_watch_count: 10357,
    live_watch_time: 11507,
    live_like_count: "145467",
    live_comment_count: "2672",
    live_activation: 0.9,
    live_fans_add: "39",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "肇庆诚利",
    company_name: "肇庆市诚利汽车销售服务有限公司",
    store_code: "SGD615",
    大区: "华南区",
    "省份-城市": "广东省-肇庆市",
    "所选分组编号/分组名称": "-",
    fans_count: "88",
    fans_count_total: "6043",
    fans_tt_count: "1",
    fans_hs_count: 0,
    aweme_count: "74",
    aweme_like_count: "771",
    aweme_comment_count: "145",
    aweme_share_count: "43",
    aweme_play_count: "253989",
    aweme_activation: 0.7333,
    live_count: "25",
    live_time: "1733",
    live_watch_count: 6617,
    live_watch_time: 7352,
    live_like_count: "64679",
    live_comment_count: "1549",
    live_activation: 0.8,
    live_fans_add: "28",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "四川融裕",
    company_name: "四川融裕汽车贸易有限责任公司",
    store_code: "WSC618",
    大区: "西部区",
    "省份-城市": "四川省-眉山市",
    "所选分组编号/分组名称": "-",
    fans_count: "-86",
    fans_count_total: "59507",
    fans_tt_count: "1860",
    fans_hs_count: 0,
    aweme_count: "85",
    aweme_like_count: "984",
    aweme_comment_count: "137",
    aweme_share_count: "57",
    aweme_play_count: "267264",
    aweme_activation: 0.9667,
    live_count: "34",
    live_time: "2110",
    live_watch_count: 14166,
    live_watch_time: 15740,
    live_like_count: "107139",
    live_comment_count: "1488",
    live_activation: 0.6,
    live_fans_add: "86",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "亳州远景特润红旗",
    company_name: "亳州市远景特润汽车销售服务有限责任公司",
    store_code: "EAH608",
    大区: "华东区",
    "省份-城市": "安徽省-亳州市",
    "所选分组编号/分组名称": "-",
    fans_count: "83",
    fans_count_total: "45907",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "56",
    aweme_like_count: "3370",
    aweme_comment_count: "124",
    aweme_share_count: "120",
    aweme_play_count: "565224",
    aweme_activation: 0.8,
    live_count: "12",
    live_time: "854",
    live_watch_count: 680,
    live_watch_time: 755,
    live_like_count: "6076",
    live_comment_count: "643",
    live_activation: 0.4667,
    live_fans_add: "1",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "绵阳红旗体验中心",
    company_name: "绵阳红旗体验中心",
    store_code: "WSC611",
    大区: "西部区",
    "省份-城市": "四川省-绵阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "360",
    fans_count_total: "11401",
    fans_tt_count: "622",
    fans_hs_count: 0,
    aweme_count: "45",
    aweme_like_count: "501",
    aweme_comment_count: "33",
    aweme_share_count: "22",
    aweme_play_count: "160103",
    aweme_activation: 0.6667,
    live_count: "56",
    live_time: "3297",
    live_watch_count: 126821,
    live_watch_time: 140912,
    live_like_count: "150381",
    live_comment_count: "1808",
    live_activation: 0.6667,
    live_fans_add: "169",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "承德天晟",
    company_name: "承德天美",
    store_code: "NJI618",
    大区: "华北区",
    "省份-城市": "河北省-承德市",
    "所选分组编号/分组名称": "-",
    fans_count: "6",
    fans_count_total: "8181",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "69",
    aweme_like_count: "352",
    aweme_comment_count: "28",
    aweme_share_count: "16",
    aweme_play_count: "18273",
    aweme_activation: 0.8667,
    live_count: "54",
    live_time: "3199",
    live_watch_count: 4211,
    live_watch_time: 4678,
    live_like_count: "104367",
    live_comment_count: "2013",
    live_activation: 0.8667,
    live_fans_add: "56",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "贵州星尊程悦航",
    company_name: "贵州星尊程悦航",
    store_code: "WGZ611",
    大区: "西部区",
    "省份-城市": "贵州省-六盘水市",
    "所选分组编号/分组名称": "-",
    fans_count: "314",
    fans_count_total: "2441",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "43",
    aweme_like_count: "367",
    aweme_comment_count: "21",
    aweme_share_count: "26",
    aweme_play_count: "20122",
    aweme_activation: 0.6667,
    live_count: "46",
    live_time: "2772",
    live_watch_count: 6400,
    live_watch_time: 7111,
    live_like_count: "48190",
    live_comment_count: "1128",
    live_activation: 0.8333,
    live_fans_add: "18",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "湛江宝旗",
    company_name: "湛江市宝旗汽车销售服务有限公司",
    store_code: "SGD616",
    大区: "华南区",
    "省份-城市": "广东省-湛江市",
    "所选分组编号/分组名称": "-",
    fans_count: "191",
    fans_count_total: "12832",
    fans_tt_count: "47",
    fans_hs_count: 0,
    aweme_count: "29",
    aweme_like_count: "257",
    aweme_comment_count: "3",
    aweme_share_count: "12",
    aweme_play_count: "39878",
    aweme_activation: 0.6333,
    live_count: "53",
    live_time: "3247",
    live_watch_count: 8310,
    live_watch_time: 9233,
    live_like_count: "15725",
    live_comment_count: "2575",
    live_activation: 0.9,
    live_fans_add: "310",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "赤峰天永红旗体验中心",
    company_name: "赤峰天永汽车销售服务有限公司",
    store_code: "DNM604",
    大区: "东北区",
    "省份-城市": "内蒙古自治区-赤峰市",
    "所选分组编号/分组名称": "-",
    fans_count: "12",
    fans_count_total: "793",
    fans_tt_count: "16",
    fans_hs_count: 0,
    aweme_count: "54",
    aweme_like_count: "188",
    aweme_comment_count: "51",
    aweme_share_count: "1",
    aweme_play_count: "7356",
    aweme_activation: 0.2333,
    live_count: "33",
    live_time: "1721",
    live_watch_count: 3820,
    live_watch_time: 4244,
    live_like_count: "20038",
    live_comment_count: "75",
    live_activation: 0.6,
    live_fans_add: "1",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "郴州恒晨",
    company_name: "郴州市恒晨汽车销售服务有限公司",
    store_code: "CHN612",
    大区: "中南区",
    "省份-城市": "湖南省-郴州市",
    "所选分组编号/分组名称": "-",
    fans_count: "141",
    fans_count_total: "24573",
    fans_tt_count: "334",
    fans_hs_count: 0,
    aweme_count: "68",
    aweme_like_count: "1633",
    aweme_comment_count: "127",
    aweme_share_count: "59",
    aweme_play_count: "461872",
    aweme_activation: 1,
    live_count: "39",
    live_time: "2342",
    live_watch_count: 6048,
    live_watch_time: 6720,
    live_like_count: "201874",
    live_comment_count: "2452",
    live_activation: 0.8,
    live_fans_add: "52",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "荆州旗阳红旗体验中心",
    company_name: "荆州旗阳汽车销售服务有限公司",
    store_code: "CHB608",
    大区: "中南区",
    "省份-城市": "湖北省-荆州市",
    "所选分组编号/分组名称": "-",
    fans_count: "-7",
    fans_count_total: "3293",
    fans_tt_count: "16",
    fans_hs_count: 0,
    aweme_count: "25",
    aweme_like_count: "107",
    aweme_comment_count: "18",
    aweme_share_count: "5",
    aweme_play_count: "5805",
    aweme_activation: 0.6333,
    live_count: "29",
    live_time: "1820",
    live_watch_count: 1749,
    live_watch_time: 1943,
    live_like_count: "4910",
    live_comment_count: "630",
    live_activation: 0.8,
    live_fans_add: "14",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "岳阳广宸",
    company_name: "岳阳广宸汽车销售服务有限公司",
    store_code: "CHN611",
    大区: "中南区",
    "省份-城市": "湖南省-岳阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "-150",
    fans_count_total: "34131",
    fans_tt_count: "1",
    fans_hs_count: 0,
    aweme_count: "42",
    aweme_like_count: "412",
    aweme_comment_count: "8",
    aweme_share_count: "1",
    aweme_play_count: "12595",
    aweme_activation: 0.8333,
    live_count: "51",
    live_time: "2863",
    live_watch_count: 2190,
    live_watch_time: 2433,
    live_like_count: "6671",
    live_comment_count: "312",
    live_activation: 0.8333,
    live_fans_add: "6",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "江门裕立",
    company_name: "江门市裕立汽车销售服务有限公司",
    store_code: "SGD617",
    大区: "华南区",
    "省份-城市": "广东省-江门市",
    "所选分组编号/分组名称": "-",
    fans_count: "168",
    fans_count_total: "2039",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "55",
    aweme_like_count: "331",
    aweme_comment_count: "17",
    aweme_share_count: "25",
    aweme_play_count: "45893",
    aweme_activation: 0.7667,
    live_count: "11",
    live_time: "559",
    live_watch_count: 283,
    live_watch_time: 314,
    live_like_count: "26564",
    live_comment_count: "664",
    live_activation: 0.3667,
    live_fans_add: "1",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "汕头众驰红旗4S店",
    company_name: "汕头市众驰汽车有限公司",
    store_code: "SGD623",
    大区: "华南区",
    "省份-城市": "广东省-汕头市",
    "所选分组编号/分组名称": "-",
    fans_count: "356",
    fans_count_total: "15133",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "50",
    aweme_like_count: "548",
    aweme_comment_count: "38",
    aweme_share_count: "55",
    aweme_play_count: "109115",
    aweme_activation: 0.6667,
    live_count: "56",
    live_time: "3490",
    live_watch_count: 108482,
    live_watch_time: 120535,
    live_like_count: "96412",
    live_comment_count: "5438",
    live_activation: 0.8333,
    live_fans_add: "389",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "资阳清巍茂美",
    company_name: "资阳市清巍茂美汽车销售服务有限公司",
    store_code: "WSC621",
    大区: "西部区",
    "省份-城市": "四川省-资阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "-16",
    fans_count_total: "7159",
    fans_tt_count: "35",
    fans_hs_count: 0,
    aweme_count: 0,
    aweme_like_count: "6",
    aweme_comment_count: 0,
    aweme_share_count: "3",
    aweme_play_count: "608",
    aweme_activation: 0.0667,
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: 0,
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "广物红旗广州鸿福",
    company_name: "广东广物鸿福汽车销售服务有限公司",
    store_code: "SGD618",
    大区: "华南区",
    "省份-城市": "广东省-广州市",
    "所选分组编号/分组名称": "-",
    fans_count: "285",
    fans_count_total: "8351",
    fans_tt_count: "5829",
    fans_hs_count: 0,
    aweme_count: "59",
    aweme_like_count: "1140",
    aweme_comment_count: "99",
    aweme_share_count: "65",
    aweme_play_count: "352284",
    aweme_activation: 0.8333,
    live_count: "51",
    live_time: "3148",
    live_watch_count: 19727,
    live_watch_time: 21918,
    live_like_count: "34209",
    live_comment_count: "2159",
    live_activation: 0.8667,
    live_fans_add: "126",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "齐齐哈尔粤华红旗",
    company_name: "齐齐哈尔粤华汽贸集团有限公司",
    store_code: "DHL603",
    大区: "东北区",
    "省份-城市": "黑龙江省-齐齐哈尔市",
    "所选分组编号/分组名称": "-",
    fans_count: "197",
    fans_count_total: "4469",
    fans_tt_count: "31",
    fans_hs_count: 0,
    aweme_count: "97",
    aweme_like_count: "609",
    aweme_comment_count: "91",
    aweme_share_count: "55",
    aweme_play_count: "24132",
    aweme_activation: 0.8,
    live_count: "28",
    live_time: "1808",
    live_watch_count: 821,
    live_watch_time: 912,
    live_like_count: "531",
    live_comment_count: "423",
    live_activation: 0.7,
    live_fans_add: "10",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "合肥和旗",
    company_name: "合肥和旗",
    store_code: "EAH624",
    大区: "华东区",
    "省份-城市": "安徽省-合肥市",
    "所选分组编号/分组名称": "-",
    fans_count: "217",
    fans_count_total: "616",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "39",
    aweme_like_count: "122",
    aweme_comment_count: "15",
    aweme_share_count: "8",
    aweme_play_count: "15255",
    aweme_activation: 0.9,
    live_count: "52",
    live_time: "3250",
    live_watch_count: 29827,
    live_watch_time: 33141,
    live_like_count: "95684",
    live_comment_count: "5287",
    live_activation: 0.8667,
    live_fans_add: "239",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "昭通国源",
    company_name: "昭通国源汽车销售服务有限公司",
    store_code: "WYN610",
    大区: "西部区",
    "省份-城市": "云南省-昭通市",
    "所选分组编号/分组名称": "-",
    fans_count: "-49",
    fans_count_total: "16760",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "7",
    aweme_like_count: "76",
    aweme_comment_count: "4",
    aweme_share_count: "3",
    aweme_play_count: "7978",
    aweme_activation: 0.1333,
    live_count: "42",
    live_time: "2637",
    live_watch_count: 5224,
    live_watch_time: 5804,
    live_like_count: "1098",
    live_comment_count: "223",
    live_activation: 0.8333,
    live_fans_add: "4",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "南京天沃红旗体验中心",
    company_name: "南京天沃汽车销售服务有限公司",
    store_code: "EJS618",
    大区: "华东区",
    "省份-城市": "江苏省-南京市",
    "所选分组编号/分组名称": "-",
    fans_count: "349",
    fans_count_total: "594715",
    fans_tt_count: "17",
    fans_hs_count: 0,
    aweme_count: "87",
    aweme_like_count: "824",
    aweme_comment_count: "127",
    aweme_share_count: "105",
    aweme_play_count: "156872",
    aweme_activation: 0.8333,
    live_count: "101",
    live_time: "9536",
    live_watch_count: 121383,
    live_watch_time: 134870,
    live_like_count: "51968",
    live_comment_count: "27572",
    live_activation: 0.9333,
    live_fans_add: "3331",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "焦作天宏",
    company_name: "焦作市天宏汽车销售服务有限公司",
    store_code: "NYU618",
    大区: "华北区",
    "省份-城市": "河南省-焦作市",
    "所选分组编号/分组名称": "-",
    fans_count: "207",
    fans_count_total: "28521",
    fans_tt_count: "91",
    fans_hs_count: 0,
    aweme_count: "32",
    aweme_like_count: "5643",
    aweme_comment_count: "98",
    aweme_share_count: "333",
    aweme_play_count: "3961455",
    aweme_activation: 0.7,
    live_count: "45",
    live_time: "2750",
    live_watch_count: 3607,
    live_watch_time: 4007,
    live_like_count: "5879",
    live_comment_count: "3755",
    live_activation: 0.8667,
    live_fans_add: "48",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "连云港海旗",
    company_name: "连云港海旗汽车销售服务有限公司",
    store_code: "EJS617",
    大区: "华东区",
    "省份-城市": "江苏省-连云港市",
    "所选分组编号/分组名称": "-",
    fans_count: "-19",
    fans_count_total: "2152",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "22",
    aweme_like_count: "157",
    aweme_comment_count: "10",
    aweme_share_count: "19",
    aweme_play_count: "24119",
    aweme_activation: 0.5667,
    live_count: "70",
    live_time: "4127",
    live_watch_count: 2439,
    live_watch_time: 2710,
    live_like_count: "2545",
    live_comment_count: "230",
    live_activation: 0.9667,
    live_fans_add: "5",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "西双版纳骏杰红旗体验中心",
    company_name: "西双版纳骏杰汽车销售服务有限公司",
    store_code: "WYN609",
    大区: "西部区",
    "省份-城市": "云南省-西双版纳傣族自治州",
    "所选分组编号/分组名称": "-",
    fans_count: "112",
    fans_count_total: "5722",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "134",
    aweme_like_count: "715",
    aweme_comment_count: "87",
    aweme_share_count: "61",
    aweme_play_count: "111787",
    aweme_activation: 0.8333,
    live_count: "46",
    live_time: "2935",
    live_watch_count: 5494,
    live_watch_time: 6104,
    live_like_count: "12873",
    live_comment_count: "585",
    live_activation: 0.6333,
    live_fans_add: "11",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "大昌福源红旗智能体验中心",
    company_name: "山西大昌福源汽车销售服务有限公司",
    store_code: "NJN608",
    大区: "华北区",
    "省份-城市": "山西省-太原市",
    "所选分组编号/分组名称": "-",
    fans_count: "343",
    fans_count_total: "18580",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "49",
    aweme_like_count: "929",
    aweme_comment_count: "76",
    aweme_share_count: "108",
    aweme_play_count: "448873",
    aweme_activation: 0.6333,
    live_count: "61",
    live_time: "3696",
    live_watch_count: 95055,
    live_watch_time: 105616,
    live_like_count: "100194",
    live_comment_count: "2834",
    live_activation: 0.8,
    live_fans_add: "158",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "徐州天捷",
    company_name: "徐州天捷",
    store_code: "EJS616",
    大区: "华东区",
    "省份-城市": "江苏省-徐州市",
    "所选分组编号/分组名称": "-",
    fans_count: "238",
    fans_count_total: "9988",
    fans_tt_count: "12",
    fans_hs_count: 0,
    aweme_count: "51",
    aweme_like_count: "922",
    aweme_comment_count: "118",
    aweme_share_count: "82",
    aweme_play_count: "202514",
    aweme_activation: 0.8,
    live_count: "32",
    live_time: "1990",
    live_watch_count: 122531,
    live_watch_time: 136145,
    live_like_count: "125442",
    live_comment_count: "3689",
    live_activation: 0.8333,
    live_fans_add: "230",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "韶关荣耀",
    company_name: "韶关市荣耀汽车销售服务有限公司",
    store_code: "SGD619",
    大区: "华南区",
    "省份-城市": "广东省-韶关市",
    "所选分组编号/分组名称": "-",
    fans_count: "451",
    fans_count_total: "157140",
    fans_tt_count: "1118",
    fans_hs_count: 0,
    aweme_count: "68",
    aweme_like_count: "4162",
    aweme_comment_count: "240",
    aweme_share_count: "180",
    aweme_play_count: "410443",
    aweme_activation: 0.9333,
    live_count: "33",
    live_time: "3411",
    live_watch_count: 93449,
    live_watch_time: 103832,
    live_like_count: "228761",
    live_comment_count: "16246",
    live_activation: 1,
    live_fans_add: "1369",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "黑龙江华之诚万家",
    company_name: "黑龙江省华之诚万家汽车销售服务有限公司",
    store_code: "DHL604",
    大区: "东北区",
    "省份-城市": "黑龙江省-哈尔滨市",
    "所选分组编号/分组名称": "-",
    fans_count: "629",
    fans_count_total: "28583",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "44",
    aweme_like_count: "1922",
    aweme_comment_count: "229",
    aweme_share_count: "518",
    aweme_play_count: "1077683",
    aweme_activation: 0.5667,
    live_count: "42",
    live_time: "2723",
    live_watch_count: 45845,
    live_watch_time: 50938,
    live_like_count: "81118",
    live_comment_count: "6650",
    live_activation: 0.7,
    live_fans_add: "370",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "深圳通利华红旗(龙岗）",
    company_name: "深圳通利华红旗(龙岗）",
    store_code: "SGD620",
    大区: "华南区",
    "省份-城市": "广东省-深圳市",
    "所选分组编号/分组名称": "-",
    fans_count: "1129",
    fans_count_total: "23306",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "36",
    aweme_like_count: "404",
    aweme_comment_count: "52",
    aweme_share_count: "28",
    aweme_play_count: "129656",
    aweme_activation: 0.5333,
    live_count: "38",
    live_time: "1428",
    live_watch_count: 62424,
    live_watch_time: 69360,
    live_like_count: "9029",
    live_comment_count: "5330",
    live_activation: 0.4,
    live_fans_add: "926",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "湖北骏翔汽车",
    company_name: "湖北骏翔汽车销售服务有限公司",
    store_code: "CHB613",
    大区: "中南区",
    "省份-城市": "湖北省-随州市",
    "所选分组编号/分组名称": "-",
    fans_count: "4",
    fans_count_total: "230",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "12",
    aweme_like_count: "50",
    aweme_comment_count: "8",
    aweme_share_count: "11",
    aweme_play_count: "1510",
    aweme_activation: 0.3,
    live_count: "34",
    live_time: "1964",
    live_watch_count: 305,
    live_watch_time: 338,
    live_like_count: "18690",
    live_comment_count: "45",
    live_activation: 0.6333,
    live_fans_add: "3",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "威海鸿运",
    company_name: "威海鸿运汽车销售服务有限公司",
    store_code: "NSD620",
    大区: "东北区",
    "省份-城市": "山东省-威海市",
    "所选分组编号/分组名称": "-",
    fans_count: "64",
    fans_count_total: "35723",
    fans_tt_count: "5",
    fans_hs_count: 0,
    aweme_count: "67",
    aweme_like_count: "568",
    aweme_comment_count: "35",
    aweme_share_count: "30",
    aweme_play_count: "154629",
    aweme_activation: 0.9,
    live_count: "30",
    live_time: "1796",
    live_watch_count: 1496,
    live_watch_time: 1662,
    live_like_count: "5654",
    live_comment_count: "496",
    live_activation: 0.7,
    live_fans_add: "9",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "湘西旗胜",
    company_name: "湘西旗胜汽车销售有限责任公司",
    store_code: "CHN614",
    大区: "中南区",
    "省份-城市": "湖南省-湘西土家族苗族自治州",
    "所选分组编号/分组名称": "-",
    fans_count: "164",
    fans_count_total: "5955",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "50",
    aweme_like_count: "1052",
    aweme_comment_count: "84",
    aweme_share_count: "40",
    aweme_play_count: "200992",
    aweme_activation: 0.8333,
    live_count: "82",
    live_time: "4910",
    live_watch_count: 28741,
    live_watch_time: 31934,
    live_like_count: "118691",
    live_comment_count: "2591",
    live_activation: 0.9,
    live_fans_add: "111",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "滁州红旗4S店",
    company_name: "滁州红旗4S店",
    store_code: "EAH612",
    大区: "华东区",
    "省份-城市": "安徽省-滁州市",
    "所选分组编号/分组名称": "-",
    fans_count: "1244",
    fans_count_total: "7800",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "65",
    aweme_like_count: "652",
    aweme_comment_count: "111",
    aweme_share_count: "23",
    aweme_play_count: "190153",
    aweme_activation: 1,
    live_count: "32",
    live_time: "2090",
    live_watch_count: 1812,
    live_watch_time: 2013,
    live_like_count: "24971",
    live_comment_count: "1560",
    live_activation: 0.8333,
    live_fans_add: "26",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "鞍山天美红旗",
    company_name: "鞍山天美汽车销售有限公司",
    store_code: "DLN609",
    大区: "东北区",
    "省份-城市": "辽宁省-鞍山市",
    "所选分组编号/分组名称": "-",
    fans_count: "82",
    fans_count_total: "5157",
    fans_tt_count: "34",
    fans_hs_count: 0,
    aweme_count: "28",
    aweme_like_count: "128",
    aweme_comment_count: "23",
    aweme_share_count: "24",
    aweme_play_count: "6992",
    aweme_activation: 0.7667,
    live_count: "45",
    live_time: "2682",
    live_watch_count: 4134,
    live_watch_time: 4593,
    live_like_count: "181886",
    live_comment_count: "3887",
    live_activation: 0.8333,
    live_fans_add: "129",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "楚雄安晟",
    company_name: "楚雄安晟汽车销售服务有限公司",
    store_code: "WYN612",
    大区: "西部区",
    "省份-城市": "云南省-楚雄彝族自治州",
    "所选分组编号/分组名称": "-",
    fans_count: "-7",
    fans_count_total: "1414",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "13",
    aweme_like_count: "58",
    aweme_comment_count: "2",
    aweme_share_count: "6",
    aweme_play_count: "4204",
    aweme_activation: 0.2,
    live_count: "40",
    live_time: "2456",
    live_watch_count: 5492,
    live_watch_time: 6102,
    live_like_count: "19151",
    live_comment_count: "242",
    live_activation: 0.8333,
    live_fans_add: "7",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "文山鑫桥红旗",
    company_name: "文山市鑫桥汽车销售服务有限公司",
    store_code: "WYN611",
    大区: "西部区",
    "省份-城市": "云南省-文山壮族苗族自治州",
    "所选分组编号/分组名称": "-",
    fans_count: "-14",
    fans_count_total: "8187",
    fans_tt_count: "28",
    fans_hs_count: 0,
    aweme_count: "66",
    aweme_like_count: "632",
    aweme_comment_count: "40",
    aweme_share_count: "16",
    aweme_play_count: "23305",
    aweme_activation: 1,
    live_count: "74",
    live_time: "4608",
    live_watch_count: 4564,
    live_watch_time: 5071,
    live_like_count: "51070",
    live_comment_count: "4130",
    live_activation: 0.9,
    live_fans_add: "25",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "深圳锦红红旗",
    company_name: "深圳锦红汽车销售服务有限公司",
    store_code: "SGD621",
    大区: "华南区",
    "省份-城市": "广东省-深圳市",
    "所选分组编号/分组名称": "-",
    fans_count: "22",
    fans_count_total: "25671",
    fans_tt_count: "5521",
    fans_hs_count: 0,
    aweme_count: "37",
    aweme_like_count: "200",
    aweme_comment_count: "9",
    aweme_share_count: "16",
    aweme_play_count: "11363",
    aweme_activation: 0.4,
    live_count: "40",
    live_time: "2474",
    live_watch_count: 2929,
    live_watch_time: 3254,
    live_like_count: "109790",
    live_comment_count: "1714",
    live_activation: 0.3667,
    live_fans_add: "74",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "莆田星奥",
    company_name: "莆田星奥汽车销售服务有限公司",
    store_code: "SFJ609",
    大区: "华南区",
    "省份-城市": "福建省-莆田市",
    "所选分组编号/分组名称": "-",
    fans_count: "-42",
    fans_count_total: "4218",
    fans_tt_count: "12",
    fans_hs_count: 0,
    aweme_count: "21",
    aweme_like_count: "76",
    aweme_comment_count: "22",
    aweme_share_count: "8",
    aweme_play_count: "6242",
    aweme_activation: 0.7,
    live_count: "39",
    live_time: "2685",
    live_watch_count: 2415,
    live_watch_time: 2683,
    live_like_count: "29114",
    live_comment_count: "1688",
    live_activation: 0.7333,
    live_fans_add: "21",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "枣庄旗尚",
    company_name: "枣庄旗尚汽车销售服务有限公司",
    store_code: "NSD621",
    大区: "东北区",
    "省份-城市": "山东省-枣庄市",
    "所选分组编号/分组名称": "-",
    fans_count: "-36",
    fans_count_total: "15591",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "32",
    aweme_like_count: "135",
    aweme_comment_count: "15",
    aweme_share_count: "7",
    aweme_play_count: "36332",
    aweme_activation: 0.6,
    live_count: "42",
    live_time: "2788",
    live_watch_count: 3790,
    live_watch_time: 4211,
    live_like_count: "30603",
    live_comment_count: "4054",
    live_activation: 0.9,
    live_fans_add: "43",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "石家庄中冀华晟红旗",
    company_name: "河北华晟汽车服务有限公司",
    store_code: "NJI609",
    大区: "华北区",
    "省份-城市": "河北省-石家庄市",
    "所选分组编号/分组名称": "-",
    fans_count: "19",
    fans_count_total: "6867",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "20",
    aweme_like_count: "131",
    aweme_comment_count: "23",
    aweme_share_count: "6",
    aweme_play_count: "13604",
    aweme_activation: 0.5667,
    live_count: "38",
    live_time: "2400",
    live_watch_count: 7239,
    live_watch_time: 8043,
    live_like_count: "138028",
    live_comment_count: "7911",
    live_activation: 0.8333,
    live_fans_add: "177",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "张家口龙瀚",
    company_name: "张家口龙瀚",
    store_code: "NJI610",
    大区: "华北区",
    "省份-城市": "河北省-张家口市",
    "所选分组编号/分组名称": "-",
    fans_count: "-74",
    fans_count_total: "40233",
    fans_tt_count: "8950",
    fans_hs_count: 0,
    aweme_count: "10",
    aweme_like_count: "59",
    aweme_comment_count: "6",
    aweme_share_count: "1",
    aweme_play_count: "1830",
    aweme_activation: 0.2333,
    live_count: "17",
    live_time: "1133",
    live_watch_count: 595,
    live_watch_time: 661,
    live_like_count: "20943",
    live_comment_count: "419",
    live_activation: 0.5,
    live_fans_add: "27",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "榆林恒盛德岳",
    company_name: "榆林恒盛德岳",
    store_code: "XSS608",
    大区: "西部区",
    "省份-城市": "陕西省-榆林市",
    "所选分组编号/分组名称": "-",
    fans_count: "464",
    fans_count_total: "28357",
    fans_tt_count: "5137",
    fans_hs_count: 0,
    aweme_count: "95",
    aweme_like_count: "2192",
    aweme_comment_count: "273",
    aweme_share_count: "495",
    aweme_play_count: "888289",
    aweme_activation: 0.9667,
    live_count: "71",
    live_time: "5114",
    live_watch_count: 20588,
    live_watch_time: 22875,
    live_like_count: "576420",
    live_comment_count: "10956",
    live_activation: 0.9333,
    live_fans_add: "339",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "大连汽贸集团华宇",
    company_name: "大连汽贸集团华宇汽车销售服务有限公司",
    store_code: "DLN605",
    大区: "东北区",
    "省份-城市": "辽宁省-大连市",
    "所选分组编号/分组名称": "-",
    fans_count: "189",
    fans_count_total: "73617",
    fans_tt_count: "17",
    fans_hs_count: 0,
    aweme_count: "46",
    aweme_like_count: "884",
    aweme_comment_count: "102",
    aweme_share_count: "98",
    aweme_play_count: "515241",
    aweme_activation: 0.6,
    live_count: "69",
    live_time: "4031",
    live_watch_count: 66926,
    live_watch_time: 74362,
    live_like_count: "207041",
    live_comment_count: "7997",
    live_activation: 0.8667,
    live_fans_add: "652",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "荆门英驰-红旗",
    company_name: "荆门英驰汽车销售有限公司",
    store_code: "CHB610",
    大区: "中南区",
    "省份-城市": "湖北省-荆门市",
    "所选分组编号/分组名称": "-",
    fans_count: "371",
    fans_count_total: "9836",
    fans_tt_count: "9",
    fans_hs_count: 0,
    aweme_count: "55",
    aweme_like_count: "508",
    aweme_comment_count: "91",
    aweme_share_count: "25",
    aweme_play_count: "37371",
    aweme_activation: 0.7667,
    live_count: "70",
    live_time: "6197",
    live_watch_count: 59042,
    live_watch_time: 65602,
    live_like_count: "236079",
    live_comment_count: "6353",
    live_activation: 0.8333,
    live_fans_add: "319",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "恩施英驰红旗",
    company_name: "恩施英驰汽车销售有限公司",
    store_code: "CHB614",
    大区: "中南区",
    "省份-城市": "湖北省-恩施土家族苗族自治州",
    "所选分组编号/分组名称": "-",
    fans_count: "159",
    fans_count_total: "3915",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "45",
    aweme_like_count: "732",
    aweme_comment_count: "56",
    aweme_share_count: "15",
    aweme_play_count: "35707",
    aweme_activation: 0.7333,
    live_count: "54",
    live_time: "3456",
    live_watch_count: 8975,
    live_watch_time: 9972,
    live_like_count: "198871",
    live_comment_count: "4860",
    live_activation: 0.8667,
    live_fans_add: "88",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "成都岳宏泰红旗",
    company_name: "成都岳宏泰汽车销售服务有限公司",
    store_code: "WSC622",
    大区: "西部区",
    "省份-城市": "四川省-成都市",
    "所选分组编号/分组名称": "-",
    fans_count: "192",
    fans_count_total: "78831",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "70",
    aweme_like_count: "1575",
    aweme_comment_count: "193",
    aweme_share_count: "105",
    aweme_play_count: "952326",
    aweme_activation: 1,
    live_count: "61",
    live_time: "3827",
    live_watch_count: 402808,
    live_watch_time: 447564,
    live_like_count: "420515",
    live_comment_count: "4964",
    live_activation: 0.8,
    live_fans_add: "344",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "武汉泰岳宏旗",
    company_name: "武汉泰岳宏旗",
    store_code: "CHB615",
    大区: "中南区",
    "省份-城市": "湖北省-武汉市",
    "所选分组编号/分组名称": "-",
    fans_count: "145",
    fans_count_total: "17759",
    fans_tt_count: "616",
    fans_hs_count: 0,
    aweme_count: "79",
    aweme_like_count: "740",
    aweme_comment_count: "134",
    aweme_share_count: "71",
    aweme_play_count: "290032",
    aweme_activation: 0.7667,
    live_count: "71",
    live_time: "4313",
    live_watch_count: 124186,
    live_watch_time: 137984,
    live_like_count: "416985",
    live_comment_count: "1720",
    live_activation: 0.8667,
    live_fans_add: "210",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "黄石新兴振宇红旗",
    company_name: "黄石市新兴振宇汽车销售有限公司",
    store_code: "CHB611",
    大区: "中南区",
    "省份-城市": "湖北省-黄石市",
    "所选分组编号/分组名称": "-",
    fans_count: "79",
    fans_count_total: "5408",
    fans_tt_count: "2",
    fans_hs_count: 0,
    aweme_count: "77",
    aweme_like_count: "702",
    aweme_comment_count: "50",
    aweme_share_count: "21",
    aweme_play_count: "148146",
    aweme_activation: 1,
    live_count: "60",
    live_time: "3613",
    live_watch_count: 2508,
    live_watch_time: 2786,
    live_like_count: "99699",
    live_comment_count: "975",
    live_activation: 0.9667,
    live_fans_add: "92",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "舟山旗翔",
    company_name: "舟山旗翔汽车销售服务有限公司",
    store_code: "EZJ620",
    大区: "华东区",
    "省份-城市": "浙江省-舟山市",
    "所选分组编号/分组名称": "-",
    fans_count: "-40",
    fans_count_total: "12971",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "56",
    aweme_like_count: "582",
    aweme_comment_count: "43",
    aweme_share_count: "34",
    aweme_play_count: "165087",
    aweme_activation: 0.8667,
    live_count: "56",
    live_time: "3212",
    live_watch_count: 1067,
    live_watch_time: 1185,
    live_like_count: "923",
    live_comment_count: "178",
    live_activation: 0.9,
    live_fans_add: 0,
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "台州星旗",
    company_name: "台州星旗",
    store_code: "EZJ619",
    大区: "华东区",
    "省份-城市": "浙江省-台州市",
    "所选分组编号/分组名称": "-",
    fans_count: "174",
    fans_count_total: "19444",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "34",
    aweme_like_count: "406",
    aweme_comment_count: "49",
    aweme_share_count: "5049",
    aweme_play_count: "146830",
    aweme_activation: 0.5667,
    live_count: "12",
    live_time: "804",
    live_watch_count: 15671,
    live_watch_time: 17412,
    live_like_count: "69892",
    live_comment_count: "2092",
    live_activation: 0.3667,
    live_fans_add: "173",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "锦州新东方红旗",
    company_name: "锦州新东方汽车销售服务有限公司",
    store_code: "DLN607",
    大区: "东北区",
    "省份-城市": "辽宁省-锦州市",
    "所选分组编号/分组名称": "-",
    fans_count: "-114",
    fans_count_total: "26239",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "48",
    aweme_like_count: "1220",
    aweme_comment_count: "1057",
    aweme_share_count: "49",
    aweme_play_count: "23592",
    aweme_activation: 0.9333,
    live_count: "6",
    live_time: "386",
    live_watch_count: 1491,
    live_watch_time: 1656,
    live_like_count: "11798",
    live_comment_count: "543",
    live_activation: 0.2333,
    live_fans_add: "50",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "佳木斯安盈",
    company_name: "佳木斯安盈汽车销售服务有限公司",
    store_code: "DHL605",
    大区: "东北区",
    "省份-城市": "黑龙江省-佳木斯市",
    "所选分组编号/分组名称": "-",
    fans_count: "48",
    fans_count_total: "15945",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "21",
    aweme_like_count: "354",
    aweme_comment_count: "27",
    aweme_share_count: "45",
    aweme_play_count: "173289",
    aweme_activation: 0.2667,
    live_count: "24",
    live_time: "1431",
    live_watch_count: 1195,
    live_watch_time: 1327,
    live_like_count: "10258",
    live_comment_count: "220",
    live_activation: 0.6,
    live_fans_add: "15",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "辽宁大地",
    company_name: "辽宁大地汽车销售服务有限公司",
    store_code: "DLN606",
    大区: "东北区",
    "省份-城市": "辽宁省-葫芦岛市",
    "所选分组编号/分组名称": "-",
    fans_count: "-1",
    fans_count_total: "15277",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "19",
    aweme_like_count: "113",
    aweme_comment_count: "39",
    aweme_share_count: "4",
    aweme_play_count: "16016",
    aweme_activation: 0.3667,
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: 0.0333,
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "松原征途中和",
    company_name: "松原市征途中和汽车销售服务有限公司",
    store_code: "DJL609",
    大区: "东北区",
    "省份-城市": "吉林省-松原市",
    "所选分组编号/分组名称": "-",
    fans_count: "3",
    fans_count_total: "1064",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "118",
    aweme_like_count: "311",
    aweme_comment_count: "13",
    aweme_share_count: "8",
    aweme_play_count: "13434",
    aweme_activation: 1,
    live_count: "118",
    live_time: "7271",
    live_watch_count: 1360,
    live_watch_time: 1511,
    live_like_count: "4462",
    live_comment_count: "130",
    live_activation: 0.9333,
    live_fans_add: "9",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "内江利恒孚",
    company_name: "内江利恒孚车业有限公司",
    store_code: "WSC620",
    大区: "西部区",
    "省份-城市": "四川省-内江市",
    "所选分组编号/分组名称": "-",
    fans_count: "-8",
    fans_count_total: "7149",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "15",
    aweme_like_count: "46",
    aweme_comment_count: "4",
    aweme_share_count: "3",
    aweme_play_count: "2696",
    aweme_activation: 0.5,
    live_count: "32",
    live_time: "2019",
    live_watch_count: 832,
    live_watch_time: 924,
    live_like_count: "6050",
    live_comment_count: "1003",
    live_activation: 0.6333,
    live_fans_add: "6",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "沈阳神州川达",
    company_name: "沈阳神州川达汽车销售服务有限责任公司",
    store_code: "DLN608",
    大区: "东北区",
    "省份-城市": "辽宁省-沈阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "377",
    fans_count_total: "11299",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "64",
    aweme_like_count: "736",
    aweme_comment_count: "142",
    aweme_share_count: "124",
    aweme_play_count: "811876",
    aweme_activation: 0.9,
    live_count: "116",
    live_time: "7346",
    live_watch_count: 13670,
    live_watch_time: 15188,
    live_like_count: "245458",
    live_comment_count: "4632",
    live_activation: 0.8667,
    live_fans_add: "128",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "永州达美",
    company_name: "永州达美汽车销售服务有限公司",
    store_code: "CHN615",
    大区: "中南区",
    "省份-城市": "湖南省-永州市",
    "所选分组编号/分组名称": "-",
    fans_count: "-31",
    fans_count_total: "7931",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "74",
    aweme_like_count: "2875",
    aweme_comment_count: "88",
    aweme_share_count: "196",
    aweme_play_count: "253839",
    aweme_activation: 0.9667,
    live_count: "57",
    live_time: "3419",
    live_watch_count: 6748,
    live_watch_time: 7497,
    live_like_count: "2143",
    live_comment_count: "347",
    live_activation: 0.7667,
    live_fans_add: "4",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "保山上通",
    company_name: "保山市上通汽车销售服务有限公司",
    store_code: "WYN613",
    大区: "西部区",
    "省份-城市": "云南省-保山市",
    "所选分组编号/分组名称": "-",
    fans_count: "104",
    fans_count_total: "8238",
    fans_tt_count: "5",
    fans_hs_count: 0,
    aweme_count: "65",
    aweme_like_count: "1056",
    aweme_comment_count: "64",
    aweme_share_count: "45",
    aweme_play_count: "298426",
    aweme_activation: 0.7,
    live_count: "65",
    live_time: "3900",
    live_watch_count: 6976,
    live_watch_time: 7751,
    live_like_count: "76953",
    live_comment_count: "3322",
    live_activation: 0.8333,
    live_fans_add: "165",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "广东腾辉鸿旗体验服务中心",
    company_name: "广东腾辉鸿旗汽车销售服务有限公司",
    store_code: "SGD629",
    大区: "华南区",
    "省份-城市": "广东省-梅州市",
    "所选分组编号/分组名称": "-",
    fans_count: "210",
    fans_count_total: "8044",
    fans_tt_count: "108",
    fans_hs_count: 0,
    aweme_count: "44",
    aweme_like_count: "1046",
    aweme_comment_count: "82",
    aweme_share_count: "90",
    aweme_play_count: "216398",
    aweme_activation: 0.9333,
    live_count: "32",
    live_time: "2032",
    live_watch_count: 14821,
    live_watch_time: 16467,
    live_like_count: "76085",
    live_comment_count: "3918",
    live_activation: 0.6667,
    live_fans_add: "164",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "池州鑫瑞",
    company_name: "池州鑫瑞汽车销售服务有限公司",
    store_code: "EAH616",
    大区: "华东区",
    "省份-城市": "安徽省-池州市",
    "所选分组编号/分组名称": "-",
    fans_count: "428",
    fans_count_total: "26445",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "127",
    aweme_like_count: "851",
    aweme_comment_count: "115",
    aweme_share_count: "67",
    aweme_play_count: "313561",
    aweme_activation: 0.9,
    live_count: "54",
    live_time: "3507",
    live_watch_count: 93898,
    live_watch_time: 104331,
    live_like_count: "35774",
    live_comment_count: "2900",
    live_activation: 0.8333,
    live_fans_add: "325",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "新疆晨运",
    company_name: "新疆晨运汽车销售有限公司",
    store_code: "XXJ601",
    大区: "西部区",
    "省份-城市": "新疆维吾尔自治区-巴音郭楞蒙古自治州",
    "所选分组编号/分组名称": "-",
    fans_count: "293",
    fans_count_total: "21325",
    fans_tt_count: "2",
    fans_hs_count: 0,
    aweme_count: "163",
    aweme_like_count: "917",
    aweme_comment_count: "93",
    aweme_share_count: "90",
    aweme_play_count: "224494",
    aweme_activation: 0.7667,
    live_count: "129",
    live_time: "10269",
    live_watch_count: 29386,
    live_watch_time: 32651,
    live_like_count: "158379",
    live_comment_count: "9030",
    live_activation: 0.8333,
    live_fans_add: "274",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "阳泉鼎晟红旗",
    company_name: "阳泉市鼎晟汽车销售服务有限公司",
    store_code: "NJN609",
    大区: "华北区",
    "省份-城市": "山西省-阳泉市",
    "所选分组编号/分组名称": "-",
    fans_count: "-44",
    fans_count_total: "18486",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "6",
    aweme_like_count: "17",
    aweme_comment_count: "7",
    aweme_share_count: 0,
    aweme_play_count: "2671",
    aweme_activation: 0.1,
    live_count: "29",
    live_time: "1725",
    live_watch_count: 2930,
    live_watch_time: 3255,
    live_like_count: "35382",
    live_comment_count: "297",
    live_activation: 0.7667,
    live_fans_add: "11",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "佛山飞扬红旗",
    company_name: "佛山飞扬红旗汽车销售服务有限公司",
    store_code: "SGD628",
    大区: "华南区",
    "省份-城市": "广东省-佛山市",
    "所选分组编号/分组名称": "-",
    fans_count: "205",
    fans_count_total: "37574",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "45",
    aweme_like_count: "411",
    aweme_comment_count: "55",
    aweme_share_count: "54",
    aweme_play_count: "153260",
    aweme_activation: 0.8333,
    live_count: "50",
    live_time: "3260",
    live_watch_count: 17892,
    live_watch_time: 19880,
    live_like_count: "101486",
    live_comment_count: "2174",
    live_activation: 1,
    live_fans_add: "106",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "钦州益辰",
    company_name: "钦州益辰汽车销售服务有限公司",
    store_code: "SGX605",
    大区: "华南区",
    "省份-城市": "广西壮族自治区-钦州市",
    "所选分组编号/分组名称": "-",
    fans_count: "482",
    fans_count_total: "16474",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "40",
    aweme_like_count: "2464",
    aweme_comment_count: "315",
    aweme_share_count: "314",
    aweme_play_count: "1338808",
    aweme_activation: 0.5333,
    live_count: "48",
    live_time: "4121",
    live_watch_count: 25266,
    live_watch_time: 28073,
    live_like_count: "33442",
    live_comment_count: "1395",
    live_activation: 0.7667,
    live_fans_add: "80",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "吉林神州红旗",
    company_name: "吉林市神州红旗汽车销售服务有限公司",
    store_code: "DJL611",
    大区: "东北区",
    "省份-城市": "吉林省-吉林市",
    "所选分组编号/分组名称": "-",
    fans_count: "-72",
    fans_count_total: "15209",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "37",
    aweme_like_count: "150",
    aweme_comment_count: "6",
    aweme_share_count: "10",
    aweme_play_count: "14481",
    aweme_activation: 0.9333,
    live_count: "47",
    live_time: "2772",
    live_watch_count: 4561,
    live_watch_time: 5067,
    live_like_count: "22876",
    live_comment_count: "899",
    live_activation: 0.8333,
    live_fans_add: "22",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "德宏海伟宏亦",
    company_name: "德宏海伟宏亦汽车销售有限公司",
    store_code: "WYN614",
    大区: "西部区",
    "省份-城市": "云南省-德宏傣族景颇族自治州",
    "所选分组编号/分组名称": "-",
    fans_count: "-23",
    fans_count_total: "6408",
    fans_tt_count: "1",
    fans_hs_count: 0,
    aweme_count: "49",
    aweme_like_count: "580",
    aweme_comment_count: "62",
    aweme_share_count: "40",
    aweme_play_count: "40275",
    aweme_activation: 1,
    live_count: "52",
    live_time: "3169",
    live_watch_count: 1852,
    live_watch_time: 2057,
    live_like_count: "8163",
    live_comment_count: "1292",
    live_activation: 0.8667,
    live_fans_add: "6",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "伊犁冠邦",
    company_name: "伊犁冠邦汽车销售服务有限公司",
    store_code: "XXJ602",
    大区: "西部区",
    "省份-城市": "新疆维吾尔自治区-伊犁哈萨克自治州",
    "所选分组编号/分组名称": "-",
    fans_count: "24",
    fans_count_total: "1659",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "110",
    aweme_like_count: "782",
    aweme_comment_count: "194",
    aweme_share_count: "87",
    aweme_play_count: "20481",
    aweme_activation: 1,
    live_count: "63",
    live_time: "3367",
    live_watch_count: 766,
    live_watch_time: 851,
    live_like_count: "96743",
    live_comment_count: "228",
    live_activation: 0.9,
    live_fans_add: "2",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "广西宝旗",
    company_name: "广西宝旗汽车销售服务有限责任公司",
    store_code: "SGX604",
    大区: "华南区",
    "省份-城市": "广西壮族自治区-柳州市",
    "所选分组编号/分组名称": "-",
    fans_count: "589",
    fans_count_total: "4891",
    fans_tt_count: "7",
    fans_hs_count: 0,
    aweme_count: "55",
    aweme_like_count: "2812",
    aweme_comment_count: "271",
    aweme_share_count: "182",
    aweme_play_count: "536943",
    aweme_activation: 0.9667,
    live_count: "49",
    live_time: "3224",
    live_watch_count: 2788,
    live_watch_time: 3097,
    live_like_count: "22443",
    live_comment_count: "2032",
    live_activation: 0.8333,
    live_fans_add: "70",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "萍乡兰天嘉华红旗",
    company_name: "萍乡市兰天嘉华汽车销售服务有限公司",
    store_code: "CJX609",
    大区: "中南区",
    "省份-城市": "江西省-萍乡市",
    "所选分组编号/分组名称": "-",
    fans_count: "15",
    fans_count_total: "38383",
    fans_tt_count: "1379",
    fans_hs_count: 0,
    aweme_count: "23",
    aweme_like_count: "676",
    aweme_comment_count: "122",
    aweme_share_count: "50",
    aweme_play_count: "176641",
    aweme_activation: 0.3,
    live_count: "16",
    live_time: "992",
    live_watch_count: 2466,
    live_watch_time: 2740,
    live_like_count: "19276",
    live_comment_count: "826",
    live_activation: 0.6,
    live_fans_add: "68",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "三明旗展",
    company_name: "三明旗展",
    store_code: "SFJ610",
    大区: "华南区",
    "省份-城市": "福建省-三明市",
    "所选分组编号/分组名称": "-",
    fans_count: "208",
    fans_count_total: "7513",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "53",
    aweme_like_count: "860",
    aweme_comment_count: "103",
    aweme_share_count: "51",
    aweme_play_count: "330686",
    aweme_activation: 0.6333,
    live_count: "46",
    live_time: "2797",
    live_watch_count: 7128,
    live_watch_time: 7920,
    live_like_count: "106084",
    live_comment_count: "2937",
    live_activation: 0.8667,
    live_fans_add: "256",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "营口国之信红旗体验中心",
    company_name: "营口市国之信汽车销售服务有限公司",
    store_code: "DLN611",
    大区: "东北区",
    "省份-城市": "辽宁省-营口市",
    "所选分组编号/分组名称": "-",
    fans_count: "-4",
    fans_count_total: "4753",
    fans_tt_count: "82",
    fans_hs_count: 0,
    aweme_count: "42",
    aweme_like_count: "111",
    aweme_comment_count: "6",
    aweme_share_count: "6",
    aweme_play_count: "9250",
    aweme_activation: 0.9667,
    live_count: "38",
    live_time: "2153",
    live_watch_count: 5831,
    live_watch_time: 6478,
    live_like_count: "10045",
    live_comment_count: "3052",
    live_activation: 0.8333,
    live_fans_add: "26",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "呼伦贝尔大鹏红旗",
    company_name: "呼伦贝尔市大鹏睿达汽车贸易有限公司",
    store_code: "DNM607",
    大区: "东北区",
    "省份-城市": "内蒙古自治区-呼伦贝尔市",
    "所选分组编号/分组名称": "-",
    fans_count: "16",
    fans_count_total: "909",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "19",
    aweme_like_count: "95",
    aweme_comment_count: "7",
    aweme_share_count: "2",
    aweme_play_count: "4365",
    aweme_activation: 0.5333,
    live_count: "45",
    live_time: "2967",
    live_watch_count: 1098,
    live_watch_time: 1220,
    live_like_count: "8909",
    live_comment_count: "860",
    live_activation: 0.7667,
    live_fans_add: "15",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "无锡和旗",
    company_name: "无锡和旗汽车销售服务有限公司",
    store_code: "EJS621",
    大区: "华东区",
    "省份-城市": "江苏省-无锡市",
    "所选分组编号/分组名称": "-",
    fans_count: "-79",
    fans_count_total: "57227",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "33",
    aweme_like_count: "836",
    aweme_comment_count: "174",
    aweme_share_count: "44",
    aweme_play_count: "182608",
    aweme_activation: 0.7667,
    live_count: "45",
    live_time: "2675",
    live_watch_count: 15663,
    live_watch_time: 17403,
    live_like_count: "126786",
    live_comment_count: "4182",
    live_activation: 0.7667,
    live_fans_add: "85",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "黑龙江万家祥和",
    company_name: "黑龙江省万家祥和汽车销售服务有限公司",
    store_code: "DHL607",
    大区: "东北区",
    "省份-城市": "黑龙江省-哈尔滨市",
    "所选分组编号/分组名称": "-",
    fans_count: "768",
    fans_count_total: "14964",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "52",
    aweme_like_count: "1433",
    aweme_comment_count: "169",
    aweme_share_count: "361",
    aweme_play_count: "764240",
    aweme_activation: 0.5,
    live_count: "56",
    live_time: "3827",
    live_watch_count: 57384,
    live_watch_time: 63760,
    live_like_count: "108666",
    live_comment_count: "6215",
    live_activation: 0.8,
    live_fans_add: "506",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "百色健稳红旗体验中心",
    company_name: "百色健稳红旗体验中心",
    store_code: "SGX606",
    大区: "华南区",
    "省份-城市": "广西壮族自治区-百色市",
    "所选分组编号/分组名称": "-",
    fans_count: "5",
    fans_count_total: "5351",
    fans_tt_count: "21",
    fans_hs_count: 0,
    aweme_count: "19",
    aweme_like_count: "315",
    aweme_comment_count: "59",
    aweme_share_count: "24",
    aweme_play_count: "43137",
    aweme_activation: 0.5667,
    live_count: "42",
    live_time: "3755",
    live_watch_count: 6902,
    live_watch_time: 7668,
    live_like_count: "19782",
    live_comment_count: "6366",
    live_activation: 0.8,
    live_fans_add: "30",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "山西吕梁大昌",
    company_name: "山西省吕梁市大昌汽车销售有限公司",
    store_code: "NJN611",
    大区: "华北区",
    "省份-城市": "山西省-吕梁市",
    "所选分组编号/分组名称": "-",
    fans_count: "1253",
    fans_count_total: "13805",
    fans_tt_count: "4",
    fans_hs_count: 0,
    aweme_count: "79",
    aweme_like_count: "2431",
    aweme_comment_count: "290",
    aweme_share_count: "716",
    aweme_play_count: "709497",
    aweme_activation: 0.8,
    live_count: "104",
    live_time: "8628",
    live_watch_count: 56712,
    live_watch_time: 63013,
    live_like_count: "105152",
    live_comment_count: "4624",
    live_activation: 0.9333,
    live_fans_add: "1448",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "白山宝信",
    company_name: "白山市宝信汽车销售服务有限公司",
    store_code: "DJL612",
    大区: "东北区",
    "省份-城市": "吉林省-白山市",
    "所选分组编号/分组名称": "-",
    fans_count: "-63",
    fans_count_total: "21894",
    fans_tt_count: "2310",
    fans_hs_count: 0,
    aweme_count: "49",
    aweme_like_count: "288",
    aweme_comment_count: "9",
    aweme_share_count: "4",
    aweme_play_count: "5944",
    aweme_activation: 1,
    live_count: "28",
    live_time: "1725",
    live_watch_count: 2466,
    live_watch_time: 2740,
    live_like_count: "6512",
    live_comment_count: "2012",
    live_activation: 0.8333,
    live_fans_add: "17",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "昌吉亚中机电红旗",
    company_name: "昌吉亚中机电有限公司",
    store_code: "XXJ603",
    大区: "西部区",
    "省份-城市": "新疆维吾尔自治区-昌吉回族自治州",
    "所选分组编号/分组名称": "-",
    fans_count: "6",
    fans_count_total: "2215",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "29",
    aweme_like_count: "269",
    aweme_comment_count: "22",
    aweme_share_count: "13",
    aweme_play_count: "22826",
    aweme_activation: 0.6,
    live_count: "29",
    live_time: "1609",
    live_watch_count: 649,
    live_watch_time: 721,
    live_like_count: "1495",
    live_comment_count: "186",
    live_activation: 0.5333,
    live_fans_add: "6",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "攀枝花驭马红旗",
    company_name: "攀枝花驭马车业有限公司",
    store_code: "WSC623",
    大区: "西部区",
    "省份-城市": "四川省-攀枝花市",
    "所选分组编号/分组名称": "-",
    fans_count: "-14",
    fans_count_total: "819",
    fans_tt_count: "15",
    fans_hs_count: 0,
    aweme_count: "22",
    aweme_like_count: "97",
    aweme_comment_count: "23",
    aweme_share_count: "1",
    aweme_play_count: "4844",
    aweme_activation: 0.7,
    live_count: "30",
    live_time: "1884",
    live_watch_count: 3178,
    live_watch_time: 3531,
    live_like_count: "4150",
    live_comment_count: "1168",
    live_activation: 0.8333,
    live_fans_add: "5",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "庆阳金岛旗胜",
    company_name: "庆阳金岛旗胜汽车销售服务有限公司",
    store_code: "XGS601",
    大区: "西部区",
    "省份-城市": "甘肃省-庆阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "109",
    fans_count_total: "4240",
    fans_tt_count: "11",
    fans_hs_count: 0,
    aweme_count: "33",
    aweme_like_count: "548",
    aweme_comment_count: "21",
    aweme_share_count: "125",
    aweme_play_count: "84643",
    aweme_activation: 1,
    live_count: "36",
    live_time: "2288",
    live_watch_count: 15550,
    live_watch_time: 17277,
    live_like_count: "41850",
    live_comment_count: "990",
    live_activation: 0.9,
    live_fans_add: "95",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "雅安国创红旗店",
    company_name: "雅安国创汽车销售服务有限公司",
    store_code: "WSC624",
    大区: "西部区",
    "省份-城市": "四川省-雅安市",
    "所选分组编号/分组名称": "-",
    fans_count: "-8",
    fans_count_total: "1593",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "18",
    aweme_like_count: "49",
    aweme_comment_count: "3",
    aweme_share_count: 0,
    aweme_play_count: "4036",
    aweme_activation: 0.5333,
    live_count: "45",
    live_time: "2680",
    live_watch_count: 3707,
    live_watch_time: 4118,
    live_like_count: "92333",
    live_comment_count: "2482",
    live_activation: 0.8333,
    live_fans_add: "10",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "黄山旗胜红旗",
    company_name: "黄山旗胜汽车销售服务有限公司",
    store_code: "EAH617",
    大区: "华东区",
    "省份-城市": "安徽省-黄山市",
    "所选分组编号/分组名称": "-",
    fans_count: "-511",
    fans_count_total: "242919",
    fans_tt_count: "16739",
    fans_hs_count: 0,
    aweme_count: "88",
    aweme_like_count: "5564",
    aweme_comment_count: "662",
    aweme_share_count: "1558",
    aweme_play_count: "2025137",
    aweme_activation: 0.7667,
    live_count: "55",
    live_time: "3497",
    live_watch_count: 57297,
    live_watch_time: 63663,
    live_like_count: "53919",
    live_comment_count: "6522",
    live_activation: 0.9,
    live_fans_add: "364",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "山西大昌宏顺",
    company_name: "山西大昌宏顺",
    store_code: "NJN612",
    大区: "华北区",
    "省份-城市": "山西省-晋中市",
    "所选分组编号/分组名称": "-",
    fans_count: "151",
    fans_count_total: "3125",
    fans_tt_count: "1",
    fans_hs_count: 0,
    aweme_count: "25",
    aweme_like_count: "136",
    aweme_comment_count: "16",
    aweme_share_count: "11",
    aweme_play_count: "25235",
    aweme_activation: 0.4,
    live_count: "5",
    live_time: "317",
    live_watch_count: 151491,
    live_watch_time: 168323,
    live_like_count: "81762",
    live_comment_count: "1078",
    live_activation: 0.1667,
    live_fans_add: "165",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "芜湖红旗体验中心",
    company_name: "芜湖宏祺汽车销售服务有限公司",
    store_code: "EAH618",
    大区: "华东区",
    "省份-城市": "安徽省-芜湖市",
    "所选分组编号/分组名称": "-",
    fans_count: "-213",
    fans_count_total: "38929",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "50",
    aweme_like_count: "101",
    aweme_comment_count: "7",
    aweme_share_count: 0,
    aweme_play_count: "18099",
    aweme_activation: 0.3667,
    live_count: "43",
    live_time: "2410",
    live_watch_count: 5214,
    live_watch_time: 5793,
    live_like_count: "13686",
    live_comment_count: "887",
    live_activation: 0.5,
    live_fans_add: "10",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "龙泽红旗",
    company_name: "北京龙泽红旗汽车销售有限公司",
    store_code: "NBJ127",
    大区: "华北区",
    "省份-城市": "北京市-北京市",
    "所选分组编号/分组名称": "-",
    fans_count: "8",
    fans_count_total: "3817",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "40",
    aweme_like_count: "72",
    aweme_comment_count: "4",
    aweme_share_count: "3",
    aweme_play_count: "18056",
    aweme_activation: 0.6,
    live_count: "30",
    live_time: "1679",
    live_watch_count: 1403,
    live_watch_time: 1558,
    live_like_count: "24",
    live_comment_count: "41",
    live_activation: 1,
    live_fans_add: "2",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "成都三和银杏",
    company_name: "成都三和银杏汽车贸易有限公司",
    store_code: "WSC626",
    大区: "西部区",
    "省份-城市": "四川省-成都市",
    "所选分组编号/分组名称": "-",
    fans_count: "-1730",
    fans_count_total: "724596",
    fans_tt_count: "4220",
    fans_hs_count: 0,
    aweme_count: "36",
    aweme_like_count: "3169",
    aweme_comment_count: "608",
    aweme_share_count: "295",
    aweme_play_count: "805329",
    aweme_activation: 0.4,
    live_count: "180",
    live_time: "14403",
    live_watch_count: 201488,
    live_watch_time: 223875,
    live_like_count: "205312",
    live_comment_count: "16858",
    live_activation: 1,
    live_fans_add: "1773",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "杭州杭旗",
    company_name: "杭州杭旗汽车有限公司",
    store_code: "EZJ608",
    大区: "华东区",
    "省份-城市": "浙江省-杭州市",
    "所选分组编号/分组名称": "-",
    fans_count: "356",
    fans_count_total: "24418",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "77",
    aweme_like_count: "1255",
    aweme_comment_count: "220",
    aweme_share_count: "92",
    aweme_play_count: "648239",
    aweme_activation: 0.8667,
    live_count: "49",
    live_time: "3091",
    live_watch_count: 14931,
    live_watch_time: 16590,
    live_like_count: "23681",
    live_comment_count: "5167",
    live_activation: 0.7333,
    live_fans_add: "313",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "贵州毕节丽安",
    company_name: "贵州毕节丽安汽车销售服务有限公司",
    store_code: "WGZ608",
    大区: "西部区",
    "省份-城市": "贵州省-毕节市",
    "所选分组编号/分组名称": "-",
    fans_count: "-424",
    fans_count_total: "196492",
    fans_tt_count: "4766",
    fans_hs_count: 0,
    aweme_count: "52",
    aweme_like_count: "1348",
    aweme_comment_count: "192",
    aweme_share_count: "81",
    aweme_play_count: "433196",
    aweme_activation: 0.5,
    live_count: "28",
    live_time: "1629",
    live_watch_count: 4752,
    live_watch_time: 5280,
    live_like_count: "4332",
    live_comment_count: "777",
    live_activation: 0.8333,
    live_fans_add: "24",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "罗村骏耀",
    company_name: "佛山市南海区罗村骏耀汽车销售服务有限公司",
    store_code: "SGD630",
    大区: "华南区",
    "省份-城市": "广东省-佛山市",
    "所选分组编号/分组名称": "-",
    fans_count: "310",
    fans_count_total: "34936",
    fans_tt_count: "105",
    fans_hs_count: 0,
    aweme_count: "50",
    aweme_like_count: "1538",
    aweme_comment_count: "160",
    aweme_share_count: "139",
    aweme_play_count: "140192",
    aweme_activation: 0.9667,
    live_count: "59",
    live_time: "3461",
    live_watch_count: 39504,
    live_watch_time: 43893,
    live_like_count: "159131",
    live_comment_count: "11500",
    live_activation: 0.9,
    live_fans_add: "536",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "苏州和旗",
    company_name: "苏州和旗汽车销售服务有限公司",
    store_code: "EJS620",
    大区: "华东区",
    "省份-城市": "江苏省-苏州市",
    "所选分组编号/分组名称": "-",
    fans_count: "-1362",
    fans_count_total: "360895",
    fans_tt_count: "65",
    fans_hs_count: 0,
    aweme_count: "44",
    aweme_like_count: "1779",
    aweme_comment_count: "264",
    aweme_share_count: "102",
    aweme_play_count: "133091",
    aweme_activation: 0.7667,
    live_count: "44",
    live_time: "2869",
    live_watch_count: 65719,
    live_watch_time: 73021,
    live_like_count: "147973",
    live_comment_count: "10189",
    live_activation: 0.8,
    live_fans_add: "582",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "桐乡裕旗",
    company_name: "桐乡裕旗汽车有限公司",
    store_code: "EZJ621",
    大区: "华东区",
    "省份-城市": "浙江省-嘉兴市",
    "所选分组编号/分组名称": "-",
    fans_count: "301",
    fans_count_total: "13766",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "36",
    aweme_like_count: "146",
    aweme_comment_count: "15",
    aweme_share_count: "18",
    aweme_play_count: "41990",
    aweme_activation: 0.9667,
    live_count: "59",
    live_time: "3705",
    live_watch_count: 32592,
    live_watch_time: 36213,
    live_like_count: "11242",
    live_comment_count: "5470",
    live_activation: 0.9333,
    live_fans_add: "225",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "上饶君悦宏旗红旗体验中心",
    company_name: "上饶君悦宏旗红旗体验中心",
    store_code: "CJX607",
    大区: "中南区",
    "省份-城市": "江西省-上饶市",
    "所选分组编号/分组名称": "-",
    fans_count: "-55",
    fans_count_total: "18950",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "27",
    aweme_like_count: "209",
    aweme_comment_count: "67",
    aweme_share_count: "6",
    aweme_play_count: "11836",
    aweme_activation: 0.7,
    live_count: "51",
    live_time: "3269",
    live_watch_count: 8425,
    live_watch_time: 9361,
    live_like_count: "66484",
    live_comment_count: "10671",
    live_activation: 0.8333,
    live_fans_add: "48",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "张家界旗胜",
    company_name: "张家界旗胜",
    store_code: "CHN617",
    大区: "中南区",
    "省份-城市": "湖南省-张家界市",
    "所选分组编号/分组名称": "-",
    fans_count: "922",
    fans_count_total: "6825",
    fans_tt_count: "96",
    fans_hs_count: 0,
    aweme_count: "62",
    aweme_like_count: "1261",
    aweme_comment_count: "69",
    aweme_share_count: "70",
    aweme_play_count: "336792",
    aweme_activation: 0.9,
    live_count: "46",
    live_time: "2837",
    live_watch_count: 3466,
    live_watch_time: 3851,
    live_like_count: "49189",
    live_comment_count: "1076",
    live_activation: 0.7667,
    live_fans_add: "19",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "延安泽之泰",
    company_name: "延安泽之泰汽贸有限责任公司",
    store_code: "XSS609",
    大区: "西部区",
    "省份-城市": "陕西省-延安市",
    "所选分组编号/分组名称": "-",
    fans_count: "76",
    fans_count_total: "3495",
    fans_tt_count: "3",
    fans_hs_count: 0,
    aweme_count: "37",
    aweme_like_count: "324",
    aweme_comment_count: "24",
    aweme_share_count: "16",
    aweme_play_count: "65877",
    aweme_activation: 0.7,
    live_count: "18",
    live_time: "1122",
    live_watch_count: 1070,
    live_watch_time: 1188,
    live_like_count: "7000",
    live_comment_count: "702",
    live_activation: 0.5333,
    live_fans_add: "16",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "张掖金岛旗瑞",
    company_name: "张掖金岛旗瑞",
    store_code: "XGS602",
    大区: "西部区",
    "省份-城市": "甘肃省-张掖市",
    "所选分组编号/分组名称": "-",
    fans_count: "84",
    fans_count_total: "9054",
    fans_tt_count: "62",
    fans_hs_count: 0,
    aweme_count: "65",
    aweme_like_count: "666",
    aweme_comment_count: "73",
    aweme_share_count: "14",
    aweme_play_count: "200179",
    aweme_activation: 0.7,
    live_count: "43",
    live_time: "2769",
    live_watch_count: 4618,
    live_watch_time: 5131,
    live_like_count: "17660",
    live_comment_count: "597",
    live_activation: 0.6,
    live_fans_add: "43",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "贵港广利",
    company_name: "贵港广利汽车销售服务有限公司",
    store_code: "SGX608",
    大区: "华南区",
    "省份-城市": "广西壮族自治区-贵港市",
    "所选分组编号/分组名称": "-",
    fans_count: "-196",
    fans_count_total: "15752",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "48",
    aweme_like_count: "640",
    aweme_comment_count: "62",
    aweme_share_count: "21",
    aweme_play_count: "20279",
    aweme_activation: 0.7667,
    live_count: "65",
    live_time: "4367",
    live_watch_count: 4931,
    live_watch_time: 5478,
    live_like_count: "56631",
    live_comment_count: "3972",
    live_activation: 0.7667,
    live_fans_add: "15",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "广物鸿福",
    company_name: "广东广物鸿福汽车销售服务有限公司汕尾分公司",
    store_code: "SGD632",
    大区: "华南区",
    "省份-城市": "广东省-汕尾市",
    "所选分组编号/分组名称": "-",
    fans_count: "-2",
    fans_count_total: "845",
    fans_tt_count: "10",
    fans_hs_count: 0,
    aweme_count: "9",
    aweme_like_count: "199",
    aweme_comment_count: "12",
    aweme_share_count: "21",
    aweme_play_count: "9839",
    aweme_activation: 0.4,
    live_count: "1",
    live_time: "51",
    live_watch_count: 93,
    live_watch_time: 103,
    live_like_count: "4347",
    live_comment_count: 0,
    live_activation: 0.0333,
    live_fans_add: "1",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "武汉大雍冉欣",
    company_name: "武汉大雍冉欣汽车销售服务有限公司",
    store_code: "CHB616",
    大区: "中南区",
    "省份-城市": "湖北省-武汉市",
    "所选分组编号/分组名称": "-",
    fans_count: "-16",
    fans_count_total: "21001",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "84",
    aweme_like_count: "930",
    aweme_comment_count: "65",
    aweme_share_count: "69",
    aweme_play_count: "235893",
    aweme_activation: 1,
    live_count: "58",
    live_time: "3604",
    live_watch_count: 16169,
    live_watch_time: 17965,
    live_like_count: "207640",
    live_comment_count: "2054",
    live_activation: 0.8333,
    live_fans_add: "124",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "酒泉金岛旗信",
    company_name: "酒泉金岛旗信",
    store_code: "XGS603",
    大区: "西部区",
    "省份-城市": "甘肃省-酒泉市",
    "所选分组编号/分组名称": "-",
    fans_count: "315",
    fans_count_total: "4757",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "66",
    aweme_like_count: "892",
    aweme_comment_count: "67",
    aweme_share_count: "71",
    aweme_play_count: "396393",
    aweme_activation: 0.6,
    live_count: "49",
    live_time: "3217",
    live_watch_count: 17470,
    live_watch_time: 19411,
    live_like_count: "160390",
    live_comment_count: "6898",
    live_activation: 0.8,
    live_fans_add: "212",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "青海嘉佑晟",
    company_name: "青海嘉佑晟汽车销售服务有限公司",
    store_code: "XQH601",
    大区: "西部区",
    "省份-城市": "青海省-海东市",
    "所选分组编号/分组名称": "-",
    fans_count: "32",
    fans_count_total: "3782",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "57",
    aweme_like_count: "466",
    aweme_comment_count: "14",
    aweme_share_count: "42",
    aweme_play_count: "20512",
    aweme_activation: 0.8667,
    live_count: "52",
    live_time: "4182",
    live_watch_count: 5331,
    live_watch_time: 5923,
    live_like_count: "47207",
    live_comment_count: "580",
    live_activation: 0.8667,
    live_fans_add: "101",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "福州榕泰鸿旗",
    company_name: "福州榕泰鸿旗汽车销售有限公司",
    store_code: "SFJ612",
    大区: "华南区",
    "省份-城市": "福建省-福州市",
    "所选分组编号/分组名称": "-",
    fans_count: "-10",
    fans_count_total: "3842",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "1",
    aweme_like_count: "2",
    aweme_comment_count: 0,
    aweme_share_count: 0,
    aweme_play_count: "226",
    aweme_activation: 0.0333,
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: 0.0667,
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "长春盛世九州",
    company_name: "长春盛世九州红旗汽车销售服务有限公司",
    store_code: "DJL613",
    大区: "东北区",
    "省份-城市": "吉林省-长春市",
    "所选分组编号/分组名称": "-",
    fans_count: "429",
    fans_count_total: "21536",
    fans_tt_count: "58",
    fans_hs_count: 0,
    aweme_count: "102",
    aweme_like_count: "802",
    aweme_comment_count: "79",
    aweme_share_count: "153",
    aweme_play_count: "416006",
    aweme_activation: 0.9,
    live_count: "65",
    live_time: "5334",
    live_watch_count: 34888,
    live_watch_time: 38764,
    live_like_count: "69261",
    live_comment_count: "6189",
    live_activation: 0.9333,
    live_fans_add: "352",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "昆明海伟峻辉红旗体验中心",
    company_name: "昆明海伟峻辉汽车销售有限公司",
    store_code: "WYN615",
    大区: "西部区",
    "省份-城市": "云南省-昆明市",
    "所选分组编号/分组名称": "-",
    fans_count: "275",
    fans_count_total: "268420",
    fans_tt_count: "1057",
    fans_hs_count: 0,
    aweme_count: "37",
    aweme_like_count: "15041",
    aweme_comment_count: "1454",
    aweme_share_count: "2978",
    aweme_play_count: "1521900",
    aweme_activation: 0.7667,
    live_count: "32",
    live_time: "1982",
    live_watch_count: 586398,
    live_watch_time: 651553,
    live_like_count: "394074",
    live_comment_count: "7491",
    live_activation: 0.7,
    live_fans_add: "1085",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "常州外汽国豪",
    company_name: "常州外汽国豪汽车销售服务有限公司",
    store_code: "EJS624",
    大区: "华东区",
    "省份-城市": "江苏省-常州市",
    "所选分组编号/分组名称": "-",
    fans_count: "41",
    fans_count_total: "4821",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "18",
    aweme_like_count: "115",
    aweme_comment_count: "29",
    aweme_share_count: "9",
    aweme_play_count: "5006",
    aweme_activation: 0.5,
    live_count: "42",
    live_time: "2615",
    live_watch_count: 12392,
    live_watch_time: 13768,
    live_like_count: "186145",
    live_comment_count: "1967",
    live_activation: 0.8333,
    live_fans_add: "121",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "烟台奥吉通宏源",
    company_name: "烟台奥吉通宏源汽车销售有限公司",
    store_code: "NSD623",
    大区: "东北区",
    "省份-城市": "山东省-烟台市",
    "所选分组编号/分组名称": "-",
    fans_count: "296",
    fans_count_total: "8264",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "57",
    aweme_like_count: "1386",
    aweme_comment_count: "175",
    aweme_share_count: "144",
    aweme_play_count: "703294",
    aweme_activation: 0.8333,
    live_count: "56",
    live_time: "3524",
    live_watch_count: 119639,
    live_watch_time: 132932,
    live_like_count: "85453",
    live_comment_count: "2285",
    live_activation: 0.7333,
    live_fans_add: "169",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "苏州益谦红旗体验中心",
    company_name: "苏州益谦汽车销售服务有限公司",
    store_code: "EJS622",
    大区: "华东区",
    "省份-城市": "江苏省-苏州市",
    "所选分组编号/分组名称": "-",
    fans_count: "27",
    fans_count_total: "3648",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "23",
    aweme_like_count: "200",
    aweme_comment_count: "7",
    aweme_share_count: "8",
    aweme_play_count: "11768",
    aweme_activation: 0.5,
    live_count: "48",
    live_time: "2878",
    live_watch_count: 10398,
    live_watch_time: 11553,
    live_like_count: "68148",
    live_comment_count: "2433",
    live_activation: 0.8333,
    live_fans_add: "170",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "惠州大雍峻安",
    company_name: "惠州市大雍峻安汽车销售服务有限责任公司",
    store_code: "SGD639",
    大区: "华南区",
    "省份-城市": "广东省-惠州市",
    "所选分组编号/分组名称": "-",
    fans_count: "187",
    fans_count_total: "13385",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "134",
    aweme_like_count: "1831",
    aweme_comment_count: "211",
    aweme_share_count: "96",
    aweme_play_count: "541762",
    aweme_activation: 1,
    live_count: "54",
    live_time: "3086",
    live_watch_count: 8203,
    live_watch_time: 9114,
    live_like_count: "27740",
    live_comment_count: "1761",
    live_activation: 0.8667,
    live_fans_add: "74",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "中山宝旗红旗体验中心",
    company_name: "中山市宝旗汽车销售服务有限公司",
    store_code: "SGD636",
    大区: "华南区",
    "省份-城市": "广东省-中山市",
    "所选分组编号/分组名称": "-",
    fans_count: "-401",
    fans_count_total: "113947",
    fans_tt_count: "1407",
    fans_hs_count: 0,
    aweme_count: "60",
    aweme_like_count: "1033",
    aweme_comment_count: "61",
    aweme_share_count: "363",
    aweme_play_count: "116748",
    aweme_activation: 0.8,
    live_count: "102",
    live_time: "6358",
    live_watch_count: 35971,
    live_watch_time: 39967,
    live_like_count: "17284",
    live_comment_count: "4273",
    live_activation: 0.8667,
    live_fans_add: "195",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "朔州领航红旗",
    company_name: "朔州领航红旗汽车销售服务有限公司",
    store_code: "NJN613",
    大区: "华北区",
    "省份-城市": "山西省-朔州市",
    "所选分组编号/分组名称": "-",
    fans_count: "108",
    fans_count_total: "6971",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "29",
    aweme_like_count: "407",
    aweme_comment_count: "26",
    aweme_share_count: "18",
    aweme_play_count: "33443",
    aweme_activation: 0.9,
    live_count: "26",
    live_time: "1653",
    live_watch_count: 105767,
    live_watch_time: 117518,
    live_like_count: "179665",
    live_comment_count: "5817",
    live_activation: 0.9,
    live_fans_add: "203",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "南昌恒信旗胜",
    company_name: "南昌恒信旗胜汽车销售服务有限公司",
    store_code: "CJX611",
    大区: "中南区",
    "省份-城市": "江西省-南昌市",
    "所选分组编号/分组名称": "-",
    fans_count: "43",
    fans_count_total: "9126",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "50",
    aweme_like_count: "157",
    aweme_comment_count: "27",
    aweme_share_count: "18",
    aweme_play_count: "47086",
    aweme_activation: 0.8,
    live_count: "27",
    live_time: "1613",
    live_watch_count: 3528,
    live_watch_time: 3920,
    live_like_count: "6185",
    live_comment_count: "1197",
    live_activation: 0.9,
    live_fans_add: "55",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "绍兴广成柯旗",
    company_name: "绍兴广成柯旗汽车有限公司",
    store_code: "EZJ625",
    大区: "华东区",
    "省份-城市": "浙江省-绍兴市",
    "所选分组编号/分组名称": "-",
    fans_count: "293",
    fans_count_total: "9324",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "94",
    aweme_like_count: "1148",
    aweme_comment_count: "96",
    aweme_share_count: "82",
    aweme_play_count: "475071",
    aweme_activation: 1,
    live_count: "45",
    live_time: "2818",
    live_watch_count: 156303,
    live_watch_time: 173670,
    live_like_count: "27620",
    live_comment_count: "2996",
    live_activation: 0.8667,
    live_fans_add: "288",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "北京鑫达润通",
    company_name: "北京鑫达润通汽车有限公司",
    store_code: "NBJ609",
    大区: "华北区",
    "省份-城市": "北京市-北京市",
    "所选分组编号/分组名称": "-",
    fans_count: "61",
    fans_count_total: "2505",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "64",
    aweme_like_count: "434",
    aweme_comment_count: "20",
    aweme_share_count: "41",
    aweme_play_count: "167323",
    aweme_activation: 0.8,
    live_count: "50",
    live_time: "2985",
    live_watch_count: 1088,
    live_watch_time: 1208,
    live_like_count: "1317",
    live_comment_count: "338",
    live_activation: 0.9,
    live_fans_add: "8",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "北京奥吉通旗盛",
    company_name: "北京奥吉通旗盛汽车销售服务有限公司",
    store_code: "NBJ608",
    大区: "华北区",
    "省份-城市": "北京市-北京市",
    "所选分组编号/分组名称": "-",
    fans_count: "200",
    fans_count_total: "21594",
    fans_tt_count: "20",
    fans_hs_count: 0,
    aweme_count: "101",
    aweme_like_count: "947",
    aweme_comment_count: "106",
    aweme_share_count: "68",
    aweme_play_count: "229497",
    aweme_activation: 0.7667,
    live_count: "70",
    live_time: "6485",
    live_watch_count: 120130,
    live_watch_time: 133477,
    live_like_count: "148403",
    live_comment_count: "2485",
    live_activation: 0.7667,
    live_fans_add: "252",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "东莞神州腾达",
    company_name: "东莞神州腾达",
    store_code: "SGD637",
    大区: "华南区",
    "省份-城市": "广东省-东莞市",
    "所选分组编号/分组名称": "-",
    fans_count: "534",
    fans_count_total: "23023",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "38",
    aweme_like_count: "318",
    aweme_comment_count: "80",
    aweme_share_count: "25",
    aweme_play_count: "101841",
    aweme_activation: 0.6333,
    live_count: "40",
    live_time: "2174",
    live_watch_count: 115560,
    live_watch_time: 128400,
    live_like_count: "81338",
    live_comment_count: "7055",
    live_activation: 0.8,
    live_fans_add: "817",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "盘锦富田",
    company_name: "盘锦富田实业有限公司",
    store_code: "DLN613",
    大区: "东北区",
    "省份-城市": "辽宁省-盘锦市",
    "所选分组编号/分组名称": "-",
    fans_count: "8",
    fans_count_total: "220",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "31",
    aweme_like_count: "179",
    aweme_comment_count: "21",
    aweme_share_count: "9",
    aweme_play_count: "7475",
    aweme_activation: 0.7,
    live_count: "25",
    live_time: "2846",
    live_watch_count: 3161,
    live_watch_time: 3512,
    live_like_count: "9292",
    live_comment_count: "150",
    live_activation: 0.5,
    live_fans_add: "4",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "陕西泰岳",
    company_name: "陕西泰岳汽车销售服务有限公司",
    store_code: "XSS611",
    大区: "西部区",
    "省份-城市": "陕西省-西安市",
    "所选分组编号/分组名称": "-",
    fans_count: "1789",
    fans_count_total: "38285",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "90",
    aweme_like_count: "6626",
    aweme_comment_count: "604",
    aweme_share_count: "456",
    aweme_play_count: "1815945",
    aweme_activation: 0.9333,
    live_count: "60",
    live_time: "4314",
    live_watch_count: 107032,
    live_watch_time: 118924,
    live_like_count: "165161",
    live_comment_count: "10037",
    live_activation: 0.8333,
    live_fans_add: "440",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "合肥盈旗",
    company_name: "合肥盈旗汽车销售有限公司",
    store_code: "EAH619",
    大区: "华东区",
    "省份-城市": "安徽省-合肥市",
    "所选分组编号/分组名称": "-",
    fans_count: "393",
    fans_count_total: "115265",
    fans_tt_count: "27",
    fans_hs_count: 0,
    aweme_count: "55",
    aweme_like_count: "3772",
    aweme_comment_count: "384",
    aweme_share_count: "376",
    aweme_play_count: "853328",
    aweme_activation: 0.9667,
    live_count: "39",
    live_time: "2631",
    live_watch_count: 305833,
    live_watch_time: 339814,
    live_like_count: "232657",
    live_comment_count: "5616",
    live_activation: 0.9,
    live_fans_add: "815",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "安康硕德",
    company_name: "安康硕德汽车销售服务有限公司",
    store_code: "XSS612",
    大区: "西部区",
    "省份-城市": "陕西省-安康市",
    "所选分组编号/分组名称": "-",
    fans_count: "6",
    fans_count_total: "14661",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "33",
    aweme_like_count: "424",
    aweme_comment_count: "35",
    aweme_share_count: "24",
    aweme_play_count: "23725",
    aweme_activation: 0.9333,
    live_count: "42",
    live_time: "2810",
    live_watch_count: 1913,
    live_watch_time: 2125,
    live_like_count: "128531",
    live_comment_count: "677",
    live_activation: 0.7667,
    live_fans_add: "17",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "海宁广成海旗",
    company_name: "海宁广成海旗汽车有限公司",
    store_code: "EZJ626",
    大区: "华东区",
    "省份-城市": "浙江省-嘉兴市",
    "所选分组编号/分组名称": "-",
    fans_count: "204",
    fans_count_total: "10954",
    fans_tt_count: "71",
    fans_hs_count: 0,
    aweme_count: "40",
    aweme_like_count: "253",
    aweme_comment_count: "25",
    aweme_share_count: "2",
    aweme_play_count: "24857",
    aweme_activation: 0.9333,
    live_count: "51",
    live_time: "3398",
    live_watch_count: 71266,
    live_watch_time: 79184,
    live_like_count: "82701",
    live_comment_count: "4499",
    live_activation: 0.8667,
    live_fans_add: "255",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "泉州旗达",
    company_name: "泉州旗达汽车销售服务有限公司",
    store_code: "SFJ615",
    大区: "华南区",
    "省份-城市": "福建省-泉州市",
    "所选分组编号/分组名称": "-",
    fans_count: "289",
    fans_count_total: "9630",
    fans_tt_count: "687",
    fans_hs_count: 0,
    aweme_count: "26",
    aweme_like_count: "424",
    aweme_comment_count: "40",
    aweme_share_count: "18",
    aweme_play_count: "87701",
    aweme_activation: 0.5,
    live_count: "59",
    live_time: "3566",
    live_watch_count: 4265,
    live_watch_time: 4738,
    live_like_count: "762",
    live_comment_count: "851",
    live_activation: 0.8333,
    live_fans_add: "16",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "潮州晟汇",
    company_name: "潮州市晟汇汽车销售有限公司",
    store_code: "SGD635",
    大区: "华南区",
    "省份-城市": "广东省-潮州市",
    "所选分组编号/分组名称": "-",
    fans_count: "-268",
    fans_count_total: "25865",
    fans_tt_count: "57",
    fans_hs_count: 0,
    aweme_count: "56",
    aweme_like_count: "1350",
    aweme_comment_count: "154",
    aweme_share_count: "187",
    aweme_play_count: "200351",
    aweme_activation: 1,
    live_count: "53",
    live_time: "3306",
    live_watch_count: 10443,
    live_watch_time: 11603,
    live_like_count: "74847",
    live_comment_count: "2561",
    live_activation: 0.8,
    live_fans_add: "10",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "台州欧龙",
    company_name: "台州欧龙汽车销售服务有限公司",
    store_code: "EZJ627",
    大区: "华东区",
    "省份-城市": "浙江省-台州市",
    "所选分组编号/分组名称": "-",
    fans_count: "83",
    fans_count_total: "3909",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "67",
    aweme_like_count: "485",
    aweme_comment_count: "49",
    aweme_share_count: "18",
    aweme_play_count: "187446",
    aweme_activation: 0.7,
    live_count: "58",
    live_time: "3510",
    live_watch_count: 3623,
    live_watch_time: 4025,
    live_like_count: "6072",
    live_comment_count: "3139",
    live_activation: 0.8333,
    live_fans_add: "28",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "贺州中裕红祺",
    company_name: "贺州中裕红祺汽车销售服务有限公司",
    store_code: "SGX612",
    大区: "华南区",
    "省份-城市": "广西壮族自治区-贺州市",
    "所选分组编号/分组名称": "-",
    fans_count: "-4",
    fans_count_total: "1746",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "35",
    aweme_like_count: "152",
    aweme_comment_count: "3",
    aweme_share_count: 0,
    aweme_play_count: "4852",
    aweme_activation: 0.9667,
    live_count: "26",
    live_time: "1606",
    live_watch_count: 668,
    live_watch_time: 742,
    live_like_count: "92124",
    live_comment_count: "170",
    live_activation: 0.8,
    live_fans_add: "4",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "北京鸿旗福瑞",
    company_name: "北京鸿旗福瑞汽车销售服务有限公司",
    store_code: "NBJ606",
    大区: "华北区",
    "省份-城市": "北京市-北京市",
    "所选分组编号/分组名称": "-",
    fans_count: "579",
    fans_count_total: "47805",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "49",
    aweme_like_count: "916",
    aweme_comment_count: "89",
    aweme_share_count: "122",
    aweme_play_count: "172759",
    aweme_activation: 0.7333,
    live_count: "72",
    live_time: "4364",
    live_watch_count: 30736,
    live_watch_time: 34151,
    live_like_count: "14259",
    live_comment_count: "5343",
    live_activation: 0.8667,
    live_fans_add: "365",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "辽源歌蓝",
    company_name: "辽源歌蓝汽车销售服务有限公司",
    store_code: "DJL614",
    大区: "东北区",
    "省份-城市": "吉林省-辽源市",
    "所选分组编号/分组名称": "-",
    fans_count: "91",
    fans_count_total: "6517",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "39",
    aweme_like_count: "277",
    aweme_comment_count: "27",
    aweme_share_count: "35",
    aweme_play_count: "70909",
    aweme_activation: 0.6,
    live_count: "35",
    live_time: "2174",
    live_watch_count: 8080,
    live_watch_time: 8977,
    live_like_count: "71682",
    live_comment_count: "1369",
    live_activation: 0.9,
    live_fans_add: "102",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "保定华臻",
    company_name: "保定市华臻汽车服务有限公司",
    store_code: "NJI611",
    大区: "华北区",
    "省份-城市": "河北省-保定市",
    "所选分组编号/分组名称": "-",
    fans_count: "228",
    fans_count_total: "19137",
    fans_tt_count: "5479",
    fans_hs_count: 0,
    aweme_count: "57",
    aweme_like_count: "950",
    aweme_comment_count: "73",
    aweme_share_count: "107",
    aweme_play_count: "418227",
    aweme_activation: 0.6667,
    live_count: "169",
    live_time: "13797",
    live_watch_count: 146957,
    live_watch_time: 163285,
    live_like_count: "74614",
    live_comment_count: "6108",
    live_activation: 1,
    live_fans_add: "331",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "长沙旗颂",
    company_name: "长沙旗颂汽车销售有限公司",
    store_code: "CHN618",
    大区: "中南区",
    "省份-城市": "湖南省-长沙市",
    "所选分组编号/分组名称": "-",
    fans_count: "852",
    fans_count_total: "61310",
    fans_tt_count: "786",
    fans_hs_count: 0,
    aweme_count: "121",
    aweme_like_count: "3178",
    aweme_comment_count: "503",
    aweme_share_count: "592",
    aweme_play_count: "1512647",
    aweme_activation: 0.8667,
    live_count: "118",
    live_time: "9868",
    live_watch_count: 56113,
    live_watch_time: 62347,
    live_like_count: "56060",
    live_comment_count: "10311",
    live_activation: 0.9,
    live_fans_add: "1015",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "东莞神州弘达",
    company_name: "东莞神州弘达",
    store_code: "SGD633",
    大区: "华南区",
    "省份-城市": "广东省-东莞市",
    "所选分组编号/分组名称": "-",
    fans_count: "136",
    fans_count_total: "7752",
    fans_tt_count: "7",
    fans_hs_count: 0,
    aweme_count: "30",
    aweme_like_count: "342",
    aweme_comment_count: "31",
    aweme_share_count: "41",
    aweme_play_count: "64116",
    aweme_activation: 0.4,
    live_count: "40",
    live_time: "2719",
    live_watch_count: 8533,
    live_watch_time: 9481,
    live_like_count: "104882",
    live_comment_count: "3409",
    live_activation: 0.7,
    live_fans_add: "95",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "河北龙泽",
    company_name: "河北龙泽红旗汽车销售服务有限公司",
    store_code: "NJI612",
    大区: "华北区",
    "省份-城市": "河北省-廊坊市",
    "所选分组编号/分组名称": "-",
    fans_count: "-1",
    fans_count_total: "175",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "2",
    aweme_like_count: "7",
    aweme_comment_count: "1",
    aweme_share_count: "1",
    aweme_play_count: "737",
    aweme_activation: 0.0667,
    live_count: "4",
    live_time: "152",
    live_watch_count: 21,
    live_watch_time: 23,
    live_like_count: "2",
    live_comment_count: 0,
    live_activation: 0.1,
    live_fans_add: 0,
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "北海鸿福鸿福分公司",
    company_name: "北海广物汽车销售服务有限公司鸿福分公司",
    store_code: "SGX609",
    大区: "华南区",
    "省份-城市": "广西壮族自治区-北海市",
    "所选分组编号/分组名称": "-",
    fans_count: "13",
    fans_count_total: "3580",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "32",
    aweme_like_count: "187",
    aweme_comment_count: "37",
    aweme_share_count: "10",
    aweme_play_count: "43955",
    aweme_activation: 0.5667,
    live_count: "32",
    live_time: "1931",
    live_watch_count: 1208,
    live_watch_time: 1342,
    live_like_count: "12380",
    live_comment_count: "2082",
    live_activation: 0.9667,
    live_fans_add: "3",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "丹东鸿祺",
    company_name: "丹东鸿祺",
    store_code: "DLN614",
    大区: "东北区",
    "省份-城市": "辽宁省-丹东市",
    "所选分组编号/分组名称": "-",
    fans_count: "-5",
    fans_count_total: "2307",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "16",
    aweme_like_count: "79",
    aweme_comment_count: "12",
    aweme_share_count: "8",
    aweme_play_count: "12033",
    aweme_activation: 0.5333,
    live_count: "10",
    live_time: "570",
    live_watch_count: 1224,
    live_watch_time: 1360,
    live_like_count: "13562",
    live_comment_count: "822",
    live_activation: 0.3667,
    live_fans_add: "5",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "玉林同人",
    company_name: "玉林同人汽车销售服务有限公司",
    store_code: "SGX610",
    大区: "华南区",
    "省份-城市": "广西壮族自治区-玉林市",
    "所选分组编号/分组名称": "-",
    fans_count: "14",
    fans_count_total: "4668",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "29",
    aweme_like_count: "133",
    aweme_comment_count: "24",
    aweme_share_count: "5",
    aweme_play_count: "12569",
    aweme_activation: 0.6333,
    live_count: "37",
    live_time: "2281",
    live_watch_count: 12402,
    live_watch_time: 13780,
    live_like_count: "42170",
    live_comment_count: "1536",
    live_activation: 0.8667,
    live_fans_add: "50",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "海南博通",
    company_name: "海南博通",
    store_code: "SHN601",
    大区: "华南区",
    "省份-城市": "海南省-海口市",
    "所选分组编号/分组名称": "-",
    fans_count: "4",
    fans_count_total: "55",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "18",
    aweme_like_count: "37",
    aweme_comment_count: 0,
    aweme_share_count: "2",
    aweme_play_count: "1624",
    aweme_activation: 0.4333,
    live_count: "1",
    live_time: "78",
    live_watch_count: 249,
    live_watch_time: 276,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: 0.0333,
    live_fans_add: 0,
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "铜陵鑫福瑞",
    company_name: "铜陵鑫福瑞汽车销售服务有限公司",
    store_code: "EAH620",
    大区: "华东区",
    "省份-城市": "安徽省-铜陵市",
    "所选分组编号/分组名称": "-",
    fans_count: "76",
    fans_count_total: "9994",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "90",
    aweme_like_count: "798",
    aweme_comment_count: "46",
    aweme_share_count: "101",
    aweme_play_count: "253538",
    aweme_activation: 0.8333,
    live_count: "25",
    live_time: "1527",
    live_watch_count: 22203,
    live_watch_time: 24670,
    live_like_count: "36566",
    live_comment_count: "887",
    live_activation: 0.4667,
    live_fans_add: "74",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "南宁达美",
    company_name: "南宁达美汽车销售服务有限公司",
    store_code: "SGX613",
    大区: "华南区",
    "省份-城市": "广西壮族自治区-南宁市",
    "所选分组编号/分组名称": "-",
    fans_count: "322",
    fans_count_total: "10759",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "72",
    aweme_like_count: "923",
    aweme_comment_count: "133",
    aweme_share_count: "16",
    aweme_play_count: "174653",
    aweme_activation: 1,
    live_count: "34",
    live_time: "2088",
    live_watch_count: 14740,
    live_watch_time: 16377,
    live_like_count: "56984",
    live_comment_count: "4867",
    live_activation: 0.8667,
    live_fans_add: "245",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "深圳鸿钧",
    company_name: "深圳鸿钧",
    store_code: "SGD651",
    大区: "华南区",
    "省份-城市": "广东省-深圳市",
    "所选分组编号/分组名称": "-",
    fans_count: "13",
    fans_count_total: "2603",
    fans_tt_count: "1",
    fans_hs_count: 0,
    aweme_count: "23",
    aweme_like_count: "44",
    aweme_comment_count: 0,
    aweme_share_count: "2",
    aweme_play_count: "4897",
    aweme_activation: 0.1667,
    live_count: "18",
    live_time: "1136",
    live_watch_count: 570,
    live_watch_time: 633,
    live_like_count: "3000",
    live_comment_count: "134",
    live_activation: 0.2667,
    live_fans_add: "3",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "广州南菱旗盛",
    company_name: "广州南菱旗盛汽车有限公司",
    store_code: "SGD634",
    大区: "华南区",
    "省份-城市": "广东省-广州市",
    "所选分组编号/分组名称": "-",
    fans_count: "232",
    fans_count_total: "10648",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "84",
    aweme_like_count: "466",
    aweme_comment_count: "53",
    aweme_share_count: "61",
    aweme_play_count: "311219",
    aweme_activation: 0.8333,
    live_count: "74",
    live_time: "4531",
    live_watch_count: 48813,
    live_watch_time: 54236,
    live_like_count: "95790",
    live_comment_count: "2283",
    live_activation: 0.8333,
    live_fans_add: "176",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "广州汉旗",
    company_name: "广州汉旗汽车贸易有限公司",
    store_code: "SGD641",
    大区: "华南区",
    "省份-城市": "广东省-广州市",
    "所选分组编号/分组名称": "-",
    fans_count: "1088",
    fans_count_total: "37527",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "63",
    aweme_like_count: "1291",
    aweme_comment_count: "144",
    aweme_share_count: "114",
    aweme_play_count: "266684",
    aweme_activation: 0.8,
    live_count: "63",
    live_time: "4423",
    live_watch_count: 566192,
    live_watch_time: 629102,
    live_like_count: "95314",
    live_comment_count: "12737",
    live_activation: 0.8333,
    live_fans_add: "659",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "上海锦筝",
    company_name: "上海锦筝汽车销售服务有限公司",
    store_code: "ESH611",
    大区: "华东区",
    "省份-城市": "上海市-上海市",
    "所选分组编号/分组名称": "-",
    fans_count: "-413",
    fans_count_total: "28879",
    fans_tt_count: "85",
    fans_hs_count: 0,
    aweme_count: 0,
    aweme_like_count: 0,
    aweme_comment_count: 0,
    aweme_share_count: 0,
    aweme_play_count: 0,
    aweme_activation: 0,
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: 0,
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "西安博行大展",
    company_name: "西安博行大展汽车销售服务有限公司",
    store_code: "XSS610",
    大区: "西部区",
    "省份-城市": "陕西省-西安市",
    "所选分组编号/分组名称": "-",
    fans_count: "503",
    fans_count_total: "49317",
    fans_tt_count: "1074",
    fans_hs_count: 0,
    aweme_count: "64",
    aweme_like_count: "1197",
    aweme_comment_count: "129",
    aweme_share_count: "161",
    aweme_play_count: "484814",
    aweme_activation: 0.8667,
    live_count: "67",
    live_time: "4132",
    live_watch_count: 116088,
    live_watch_time: 128986,
    live_like_count: "26969",
    live_comment_count: "8585",
    live_activation: 0.9333,
    live_fans_add: "940",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "东阳欧龙",
    company_name: "东阳欧龙汽车有限公司",
    store_code: "EZJ628",
    大区: "华东区",
    "省份-城市": "浙江省-金华市",
    "所选分组编号/分组名称": "-",
    fans_count: "297",
    fans_count_total: "8807",
    fans_tt_count: "57",
    fans_hs_count: 0,
    aweme_count: "96",
    aweme_like_count: "1200",
    aweme_comment_count: "230",
    aweme_share_count: "78",
    aweme_play_count: "827286",
    aweme_activation: 0.8333,
    live_count: "49",
    live_time: "3085",
    live_watch_count: 5668,
    live_watch_time: 6297,
    live_like_count: "41769",
    live_comment_count: "3052",
    live_activation: 0.8,
    live_fans_add: "69",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "天水天升星旗",
    company_name: "天水天升星旗汽车销售服务有限公司",
    store_code: "XGS604",
    大区: "西部区",
    "省份-城市": "甘肃省-天水市",
    "所选分组编号/分组名称": "-",
    fans_count: "62",
    fans_count_total: "2054",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "53",
    aweme_like_count: "593",
    aweme_comment_count: "16",
    aweme_share_count: "9",
    aweme_play_count: "26604",
    aweme_activation: 0.9333,
    live_count: "49",
    live_time: "3617",
    live_watch_count: 4134,
    live_watch_time: 4593,
    live_like_count: "238651",
    live_comment_count: "1433",
    live_activation: 0.8333,
    live_fans_add: "75",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "广西宝旗勇昌",
    company_name: "广西宝旗勇昌汽车销售服务有限公司",
    store_code: "SGX614",
    大区: "华南区",
    "省份-城市": "广西壮族自治区-南宁市",
    "所选分组编号/分组名称": "-",
    fans_count: "112",
    fans_count_total: "3139",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "34",
    aweme_like_count: "466",
    aweme_comment_count: "49",
    aweme_share_count: "113",
    aweme_play_count: "42842",
    aweme_activation: 0.9,
    live_count: "42",
    live_time: "2589",
    live_watch_count: 9313,
    live_watch_time: 10347,
    live_like_count: "117986",
    live_comment_count: "4318",
    live_activation: 0.8,
    live_fans_add: "86",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "新余市新征途",
    company_name: "新余市新征途汽车销售服务有限公司",
    store_code: "CJX612",
    大区: "中南区",
    "省份-城市": "江西省-新余市",
    "所选分组编号/分组名称": "-",
    fans_count: "139",
    fans_count_total: "13457",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "23",
    aweme_like_count: "575",
    aweme_comment_count: "163",
    aweme_share_count: "87",
    aweme_play_count: "113006",
    aweme_activation: 0.5667,
    live_count: "34",
    live_time: "2108",
    live_watch_count: 20650,
    live_watch_time: 22944,
    live_like_count: "277057",
    live_comment_count: "8439",
    live_activation: 0.8333,
    live_fans_add: "246",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "三亚华奥文源",
    company_name: "三亚华奥文源汽车工贸有限公司",
    store_code: "SHN602",
    大区: "华南区",
    "省份-城市": "海南省-三亚市",
    "所选分组编号/分组名称": "-",
    fans_count: "-6",
    fans_count_total: "13541",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "40",
    aweme_like_count: "212",
    aweme_comment_count: "19",
    aweme_share_count: "22",
    aweme_play_count: "16399",
    aweme_activation: 0.7333,
    live_count: "32",
    live_time: "1860",
    live_watch_count: 4453,
    live_watch_time: 4947,
    live_like_count: "122806",
    live_comment_count: "1995",
    live_activation: 0.5333,
    live_fans_add: "23",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "贵州星启源",
    company_name: "贵州星启源汽车销售服务有限公司",
    store_code: "WGZ613",
    大区: "西部区",
    "省份-城市": "贵州省-遵义市",
    "所选分组编号/分组名称": "-",
    fans_count: "4",
    fans_count_total: "11638",
    fans_tt_count: "28",
    fans_hs_count: 0,
    aweme_count: "45",
    aweme_like_count: "477",
    aweme_comment_count: "60",
    aweme_share_count: "31",
    aweme_play_count: "29683",
    aweme_activation: 1,
    live_count: "41",
    live_time: "2538",
    live_watch_count: 6780,
    live_watch_time: 7533,
    live_like_count: "30246",
    live_comment_count: "4336",
    live_activation: 0.8667,
    live_fans_add: "76",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "温州欧龙",
    company_name: "温州欧龙机电有限公司",
    store_code: "EZJ622",
    大区: "华东区",
    "省份-城市": "浙江省-温州市",
    "所选分组编号/分组名称": "-",
    fans_count: "301",
    fans_count_total: "19245",
    fans_tt_count: "59",
    fans_hs_count: 0,
    aweme_count: "82",
    aweme_like_count: "403",
    aweme_comment_count: "72",
    aweme_share_count: "15",
    aweme_play_count: "149416",
    aweme_activation: 1,
    live_count: "55",
    live_time: "3289",
    live_watch_count: 128919,
    live_watch_time: 143243,
    live_like_count: "165138",
    live_comment_count: "3309",
    live_activation: 0.8333,
    live_fans_add: "271",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "宁德华奥宏旗",
    company_name: "宁德华奥宏旗汽车销售有限公司",
    store_code: "SFJ611",
    大区: "华南区",
    "省份-城市": "福建省-宁德市",
    "所选分组编号/分组名称": "-",
    fans_count: "119",
    fans_count_total: "12485",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "156",
    aweme_like_count: "804",
    aweme_comment_count: "120",
    aweme_share_count: "72",
    aweme_play_count: "66048",
    aweme_activation: 1,
    live_count: "63",
    live_time: "3765",
    live_watch_count: 3773,
    live_watch_time: 4192,
    live_like_count: "67681",
    live_comment_count: "2512",
    live_activation: 0.9667,
    live_fans_add: "35",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "临沧国源",
    company_name: "临沧国源汽车销售服务有限公司",
    store_code: "WYN616",
    大区: "西部区",
    "省份-城市": "云南省-临沧市",
    "所选分组编号/分组名称": "-",
    fans_count: "-44",
    fans_count_total: "8624",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "24",
    aweme_like_count: "147",
    aweme_comment_count: "11",
    aweme_share_count: "11",
    aweme_play_count: "28473",
    aweme_activation: 0.5,
    live_count: "34",
    live_time: "2362",
    live_watch_count: 2676,
    live_watch_time: 2973,
    live_like_count: "127468",
    live_comment_count: "4386",
    live_activation: 0.8,
    live_fans_add: "17",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "宁夏汽车大世界吴忠",
    company_name: "宁夏汽车大世界吴忠",
    store_code: "XNX601",
    大区: "西部区",
    "省份-城市": "宁夏回族自治区-吴忠市",
    "所选分组编号/分组名称": "-",
    fans_count: "135",
    fans_count_total: "2490",
    fans_tt_count: "94",
    fans_hs_count: 0,
    aweme_count: "85",
    aweme_like_count: "866",
    aweme_comment_count: "77",
    aweme_share_count: "41",
    aweme_play_count: "423689",
    aweme_activation: 0.8,
    live_count: "109",
    live_time: "6624",
    live_watch_count: 7900,
    live_watch_time: 8777,
    live_like_count: "9300",
    live_comment_count: "1624",
    live_activation: 0.8667,
    live_fans_add: "12",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "厦门欧骋",
    company_name: "厦门欧骋",
    store_code: "SFJ617",
    大区: "华南区",
    "省份-城市": "福建省-厦门市",
    "所选分组编号/分组名称": "-",
    fans_count: "41",
    fans_count_total: "58568",
    fans_tt_count: "81",
    fans_hs_count: 0,
    aweme_count: "35",
    aweme_like_count: "261",
    aweme_comment_count: "36",
    aweme_share_count: "30",
    aweme_play_count: "54157",
    aweme_activation: 0.9333,
    live_count: "45",
    live_time: "2596",
    live_watch_count: 34818,
    live_watch_time: 38686,
    live_like_count: "57745",
    live_comment_count: "5240",
    live_activation: 0.7667,
    live_fans_add: "579",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "南京宏众大晟",
    company_name: "南京宏众大晟汽车销售有限公司",
    store_code: "EJS625",
    大区: "华东区",
    "省份-城市": "江苏省-南京市",
    "所选分组编号/分组名称": "-",
    fans_count: "160",
    fans_count_total: "33169",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "71",
    aweme_like_count: "269",
    aweme_comment_count: "14",
    aweme_share_count: "14",
    aweme_play_count: "40158",
    aweme_activation: 0.6333,
    live_count: "52",
    live_time: "4512",
    live_watch_count: 139156,
    live_watch_time: 154617,
    live_like_count: "33198",
    live_comment_count: "1619",
    live_activation: 0.8333,
    live_fans_add: "401",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "上海岱岳红旗",
    company_name: "上海岱岳汽车销售服务有限公司",
    store_code: "ESH616",
    大区: "华东区",
    "省份-城市": "上海市-上海市",
    "所选分组编号/分组名称": "-",
    fans_count: "323",
    fans_count_total: "11608",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "67",
    aweme_like_count: "599",
    aweme_comment_count: "64",
    aweme_share_count: "72",
    aweme_play_count: "106600",
    aweme_activation: 1,
    live_count: "54",
    live_time: "3392",
    live_watch_count: 148805,
    live_watch_time: 165338,
    live_like_count: "413467",
    live_comment_count: "16139",
    live_activation: 0.6333,
    live_fans_add: "480",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "赣州鸿旗",
    company_name: "赣州市鸿旗汽车有限公司",
    store_code: "CJX614",
    大区: "中南区",
    "省份-城市": "江西省-赣州市",
    "所选分组编号/分组名称": "-",
    fans_count: "16",
    fans_count_total: "5220",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "13",
    aweme_like_count: "170",
    aweme_comment_count: "12",
    aweme_share_count: "15",
    aweme_play_count: "105822",
    aweme_activation: 0.4,
    live_count: "37",
    live_time: "2178",
    live_watch_count: 3120,
    live_watch_time: 3466,
    live_like_count: "11733",
    live_comment_count: "1027",
    live_activation: 0.8333,
    live_fans_add: "11",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "沧州华泓",
    company_name: "沧州华泓汽车服务有限公司",
    store_code: "NJI616",
    大区: "华北区",
    "省份-城市": "河北省-沧州市",
    "所选分组编号/分组名称": "-",
    fans_count: "44",
    fans_count_total: "6937",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "43",
    aweme_like_count: "225",
    aweme_comment_count: "24",
    aweme_share_count: "23",
    aweme_play_count: "108455",
    aweme_activation: 0.5333,
    live_count: "44",
    live_time: "2576",
    live_watch_count: 4046,
    live_watch_time: 4495,
    live_like_count: "34902",
    live_comment_count: "2904",
    live_activation: 0.8333,
    live_fans_add: "34",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "唐山泰岳宏旗体验中心",
    company_name: "唐山泰岳宏旗体验中心",
    store_code: "NJI614",
    大区: "华北区",
    "省份-城市": "河北省-唐山市",
    "所选分组编号/分组名称": "-",
    fans_count: "833",
    fans_count_total: "13456",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "56",
    aweme_like_count: "460",
    aweme_comment_count: "204",
    aweme_share_count: "1718",
    aweme_play_count: "36113",
    aweme_activation: 0.8,
    live_count: "59",
    live_time: "3669",
    live_watch_count: 83063,
    live_watch_time: 92292,
    live_like_count: "1753769",
    live_comment_count: "36415",
    live_activation: 0.8,
    live_fans_add: "1431",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "宁夏汽车大世界红旗",
    company_name: "宁夏汽车大世界红旗",
    store_code: "XNX602",
    大区: "西部区",
    "省份-城市": "宁夏回族自治区-银川市",
    "所选分组编号/分组名称": "-",
    fans_count: "174",
    fans_count_total: "3016",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "115",
    aweme_like_count: "1248",
    aweme_comment_count: "122",
    aweme_share_count: "90",
    aweme_play_count: "205092",
    aweme_activation: 0.9667,
    live_count: "72",
    live_time: "4527",
    live_watch_count: 7727,
    live_watch_time: 8585,
    live_like_count: "14663",
    live_comment_count: "1911",
    live_activation: 0.8667,
    live_fans_add: "93",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "永康正鑫",
    company_name: "永康正鑫",
    store_code: "EZJ634",
    大区: "华东区",
    "省份-城市": "浙江省-金华市",
    "所选分组编号/分组名称": "-",
    fans_count: "114",
    fans_count_total: "2358",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "47",
    aweme_like_count: "605",
    aweme_comment_count: "73",
    aweme_share_count: "31",
    aweme_play_count: "210293",
    aweme_activation: 0.7,
    live_count: "48",
    live_time: "3007",
    live_watch_count: 2844,
    live_watch_time: 3160,
    live_like_count: "5303",
    live_comment_count: "6215",
    live_activation: 0.9333,
    live_fans_add: "40",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "哈尔滨森华红旗体验中心",
    company_name: "哈尔滨森华红旗体验中心",
    store_code: "DHL610",
    大区: "东北区",
    "省份-城市": "黑龙江省-哈尔滨市",
    "所选分组编号/分组名称": "-",
    fans_count: "615",
    fans_count_total: "3407",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "60",
    aweme_like_count: "124",
    aweme_comment_count: "29",
    aweme_share_count: "8",
    aweme_play_count: "26181",
    aweme_activation: 0.5667,
    live_count: "49",
    live_time: "3355",
    live_watch_count: 62811,
    live_watch_time: 69790,
    live_like_count: "431745",
    live_comment_count: "11310",
    live_activation: 0.7333,
    live_fans_add: "694",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "新疆国奥伟鸿",
    company_name: "新疆国奥伟鸿",
    store_code: "XXJ607",
    大区: "西部区",
    "省份-城市": "新疆维吾尔自治区-乌鲁木齐市",
    "所选分组编号/分组名称": "-",
    fans_count: "5",
    fans_count_total: "533",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "46",
    aweme_like_count: "84",
    aweme_comment_count: "7",
    aweme_share_count: "22",
    aweme_play_count: "5230",
    aweme_activation: 0.8333,
    live_count: "40",
    live_time: "3101",
    live_watch_count: 4166,
    live_watch_time: 4628,
    live_like_count: "21606",
    live_comment_count: "2981",
    live_activation: 0.6667,
    live_fans_add: "26",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "天津领通",
    company_name: "天津领通",
    store_code: "NTJ606",
    大区: "华北区",
    "省份-城市": "天津市-天津市",
    "所选分组编号/分组名称": "-",
    fans_count: "135",
    fans_count_total: "13470",
    fans_tt_count: "152",
    fans_hs_count: 0,
    aweme_count: "26",
    aweme_like_count: "230",
    aweme_comment_count: "31",
    aweme_share_count: "37",
    aweme_play_count: "91803",
    aweme_activation: 0.5667,
    live_count: "23",
    live_time: "1359",
    live_watch_count: 91752,
    live_watch_time: 101946,
    live_like_count: "62654",
    live_comment_count: "1471",
    live_activation: 0.8333,
    live_fans_add: "180",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "辽宁福宏旗",
    company_name: "辽宁福宏旗",
    store_code: "DLN618",
    大区: "东北区",
    "省份-城市": "辽宁省-沈阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "155",
    fans_count_total: "502",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "53",
    aweme_like_count: "134",
    aweme_comment_count: "19",
    aweme_share_count: "36",
    aweme_play_count: "42528",
    aweme_activation: 0.6667,
    live_count: "45",
    live_time: "2817",
    live_watch_count: 5746,
    live_watch_time: 6384,
    live_like_count: "13815",
    live_comment_count: "791",
    live_activation: 0.8333,
    live_fans_add: "41",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "聊城北斗泰和",
    company_name: "聊城北斗泰和",
    store_code: "NSD630",
    大区: "东北区",
    "省份-城市": "山东省-聊城市",
    "所选分组编号/分组名称": "-",
    fans_count: "48",
    fans_count_total: "455",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "52",
    aweme_like_count: "166",
    aweme_comment_count: "22",
    aweme_share_count: "17",
    aweme_play_count: "9244",
    aweme_activation: 0.9333,
    live_count: "52",
    live_time: "3168",
    live_watch_count: 6579,
    live_watch_time: 7310,
    live_like_count: "61616",
    live_comment_count: "1208",
    live_activation: 0.9333,
    live_fans_add: "32",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "廊坊车朋达",
    company_name: "廊坊车朋达",
    store_code: "NJI617",
    大区: "华北区",
    "省份-城市": "河北省-廊坊市",
    "所选分组编号/分组名称": "-",
    fans_count: "21",
    fans_count_total: "166",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "50",
    aweme_like_count: "149",
    aweme_comment_count: "12",
    aweme_share_count: "13",
    aweme_play_count: "7711",
    aweme_activation: 0.6333,
    live_count: "67",
    live_time: "4011",
    live_watch_count: 6212,
    live_watch_time: 6902,
    live_like_count: "52465",
    live_comment_count: "93",
    live_activation: 0.9667,
    live_fans_add: "8",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "辽宁和奉",
    company_name: "辽宁和奉",
    store_code: "DLN619",
    大区: "东北区",
    "省份-城市": "辽宁省-沈阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "136",
    fans_count_total: "693",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "26",
    aweme_like_count: "95",
    aweme_comment_count: "4",
    aweme_share_count: "9",
    aweme_play_count: "9041",
    aweme_activation: 0.6667,
    live_count: "14",
    live_time: "816",
    live_watch_count: 617,
    live_watch_time: 685,
    live_like_count: "4283",
    live_comment_count: "454",
    live_activation: 0.4667,
    live_fans_add: "29",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "喀什通工宏旗",
    company_name: "喀什通工宏旗",
    store_code: "XXJ606",
    大区: "西部区",
    "省份-城市": "新疆维吾尔自治区-喀什地区",
    "所选分组编号/分组名称": "-",
    fans_count: "173",
    fans_count_total: "3442",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "46",
    aweme_like_count: "972",
    aweme_comment_count: "107",
    aweme_share_count: "214",
    aweme_play_count: "438378",
    aweme_activation: 0.9,
    live_count: "56",
    live_time: "3354",
    live_watch_count: 3156,
    live_watch_time: 3506,
    live_like_count: "124284",
    live_comment_count: "2755",
    live_activation: 0.9333,
    live_fans_add: "36",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "佛山富华",
    company_name: "佛山富华",
    store_code: "SGD653",
    大区: "华南区",
    "省份-城市": "广东省-佛山市",
    "所选分组编号/分组名称": "-",
    fans_count: "938",
    fans_count_total: "3181",
    fans_tt_count: "16",
    fans_hs_count: 0,
    aweme_count: "47",
    aweme_like_count: "1014",
    aweme_comment_count: "108",
    aweme_share_count: "112",
    aweme_play_count: "286181",
    aweme_activation: 0.7333,
    live_count: "90",
    live_time: "5517",
    live_watch_count: 13104,
    live_watch_time: 14560,
    live_like_count: "33725",
    live_comment_count: "3952",
    live_activation: 0.8667,
    live_fans_add: "536",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "蚌埠福顺红旗体验中心",
    company_name: "蚌埠福顺红旗体验中心",
    store_code: "EAH623",
    大区: "华东区",
    "省份-城市": "安徽省-蚌埠市",
    "所选分组编号/分组名称": "-",
    fans_count: "202",
    fans_count_total: "1039",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "49",
    aweme_like_count: "445",
    aweme_comment_count: "59",
    aweme_share_count: "25",
    aweme_play_count: "85385",
    aweme_activation: 0.8667,
    live_count: "66",
    live_time: "4101",
    live_watch_count: 5288,
    live_watch_time: 5875,
    live_like_count: "46973",
    live_comment_count: "4227",
    live_activation: 0.8667,
    live_fans_add: "169",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "南京朗驰旗胜红旗融合4s店",
    company_name: "南京朗驰旗胜红旗融合4s店",
    store_code: "EJS635",
    大区: "华东区",
    "省份-城市": "江苏省-南京市",
    "所选分组编号/分组名称": "-",
    fans_count: "91",
    fans_count_total: "325",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "73",
    aweme_like_count: "273",
    aweme_comment_count: "19",
    aweme_share_count: "6",
    aweme_play_count: "10071",
    aweme_activation: 0.4667,
    live_count: "50",
    live_time: "3194",
    live_watch_count: 13384,
    live_watch_time: 14871,
    live_like_count: "33723",
    live_comment_count: "1292",
    live_activation: 0.8333,
    live_fans_add: "65",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "新乡市融之汇",
    company_name: "新乡市融之汇",
    store_code: "NYU626",
    大区: "华北区",
    "省份-城市": "河南省-新乡市",
    "所选分组编号/分组名称": "-",
    fans_count: "725",
    fans_count_total: "4290",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "28",
    aweme_like_count: "280",
    aweme_comment_count: "28",
    aweme_share_count: "30",
    aweme_play_count: "14662",
    aweme_activation: 1,
    live_count: "58",
    live_time: "3317",
    live_watch_count: 6253,
    live_watch_time: 6947,
    live_like_count: "9348",
    live_comment_count: "1466",
    live_activation: 0.9,
    live_fans_add: "236",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "北京奥信鸿旗汽车销售服务有限公司",
    company_name: "北京奥信鸿旗汽车销售服务有限公司",
    store_code: "NBJ613",
    大区: "华北区",
    "省份-城市": "北京市-北京市",
    "所选分组编号/分组名称": "-",
    fans_count: "10",
    fans_count_total: "822",
    fans_tt_count: "12",
    fans_hs_count: 0,
    aweme_count: "30",
    aweme_like_count: "187",
    aweme_comment_count: "16",
    aweme_share_count: "16",
    aweme_play_count: "5277",
    aweme_activation: 0.6,
    live_count: "75",
    live_time: "5569",
    live_watch_count: 6070,
    live_watch_time: 6744,
    live_like_count: "116583",
    live_comment_count: "1525",
    live_activation: 0.8667,
    live_fans_add: "11",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "宁波东旗",
    company_name: "宁波东旗",
    store_code: "EZJ635",
    大区: "华东区",
    "省份-城市": "浙江省-宁波市",
    "所选分组编号/分组名称": "-",
    fans_count: "109",
    fans_count_total: "371",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "88",
    aweme_like_count: "632",
    aweme_comment_count: "40",
    aweme_share_count: "67",
    aweme_play_count: "238573",
    aweme_activation: 1,
    live_count: "23",
    live_time: "1194",
    live_watch_count: 500,
    live_watch_time: 555,
    live_like_count: "1454",
    live_comment_count: "179",
    live_activation: 0.7,
    live_fans_add: "19",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "盐城雅锋",
    company_name: "盐城雅锋",
    store_code: "EJS401",
    大区: "华东区",
    "省份-城市": "江苏省-盐城市",
    "所选分组编号/分组名称": "-",
    fans_count: "313",
    fans_count_total: "313",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "35",
    aweme_like_count: "137",
    aweme_comment_count: "4",
    aweme_share_count: "3",
    aweme_play_count: "6920",
    aweme_activation: 0.7,
    live_count: "41",
    live_time: "2559",
    live_watch_count: 5164,
    live_watch_time: 5737,
    live_like_count: "8340",
    live_comment_count: "3983",
    live_activation: 0.8667,
    live_fans_add: "105",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "乌鲁木齐泰岳红旗体验中心",
    company_name: "乌鲁木齐泰岳红旗体验中心",
    store_code: "XXJ604",
    大区: "西部区",
    "省份-城市": "新疆维吾尔自治区-乌鲁木齐市",
    "所选分组编号/分组名称": "-",
    fans_count: "221",
    fans_count_total: "7643",
    fans_tt_count: "2",
    fans_hs_count: 0,
    aweme_count: "41",
    aweme_like_count: "728",
    aweme_comment_count: "37",
    aweme_share_count: "39",
    aweme_play_count: "188507",
    aweme_activation: 0.3,
    live_count: "70",
    live_time: "4282",
    live_watch_count: 7149,
    live_watch_time: 7943,
    live_like_count: "39548",
    live_comment_count: "1548",
    live_activation: 0.8333,
    live_fans_add: "72",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "郑州博行大展汽车",
    company_name: "郑州博行大展汽车",
    store_code: "NYU622",
    大区: "华北区",
    "省份-城市": "河南省-郑州市",
    "所选分组编号/分组名称": "-",
    fans_count: "2820",
    fans_count_total: "25031",
    fans_tt_count: "26",
    fans_hs_count: 0,
    aweme_count: "73",
    aweme_like_count: "1133",
    aweme_comment_count: "165",
    aweme_share_count: "164",
    aweme_play_count: "223398",
    aweme_activation: 0.7333,
    live_count: "71",
    live_time: "3770",
    live_watch_count: 97198,
    live_watch_time: 107997,
    live_like_count: "32116",
    live_comment_count: "11082",
    live_activation: 0.7667,
    live_fans_add: "1098",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "沈阳德联旗骏店",
    company_name: "沈阳德联旗骏店",
    store_code: "DLN617",
    大区: "东北区",
    "省份-城市": "辽宁省-沈阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "160",
    fans_count_total: "1896",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "34",
    aweme_like_count: "139",
    aweme_comment_count: "8",
    aweme_share_count: "20",
    aweme_play_count: "55979",
    aweme_activation: 0.4667,
    live_count: "43",
    live_time: "2521",
    live_watch_count: 9974,
    live_watch_time: 11082,
    live_like_count: "33245",
    live_comment_count: "2064",
    live_activation: 0.7333,
    live_fans_add: "148",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "合肥博融祥之旗",
    company_name: "合肥博融祥之旗",
    store_code: "EAH622",
    大区: "华东区",
    "省份-城市": "安徽省-合肥市",
    "所选分组编号/分组名称": "-",
    fans_count: "455",
    fans_count_total: "6169",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "68",
    aweme_like_count: "310",
    aweme_comment_count: "9",
    aweme_share_count: "45",
    aweme_play_count: "53104",
    aweme_activation: 0.9,
    live_count: "98",
    live_time: "6158",
    live_watch_count: 24339,
    live_watch_time: 27043,
    live_like_count: "7867",
    live_comment_count: "4430",
    live_activation: 1,
    live_fans_add: "452",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "驻马店祥聚",
    company_name: "驻马店祥聚",
    store_code: "NYU624",
    大区: "华北区",
    "省份-城市": "河南省-驻马店市",
    "所选分组编号/分组名称": "-",
    fans_count: "118",
    fans_count_total: "1666",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "10",
    aweme_like_count: "717",
    aweme_comment_count: "67",
    aweme_share_count: "88",
    aweme_play_count: "308502",
    aweme_activation: 0.4667,
    live_count: "17",
    live_time: "1057",
    live_watch_count: 2348,
    live_watch_time: 2608,
    live_like_count: "241",
    live_comment_count: "404",
    live_activation: 0.4667,
    live_fans_add: "14",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "江苏协众旗瑞",
    company_name: "江苏协众旗瑞",
    store_code: "EJS634",
    大区: "华东区",
    "省份-城市": "江苏省-南京市",
    "所选分组编号/分组名称": "-",
    fans_count: "293",
    fans_count_total: "4048",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "41",
    aweme_like_count: "497",
    aweme_comment_count: "59",
    aweme_share_count: "32",
    aweme_play_count: "117388",
    aweme_activation: 0.7333,
    live_count: "67",
    live_time: "4061",
    live_watch_count: 26151,
    live_watch_time: 29056,
    live_like_count: "68811",
    live_comment_count: "4312",
    live_activation: 0.8667,
    live_fans_add: "270",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "周口人合元南环",
    company_name: "周口人合元南环",
    store_code: "NYU625",
    大区: "华北区",
    "省份-城市": "河南省-周口市",
    "所选分组编号/分组名称": "-",
    fans_count: "242",
    fans_count_total: "8139",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "73",
    aweme_like_count: "771",
    aweme_comment_count: "65",
    aweme_share_count: "54",
    aweme_play_count: "198919",
    aweme_activation: 0.9333,
    live_count: "87",
    live_time: "5367",
    live_watch_count: 19978,
    live_watch_time: 22197,
    live_like_count: "321229",
    live_comment_count: "5537",
    live_activation: 0.8667,
    live_fans_add: "213",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "兰州新瑞宏旗体验中心",
    company_name: "兰州新瑞宏旗体验中心",
    store_code: "XGS605",
    大区: "西部区",
    "省份-城市": "甘肃省-兰州市",
    "所选分组编号/分组名称": "-",
    fans_count: "480",
    fans_count_total: "6923",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "76",
    aweme_like_count: "528",
    aweme_comment_count: "27",
    aweme_share_count: "56",
    aweme_play_count: "190042",
    aweme_activation: 1,
    live_count: "96",
    live_time: "6220",
    live_watch_count: 185141,
    live_watch_time: 205712,
    live_like_count: "61512",
    live_comment_count: "2688",
    live_activation: 1,
    live_fans_add: "630",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "上海东创宏旗汽车销售服务有限公司",
    company_name: "上海东创宏旗汽车销售服务有限公司",
    store_code: "ESH618",
    大区: "华东区",
    "省份-城市": "上海市-上海市",
    "所选分组编号/分组名称": "-",
    fans_count: "2150",
    fans_count_total: "17486",
    fans_tt_count: 0,
    fans_hs_count: 0,
    aweme_count: "44",
    aweme_like_count: "2852",
    aweme_comment_count: "155",
    aweme_share_count: "128",
    aweme_play_count: "246480",
    aweme_activation: 0.9667,
    live_count: "42",
    live_time: "2490",
    live_watch_count: 590112,
    live_watch_time: 655680,
    live_like_count: "204769",
    live_comment_count: "14081",
    live_activation: 0.7,
    live_fans_add: "1942",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "阿克苏万禾",
    company_name: "阿克苏万禾",
    store_code: "XXJ605",
    大区: "西部区",
    "省份-城市": "新疆维吾尔自治区-阿克苏地区",
    "所选分组编号/分组名称": "-",
    fans_count: "2436",
    fans_count_total: "15601",
    fans_tt_count: "11",
    fans_hs_count: 0,
    aweme_count: "217",
    aweme_like_count: "8803",
    aweme_comment_count: "1345",
    aweme_share_count: "1360",
    aweme_play_count: "1741392",
    aweme_activation: 1,
    live_count: "141",
    live_time: "9983",
    live_watch_count: 14828,
    live_watch_time: 16475,
    live_like_count: "412964",
    live_comment_count: "7736",
    live_activation: 0.8667,
    live_fans_add: "182",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "郑州威佳红旗",
    company_name: "郑州威佳红旗",
    store_code: "NYU623",
    大区: "华北区",
    "省份-城市": "河南省-郑州市",
    "所选分组编号/分组名称": "-",
    fans_count: "3497",
    fans_count_total: "6886",
    fans_tt_count: "25",
    fans_hs_count: 0,
    aweme_count: "64",
    aweme_like_count: "778",
    aweme_comment_count: "60",
    aweme_share_count: "99",
    aweme_play_count: "166416",
    aweme_activation: 0.5333,
    live_count: "196",
    live_time: "17108",
    live_watch_count: 55955,
    live_watch_time: 62172,
    live_like_count: "39019",
    live_comment_count: "5756",
    live_activation: 0.8333,
    live_fans_add: "451",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "滨州国悦",
    company_name: "滨州市国悦汽车销售服务有限公司 ",
    store_code: "NSD401",
    大区: "东北区",
    "省份-城市": "山东省-滨州市",
    "所选分组编号/分组名称": "-",
    fans_count: "-",
    fans_count_total: "-",
    fans_tt_count: "-",
    fans_hs_count: "-",
    aweme_count: "-",
    aweme_like_count: "-",
    aweme_comment_count: "-",
    aweme_share_count: "-",
    aweme_play_count: "-",
    aweme_activation: 0,
    live_count: "-",
    live_time: "-",
    live_watch_count: null,
    live_watch_time: null,
    live_like_count: "-",
    live_comment_count: "-",
    live_activation: 0,
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "淮北宏祺",
    company_name: "淮北宏祺汽车销售服务有限公司",
    store_code: "EAH401",
    大区: "华东区",
    "省份-城市": "安徽省-淮北市",
    "所选分组编号/分组名称": "-",
    fans_count: 0,
    fans_count_total: 0,
    fans_tt_count: "-",
    fans_hs_count: "-",
    aweme_count: "12",
    aweme_like_count: "136",
    aweme_comment_count: "31",
    aweme_share_count: "22",
    aweme_play_count: "9536",
    aweme_activation: 0.3667,
    live_count: "-",
    live_time: "-",
    live_watch_count: null,
    live_watch_time: null,
    live_like_count: "-",
    live_comment_count: "-",
    live_activation: 0,
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "湘潭兰天旗胜",
    company_name: "湘潭兰天旗胜汽车销售有限公司",
    store_code: "CHN403",
    大区: "中南区",
    "省份-城市": "湖南省-长沙市",
    "所选分组编号/分组名称": "-",
    fans_count: 0,
    fans_count_total: 0,
    fans_tt_count: "-",
    fans_hs_count: "-",
    aweme_count: "48",
    aweme_like_count: "405",
    aweme_comment_count: "66",
    aweme_share_count: "16",
    aweme_play_count: "40267",
    aweme_activation: 0.8333,
    live_count: "-",
    live_time: "-",
    live_watch_count: null,
    live_watch_time: null,
    live_like_count: "-",
    live_comment_count: "-",
    live_activation: 0,
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "益阳兰天悦旗",
    company_name: "益阳兰天悦旗汽车销售有限公司",
    store_code: "CHN402",
    大区: "中南区",
    "省份-城市": "湖南省-益阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "-",
    fans_count_total: "-",
    fans_tt_count: "-",
    fans_hs_count: "-",
    aweme_count: "-",
    aweme_like_count: "-",
    aweme_comment_count: "-",
    aweme_share_count: "-",
    aweme_play_count: "-",
    aweme_activation: 0,
    live_count: "-",
    live_time: "-",
    live_watch_count: null,
    live_watch_time: null,
    live_like_count: "-",
    live_comment_count: "-",
    live_activation: 0,
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "宿州宏祺",
    company_name: "宿州宏祺汽车销售服务有限公司",
    store_code: "EAH625",
    大区: "华东区",
    "省份-城市": "安徽省-宿州市",
    "所选分组编号/分组名称": "-",
    fans_count: "-",
    fans_count_total: "-",
    fans_tt_count: "-",
    fans_hs_count: "-",
    aweme_count: "-",
    aweme_like_count: "-",
    aweme_comment_count: "-",
    aweme_share_count: "-",
    aweme_play_count: "-",
    aweme_activation: 0,
    live_count: "-",
    live_time: "-",
    live_watch_count: null,
    live_watch_time: null,
    live_like_count: "-",
    live_comment_count: "-",
    live_activation: 0,
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "抖音",
    dealer_name: "陕西众恒",
    company_name: "陕西众恒宏旗汽车贸易有限公司",
    store_code: "XSS401",
    大区: "西部区",
    "省份-城市": "陕西省-渭南市",
    "所选分组编号/分组名称": "-",
    fans_count: "-",
    fans_count_total: "-",
    fans_tt_count: "-",
    fans_hs_count: "-",
    aweme_count: "-",
    aweme_like_count: "-",
    aweme_comment_count: "-",
    aweme_share_count: "-",
    aweme_play_count: "-",
    aweme_activation: 0,
    live_count: "-",
    live_time: "-",
    live_watch_count: null,
    live_watch_time: null,
    live_like_count: "-",
    live_comment_count: "-",
    live_activation: 0,
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
  },
];

export const kuaishouData = [
  {
    平台: "快手",
    dealer_name: "临沂星光",
    company_name: "临沂星光汽车销售服务有限公司",
    store_code: "NSD624",
    大区: "东北区",
    "省份-城市": "山东省-临沂市",
    "所选分组编号/分组名称": "-",
    fans_count: "-853",
    fans_count_total: "169728",
    aweme_count: "28",
    aweme_like_count: "102",
    aweme_comment_count: "7",
    aweme_share_count: "8",
    aweme_play_count: "12708",
    aweme_activation: "0.6667",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "广州红升",
    company_name: "广州红升",
    store_code: "SGD652",
    大区: "华南区",
    "省份-城市": "广东省-广州市",
    "所选分组编号/分组名称": "-",
    fans_count: "14",
    fans_count_total: "136",
    aweme_count: "42",
    aweme_like_count: "155",
    aweme_comment_count: "19",
    aweme_share_count: "17",
    aweme_play_count: "13677",
    aweme_activation: "0.6333",
    live_count: "1",
    live_time: "104",
    live_watch_count: 1,
    live_watch_time: 2,
    live_like_count: "6",
    live_comment_count: 0,
    live_activation: "0.1",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "上海建国弘旗",
    company_name: 0,
    store_code: "ESH612",
    大区: "华东区",
    "省份-城市": 0,
    "所选分组编号/分组名称": "-",
    fans_count: 0,
    fans_count_total: 0,
    aweme_count: 0,
    aweme_like_count: 0,
    aweme_comment_count: 0,
    aweme_share_count: 0,
    aweme_play_count: 0,
    aweme_activation: 0,
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: 0,
    live_fans_add: 0,
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "武汉岳宏泰",
    company_name: "武汉岳宏泰汽车销售服务有限公司",
    store_code: "CHB617",
    大区: "中南区",
    "省份-城市": "湖北省-武汉市",
    "所选分组编号/分组名称": "-",
    fans_count: "-49",
    fans_count_total: "12663",
    aweme_count: "50",
    aweme_like_count: "72",
    aweme_comment_count: "10",
    aweme_share_count: "60",
    aweme_play_count: "13795",
    aweme_activation: "0.2",
    live_count: "33",
    live_time: "2105",
    live_watch_count: 640,
    live_watch_time: 705,
    live_like_count: "139",
    live_comment_count: "5",
    live_activation: "0.7667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "重庆大雍广峻",
    company_name: "重庆大雍广峻",
    store_code: "WCQ603",
    大区: "西部区",
    "省份-城市": "重庆市-重庆市",
    "所选分组编号/分组名称": "-",
    fans_count: "-15",
    fans_count_total: "11031",
    aweme_count: "47",
    aweme_like_count: "20",
    aweme_comment_count: "4",
    aweme_share_count: "25",
    aweme_play_count: "7597",
    aweme_activation: "0.9",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "常熟伟杰红旗",
    company_name: 0,
    store_code: "EJS628",
    大区: "华东区",
    "省份-城市": 0,
    "所选分组编号/分组名称": "-",
    fans_count: 0,
    fans_count_total: 0,
    aweme_count: 0,
    aweme_like_count: 0,
    aweme_comment_count: 0,
    aweme_share_count: 0,
    aweme_play_count: 0,
    aweme_activation: 0,
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: 0,
    live_fans_add: 0,
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "抚顺千乘",
    company_name: "抚顺千乘汽车销售有限公司",
    store_code: "DLN615",
    大区: "东北区",
    "省份-城市": "辽宁省-抚顺市",
    "所选分组编号/分组名称": "-",
    fans_count: "-9",
    fans_count_total: "1372",
    aweme_count: "26",
    aweme_like_count: "61",
    aweme_comment_count: "24",
    aweme_share_count: "2",
    aweme_play_count: "9865",
    aweme_activation: "0.5667",
    live_count: "26",
    live_time: "1646",
    live_watch_count: 309,
    live_watch_time: 340,
    live_like_count: "1194",
    live_comment_count: "39",
    live_activation: "0.8667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "通利华红旗（光明）",
    company_name: "通利华红旗（光明）",
    store_code: "SGD644",
    大区: "华南区",
    "省份-城市": "广东省-深圳市",
    "所选分组编号/分组名称": "-",
    fans_count: "725",
    fans_count_total: "18671",
    aweme_count: "124",
    aweme_like_count: "8714",
    aweme_comment_count: "815",
    aweme_share_count: "636",
    aweme_play_count: "337553",
    aweme_activation: "1.0",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "山西大昌浩瑞",
    company_name: "山西大昌浩瑞汽车销售服务有限公司",
    store_code: "NJN614",
    大区: "华北区",
    "省份-城市": "山西省-太原市",
    "所选分组编号/分组名称": "-",
    fans_count: 0,
    fans_count_total: "316",
    aweme_count: "28",
    aweme_like_count: "102",
    aweme_comment_count: "30",
    aweme_share_count: "1",
    aweme_play_count: "13598",
    aweme_activation: "0.8667",
    live_count: "37",
    live_time: "2179",
    live_watch_count: 481,
    live_watch_time: 530,
    live_like_count: "241",
    live_comment_count: "45",
    live_activation: "0.8667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "乐清红通",
    company_name: "乐清红通汽车销售服务有限公司",
    store_code: "EZJ630",
    大区: "华东区",
    "省份-城市": "浙江省-温州市",
    "所选分组编号/分组名称": "-",
    fans_count: "4",
    fans_count_total: "339",
    aweme_count: "2",
    aweme_like_count: 0,
    aweme_comment_count: 0,
    aweme_share_count: 0,
    aweme_play_count: "455",
    aweme_activation: "0.0333",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "宜兴天诚",
    company_name: "宜兴天诚汽车销售服务有限公司",
    store_code: "EJS630",
    大区: "华东区",
    "省份-城市": "江苏省-无锡市",
    "所选分组编号/分组名称": "-",
    fans_count: "3",
    fans_count_total: "490",
    aweme_count: "20",
    aweme_like_count: "16",
    aweme_comment_count: "4",
    aweme_share_count: "19",
    aweme_play_count: "4192",
    aweme_activation: "0.6333",
    live_count: "2",
    live_time: "124",
    live_watch_count: 4,
    live_watch_time: 5,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.1667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "贵阳万达汽车红旗体验中心",
    company_name: "贵阳万达汽车科技服务有限公司",
    store_code: "WGZ501",
    大区: "西部区",
    "省份-城市": "贵州省-贵阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "-16",
    fans_count_total: "49",
    aweme_count: 0,
    aweme_like_count: 0,
    aweme_comment_count: 0,
    aweme_share_count: 0,
    aweme_play_count: 0,
    aweme_activation: "0.0",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "长春泰岳红旗",
    company_name: "长春泰岳红旗",
    store_code: "DJL501",
    大区: "东北区",
    "省份-城市": "吉林省-长春市",
    "所选分组编号/分组名称": "-",
    fans_count: "-9",
    fans_count_total: "297",
    aweme_count: "10",
    aweme_like_count: "90",
    aweme_comment_count: "22",
    aweme_share_count: "3",
    aweme_play_count: "27451",
    aweme_activation: "0.3667",
    live_count: "7",
    live_time: "435",
    live_watch_count: 116,
    live_watch_time: 128,
    live_like_count: "3548",
    live_comment_count: "22",
    live_activation: "0.2333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "广州路易通",
    company_name: "广州路易通汽车销售服务有限公司",
    store_code: "SGD645",
    大区: "华南区",
    "省份-城市": "广东省-广州市",
    "所选分组编号/分组名称": "-",
    fans_count: "21",
    fans_count_total: "310",
    aweme_count: "63",
    aweme_like_count: "160",
    aweme_comment_count: "30",
    aweme_share_count: "1",
    aweme_play_count: "52889",
    aweme_activation: "0.7333",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "太原泰岳红旗",
    company_name: "太原泰岳红旗",
    store_code: "NJN501",
    大区: "华北区",
    "省份-城市": "山西省-太原市",
    "所选分组编号/分组名称": "-",
    fans_count: "-15",
    fans_count_total: "745",
    aweme_count: "88",
    aweme_like_count: "48",
    aweme_comment_count: "26",
    aweme_share_count: 0,
    aweme_play_count: "24957",
    aweme_activation: "0.9667",
    live_count: "36",
    live_time: "2835",
    live_watch_count: 428,
    live_watch_time: 471,
    live_like_count: "205",
    live_comment_count: "6",
    live_activation: "0.7667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "银川岳宏泰",
    company_name: "银川岳宏泰",
    store_code: "XNX501",
    大区: "西部区",
    "省份-城市": "宁夏回族自治区-银川市",
    "所选分组编号/分组名称": "-",
    fans_count: "74",
    fans_count_total: "2103",
    aweme_count: "138",
    aweme_like_count: "957",
    aweme_comment_count: "16",
    aweme_share_count: "35",
    aweme_play_count: "558204",
    aweme_activation: "1.0",
    live_count: "78",
    live_time: "4785",
    live_watch_count: 3550,
    live_watch_time: 3906,
    live_like_count: "892",
    live_comment_count: "458",
    live_activation: "1.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "深圳奥吉通",
    company_name: "深圳奥吉通汽车销售服务有限公司",
    store_code: "SGD646",
    大区: "华南区",
    "省份-城市": "广东省-深圳市",
    "所选分组编号/分组名称": "-",
    fans_count: "3",
    fans_count_total: "225",
    aweme_count: "2",
    aweme_like_count: "71",
    aweme_comment_count: "7",
    aweme_share_count: "1",
    aweme_play_count: "19088",
    aweme_activation: "0.1333",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "慈溪中基",
    company_name: "慈溪中基汽车销售服务有限公司",
    store_code: "EZJ632",
    大区: "华东区",
    "省份-城市": "浙江省-宁波市",
    "所选分组编号/分组名称": "-",
    fans_count: "-72",
    fans_count_total: "4573",
    aweme_count: "52",
    aweme_like_count: "96",
    aweme_comment_count: "46",
    aweme_share_count: 0,
    aweme_play_count: "29969",
    aweme_activation: "0.8333",
    live_count: "34",
    live_time: "2975",
    live_watch_count: 1199,
    live_watch_time: 1319,
    live_like_count: "620",
    live_comment_count: "74",
    live_activation: "0.6",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "南阳英驰",
    company_name: "南阳英驰汽车销售有限公司",
    store_code: "NYU621",
    大区: "华北区",
    "省份-城市": "河南省-南阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "-33",
    fans_count_total: "6272",
    aweme_count: "56",
    aweme_like_count: "51",
    aweme_comment_count: "16",
    aweme_share_count: "21",
    aweme_play_count: "6230",
    aweme_activation: "0.7667",
    live_count: "48",
    live_time: "2974",
    live_watch_count: 774,
    live_watch_time: 852,
    live_like_count: "1049",
    live_comment_count: "94",
    live_activation: "0.9333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "北京博瑞祥浓",
    company_name: "北京博瑞祥浓汽车销售服务有限公司",
    store_code: "NBJ612",
    大区: "华北区",
    "省份-城市": "北京市-北京市",
    "所选分组编号/分组名称": "-",
    fans_count: "3003",
    fans_count_total: "8657",
    aweme_count: "33",
    aweme_like_count: "1795",
    aweme_comment_count: "38",
    aweme_share_count: "76",
    aweme_play_count: "26929",
    aweme_activation: "0.8667",
    live_count: "27",
    live_time: "1660",
    live_watch_count: 129222,
    live_watch_time: 142145,
    live_like_count: "21399",
    live_comment_count: "791",
    live_activation: "0.7",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "淮安宏众万晟汽",
    company_name: "淮安市宏众万晟汽车销售服务有限公司",
    store_code: "EJS631",
    大区: "华东区",
    "省份-城市": "江苏省-淮安市",
    "所选分组编号/分组名称": "-",
    fans_count: "4",
    fans_count_total: "274",
    aweme_count: "20",
    aweme_like_count: "151",
    aweme_comment_count: "21",
    aweme_share_count: "2",
    aweme_play_count: "48015",
    aweme_activation: "0.4",
    live_count: "1",
    live_time: "64",
    live_watch_count: 8,
    live_watch_time: 9,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "白城致诚红旗体验中心",
    company_name: "白城市致诚汽车销售服务有限公司",
    store_code: "DJL616",
    大区: "东北区",
    "省份-城市": "吉林省-白城市",
    "所选分组编号/分组名称": "-",
    fans_count: "1651",
    fans_count_total: "10718",
    aweme_count: "26",
    aweme_like_count: "172",
    aweme_comment_count: "56",
    aweme_share_count: "55",
    aweme_play_count: "32932",
    aweme_activation: "0.6",
    live_count: "30",
    live_time: "2469",
    live_watch_count: 87330,
    live_watch_time: 96063,
    live_like_count: "65598",
    live_comment_count: "1640",
    live_activation: "0.7",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "江门中升红旗体验中心",
    company_name: "江门市中升汽车销售服务有限公司",
    store_code: "SGD649",
    大区: "华南区",
    "省份-城市": "广东省-江门市",
    "所选分组编号/分组名称": "-",
    fans_count: "-27",
    fans_count_total: "769",
    aweme_count: "22",
    aweme_like_count: "3",
    aweme_comment_count: "1",
    aweme_share_count: 0,
    aweme_play_count: "1127",
    aweme_activation: "0.7",
    live_count: "14",
    live_time: "890",
    live_watch_count: 291,
    live_watch_time: 321,
    live_like_count: "13",
    live_comment_count: "1",
    live_activation: "0.3",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "泰州同悦汽车",
    company_name: "泰州同悦汽车销售服务有限公司",
    store_code: "EJS633",
    大区: "华东区",
    "省份-城市": "江苏省-泰州市",
    "所选分组编号/分组名称": "-",
    fans_count: "29",
    fans_count_total: "1022",
    aweme_count: "23",
    aweme_like_count: "147",
    aweme_comment_count: "31",
    aweme_share_count: "21",
    aweme_play_count: "37000",
    aweme_activation: "0.5667",
    live_count: "28",
    live_time: "2301",
    live_watch_count: 188,
    live_watch_time: 207,
    live_like_count: "21",
    live_comment_count: 0,
    live_activation: "0.5667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "徐州天扬",
    company_name: "徐州天扬",
    store_code: "EJS632",
    大区: "华东区",
    "省份-城市": "江苏省-徐州市",
    "所选分组编号/分组名称": "-",
    fans_count: "3",
    fans_count_total: "37",
    aweme_count: "3",
    aweme_like_count: "44",
    aweme_comment_count: "7",
    aweme_share_count: 0,
    aweme_play_count: "9201",
    aweme_activation: "0.1",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "贵阳通源源旗",
    company_name: "贵阳通源源旗汽车销售服务有限公司",
    store_code: "WGZ614",
    大区: "西部区",
    "省份-城市": "贵州省-贵阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "-21",
    fans_count_total: "20559",
    aweme_count: "18",
    aweme_like_count: "141",
    aweme_comment_count: "13",
    aweme_share_count: "9",
    aweme_play_count: "9366",
    aweme_activation: "0.5333",
    live_count: "19",
    live_time: "1266",
    live_watch_count: 926,
    live_watch_time: 1019,
    live_like_count: "356",
    live_comment_count: "74",
    live_activation: "0.5667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "重庆博行大展",
    company_name: "重庆博行大展汽车销售有限公司",
    store_code: "WCQ604",
    大区: "西部区",
    "省份-城市": "重庆市-重庆市",
    "所选分组编号/分组名称": "-",
    fans_count: "-36",
    fans_count_total: "7981",
    aweme_count: "24",
    aweme_like_count: "110",
    aweme_comment_count: "18",
    aweme_share_count: "8",
    aweme_play_count: "20821",
    aweme_activation: "0.3667",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "珠海宝旗",
    company_name: "珠海市宝旗汽车销售服务有限公司",
    store_code: "SGD648",
    大区: "华南区",
    "省份-城市": "广东省-珠海市",
    "所选分组编号/分组名称": "-",
    fans_count: "17",
    fans_count_total: "64",
    aweme_count: "2",
    aweme_like_count: "77",
    aweme_comment_count: "7",
    aweme_share_count: 0,
    aweme_play_count: "17789",
    aweme_activation: "0.1333",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "广东荣洲",
    company_name: "广东荣洲汽车销售服务有限公司",
    store_code: "SGD647",
    大区: "华南区",
    "省份-城市": "广东省-东莞市",
    "所选分组编号/分组名称": "-",
    fans_count: "18",
    fans_count_total: "570",
    aweme_count: "50",
    aweme_like_count: "156",
    aweme_comment_count: "28",
    aweme_share_count: "1",
    aweme_play_count: "28917",
    aweme_activation: "0.9",
    live_count: "1",
    live_time: "63",
    live_watch_count: 18,
    live_watch_time: 20,
    live_like_count: "770",
    live_comment_count: "2",
    live_activation: "0.0333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "济宁星光",
    company_name: "济宁星光",
    store_code: "NSD626",
    大区: "东北区",
    "省份-城市": "山东省-济宁市",
    "所选分组编号/分组名称": "-",
    fans_count: "55",
    fans_count_total: "878",
    aweme_count: "19",
    aweme_like_count: "136",
    aweme_comment_count: "38",
    aweme_share_count: "2",
    aweme_play_count: "19653",
    aweme_activation: "0.4667",
    live_count: "24",
    live_time: "1464",
    live_watch_count: 736,
    live_watch_time: 810,
    live_like_count: "332",
    live_comment_count: "86",
    live_activation: "0.8333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "遵义通源源旗",
    company_name: "遵义通源源旗汽车销售服务有限公司",
    store_code: "WGZ615",
    大区: "西部区",
    "省份-城市": "贵州省-遵义市",
    "所选分组编号/分组名称": "-",
    fans_count: "14",
    fans_count_total: "1622",
    aweme_count: "46",
    aweme_like_count: "31",
    aweme_comment_count: "6",
    aweme_share_count: "11",
    aweme_play_count: "6139",
    aweme_activation: "0.7667",
    live_count: "3",
    live_time: "186",
    live_watch_count: 38,
    live_watch_time: 42,
    live_like_count: "6",
    live_comment_count: "1",
    live_activation: "0.1333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "菏泽顺祺",
    company_name: "菏泽顺祺",
    store_code: "NSD627",
    大区: "东北区",
    "省份-城市": "山东省-菏泽市",
    "所选分组编号/分组名称": "-",
    fans_count: "29",
    fans_count_total: "123",
    aweme_count: "15",
    aweme_like_count: "64",
    aweme_comment_count: "13",
    aweme_share_count: "10",
    aweme_play_count: "19294",
    aweme_activation: "0.3",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "湖南兰天嘉旗",
    company_name: "湖南兰天嘉旗汽车销售有限公司",
    store_code: "CHN620",
    大区: "中南区",
    "省份-城市": "湖南省-长沙市",
    "所选分组编号/分组名称": "-",
    fans_count: "15",
    fans_count_total: "285",
    aweme_count: "36",
    aweme_like_count: "206",
    aweme_comment_count: "36",
    aweme_share_count: "8",
    aweme_play_count: "56483",
    aweme_activation: "0.5667",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "云南宏胜瑞达",
    company_name: "云南宏胜瑞达汽车销售服务有限公司",
    store_code: "WYN617",
    大区: "西部区",
    "省份-城市": "云南省-昆明市",
    "所选分组编号/分组名称": "-",
    fans_count: "19",
    fans_count_total: "867",
    aweme_count: "25",
    aweme_like_count: "131",
    aweme_comment_count: "57",
    aweme_share_count: 0,
    aweme_play_count: "16534",
    aweme_activation: "0.8333",
    live_count: "47",
    live_time: "2916",
    live_watch_count: 1887,
    live_watch_time: 2076,
    live_like_count: "1150",
    live_comment_count: "158",
    live_activation: "0.8667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "阜阳华奥",
    company_name: "阜阳华奥汽车销售服务有限公司",
    store_code: "EAH621",
    大区: "华东区",
    "省份-城市": "安徽省-阜阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "-9",
    fans_count_total: "234",
    aweme_count: "65",
    aweme_like_count: "63",
    aweme_comment_count: "29",
    aweme_share_count: "20",
    aweme_play_count: "10982",
    aweme_activation: "1.0",
    live_count: "37",
    live_time: "2307",
    live_watch_count: 332,
    live_watch_time: 366,
    live_like_count: "534",
    live_comment_count: "49",
    live_activation: "0.8667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "长春凯胜",
    company_name: "长春凯胜汽车销售服务有限公司",
    store_code: "DJL615",
    大区: "东北区",
    "省份-城市": "吉林省-长春市",
    "所选分组编号/分组名称": "-",
    fans_count: "686",
    fans_count_total: "38273",
    aweme_count: "23",
    aweme_like_count: "474",
    aweme_comment_count: "147",
    aweme_share_count: "43",
    aweme_play_count: "170605",
    aweme_activation: "0.3333",
    live_count: "22",
    live_time: "1519",
    live_watch_count: 145420,
    live_watch_time: 159962,
    live_like_count: "19030",
    live_comment_count: "3283",
    live_activation: "0.7",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "成都泰岳宏旗",
    company_name: "成都泰岳宏旗汽车销售服务有限公司",
    store_code: "WSC627",
    大区: "西部区",
    "省份-城市": "四川省-成都市",
    "所选分组编号/分组名称": "-",
    fans_count: "-111",
    fans_count_total: "13856",
    aweme_count: "44",
    aweme_like_count: "63",
    aweme_comment_count: "13",
    aweme_share_count: "171263",
    aweme_play_count: "1126443",
    aweme_activation: "1.0",
    live_count: "56",
    live_time: "3557",
    live_watch_count: 30082,
    live_watch_time: 33091,
    live_like_count: "50663",
    live_comment_count: "329",
    live_activation: "0.8667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "邯郸坤铂",
    company_name: "邯郸市坤铂汽车销售服务有限公司",
    store_code: "NJI615",
    大区: "华北区",
    "省份-城市": "河北省-邯郸市",
    "所选分组编号/分组名称": "-",
    fans_count: "1598",
    fans_count_total: "33306",
    aweme_count: "35",
    aweme_like_count: "394",
    aweme_comment_count: "60",
    aweme_share_count: "11",
    aweme_play_count: "39570",
    aweme_activation: "0.5667",
    live_count: "61",
    live_time: "3701",
    live_watch_count: 526306,
    live_watch_time: 578937,
    live_like_count: "11817",
    live_comment_count: "2051",
    live_activation: "0.9333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "天津海润达",
    company_name: "天津海润达",
    store_code: "NTJ605",
    大区: "华北区",
    "省份-城市": "天津市-天津市",
    "所选分组编号/分组名称": "-",
    fans_count: "7",
    fans_count_total: "285",
    aweme_count: "27",
    aweme_like_count: "146",
    aweme_comment_count: "26",
    aweme_share_count: "1",
    aweme_play_count: "60282",
    aweme_activation: "0.5",
    live_count: "42",
    live_time: "2583",
    live_watch_count: 486,
    live_watch_time: 535,
    live_like_count: "36",
    live_comment_count: "23",
    live_activation: "0.7",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "淄博泰岳红旗体验中心",
    company_name: "淄博泰岳宏旗汽车销售服务有限公司",
    store_code: "NSD629",
    大区: "东北区",
    "省份-城市": "山东省-淄博市",
    "所选分组编号/分组名称": "-",
    fans_count: "634",
    fans_count_total: "6015",
    aweme_count: "42",
    aweme_like_count: "292",
    aweme_comment_count: "43",
    aweme_share_count: "28",
    aweme_play_count: "603277",
    aweme_activation: "0.6333",
    live_count: "40",
    live_time: "2945",
    live_watch_count: 195470,
    live_watch_time: 215017,
    live_like_count: "5035",
    live_comment_count: "293",
    live_activation: "0.8333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "青岛岳宏泰红旗体验中心",
    company_name: "青岛岳宏泰汽车销售服务有限公司",
    store_code: "NSD628",
    大区: "东北区",
    "省份-城市": "山东省-青岛市",
    "所选分组编号/分组名称": "-",
    fans_count: "-1",
    fans_count_total: "991",
    aweme_count: "36",
    aweme_like_count: "114",
    aweme_comment_count: "20",
    aweme_share_count: "59",
    aweme_play_count: "577937",
    aweme_activation: "0.3",
    live_count: "17",
    live_time: "988",
    live_watch_count: 250,
    live_watch_time: 275,
    live_like_count: "10",
    live_comment_count: "18",
    live_activation: "0.3667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "郑州大展红旗汽车",
    company_name: "郑州大展红旗汽车",
    store_code: "NYU172",
    大区: "华北区",
    "省份-城市": "河南省-郑州市",
    "所选分组编号/分组名称": "-",
    fans_count: "790",
    fans_count_total: "183807",
    aweme_count: "43",
    aweme_like_count: "2638",
    aweme_comment_count: "303",
    aweme_share_count: "214",
    aweme_play_count: "125779",
    aweme_activation: "0.4333",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "银川大世界红旗汽车",
    company_name: "银川大世界红旗汽车销售有限公司",
    store_code: "XNX109",
    大区: "西部区",
    "省份-城市": "宁夏回族自治区-银川市",
    "所选分组编号/分组名称": "-",
    fans_count: "-436",
    fans_count_total: "250948",
    aweme_count: "66",
    aweme_like_count: "442",
    aweme_comment_count: "104",
    aweme_share_count: "56",
    aweme_play_count: "47781",
    aweme_activation: "0.9",
    live_count: "66",
    live_time: "4198",
    live_watch_count: 611835,
    live_watch_time: 673019,
    live_like_count: "15921",
    live_comment_count: "3658",
    live_activation: "1.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "石家庄庞大华旗",
    company_name: "石家庄庞大华旗汽车销售有限公司",
    store_code: "NJI162",
    大区: "华北区",
    "省份-城市": "河北省-石家庄市",
    "所选分组编号/分组名称": "-",
    fans_count: "38",
    fans_count_total: "197",
    aweme_count: "12",
    aweme_like_count: "180",
    aweme_comment_count: "33",
    aweme_share_count: "1",
    aweme_play_count: "40485",
    aweme_activation: "0.3333",
    live_count: "2",
    live_time: "134",
    live_watch_count: 60,
    live_watch_time: 66,
    live_like_count: "407",
    live_comment_count: "2",
    live_activation: "0.0667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "天津奥吉通红韵",
    company_name: "天津奥吉通红韵汽车销售有限公司",
    store_code: "NTJ025",
    大区: "华北区",
    "省份-城市": "天津市-天津市",
    "所选分组编号/分组名称": "-",
    fans_count: "-198",
    fans_count_total: "29505",
    aweme_count: "24",
    aweme_like_count: "68",
    aweme_comment_count: "8",
    aweme_share_count: "10",
    aweme_play_count: "821432",
    aweme_activation: "0.6667",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "重庆万家红旗",
    company_name: "重庆万家红旗",
    store_code: "WCQ018",
    大区: "西部区",
    "省份-城市": "重庆市-重庆市",
    "所选分组编号/分组名称": "-",
    fans_count: "-101",
    fans_count_total: "25680",
    aweme_count: "15",
    aweme_like_count: "98",
    aweme_comment_count: "11",
    aweme_share_count: "8",
    aweme_play_count: "7802",
    aweme_activation: "0.5667",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "南昌龙和",
    company_name: "南昌龙和",
    store_code: "CJX600",
    大区: "中南区",
    "省份-城市": "江西省-南昌市",
    "所选分组编号/分组名称": "-",
    fans_count: "729",
    fans_count_total: "4434",
    aweme_count: "39",
    aweme_like_count: "239",
    aweme_comment_count: "34",
    aweme_share_count: "56",
    aweme_play_count: "1902545",
    aweme_activation: "0.7667",
    live_count: "31",
    live_time: "2208",
    live_watch_count: 388149,
    live_watch_time: 426964,
    live_like_count: "9093",
    live_comment_count: "687",
    live_activation: "0.9",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "长春通立红旗",
    company_name: "长春通立红旗汽车销售服务有限公司",
    store_code: "DJL603",
    大区: "东北区",
    "省份-城市": "吉林省-长春市",
    "所选分组编号/分组名称": "-",
    fans_count: "-1140",
    fans_count_total: "270811",
    aweme_count: "65",
    aweme_like_count: "9545",
    aweme_comment_count: "2143",
    aweme_share_count: "759",
    aweme_play_count: "1063183",
    aweme_activation: "0.8667",
    live_count: "56",
    live_time: "3371",
    live_watch_count: 141849,
    live_watch_time: 156034,
    live_like_count: "157878",
    live_comment_count: "4856",
    live_activation: "0.5667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "福建华奥红旗",
    company_name: "福建华奥红旗汽车销售有限公司",
    store_code: "SFJ601",
    大区: "华南区",
    "省份-城市": "福建省-福州市",
    "所选分组编号/分组名称": "-",
    fans_count: "-1",
    fans_count_total: "2632",
    aweme_count: "26",
    aweme_like_count: "144",
    aweme_comment_count: "35",
    aweme_share_count: "3",
    aweme_play_count: "17770",
    aweme_activation: "0.8333",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "成都新元素红旗",
    company_name: "成都新元素红旗汽车销售服务有限公司",
    store_code: "WSC600",
    大区: "西部区",
    "省份-城市": "四川省-成都市",
    "所选分组编号/分组名称": "-",
    fans_count: "-111",
    fans_count_total: "46930",
    aweme_count: "14",
    aweme_like_count: "1005",
    aweme_comment_count: "56",
    aweme_share_count: "98",
    aweme_play_count: "27248",
    aweme_activation: "0.1667",
    live_count: "82",
    live_time: "5139",
    live_watch_count: 167085,
    live_watch_time: 183794,
    live_like_count: "3810",
    live_comment_count: "534",
    live_activation: "1.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "北京中润发汽车",
    company_name: "北京中润发汽车",
    store_code: "NBJ601",
    大区: "华北区",
    "省份-城市": "北京市-北京市",
    "所选分组编号/分组名称": "-",
    fans_count: "6480",
    fans_count_total: "273723",
    aweme_count: "26",
    aweme_like_count: "13078",
    aweme_comment_count: "3415",
    aweme_share_count: "1878",
    aweme_play_count: "286370",
    aweme_activation: "0.7333",
    live_count: "67",
    live_time: "4270",
    live_watch_count: 989531,
    live_watch_time: 1088485,
    live_like_count: "1141795",
    live_comment_count: "35371",
    live_activation: "0.8667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "上海旗泽",
    company_name: "上海旗泽汽车销售服务有限公司",
    store_code: "ESH607",
    大区: "华东区",
    "省份-城市": "上海市-上海市",
    "所选分组编号/分组名称": "-",
    fans_count: "6",
    fans_count_total: "460",
    aweme_count: "37",
    aweme_like_count: "95",
    aweme_comment_count: "29",
    aweme_share_count: "32",
    aweme_play_count: "21844",
    aweme_activation: "0.7667",
    live_count: "32",
    live_time: "1999",
    live_watch_count: 408,
    live_watch_time: 449,
    live_like_count: "241",
    live_comment_count: "68",
    live_activation: "0.7667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "湖北长泽红旗",
    company_name: "湖北长泽汽车销售服务有限公司",
    store_code: "CHB600",
    大区: "中南区",
    "省份-城市": "湖北省-武汉市",
    "所选分组编号/分组名称": "-",
    fans_count: "-31",
    fans_count_total: "10359",
    aweme_count: 0,
    aweme_like_count: 0,
    aweme_comment_count: 0,
    aweme_share_count: 0,
    aweme_play_count: 0,
    aweme_activation: "0.0",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "南通百恒红旗",
    company_name: "南通百恒汽车销售服务有限公司",
    store_code: "EJS602",
    大区: "华东区",
    "省份-城市": "江苏省-南通市",
    "所选分组编号/分组名称": "-",
    fans_count: "40",
    fans_count_total: "941",
    aweme_count: "32",
    aweme_like_count: "200",
    aweme_comment_count: "41",
    aweme_share_count: "6",
    aweme_play_count: "65299",
    aweme_activation: "0.7667",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "南充明云红旗4S店",
    company_name: "南充明云日月宏新车业有限公司",
    store_code: "WSC603",
    大区: "西部区",
    "省份-城市": "四川省-南充市",
    "所选分组编号/分组名称": "-",
    fans_count: "781",
    fans_count_total: "62764",
    aweme_count: "29",
    aweme_like_count: "128",
    aweme_comment_count: "8",
    aweme_share_count: "11",
    aweme_play_count: "14569",
    aweme_activation: "0.6333",
    live_count: "43",
    live_time: "2667",
    live_watch_count: 616462,
    live_watch_time: 678109,
    live_like_count: "25564",
    live_comment_count: "2643",
    live_activation: "0.9",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "兰州金岛红旗",
    company_name: "兰州金岛红旗汽车销售服务有限公司",
    store_code: "XGS600",
    大区: "西部区",
    "省份-城市": "甘肃省-兰州市",
    "所选分组编号/分组名称": "-",
    fans_count: "2052",
    fans_count_total: "69426",
    aweme_count: "134",
    aweme_like_count: "3717",
    aweme_comment_count: "971",
    aweme_share_count: "327",
    aweme_play_count: "262746",
    aweme_activation: "1.0",
    live_count: "69",
    live_time: "5349",
    live_watch_count: 518415,
    live_watch_time: 570257,
    live_like_count: "85959",
    live_comment_count: "4760",
    live_activation: "1.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "临汾荣翔",
    company_name: "临汾荣翔",
    store_code: "NJN602",
    大区: "华北区",
    "省份-城市": "山西省-临汾市",
    "所选分组编号/分组名称": "-",
    fans_count: "-317",
    fans_count_total: "133419",
    aweme_count: "28",
    aweme_like_count: "621",
    aweme_comment_count: "76",
    aweme_share_count: "35",
    aweme_play_count: "51512",
    aweme_activation: "0.7",
    live_count: "19",
    live_time: "1188",
    live_watch_count: 3903,
    live_watch_time: 4294,
    live_like_count: "3249",
    live_comment_count: "154",
    live_activation: "0.5",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "达州天裕",
    company_name: "达州天裕汽车服务有限公司",
    store_code: "WSC601",
    大区: "西部区",
    "省份-城市": "四川省-达州市",
    "所选分组编号/分组名称": "-",
    fans_count: "34",
    fans_count_total: "178",
    aweme_count: "16",
    aweme_like_count: "195",
    aweme_comment_count: "38",
    aweme_share_count: "1",
    aweme_play_count: "24162",
    aweme_activation: "0.4",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "重庆璐菲",
    company_name: "重庆璐菲汽车销售服务有限公司",
    store_code: "WCQ601",
    大区: "西部区",
    "省份-城市": "重庆市-重庆市",
    "所选分组编号/分组名称": "-",
    fans_count: "1",
    fans_count_total: "133",
    aweme_count: "39",
    aweme_like_count: "57",
    aweme_comment_count: "20",
    aweme_share_count: "17",
    aweme_play_count: "10847",
    aweme_activation: "0.8333",
    live_count: "1",
    live_time: "61",
    live_watch_count: 10,
    live_watch_time: 11,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "驻马店祥诚红旗体验中心",
    company_name: "驻马店祥诚红旗体验中心",
    store_code: "NYU603",
    大区: "华北区",
    "省份-城市": "河南省-驻马店市",
    "所选分组编号/分组名称": "-",
    fans_count: "923",
    fans_count_total: "43543",
    aweme_count: "20",
    aweme_like_count: "23",
    aweme_comment_count: "1",
    aweme_share_count: "21",
    aweme_play_count: "1267",
    aweme_activation: "0.8",
    live_count: "22",
    live_time: "1445",
    live_watch_count: 198152,
    live_watch_time: 217968,
    live_like_count: "3738",
    live_comment_count: "342",
    live_activation: "0.5667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "昆山联合红旗",
    company_name: "昆山联合红旗汽车销售有限公司",
    store_code: "EJS605",
    大区: "华东区",
    "省份-城市": "江苏省-苏州市",
    "所选分组编号/分组名称": "-",
    fans_count: "7",
    fans_count_total: "54",
    aweme_count: "2",
    aweme_like_count: "38",
    aweme_comment_count: "4",
    aweme_share_count: "2",
    aweme_play_count: "8776",
    aweme_activation: "0.0333",
    live_count: "1",
    live_time: "62",
    live_watch_count: 12,
    live_watch_time: 14,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "陕西奥诚红旗",
    company_name: "陕西奥诚红旗汽车销售服务有限公司",
    store_code: "XSS601",
    大区: "西部区",
    "省份-城市": "陕西省-西安市",
    "所选分组编号/分组名称": "-",
    fans_count: "218",
    fans_count_total: "7102",
    aweme_count: "80",
    aweme_like_count: "1418",
    aweme_comment_count: "209",
    aweme_share_count: "113",
    aweme_play_count: "87375",
    aweme_activation: "0.8333",
    live_count: "67",
    live_time: "4131",
    live_watch_count: 1887,
    live_watch_time: 2076,
    live_like_count: "770",
    live_comment_count: "109",
    live_activation: "0.9667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "怀化旗通",
    company_name: "怀化市旗通汽车贸易有限公司",
    store_code: "CHN602",
    大区: "中南区",
    "省份-城市": "湖南省-怀化市",
    "所选分组编号/分组名称": "-",
    fans_count: "40",
    fans_count_total: "388",
    aweme_count: "38",
    aweme_like_count: "114",
    aweme_comment_count: "71",
    aweme_share_count: "1",
    aweme_play_count: "28530",
    aweme_activation: "0.6",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "巴中先锋恒远",
    company_name: "巴中先锋恒远汽车服务有限公司",
    store_code: "WSC604",
    大区: "西部区",
    "省份-城市": "四川省-巴中市",
    "所选分组编号/分组名称": "-",
    fans_count: "-13",
    fans_count_total: "3938",
    aweme_count: "31",
    aweme_like_count: "80",
    aweme_comment_count: "30",
    aweme_share_count: "3",
    aweme_play_count: "29879",
    aweme_activation: "0.8",
    live_count: "43",
    live_time: "2849",
    live_watch_count: 506,
    live_watch_time: 557,
    live_like_count: "59",
    live_comment_count: "21",
    live_activation: "0.8667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "济南泊思",
    company_name: "济南泊思",
    store_code: "NSD601",
    大区: "东北区",
    "省份-城市": "山东省-济南市",
    "所选分组编号/分组名称": "-",
    fans_count: "-263",
    fans_count_total: "65695",
    aweme_count: "20",
    aweme_like_count: "103",
    aweme_comment_count: "9",
    aweme_share_count: "8",
    aweme_play_count: "18895",
    aweme_activation: "0.2",
    live_count: "34",
    live_time: "2097",
    live_watch_count: 2828,
    live_watch_time: 3111,
    live_like_count: "43",
    live_comment_count: "58",
    live_activation: "0.6333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "山西大昌宏源红旗体验中心",
    company_name: "山西大昌宏源红旗体验中心",
    store_code: "NJN603",
    大区: "华北区",
    "省份-城市": "山西省-太原市",
    "所选分组编号/分组名称": "-",
    fans_count: "2",
    fans_count_total: "9",
    aweme_count: "2",
    aweme_like_count: "24",
    aweme_comment_count: "3",
    aweme_share_count: 0,
    aweme_play_count: "1554",
    aweme_activation: "0.0333",
    live_count: "1",
    live_time: "75",
    live_watch_count: 7,
    live_watch_time: 8,
    live_like_count: "25",
    live_comment_count: 0,
    live_activation: "0.0333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "义乌市正通",
    company_name: "义乌市正通汽车销售服务有限公司",
    store_code: "EZJ602",
    大区: "华东区",
    "省份-城市": "浙江省-金华市",
    "所选分组编号/分组名称": "-",
    fans_count: "-8",
    fans_count_total: "1607",
    aweme_count: "15",
    aweme_like_count: 0,
    aweme_comment_count: "1",
    aweme_share_count: "15",
    aweme_play_count: "373",
    aweme_activation: "0.4667",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "常州外汽红豪",
    company_name: "常州外汽红豪汽车销售服务有限公司",
    store_code: "EJS604",
    大区: "华东区",
    "省份-城市": "江苏省-常州市",
    "所选分组编号/分组名称": "-",
    fans_count: "-2",
    fans_count_total: "1463",
    aweme_count: "1",
    aweme_like_count: "38",
    aweme_comment_count: "4",
    aweme_share_count: 0,
    aweme_play_count: "2152",
    aweme_activation: "0.0667",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "烟台鸿旗",
    company_name: "烟台鸿旗汽车销售服务有限公司",
    store_code: "NSD603",
    大区: "东北区",
    "省份-城市": "山东省-烟台市",
    "所选分组编号/分组名称": "-",
    fans_count: "-3",
    fans_count_total: "1525",
    aweme_count: "40",
    aweme_like_count: "80",
    aweme_comment_count: "22",
    aweme_share_count: "3",
    aweme_play_count: "23471",
    aweme_activation: "0.5667",
    live_count: "9",
    live_time: "568",
    live_watch_count: 159,
    live_watch_time: 175,
    live_like_count: "61",
    live_comment_count: "7",
    live_activation: "0.2667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "武汉东瑞红旗体验中心",
    company_name: "武汉市东瑞汽车销售服务有限公司",
    store_code: "CHB604",
    大区: "中南区",
    "省份-城市": "湖北省-武汉市",
    "所选分组编号/分组名称": "-",
    fans_count: "611",
    fans_count_total: "3738",
    aweme_count: "29",
    aweme_like_count: "145",
    aweme_comment_count: "27",
    aweme_share_count: 0,
    aweme_play_count: "21517",
    aweme_activation: "0.5667",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "宜宾吉茂",
    company_name: "宜宾吉茂汽车销售服务有限公司",
    store_code: "WSC606",
    大区: "西部区",
    "省份-城市": "四川省-宜宾市",
    "所选分组编号/分组名称": "-",
    fans_count: "-227",
    fans_count_total: "38284",
    aweme_count: "14",
    aweme_like_count: "92",
    aweme_comment_count: "8",
    aweme_share_count: "3",
    aweme_play_count: "28574",
    aweme_activation: "0.2333",
    live_count: "13",
    live_time: "874",
    live_watch_count: 457,
    live_watch_time: 503,
    live_like_count: "676",
    live_comment_count: "82",
    live_activation: "0.4333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "惠州市通利华",
    company_name: "惠州市通利华实业有限公司",
    store_code: "SGD606",
    大区: "华南区",
    "省份-城市": "广东省-惠州市",
    "所选分组编号/分组名称": "-",
    fans_count: "-32",
    fans_count_total: "12917",
    aweme_count: "40",
    aweme_like_count: "17",
    aweme_comment_count: "7",
    aweme_share_count: "38",
    aweme_play_count: "3548",
    aweme_activation: "0.8",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "中山市中升红旗",
    company_name: "中山市中升汽车销售服务有限公司",
    store_code: "SGD604",
    大区: "华南区",
    "省份-城市": "广东省-中山市",
    "所选分组编号/分组名称": "-",
    fans_count: "6",
    fans_count_total: "149",
    aweme_count: "40",
    aweme_like_count: "57",
    aweme_comment_count: "6",
    aweme_share_count: "2",
    aweme_play_count: "7525",
    aweme_activation: "0.9",
    live_count: "32",
    live_time: "2040",
    live_watch_count: 289,
    live_watch_time: 318,
    live_like_count: "61",
    live_comment_count: "5",
    live_activation: "0.8",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "昆明海伟宏亦",
    company_name: "昆明海伟宏亦汽车销售有限公司",
    store_code: "WYN603",
    大区: "西部区",
    "省份-城市": "云南省-昆明市",
    "所选分组编号/分组名称": "-",
    fans_count: 0,
    fans_count_total: "93",
    aweme_count: 0,
    aweme_like_count: 0,
    aweme_comment_count: 0,
    aweme_share_count: 0,
    aweme_play_count: 0,
    aweme_activation: "0.0",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "赣州凯迪红旗体验中心",
    company_name: "赣州凯迪红旗体验中心",
    store_code: "CJX601",
    大区: "中南区",
    "省份-城市": "江西省-赣州市",
    "所选分组编号/分组名称": "-",
    fans_count: "24",
    fans_count_total: "237",
    aweme_count: "13",
    aweme_like_count: "125",
    aweme_comment_count: "17",
    aweme_share_count: "1",
    aweme_play_count: "20248",
    aweme_activation: "0.2667",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "贵州大雍峻辰",
    company_name: "贵州大雍峻辰汽车销售有限公司",
    store_code: "WGZ602",
    大区: "西部区",
    "省份-城市": "贵州省-贵阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "57",
    fans_count_total: "8295",
    aweme_count: "30",
    aweme_like_count: "2145",
    aweme_comment_count: "427",
    aweme_share_count: "134",
    aweme_play_count: "398876",
    aweme_activation: "0.8",
    live_count: "22",
    live_time: "1647",
    live_watch_count: 655,
    live_watch_time: 721,
    live_like_count: "1318",
    live_comment_count: "10",
    live_activation: "0.8667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "宁波鑫之旗",
    company_name: "宁波鑫之旗",
    store_code: "EZJ603",
    大区: "华东区",
    "省份-城市": "浙江省-宁波市",
    "所选分组编号/分组名称": "-",
    fans_count: "-89",
    fans_count_total: "26688",
    aweme_count: "6",
    aweme_like_count: "64",
    aweme_comment_count: "6",
    aweme_share_count: 0,
    aweme_play_count: "12001",
    aweme_activation: "0.1333",
    live_count: "24",
    live_time: "1482",
    live_watch_count: 364,
    live_watch_time: 401,
    live_like_count: "81",
    live_comment_count: "7",
    live_activation: "0.5333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "上海东昌宏旗",
    company_name: "上海东昌宏旗",
    store_code: "ESH608",
    大区: "华东区",
    "省份-城市": "上海市-上海市",
    "所选分组编号/分组名称": "-",
    fans_count: "-3",
    fans_count_total: "2472",
    aweme_count: "34",
    aweme_like_count: "68",
    aweme_comment_count: "11",
    aweme_share_count: "5",
    aweme_play_count: "9963",
    aweme_activation: "0.9",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "遂宁清巍瑞祥",
    company_name: "遂宁清巍瑞祥汽车销售服务有限公司",
    store_code: "WSC608",
    大区: "西部区",
    "省份-城市": "四川省-遂宁市",
    "所选分组编号/分组名称": "-",
    fans_count: "100",
    fans_count_total: "5644",
    aweme_count: "22",
    aweme_like_count: "1725",
    aweme_comment_count: "39",
    aweme_share_count: "63",
    aweme_play_count: "1166387",
    aweme_activation: "0.6667",
    live_count: "30",
    live_time: "1866",
    live_watch_count: 423,
    live_watch_time: 466,
    live_like_count: "71",
    live_comment_count: "10",
    live_activation: "0.7667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "福建赢宸",
    company_name: "福建赢宸汽车销售服务有限公司",
    store_code: "SFJ602",
    大区: "华南区",
    "省份-城市": "福建省-南平市",
    "所选分组编号/分组名称": "-",
    fans_count: "7",
    fans_count_total: "111",
    aweme_count: "3",
    aweme_like_count: "46",
    aweme_comment_count: "6",
    aweme_share_count: "2",
    aweme_play_count: "612",
    aweme_activation: "0.0667",
    live_count: "1",
    live_time: "64",
    live_watch_count: 2,
    live_watch_time: 3,
    live_like_count: "51",
    live_comment_count: 0,
    live_activation: "0.0333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "西宁金岛红旗",
    company_name: "西宁金岛红旗汽车销售服务有限公司",
    store_code: "XQH600",
    大区: "西部区",
    "省份-城市": "青海省-西宁市",
    "所选分组编号/分组名称": "-",
    fans_count: "37",
    fans_count_total: "2279",
    aweme_count: "47",
    aweme_like_count: "280",
    aweme_comment_count: "85",
    aweme_share_count: "59",
    aweme_play_count: "55936",
    aweme_activation: "0.8",
    live_count: "31",
    live_time: "1733",
    live_watch_count: 6634,
    live_watch_time: 7298,
    live_like_count: "29420",
    live_comment_count: "569",
    live_activation: "0.9",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "安徽博融众旗",
    company_name: "安徽博融众旗汽车销售服务有限公司",
    store_code: "EAH602",
    大区: "华东区",
    "省份-城市": "安徽省-合肥市",
    "所选分组编号/分组名称": "-",
    fans_count: "7",
    fans_count_total: "56",
    aweme_count: "3",
    aweme_like_count: "30",
    aweme_comment_count: "6",
    aweme_share_count: "1",
    aweme_play_count: "4830",
    aweme_activation: "0.1",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "广东鸿粤益嘉店",
    company_name: "广东鸿粤益嘉汽车销售服务有限公司",
    store_code: "SGD603",
    大区: "华南区",
    "省份-城市": "广东省-广州市",
    "所选分组编号/分组名称": "-",
    fans_count: "18",
    fans_count_total: "74",
    aweme_count: "4",
    aweme_like_count: "37",
    aweme_comment_count: "9",
    aweme_share_count: 0,
    aweme_play_count: "15027",
    aweme_activation: "0.1333",
    live_count: "1",
    live_time: "76",
    live_watch_count: 17,
    live_watch_time: 19,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "济宁天禧",
    company_name: "济宁天禧",
    store_code: "NSD600",
    大区: "东北区",
    "省份-城市": "山东省-济宁市",
    "所选分组编号/分组名称": "-",
    fans_count: "-250",
    fans_count_total: "114303",
    aweme_count: "24",
    aweme_like_count: "128",
    aweme_comment_count: "22",
    aweme_share_count: "31",
    aweme_play_count: "25339",
    aweme_activation: "0.6",
    live_count: "34",
    live_time: "2103",
    live_watch_count: 51952,
    live_watch_time: 57148,
    live_like_count: "68755",
    live_comment_count: "1899",
    live_activation: "0.8333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "宜昌市华健晟旗",
    company_name: "宜昌市华健晟旗汽车销售服务有限责任公司",
    store_code: "CHB605",
    大区: "中南区",
    "省份-城市": "湖北省-宜昌市",
    "所选分组编号/分组名称": "-",
    fans_count: "83",
    fans_count_total: "202",
    aweme_count: "2",
    aweme_like_count: "24",
    aweme_comment_count: "3",
    aweme_share_count: 0,
    aweme_play_count: "3343",
    aweme_activation: "0.0667",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "许昌恒旭红旗4s店",
    company_name: "许昌市恒旭汽车销售服务有限公司",
    store_code: "NYU604",
    大区: "华北区",
    "省份-城市": "河南省-许昌市",
    "所选分组编号/分组名称": "-",
    fans_count: "863",
    fans_count_total: "10943",
    aweme_count: "36",
    aweme_like_count: "156",
    aweme_comment_count: "66",
    aweme_share_count: "15",
    aweme_play_count: "38350",
    aweme_activation: "0.7667",
    live_count: "57",
    live_time: "2879",
    live_watch_count: 572363,
    live_watch_time: 629600,
    live_like_count: "5903",
    live_comment_count: "1703",
    live_activation: "0.8667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "保定中冀华达红旗体验中心",
    company_name: "保定市华达汽车销售服务有限公司",
    store_code: "NJI600",
    大区: "华北区",
    "省份-城市": "河北省-保定市",
    "所选分组编号/分组名称": "-",
    fans_count: "-193",
    fans_count_total: "56554",
    aweme_count: "31",
    aweme_like_count: "77",
    aweme_comment_count: "6",
    aweme_share_count: 0,
    aweme_play_count: "4827",
    aweme_activation: "0.4",
    live_count: "44",
    live_time: "3500",
    live_watch_count: 1927,
    live_watch_time: 2120,
    live_like_count: "175",
    live_comment_count: "59",
    live_activation: "0.7",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "临沂美华红旗",
    company_name: "临沂美华汽车销售服务有限公司",
    store_code: "HSD603",
    大区: "东北区",
    "省份-城市": "山东省-临沂市",
    "所选分组编号/分组名称": "-",
    fans_count: "-3409",
    fans_count_total: "1099214",
    aweme_count: "42",
    aweme_like_count: "597",
    aweme_comment_count: "92",
    aweme_share_count: "63",
    aweme_play_count: "77257",
    aweme_activation: "0.6",
    live_count: "24",
    live_time: "1516",
    live_watch_count: 40309,
    live_watch_time: 44340,
    live_like_count: "42987",
    live_comment_count: "1334",
    live_activation: "0.8333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "重庆九禾缘红旗",
    company_name: "重庆九禾缘汽车销售服务有限公司",
    store_code: "WCQ600",
    大区: "西部区",
    "省份-城市": "重庆市-重庆市",
    "所选分组编号/分组名称": "-",
    fans_count: "4",
    fans_count_total: "21",
    aweme_count: "2",
    aweme_like_count: 0,
    aweme_comment_count: 0,
    aweme_share_count: 0,
    aweme_play_count: "106",
    aweme_activation: "0.0667",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "湖北英驰红旗",
    company_name: "湖北英驰汽车集团有限公司",
    store_code: "CHB601",
    大区: "中南区",
    "省份-城市": "湖北省-襄阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "3",
    fans_count_total: "1097",
    aweme_count: "57",
    aweme_like_count: "157",
    aweme_comment_count: "35",
    aweme_share_count: "4",
    aweme_play_count: "52853",
    aweme_activation: "0.4667",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "宝鸡威凯红旗",
    company_name: "宝鸡威凯红旗汽车销售服务有限公司",
    store_code: "XSS604",
    大区: "西部区",
    "省份-城市": "陕西省-宝鸡市",
    "所选分组编号/分组名称": "-",
    fans_count: "14",
    fans_count_total: "146",
    aweme_count: "102",
    aweme_like_count: "226",
    aweme_comment_count: "46",
    aweme_share_count: 0,
    aweme_play_count: "29454",
    aweme_activation: "0.8",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "云南宏通达红旗体验中心",
    company_name: "云南宏通达汽车销售服务有限公司",
    store_code: "WYN600",
    大区: "西部区",
    "省份-城市": "云南省-昆明市",
    "所选分组编号/分组名称": "-",
    fans_count: "13",
    fans_count_total: "247",
    aweme_count: "52",
    aweme_like_count: "70",
    aweme_comment_count: "3",
    aweme_share_count: "1",
    aweme_play_count: "2916",
    aweme_activation: "1.0",
    live_count: "25",
    live_time: "1543",
    live_watch_count: 1645,
    live_watch_time: 1810,
    live_like_count: "534",
    live_comment_count: "52",
    live_activation: "0.4667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "东莞德现",
    company_name: "东莞德现汽车销售服务有限公司",
    store_code: "SGD607",
    大区: "华南区",
    "省份-城市": "广东省-东莞市",
    "所选分组编号/分组名称": "-",
    fans_count: "19",
    fans_count_total: "127",
    aweme_count: "2",
    aweme_like_count: "58",
    aweme_comment_count: "5",
    aweme_share_count: 0,
    aweme_play_count: "4843",
    aweme_activation: "0.1",
    live_count: "2",
    live_time: "143",
    live_watch_count: 44,
    live_watch_time: 49,
    live_like_count: "689",
    live_comment_count: "8",
    live_activation: "0.0667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "商丘市恒美红旗体验中心",
    company_name: "商丘市恒美红旗体验中心",
    store_code: "NYU606",
    大区: "华北区",
    "省份-城市": "河南省-商丘市",
    "所选分组编号/分组名称": "-",
    fans_count: "165",
    fans_count_total: "29516",
    aweme_count: "38",
    aweme_like_count: "166",
    aweme_comment_count: "37",
    aweme_share_count: "60",
    aweme_play_count: "1791047",
    aweme_activation: "0.8",
    live_count: "33",
    live_time: "1961",
    live_watch_count: 96774,
    live_watch_time: 106452,
    live_like_count: "58191",
    live_comment_count: "1734",
    live_activation: "0.8667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "浙江裕旗",
    company_name: "浙江裕旗汽车有限公司",
    store_code: "EZJ606",
    大区: "华东区",
    "省份-城市": "浙江省-杭州市",
    "所选分组编号/分组名称": "-",
    fans_count: "-738",
    fans_count_total: "215465",
    aweme_count: "57",
    aweme_like_count: "579",
    aweme_comment_count: "74",
    aweme_share_count: "62",
    aweme_play_count: "53375",
    aweme_activation: "0.8333",
    live_count: "3",
    live_time: "195",
    live_watch_count: 1780,
    live_watch_time: 1959,
    live_like_count: "241",
    live_comment_count: "46",
    live_activation: "0.2333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "运城大昌红旗体验中心",
    company_name: "运城大昌宏源汽车销售服务有限公司",
    store_code: "NJN604",
    大区: "华北区",
    "省份-城市": "山西省-运城市",
    "所选分组编号/分组名称": "-",
    fans_count: "1",
    fans_count_total: "3185",
    aweme_count: "61",
    aweme_like_count: "64",
    aweme_comment_count: "14",
    aweme_share_count: "9",
    aweme_play_count: "8757",
    aweme_activation: "1.0",
    live_count: "36",
    live_time: "2264",
    live_watch_count: 372,
    live_watch_time: 410,
    live_like_count: "127",
    live_comment_count: "25",
    live_activation: "0.9333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "湖南兰天天旗",
    company_name: "湖南兰天天旗",
    store_code: "CHN603",
    大区: "中南区",
    "省份-城市": "湖南省-长沙市",
    "所选分组编号/分组名称": "-",
    fans_count: "573",
    fans_count_total: "20315",
    aweme_count: "35",
    aweme_like_count: "2829",
    aweme_comment_count: "224",
    aweme_share_count: "239",
    aweme_play_count: "339227",
    aweme_activation: "0.7333",
    live_count: "22",
    live_time: "1325",
    live_watch_count: 101181,
    live_watch_time: 111300,
    live_like_count: "30277",
    live_comment_count: "620",
    live_activation: "0.7333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "内蒙古思旗红旗体验中心",
    company_name: "内蒙古思旗汽车销售有限责任公司",
    store_code: "DNM601",
    大区: "华北区",
    "省份-城市": "内蒙古自治区-呼和浩特市",
    "所选分组编号/分组名称": "-",
    fans_count: "-522",
    fans_count_total: "317348",
    aweme_count: "75",
    aweme_like_count: "3732",
    aweme_comment_count: "3990",
    aweme_share_count: "2819",
    aweme_play_count: "63128",
    aweme_activation: "1.0",
    live_count: "54",
    live_time: "3631",
    live_watch_count: 223969,
    live_watch_time: 246366,
    live_like_count: "23444",
    live_comment_count: "1571",
    live_activation: "0.9333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "远达红旗",
    company_name: "聊城远达汽车销售服务有限公司",
    store_code: "NSD602",
    大区: "东北区",
    "省份-城市": "山东省-聊城市",
    "所选分组编号/分组名称": "-",
    fans_count: "-52",
    fans_count_total: "20832",
    aweme_count: "27",
    aweme_like_count: "69",
    aweme_comment_count: "4",
    aweme_share_count: "48",
    aweme_play_count: "9823",
    aweme_activation: "0.8333",
    live_count: "22",
    live_time: "1306",
    live_watch_count: 10680,
    live_watch_time: 11749,
    live_like_count: "1040",
    live_comment_count: "74",
    live_activation: "0.6667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "衡阳恒宇红旗",
    company_name: "衡阳市恒宇汽车销售服务有限公司",
    store_code: "CHN604",
    大区: "中南区",
    "省份-城市": "湖南省-衡阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "-6",
    fans_count_total: "316",
    aweme_count: "2",
    aweme_like_count: "88",
    aweme_comment_count: "8",
    aweme_share_count: "2",
    aweme_play_count: "5083",
    aweme_activation: "0.1",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "长治大昌红旗体验中心",
    company_name: "长治市大昌汽车销售服务有限公司",
    store_code: "NJN605",
    大区: "华北区",
    "省份-城市": "山西省-长治市",
    "所选分组编号/分组名称": "-",
    fans_count: "7",
    fans_count_total: "98",
    aweme_count: "4",
    aweme_like_count: "39",
    aweme_comment_count: "7",
    aweme_share_count: 0,
    aweme_play_count: "14655",
    aweme_activation: "0.1667",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "邢台邦华",
    company_name: "邢台邦华汽车销售服务有限公司",
    store_code: "NJI601",
    大区: "华北区",
    "省份-城市": "河北省-邢台市",
    "所选分组编号/分组名称": "-",
    fans_count: "12",
    fans_count_total: "5719",
    aweme_count: "51",
    aweme_like_count: "227",
    aweme_comment_count: "35",
    aweme_share_count: "2",
    aweme_play_count: "56445",
    aweme_activation: "0.4667",
    live_count: "50",
    live_time: "3553",
    live_watch_count: 4544,
    live_watch_time: 4999,
    live_like_count: "2136",
    live_comment_count: "461",
    live_activation: "0.9",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "大连通洲",
    company_name: "大连通洲",
    store_code: "DLN601",
    大区: "东北区",
    "省份-城市": "辽宁省-大连市",
    "所选分组编号/分组名称": "-",
    fans_count: 0,
    fans_count_total: "1755",
    aweme_count: "37",
    aweme_like_count: "80",
    aweme_comment_count: "23",
    aweme_share_count: 0,
    aweme_play_count: "13946",
    aweme_activation: "0.8",
    live_count: "24",
    live_time: "1517",
    live_watch_count: 644,
    live_watch_time: 709,
    live_like_count: "366",
    live_comment_count: "55",
    live_activation: "0.7667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "包头市宏腾红旗体验中心",
    company_name: "包头市宏腾汽车销售服务有限公司",
    store_code: "DNM602",
    大区: "华北区",
    "省份-城市": "内蒙古自治区-包头市",
    "所选分组编号/分组名称": "-",
    fans_count: "24",
    fans_count_total: "1749",
    aweme_count: "29",
    aweme_like_count: "152",
    aweme_comment_count: "32",
    aweme_share_count: "29",
    aweme_play_count: "50981",
    aweme_activation: "0.5667",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "兴安盟华盛",
    company_name: "兴安盟华盛汽车销售服务有限公司",
    store_code: "DNM603",
    大区: "东北区",
    "省份-城市": "内蒙古自治区-兴安盟",
    "所选分组编号/分组名称": "-",
    fans_count: "933",
    fans_count_total: "38643",
    aweme_count: "63",
    aweme_like_count: "463",
    aweme_comment_count: "118",
    aweme_share_count: "54",
    aweme_play_count: "40640",
    aweme_activation: "0.9333",
    live_count: "15",
    live_time: "914",
    live_watch_count: 127374,
    live_watch_time: 140112,
    live_like_count: "39024",
    live_comment_count: "4161",
    live_activation: "0.4333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "大同大昌宏源",
    company_name: "大同大昌宏源汽车销售服务有限公司",
    store_code: "NJN606",
    大区: "华北区",
    "省份-城市": "山西省-大同市",
    "所选分组编号/分组名称": "-",
    fans_count: "11",
    fans_count_total: "2588",
    aweme_count: "31",
    aweme_like_count: "84",
    aweme_comment_count: "17",
    aweme_share_count: 0,
    aweme_play_count: "17613",
    aweme_activation: "0.9667",
    live_count: "22",
    live_time: "1364",
    live_watch_count: 5460,
    live_watch_time: 6007,
    live_like_count: "7955",
    live_comment_count: "234",
    live_activation: "0.8",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "辽阳红兴红旗4S店",
    company_name: "辽阳红兴汽车销售服务有限公司",
    store_code: "DLN602",
    大区: "东北区",
    "省份-城市": "辽宁省-辽阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "4",
    fans_count_total: "235174",
    aweme_count: "21",
    aweme_like_count: "1322",
    aweme_comment_count: "194",
    aweme_share_count: "79",
    aweme_play_count: "156541",
    aweme_activation: "0.6",
    live_count: "27",
    live_time: "1722",
    live_watch_count: 124277,
    live_watch_time: 136705,
    live_like_count: "79583",
    live_comment_count: "6284",
    live_activation: "0.8",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "新疆天汇华辉",
    company_name: "新疆天汇华辉汽车销售服务有限公司",
    store_code: "XXJ600",
    大区: "西部区",
    "省份-城市": "新疆维吾尔自治区-乌鲁木齐市",
    "所选分组编号/分组名称": "-",
    fans_count: "-353",
    fans_count_total: "95269",
    aweme_count: "33",
    aweme_like_count: "136",
    aweme_comment_count: "22",
    aweme_share_count: "48",
    aweme_play_count: "5099",
    aweme_activation: "0.5333",
    live_count: "32",
    live_time: "2040",
    live_watch_count: 1521,
    live_watch_time: 1674,
    live_like_count: "4697",
    live_comment_count: "32",
    live_activation: "0.7",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "秦皇岛瑞通嘉禾",
    company_name: "秦皇岛瑞通嘉禾汽车销售服务有限公司",
    store_code: "NJI602",
    大区: "华北区",
    "省份-城市": "河北省-秦皇岛市",
    "所选分组编号/分组名称": "-",
    fans_count: "2717",
    fans_count_total: "115934",
    aweme_count: "35",
    aweme_like_count: "110",
    aweme_comment_count: "29",
    aweme_share_count: "120",
    aweme_play_count: "298161",
    aweme_activation: "0.6667",
    live_count: "43",
    live_time: "3509",
    live_watch_count: 699700,
    live_watch_time: 769670,
    live_like_count: "15088",
    live_comment_count: "1109",
    live_activation: "0.8",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "安庆市天位",
    company_name: "安庆市天位汽车销售服务有限公司",
    store_code: "EAH605",
    大区: "华东区",
    "省份-城市": "安徽省-安庆市",
    "所选分组编号/分组名称": "-",
    fans_count: "-24",
    fans_count_total: "3126",
    aweme_count: "35",
    aweme_like_count: "76",
    aweme_comment_count: "14",
    aweme_share_count: "30",
    aweme_play_count: "5981",
    aweme_activation: "0.6",
    live_count: "8",
    live_time: "504",
    live_watch_count: 40,
    live_watch_time: 45,
    live_like_count: 0,
    live_comment_count: "1",
    live_activation: "0.3",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "泉州同行红旗",
    company_name: "泉州同行红旗",
    store_code: "SFJ603",
    大区: "华南区",
    "省份-城市": "福建省-泉州市",
    "所选分组编号/分组名称": "-",
    fans_count: "625",
    fans_count_total: "27901",
    aweme_count: "19",
    aweme_like_count: "1764",
    aweme_comment_count: "267",
    aweme_share_count: "97",
    aweme_play_count: "165618",
    aweme_activation: "0.5667",
    live_count: "33",
    live_time: "2324",
    live_watch_count: 183341,
    live_watch_time: 201676,
    live_like_count: "13558",
    live_comment_count: "5933",
    live_activation: "0.6667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "宁波中基明瑞",
    company_name: "宁波中基明瑞汽车销售服务有限公司",
    store_code: "EZJ607",
    大区: "华东区",
    "省份-城市": "浙江省-宁波市",
    "所选分组编号/分组名称": "-",
    fans_count: "-6",
    fans_count_total: "200",
    aweme_count: "33",
    aweme_like_count: "123",
    aweme_comment_count: "23",
    aweme_share_count: 0,
    aweme_play_count: "68524",
    aweme_activation: "0.5667",
    live_count: "32",
    live_time: "2012",
    live_watch_count: 300,
    live_watch_time: 330,
    live_like_count: "13",
    live_comment_count: "13",
    live_activation: "0.7",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "杭州广旗",
    company_name: "杭州广旗汽车有限公司",
    store_code: "EZJ609",
    大区: "华东区",
    "省份-城市": "浙江省-杭州市",
    "所选分组编号/分组名称": "-",
    fans_count: "-4",
    fans_count_total: "1076",
    aweme_count: "37",
    aweme_like_count: "54",
    aweme_comment_count: "18",
    aweme_share_count: "1",
    aweme_play_count: "7651",
    aweme_activation: "0.5667",
    live_count: "6",
    live_time: "276",
    live_watch_count: 75,
    live_watch_time: 83,
    live_like_count: "1978",
    live_comment_count: "37",
    live_activation: "0.1667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "广西钜荣红旗",
    company_name: "广西钜荣红旗汽车销售服务有限公司",
    store_code: "SGX601",
    大区: "华南区",
    "省份-城市": "广西壮族自治区-南宁市",
    "所选分组编号/分组名称": "-",
    fans_count: "6",
    fans_count_total: "14",
    aweme_count: "1",
    aweme_like_count: "32",
    aweme_comment_count: "2",
    aweme_share_count: 0,
    aweme_play_count: "1086",
    aweme_activation: "0.1",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "北京龙泽百旺红旗",
    company_name: "北京龙泽百旺销售服务有限公司",
    store_code: "NBJ123",
    大区: "华北区",
    "省份-城市": "北京市-北京市",
    "所选分组编号/分组名称": "-",
    fans_count: "2",
    fans_count_total: "77",
    aweme_count: "4",
    aweme_like_count: "12",
    aweme_comment_count: "2",
    aweme_share_count: 0,
    aweme_play_count: "10960",
    aweme_activation: "0.1",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "河南圆诺",
    company_name: "河南圆诺汽车销售有限公司",
    store_code: "NYU607",
    大区: "华北区",
    "省份-城市": "河南省-开封市",
    "所选分组编号/分组名称": "-",
    fans_count: "432",
    fans_count_total: "10969",
    aweme_count: "39",
    aweme_like_count: "164",
    aweme_comment_count: "34",
    aweme_share_count: "32",
    aweme_play_count: "23702",
    aweme_activation: "0.6333",
    live_count: "27",
    live_time: "1648",
    live_watch_count: 38011,
    live_watch_time: 41813,
    live_like_count: "29993",
    live_comment_count: "5719",
    live_activation: "0.7667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "济南快爱特红旗",
    company_name: "济南快爱特有限公司",
    store_code: "NSD608",
    大区: "东北区",
    "省份-城市": "山东省-济南市",
    "所选分组编号/分组名称": "-",
    fans_count: "2510",
    fans_count_total: "88266",
    aweme_count: "22",
    aweme_like_count: "15161",
    aweme_comment_count: "1555",
    aweme_share_count: "924",
    aweme_play_count: "697276",
    aweme_activation: "0.8667",
    live_count: "19",
    live_time: "1396",
    live_watch_count: 248030,
    live_watch_time: 272833,
    live_like_count: "21551",
    live_comment_count: "9513",
    live_activation: "0.7667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "成都建国红旗",
    company_name: "成都建国汽车贸易有限公司",
    store_code: "WSC609",
    大区: "西部区",
    "省份-城市": "四川省-成都市",
    "所选分组编号/分组名称": "-",
    fans_count: "6",
    fans_count_total: "721",
    aweme_count: "41",
    aweme_like_count: "18",
    aweme_comment_count: "5",
    aweme_share_count: "1",
    aweme_play_count: "2367",
    aweme_activation: "0.8",
    live_count: "85",
    live_time: "5078",
    live_watch_count: 1610,
    live_watch_time: 1772,
    live_like_count: "728",
    live_comment_count: "57",
    live_activation: "0.8",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "东莞鸿粤益嘉",
    company_name: "东莞鸿粤益嘉汽车销售服务有限公司",
    store_code: "SGD609",
    大区: "华南区",
    "省份-城市": "广东省-东莞市",
    "所选分组编号/分组名称": "-",
    fans_count: "-1",
    fans_count_total: "1446",
    aweme_count: "36",
    aweme_like_count: "106",
    aweme_comment_count: "17",
    aweme_share_count: 0,
    aweme_play_count: "4350",
    aweme_activation: "0.2667",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "海南优之杰红旗",
    company_name: "海南优之杰商贸有限公司",
    store_code: "SHN600",
    大区: "华南区",
    "省份-城市": "海南省-海口市",
    "所选分组编号/分组名称": "-",
    fans_count: "188",
    fans_count_total: "249",
    aweme_count: "17",
    aweme_like_count: "135",
    aweme_comment_count: "41",
    aweme_share_count: "2",
    aweme_play_count: "41033",
    aweme_activation: "0.5",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "天津汇裕永达",
    company_name: "天津汇裕永达汽车贸易有限公司",
    store_code: "NTJ603",
    大区: "华北区",
    "省份-城市": "天津市-天津市",
    "所选分组编号/分组名称": "-",
    fans_count: "73",
    fans_count_total: "109049",
    aweme_count: "58",
    aweme_like_count: "298",
    aweme_comment_count: "53",
    aweme_share_count: "38",
    aweme_play_count: "35166",
    aweme_activation: "0.9667",
    live_count: "70",
    live_time: "4280",
    live_watch_count: 117230,
    live_watch_time: 128953,
    live_like_count: "6377",
    live_comment_count: "1212",
    live_activation: "0.9667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "日照晟瑞红旗",
    company_name: "日照晟瑞汽车销售服务有限公司",
    store_code: "NSD609",
    大区: "东北区",
    "省份-城市": "山东省-日照市",
    "所选分组编号/分组名称": "-",
    fans_count: "-25",
    fans_count_total: "4958",
    aweme_count: "13",
    aweme_like_count: "147",
    aweme_comment_count: "26",
    aweme_share_count: "2",
    aweme_play_count: "30651",
    aweme_activation: "0.3333",
    live_count: "3",
    live_time: "185",
    live_watch_count: 52,
    live_watch_time: 58,
    live_like_count: "1735",
    live_comment_count: "10",
    live_activation: "0.2",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "菏泽兴邦红旗汽车体验中心",
    company_name: "菏泽兴邦汽车销售服务有限公司",
    store_code: "NSD610",
    大区: "东北区",
    "省份-城市": "山东省-菏泽市",
    "所选分组编号/分组名称": "-",
    fans_count: "504",
    fans_count_total: "174889",
    aweme_count: "27",
    aweme_like_count: "21272",
    aweme_comment_count: "1559",
    aweme_share_count: "333",
    aweme_play_count: "1305084",
    aweme_activation: "0.8667",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "河北华美红旗体验中心",
    company_name: "河北华美红旗体验中心",
    store_code: "NJI603",
    大区: "华北区",
    "省份-城市": "河北省-石家庄市",
    "所选分组编号/分组名称": "-",
    fans_count: "164",
    fans_count_total: "162669",
    aweme_count: "36",
    aweme_like_count: "248",
    aweme_comment_count: "27",
    aweme_share_count: "24",
    aweme_play_count: "32374",
    aweme_activation: "0.5667",
    live_count: "43",
    live_time: "2657",
    live_watch_count: 159019,
    live_watch_time: 174921,
    live_like_count: "8858",
    live_comment_count: "868",
    live_activation: "0.6667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "大理国源",
    company_name: "大理国源汽车销售服务有限公司",
    store_code: "WYN604",
    大区: "西部区",
    "省份-城市": "云南省-大理白族自治州",
    "所选分组编号/分组名称": "-",
    fans_count: "28",
    fans_count_total: "474",
    aweme_count: "25",
    aweme_like_count: "181",
    aweme_comment_count: "32",
    aweme_share_count: "9",
    aweme_play_count: "40300",
    aweme_activation: "0.4333",
    live_count: "4",
    live_time: "146",
    live_watch_count: 67,
    live_watch_time: 74,
    live_like_count: "1663",
    live_comment_count: "6",
    live_activation: "0.0333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "北京祥龙博瑞红旗体验中心",
    company_name: "北京祥龙博瑞汽车服务(集团)有限公司一分公司",
    store_code: "NBJ603",
    大区: "华北区",
    "省份-城市": "北京市-北京市",
    "所选分组编号/分组名称": "-",
    fans_count: "3191",
    fans_count_total: "5830",
    aweme_count: "42",
    aweme_like_count: "2551",
    aweme_comment_count: "115",
    aweme_share_count: "62",
    aweme_play_count: "94523",
    aweme_activation: "0.6",
    live_count: "30",
    live_time: "1914",
    live_watch_count: 151544,
    live_watch_time: 166699,
    live_like_count: "29731",
    live_comment_count: "1935",
    live_activation: "0.5667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "无锡红博红旗",
    company_name: "无锡红博汽车销售有限公司",
    store_code: "EJS609",
    大区: "华东区",
    "省份-城市": "江苏省-无锡市",
    "所选分组编号/分组名称": "-",
    fans_count: "1",
    fans_count_total: "384",
    aweme_count: "20",
    aweme_like_count: "2",
    aweme_comment_count: 0,
    aweme_share_count: "19",
    aweme_play_count: "760",
    aweme_activation: "0.5667",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "黔西南州星尊程领航",
    company_name: "黔西南州星尊程领航汽车销售服务有限公司",
    store_code: "WGZ604",
    大区: "西部区",
    "省份-城市": "贵州省-黔西南布依族苗族自治州",
    "所选分组编号/分组名称": "-",
    fans_count: "125",
    fans_count_total: "10713",
    aweme_count: "21",
    aweme_like_count: "394",
    aweme_comment_count: "57",
    aweme_share_count: "81",
    aweme_play_count: "13790",
    aweme_activation: "0.7333",
    live_count: "21",
    live_time: "1334",
    live_watch_count: 628,
    live_watch_time: 691,
    live_like_count: "60",
    live_comment_count: "17",
    live_activation: "0.6",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "德阳冠仑",
    company_name: "德阳冠仑",
    store_code: "WSC613",
    大区: "西部区",
    "省份-城市": "四川省-德阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "43",
    fans_count_total: "96",
    aweme_count: "25",
    aweme_like_count: "87",
    aweme_comment_count: "34",
    aweme_share_count: 0,
    aweme_play_count: "2989",
    aweme_activation: "0.8333",
    live_count: "28",
    live_time: "1727",
    live_watch_count: 358,
    live_watch_time: 394,
    live_like_count: "493",
    live_comment_count: "18",
    live_activation: "0.6",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "温州宝旗红旗",
    company_name: "温州宝旗汽车服务有限公司",
    store_code: "EZJ611",
    大区: "华东区",
    "省份-城市": "浙江省-温州市",
    "所选分组编号/分组名称": "-",
    fans_count: "-489",
    fans_count_total: "113551",
    aweme_count: "4",
    aweme_like_count: "78",
    aweme_comment_count: "4",
    aweme_share_count: "1",
    aweme_play_count: "10911",
    aweme_activation: "0.1",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "曲靖开源红旗体验中心",
    company_name: "曲靖开源汽车销售服务有限公司",
    store_code: "WYN605",
    大区: "西部区",
    "省份-城市": "云南省-曲靖市",
    "所选分组编号/分组名称": "-",
    fans_count: "4",
    fans_count_total: "147",
    aweme_count: "5",
    aweme_like_count: "10",
    aweme_comment_count: "2",
    aweme_share_count: 0,
    aweme_play_count: "15363",
    aweme_activation: "0.0667",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "厦门亿海红祺",
    company_name: "厦门亿海红祺汽车服务有限公司",
    store_code: "SFJ604",
    大区: "华南区",
    "省份-城市": "福建省-厦门市",
    "所选分组编号/分组名称": "-",
    fans_count: "4",
    fans_count_total: "163",
    aweme_count: "1",
    aweme_like_count: "22",
    aweme_comment_count: "3",
    aweme_share_count: 0,
    aweme_play_count: "798",
    aweme_activation: "0.0667",
    live_count: "1",
    live_time: "10",
    live_watch_count: 5,
    live_watch_time: 6,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "德州润吉汽车",
    company_name: "德州润吉汽车销售服务有限公司",
    store_code: "NSD611",
    大区: "东北区",
    "省份-城市": "山东省-德州市",
    "所选分组编号/分组名称": "-",
    fans_count: "55",
    fans_count_total: "5147",
    aweme_count: "24",
    aweme_like_count: "149",
    aweme_comment_count: "39",
    aweme_share_count: "2",
    aweme_play_count: "10016",
    aweme_activation: "0.8",
    live_count: "9",
    live_time: "580",
    live_watch_count: 159,
    live_watch_time: 175,
    live_like_count: "1566",
    live_comment_count: "14",
    live_activation: "0.3",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "陕西汉中天汉旗胜",
    company_name: "陕西汉中天汉旗胜",
    store_code: "XSS606",
    大区: "西部区",
    "省份-城市": "陕西省-汉中市",
    "所选分组编号/分组名称": "-",
    fans_count: "2",
    fans_count_total: "5873",
    aweme_count: "56",
    aweme_like_count: "129",
    aweme_comment_count: "41",
    aweme_share_count: "21",
    aweme_play_count: "19880",
    aweme_activation: "0.9333",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "泸州明云华盛红旗体验中心",
    company_name: "泸州明云华盛红旗体验中心",
    store_code: "WSC616",
    大区: "西部区",
    "省份-城市": "四川省-泸州市",
    "所选分组编号/分组名称": "-",
    fans_count: "-5",
    fans_count_total: "2791",
    aweme_count: "22",
    aweme_like_count: "180",
    aweme_comment_count: "48",
    aweme_share_count: 0,
    aweme_play_count: "61388",
    aweme_activation: "0.7333",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "吉林长春神州红旗",
    company_name: "吉林省神州红旗汽车销售服务有限公司",
    store_code: "DJL606",
    大区: "东北区",
    "省份-城市": "吉林省-长春市",
    "所选分组编号/分组名称": "-",
    fans_count: "374",
    fans_count_total: "37792",
    aweme_count: "61",
    aweme_like_count: "117",
    aweme_comment_count: "16",
    aweme_share_count: "96",
    aweme_play_count: "1148269",
    aweme_activation: "0.7",
    live_count: "49",
    live_time: "3017",
    live_watch_count: 100520,
    live_watch_time: 110573,
    live_like_count: "141905",
    live_comment_count: "3852",
    live_activation: "0.8333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "广元峰帆红旗体验中心",
    company_name: "广元市峰帆汽车商贸有限公司",
    store_code: "WSC612",
    大区: "西部区",
    "省份-城市": "四川省-广元市",
    "所选分组编号/分组名称": "-",
    fans_count: "-34",
    fans_count_total: "108041",
    aweme_count: "36",
    aweme_like_count: "1192",
    aweme_comment_count: "304",
    aweme_share_count: "159",
    aweme_play_count: "52835",
    aweme_activation: "0.9333",
    live_count: "43",
    live_time: "2563",
    live_watch_count: 77250,
    live_watch_time: 84975,
    live_like_count: "26072",
    live_comment_count: "1553",
    live_activation: "0.9667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "长春金山红旗",
    company_name: "长春金山红旗汽车销售服务有限公司",
    store_code: "DJL605",
    大区: "东北区",
    "省份-城市": "吉林省-长春市",
    "所选分组编号/分组名称": "-",
    fans_count: "-137",
    fans_count_total: "41167",
    aweme_count: "30",
    aweme_like_count: "127",
    aweme_comment_count: "7",
    aweme_share_count: "31",
    aweme_play_count: "16412",
    aweme_activation: "0.5667",
    live_count: "1",
    live_time: "70",
    live_watch_count: 24,
    live_watch_time: 27,
    live_like_count: "19",
    live_comment_count: 0,
    live_activation: "0.0667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "自贡新成红兴",
    company_name: "自贡新成红兴汽车销售服务有限责任公司",
    store_code: "WSC614",
    大区: "西部区",
    "省份-城市": "四川省-自贡市",
    "所选分组编号/分组名称": "-",
    fans_count: "4",
    fans_count_total: "59",
    aweme_count: "22",
    aweme_like_count: "10",
    aweme_comment_count: "3",
    aweme_share_count: "18",
    aweme_play_count: "2835",
    aweme_activation: "0.6",
    live_count: "13",
    live_time: "819",
    live_watch_count: 250,
    live_watch_time: 276,
    live_like_count: "13",
    live_comment_count: "1",
    live_activation: "0.5333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "郑州吉展红旗",
    company_name: "郑州吉展汽车销售服务有限公司",
    store_code: "NYU610",
    大区: "华北区",
    "省份-城市": "河南省-郑州市",
    "所选分组编号/分组名称": "-",
    fans_count: "530",
    fans_count_total: "80675",
    aweme_count: "33",
    aweme_like_count: "1261",
    aweme_comment_count: "302",
    aweme_share_count: "127",
    aweme_play_count: "113233",
    aweme_activation: "0.7667",
    live_count: "28",
    live_time: "1720",
    live_watch_count: 372741,
    live_watch_time: 410016,
    live_like_count: "20527",
    live_comment_count: "4416",
    live_activation: "0.6333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "信阳天泓",
    company_name: "信阳天泓汽车销售服务有限公司",
    store_code: "NYU608",
    大区: "华北区",
    "省份-城市": "河南省-信阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "-470",
    fans_count_total: "180393",
    aweme_count: "44",
    aweme_like_count: "2983",
    aweme_comment_count: "940",
    aweme_share_count: "244",
    aweme_play_count: "361907",
    aweme_activation: "0.7667",
    live_count: "30",
    live_time: "1867",
    live_watch_count: 4916,
    live_watch_time: 5408,
    live_like_count: "1523",
    live_comment_count: "159",
    live_activation: "0.8667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "青岛泰岳宏旗",
    company_name: "青岛泰岳宏旗",
    store_code: "NSD613",
    大区: "东北区",
    "省份-城市": "山东省-青岛市",
    "所选分组编号/分组名称": "-",
    fans_count: "587",
    fans_count_total: "30351",
    aweme_count: "90",
    aweme_like_count: "57",
    aweme_comment_count: "9",
    aweme_share_count: "97",
    aweme_play_count: "11725",
    aweme_activation: "0.6667",
    live_count: "28",
    live_time: "1736",
    live_watch_count: 163104,
    live_watch_time: 179415,
    live_like_count: "30305",
    live_comment_count: "1584",
    live_activation: "0.7667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "潍坊旗胜红旗4S店",
    company_name: "潍坊广潍旗胜汽车销售服务有限公司",
    store_code: "NSD614",
    大区: "东北区",
    "省份-城市": "山东省-潍坊市",
    "所选分组编号/分组名称": "-",
    fans_count: "-40",
    fans_count_total: "16488",
    aweme_count: "17",
    aweme_like_count: "277",
    aweme_comment_count: "20",
    aweme_share_count: "64",
    aweme_play_count: "19432",
    aweme_activation: "0.2667",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.1",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "吉安凯迪红旗",
    company_name: "吉安市凯迪汽车销售服务有限公司",
    store_code: "CJX602",
    大区: "中南区",
    "省份-城市": "江西省-吉安市",
    "所选分组编号/分组名称": "-",
    fans_count: "22",
    fans_count_total: "90",
    aweme_count: "6",
    aweme_like_count: "69",
    aweme_comment_count: "14",
    aweme_share_count: 0,
    aweme_play_count: "18594",
    aweme_activation: "0.2",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "湖州湖旗红旗",
    company_name: "湖州湖旗汽车有限公司",
    store_code: "EZJ615",
    大区: "华东区",
    "省份-城市": "浙江省-湖州市",
    "所选分组编号/分组名称": "-",
    fans_count: "-8",
    fans_count_total: "1573",
    aweme_count: 0,
    aweme_like_count: 0,
    aweme_comment_count: 0,
    aweme_share_count: 0,
    aweme_play_count: 0,
    aweme_activation: "0.0",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "沧州华泽红旗店",
    company_name: "沧州市华泽汽车贸易有限公司",
    store_code: "NJI604",
    大区: "华北区",
    "省份-城市": "河北省-沧州市",
    "所选分组编号/分组名称": "-",
    fans_count: "-30",
    fans_count_total: "110465",
    aweme_count: "47",
    aweme_like_count: "171",
    aweme_comment_count: "22",
    aweme_share_count: "45",
    aweme_play_count: "29718",
    aweme_activation: "0.7667",
    live_count: "27",
    live_time: "1921",
    live_watch_count: 377287,
    live_watch_time: 415016,
    live_like_count: "15153",
    live_comment_count: "1689",
    live_activation: "0.7667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "潍坊泰岳红旗4S店",
    company_name: "潍坊泰岳宏旗汽车销售服务有限公司",
    store_code: "NSD617",
    大区: "东北区",
    "省份-城市": "山东省-潍坊市",
    "所选分组编号/分组名称": "-",
    fans_count: "-27",
    fans_count_total: "7792",
    aweme_count: "18",
    aweme_like_count: "439",
    aweme_comment_count: "22",
    aweme_share_count: "21",
    aweme_play_count: "264325",
    aweme_activation: "0.6",
    live_count: "1",
    live_time: "62",
    live_watch_count: 12,
    live_watch_time: 14,
    live_like_count: "2618",
    live_comment_count: "15",
    live_activation: "0.0333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "广东容大红旗体验中心",
    company_name: "广东容大星旗汽车有限公司",
    store_code: "SGD614",
    大区: "华南区",
    "省份-城市": "广东省-揭阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "-9",
    fans_count_total: "1276",
    aweme_count: "13",
    aweme_like_count: "11",
    aweme_comment_count: 0,
    aweme_share_count: 0,
    aweme_play_count: "1029",
    aweme_activation: "0.4333",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "两江璐菲红旗",
    company_name: "重庆两江璐菲汽车销售服务有限公司",
    store_code: "WCQ602",
    大区: "西部区",
    "省份-城市": "重庆市-重庆市",
    "所选分组编号/分组名称": "-",
    fans_count: "-33",
    fans_count_total: "175",
    aweme_count: "25",
    aweme_like_count: "70",
    aweme_comment_count: "21",
    aweme_share_count: "17",
    aweme_play_count: "23214",
    aweme_activation: "0.6",
    live_count: "16",
    live_time: "975",
    live_watch_count: 137,
    live_watch_time: 151,
    live_like_count: "3",
    live_comment_count: 0,
    live_activation: "0.3667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "珠海中升红旗",
    company_name: "珠海市中升汽车销售服务有限公司",
    store_code: "SGD611",
    大区: "华南区",
    "省份-城市": "广东省-珠海市",
    "所选分组编号/分组名称": "-",
    fans_count: "44",
    fans_count_total: "897",
    aweme_count: "24",
    aweme_like_count: "395",
    aweme_comment_count: "63",
    aweme_share_count: "46",
    aweme_play_count: "23970",
    aweme_activation: "0.7333",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "衢州君悦宏旗",
    company_name: "衢州君悦宏旗",
    store_code: "EZJ612",
    大区: "华东区",
    "省份-城市": "浙江省-衢州市",
    "所选分组编号/分组名称": "-",
    fans_count: "8",
    fans_count_total: "3113",
    aweme_count: "2",
    aweme_like_count: "40",
    aweme_comment_count: "5",
    aweme_share_count: 0,
    aweme_play_count: "8521",
    aweme_activation: "0.0667",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "贵州铜仁市星尊程鑫航",
    company_name: "贵州铜仁市星尊程鑫航汽车销售服务有限公司",
    store_code: "WGZ605",
    大区: "西部区",
    "省份-城市": "贵州省-铜仁市",
    "所选分组编号/分组名称": "-",
    fans_count: "-9",
    fans_count_total: "354",
    aweme_count: 0,
    aweme_like_count: "40",
    aweme_comment_count: "2",
    aweme_share_count: 0,
    aweme_play_count: "683",
    aweme_activation: "0.0333",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "南京大道",
    company_name: "南京大道汽车销售服务有限公司",
    store_code: "EJS610",
    大区: "华东区",
    "省份-城市": "江苏省-南京市",
    "所选分组编号/分组名称": "-",
    fans_count: "-361",
    fans_count_total: "70312",
    aweme_count: "73",
    aweme_like_count: "44",
    aweme_comment_count: "5",
    aweme_share_count: "13",
    aweme_play_count: "4741",
    aweme_activation: "0.8",
    live_count: "6",
    live_time: "370",
    live_watch_count: 269,
    live_watch_time: 296,
    live_like_count: "3",
    live_comment_count: "7",
    live_activation: "0.1667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "郑州泰岳宏旗",
    company_name: "郑州泰岳宏旗汽车销售服务有限公司",
    store_code: "NYU611",
    大区: "华北区",
    "省份-城市": "河南省-郑州市",
    "所选分组编号/分组名称": "-",
    fans_count: "-49",
    fans_count_total: "19348",
    aweme_count: "27",
    aweme_like_count: "63",
    aweme_comment_count: "9",
    aweme_share_count: "20",
    aweme_play_count: "10910",
    aweme_activation: "0.6333",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "洛阳随诺",
    company_name: "洛阳随诺",
    store_code: "NYU609",
    大区: "华北区",
    "省份-城市": "河南省-洛阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "-592",
    fans_count_total: "143010",
    aweme_count: "88",
    aweme_like_count: "195",
    aweme_comment_count: "23",
    aweme_share_count: "5",
    aweme_play_count: "14799",
    aweme_activation: "0.9667",
    live_count: "35",
    live_time: "2222",
    live_watch_count: 33471,
    live_watch_time: 36819,
    live_like_count: "14859",
    live_comment_count: "1487",
    live_activation: "0.8667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "濮阳德源红旗体验中心",
    company_name: "濮阳德源红旗体验中心",
    store_code: "NYU613",
    大区: "华北区",
    "省份-城市": "河南省-濮阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "26",
    fans_count_total: "382",
    aweme_count: "27",
    aweme_like_count: "165",
    aweme_comment_count: "49",
    aweme_share_count: "2",
    aweme_play_count: "18107",
    aweme_activation: "0.8",
    live_count: "45",
    live_time: "2943",
    live_watch_count: 1562,
    live_watch_time: 1719,
    live_like_count: "274",
    live_comment_count: "49",
    live_activation: "0.6667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "晋城中一",
    company_name: "晋城中一汽车有限公司",
    store_code: "NJN607",
    大区: "华北区",
    "省份-城市": "山西省-晋城市",
    "所选分组编号/分组名称": "-",
    fans_count: "-7",
    fans_count_total: "4788",
    aweme_count: "4",
    aweme_like_count: "14",
    aweme_comment_count: "4",
    aweme_share_count: 0,
    aweme_play_count: "2344",
    aweme_activation: "0.1333",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "六安之道红旗",
    company_name: "六安之道汽车销售服务有限公司",
    store_code: "EAH607",
    大区: "华东区",
    "省份-城市": "安徽省-六安市",
    "所选分组编号/分组名称": "-",
    fans_count: "-155",
    fans_count_total: "47724",
    aweme_count: "32",
    aweme_like_count: "59",
    aweme_comment_count: "4",
    aweme_share_count: "23",
    aweme_play_count: "9357",
    aweme_activation: "0.7",
    live_count: "1",
    live_time: "68",
    live_watch_count: 47,
    live_watch_time: 52,
    live_like_count: "546",
    live_comment_count: 0,
    live_activation: "0.0333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "南阳宛骏",
    company_name: "南阳宛骏",
    store_code: "CHN605",
    大区: "华北区",
    "省份-城市": "河南省-南阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "7",
    fans_count_total: "3949",
    aweme_count: "62",
    aweme_like_count: "66",
    aweme_comment_count: "26",
    aweme_share_count: "20",
    aweme_play_count: "19579",
    aweme_activation: "0.9667",
    live_count: "23",
    live_time: "1480",
    live_watch_count: 4878,
    live_watch_time: 5366,
    live_like_count: "2736",
    live_comment_count: "157",
    live_activation: "0.8",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "大汉集团红旗体验中心",
    company_name: "长沙美捷汽车贸易有限公司",
    store_code: "CHN606",
    大区: "中南区",
    "省份-城市": "湖南省-长沙市",
    "所选分组编号/分组名称": "-",
    fans_count: "-193",
    fans_count_total: "51308",
    aweme_count: "28",
    aweme_like_count: "55",
    aweme_comment_count: "5",
    aweme_share_count: "5",
    aweme_play_count: "2841",
    aweme_activation: "0.8667",
    live_count: "18",
    live_time: "1119",
    live_watch_count: 6983,
    live_watch_time: 7682,
    live_like_count: "566",
    live_comment_count: "64",
    live_activation: "0.7333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "北京泰岳金港红旗体验中心",
    company_name: "北京泰岳宏旗汽车销售服务有限公司",
    store_code: "NBJ605",
    大区: "华北区",
    "省份-城市": "北京市-北京市",
    "所选分组编号/分组名称": "-",
    fans_count: "-86",
    fans_count_total: "26343",
    aweme_count: "49",
    aweme_like_count: "70",
    aweme_comment_count: "7",
    aweme_share_count: "79",
    aweme_play_count: "10353",
    aweme_activation: "0.8333",
    live_count: "97",
    live_time: "5950",
    live_watch_count: 19312,
    live_watch_time: 21244,
    live_like_count: "4082",
    live_comment_count: "645",
    live_activation: "1.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "桂林弘帆红旗体验中心",
    company_name: "桂林弘帆桂仕汽车销售服务有限公司",
    store_code: "SGX603",
    大区: "华南区",
    "省份-城市": "广西壮族自治区-桂林市",
    "所选分组编号/分组名称": "-",
    fans_count: "27",
    fans_count_total: "215",
    aweme_count: "26",
    aweme_like_count: "192",
    aweme_comment_count: "51",
    aweme_share_count: "2",
    aweme_play_count: "24442",
    aweme_activation: "0.4667",
    live_count: "7",
    live_time: "445",
    live_watch_count: 101,
    live_watch_time: 112,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.2",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "阜阳博融亚之旗",
    company_name: "阜阳博融亚之旗汽车销售服务有限公司",
    store_code: "EAH606",
    大区: "华东区",
    "省份-城市": "安徽省-阜阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "-61",
    fans_count_total: "22372",
    aweme_count: "18",
    aweme_like_count: "112",
    aweme_comment_count: "17",
    aweme_share_count: "14",
    aweme_play_count: "38684",
    aweme_activation: "0.5667",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "成都东创国城红旗",
    company_name: "成都东创国城实业有限公司",
    store_code: "WSC615",
    大区: "西部区",
    "省份-城市": "四川省-成都市",
    "所选分组编号/分组名称": "-",
    fans_count: 0,
    fans_count_total: "1063",
    aweme_count: "37",
    aweme_like_count: "65",
    aweme_comment_count: "40",
    aweme_share_count: "5",
    aweme_play_count: "508212",
    aweme_activation: "0.9",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "南通百弘红旗",
    company_name: "南通百弘红旗",
    store_code: "EJS611",
    大区: "华东区",
    "省份-城市": "江苏省-南通市",
    "所选分组编号/分组名称": "-",
    fans_count: "33",
    fans_count_total: "230",
    aweme_count: "25",
    aweme_like_count: "78",
    aweme_comment_count: "22",
    aweme_share_count: "18",
    aweme_play_count: "58620",
    aweme_activation: "0.7",
    live_count: "5",
    live_time: "319",
    live_watch_count: 77,
    live_watch_time: 85,
    live_like_count: "1058",
    live_comment_count: "10",
    live_activation: "0.2667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "嘉兴禾旗",
    company_name: "嘉兴禾旗汽车销售服务有限公司",
    store_code: "EZJ616",
    大区: "华东区",
    "省份-城市": "浙江省-嘉兴市",
    "所选分组编号/分组名称": "-",
    fans_count: "474",
    fans_count_total: "6905",
    aweme_count: "54",
    aweme_like_count: "68",
    aweme_comment_count: "26",
    aweme_share_count: 0,
    aweme_play_count: "5514",
    aweme_activation: "0.8",
    live_count: "34",
    live_time: "2200",
    live_watch_count: 57688,
    live_watch_time: 63457,
    live_like_count: "1685",
    live_comment_count: "191",
    live_activation: "0.7667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "新乡盛世红旗体验中心",
    company_name: "新乡市盛世汽车销售服务有限公司",
    store_code: "NYU615",
    大区: "华北区",
    "省份-城市": "河南省-新乡市",
    "所选分组编号/分组名称": "-",
    fans_count: "-11",
    fans_count_total: "3680",
    aweme_count: "28",
    aweme_like_count: "276",
    aweme_comment_count: "31",
    aweme_share_count: "21",
    aweme_play_count: "221681",
    aweme_activation: "0.6333",
    live_count: "1",
    live_time: "60",
    live_watch_count: 7,
    live_watch_time: 8,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "浙江金华裕旗",
    company_name: "浙江金华裕旗汽车有限公司",
    store_code: "EZJ613",
    大区: "华东区",
    "省份-城市": "浙江省-金华市",
    "所选分组编号/分组名称": "-",
    fans_count: "629",
    fans_count_total: "9940",
    aweme_count: "104",
    aweme_like_count: "302",
    aweme_comment_count: "63",
    aweme_share_count: "153",
    aweme_play_count: "27978",
    aweme_activation: "1.0",
    live_count: "54",
    live_time: "3970",
    live_watch_count: 28456,
    live_watch_time: 31302,
    live_like_count: "71265",
    live_comment_count: "2057",
    live_activation: "0.8667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "青岛欣盛红旗中心店",
    company_name: "青岛欣盛汽车销售有限公司",
    store_code: "NSD615",
    大区: "东北区",
    "省份-城市": "山东省-青岛市",
    "所选分组编号/分组名称": "-",
    fans_count: "349",
    fans_count_total: "33022",
    aweme_count: "52",
    aweme_like_count: "49",
    aweme_comment_count: "5",
    aweme_share_count: "18",
    aweme_play_count: "4944",
    aweme_activation: "0.8333",
    live_count: "31",
    live_time: "1942",
    live_watch_count: 113259,
    live_watch_time: 124585,
    live_like_count: "2356",
    live_comment_count: "356",
    live_activation: "0.6667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "东营鑫红红旗体验中心",
    company_name: "东营鑫红汽车销售服务有限公司",
    store_code: "NSD612",
    大区: "东北区",
    "省份-城市": "山东省-东营市",
    "所选分组编号/分组名称": "-",
    fans_count: "41",
    fans_count_total: "286",
    aweme_count: "23",
    aweme_like_count: "169",
    aweme_comment_count: "31",
    aweme_share_count: "2",
    aweme_play_count: "10441",
    aweme_activation: "0.6333",
    live_count: "1",
    live_time: "1",
    live_watch_count: 0,
    live_watch_time: 1,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "瑞安宝合",
    company_name: "瑞安市宝合汽车销售有限公司",
    store_code: "EZJ614",
    大区: "华东区",
    "省份-城市": "浙江省-温州市",
    "所选分组编号/分组名称": "-",
    fans_count: "1000",
    fans_count_total: "81129",
    aweme_count: "47",
    aweme_like_count: "44414",
    aweme_comment_count: "2467",
    aweme_share_count: "1547",
    aweme_play_count: "1661852",
    aweme_activation: "0.9333",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "贵州安晟",
    company_name: "贵州安晟汽车销售服务有限公司",
    store_code: "WGZ606",
    大区: "西部区",
    "省份-城市": "贵州省-安顺市",
    "所选分组编号/分组名称": "-",
    fans_count: "9",
    fans_count_total: "313",
    aweme_count: "16",
    aweme_like_count: "103",
    aweme_comment_count: "26",
    aweme_share_count: 0,
    aweme_play_count: "27841",
    aweme_activation: "0.6",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "安阳世祥红旗体验中心",
    company_name: "安阳世祥汽车销售服务有限公司",
    store_code: "NYU616",
    大区: "华北区",
    "省份-城市": "河南省-安阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "117",
    fans_count_total: "46879",
    aweme_count: "26",
    aweme_like_count: "77",
    aweme_comment_count: "13",
    aweme_share_count: "33",
    aweme_play_count: "713194",
    aweme_activation: "0.2333",
    live_count: "12",
    live_time: "731",
    live_watch_count: 76086,
    live_watch_time: 83695,
    live_like_count: "17859",
    live_comment_count: "125",
    live_activation: "0.4667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "泰州海沃",
    company_name: "泰州海沃汽车销售服务有限公司",
    store_code: "EJS612",
    大区: "华东区",
    "省份-城市": "江苏省-泰州市",
    "所选分组编号/分组名称": "-",
    fans_count: "166",
    fans_count_total: "1393",
    aweme_count: "28",
    aweme_like_count: "123",
    aweme_comment_count: "38",
    aweme_share_count: "30",
    aweme_play_count: "11894",
    aweme_activation: "0.8",
    live_count: "16",
    live_time: "1029",
    live_watch_count: 8373,
    live_watch_time: 9211,
    live_like_count: "10734",
    live_comment_count: "2649",
    live_activation: "0.4",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "红河海伟宏亦红旗体验中心",
    company_name: "红河海伟宏亦红旗体验中心",
    store_code: "WYN606",
    大区: "西部区",
    "省份-城市": "云南省-红河哈尼族彝族自治州",
    "所选分组编号/分组名称": "-",
    fans_count: "9",
    fans_count_total: "76",
    aweme_count: "6",
    aweme_like_count: "109",
    aweme_comment_count: "14",
    aweme_share_count: 0,
    aweme_play_count: "17887",
    aweme_activation: "0.0667",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "晋江同行红旗体验中心",
    company_name: "晋江同行红旗体验中心",
    store_code: "SFJ605",
    大区: "华南区",
    "省份-城市": "福建省-泉州市",
    "所选分组编号/分组名称": "-",
    fans_count: "-129",
    fans_count_total: "33357",
    aweme_count: "23",
    aweme_like_count: "356",
    aweme_comment_count: "48",
    aweme_share_count: "10",
    aweme_play_count: "29650",
    aweme_activation: "0.7333",
    live_count: "1",
    live_time: "68",
    live_watch_count: 18,
    live_watch_time: 20,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "贵阳冉丰",
    company_name: "贵阳冉丰汽车服务有限公司",
    store_code: "WGZ607",
    大区: "西部区",
    "省份-城市": "贵州省-贵阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "8",
    fans_count_total: "121",
    aweme_count: "41",
    aweme_like_count: "109",
    aweme_comment_count: "28",
    aweme_share_count: "25",
    aweme_play_count: "2013729",
    aweme_activation: "0.9",
    live_count: "25",
    live_time: "1545",
    live_watch_count: 353,
    live_watch_time: 389,
    live_like_count: "88",
    live_comment_count: "18",
    live_activation: "0.6667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "娄底宝盛",
    company_name: "娄底市宝盛汽车销售服务有限公司",
    store_code: "CHN608",
    大区: "中南区",
    "省份-城市": "湖南省-娄底市",
    "所选分组编号/分组名称": "-",
    fans_count: "-19",
    fans_count_total: "94",
    aweme_count: "4",
    aweme_like_count: "62",
    aweme_comment_count: "7",
    aweme_share_count: 0,
    aweme_play_count: "18878",
    aweme_activation: "0.0667",
    live_count: "2",
    live_time: "96",
    live_watch_count: 10,
    live_watch_time: 12,
    live_like_count: "428",
    live_comment_count: 0,
    live_activation: "0.0667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "九江华宏一汽红旗",
    company_name: "九江华宏昇汽车有限公司",
    store_code: "CJX605",
    大区: "中南区",
    "省份-城市": "江西省-九江市",
    "所选分组编号/分组名称": "-",
    fans_count: "36",
    fans_count_total: "267",
    aweme_count: "80",
    aweme_like_count: "227",
    aweme_comment_count: "36",
    aweme_share_count: "7",
    aweme_play_count: "34911",
    aweme_activation: "0.8667",
    live_count: "4",
    live_time: "256",
    live_watch_count: 205,
    live_watch_time: 226,
    live_like_count: "716",
    live_comment_count: "1",
    live_activation: "0.1",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "泰安利华晟旗悦",
    company_name: "泰安利华晟旗悦汽车销售服务有限公司",
    store_code: "NSD619",
    大区: "东北区",
    "省份-城市": "山东省-泰安市",
    "所选分组编号/分组名称": "-",
    fans_count: "14",
    fans_count_total: "5986",
    aweme_count: "82",
    aweme_like_count: "54",
    aweme_comment_count: "3",
    aweme_share_count: "3",
    aweme_play_count: "8432",
    aweme_activation: "1.0",
    live_count: "5",
    live_time: "312",
    live_watch_count: 119,
    live_watch_time: 131,
    live_like_count: "1299",
    live_comment_count: "86",
    live_activation: "0.2333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "周口昱旗红旗4S店",
    company_name: "周口市昱旗汽车销售有限公司",
    store_code: "NYU612",
    大区: "华北区",
    "省份-城市": "河南省-周口市",
    "所选分组编号/分组名称": "-",
    fans_count: "-10",
    fans_count_total: "270",
    aweme_count: "36",
    aweme_like_count: "132",
    aweme_comment_count: "45",
    aweme_share_count: "62",
    aweme_play_count: "16268",
    aweme_activation: "0.8667",
    live_count: "5",
    live_time: "339",
    live_watch_count: 50,
    live_watch_time: 55,
    live_like_count: "1",
    live_comment_count: "5",
    live_activation: "0.1333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "红旗体验中心抚州龙旗店",
    company_name: "抚州市龙旗汽车销售有限公司",
    store_code: "CJX603",
    大区: "中南区",
    "省份-城市": "江西省-抚州市",
    "所选分组编号/分组名称": "-",
    fans_count: "1",
    fans_count_total: "54",
    aweme_count: "2",
    aweme_like_count: "7",
    aweme_comment_count: 0,
    aweme_share_count: "2",
    aweme_play_count: "1123",
    aweme_activation: "0.1",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "邵阳旗乐",
    company_name: "邵阳旗乐汽车销售服务有限公司",
    store_code: "CHN607",
    大区: "中南区",
    "省份-城市": "湖南省-邵阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "20",
    fans_count_total: "111",
    aweme_count: "4",
    aweme_like_count: "61",
    aweme_comment_count: "13",
    aweme_share_count: 0,
    aweme_play_count: "23505",
    aweme_activation: "0.1",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.1",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "玉溪国臻红旗体验中心",
    company_name: "玉溪国臻汽车销售服务有限公司",
    store_code: "WYN607",
    大区: "西部区",
    "省份-城市": "云南省-玉溪市",
    "所选分组编号/分组名称": "-",
    fans_count: "-31",
    fans_count_total: "22885",
    aweme_count: "26",
    aweme_like_count: "149",
    aweme_comment_count: "11",
    aweme_share_count: "4",
    aweme_play_count: "10952",
    aweme_activation: "0.7667",
    live_count: "4",
    live_time: "230",
    live_watch_count: 56,
    live_watch_time: 62,
    live_like_count: "1961",
    live_comment_count: 0,
    live_activation: "0.1333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "苏州华朔红旗体验中心",
    company_name: "苏州华朔汽车销售服务有限公司",
    store_code: "EJS613",
    大区: "华东区",
    "省份-城市": "江苏省-苏州市",
    "所选分组编号/分组名称": "-",
    fans_count: "9",
    fans_count_total: "31",
    aweme_count: "2",
    aweme_like_count: "42",
    aweme_comment_count: "10",
    aweme_share_count: 0,
    aweme_play_count: "5073",
    aweme_activation: "0.0667",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "孝感祥沃红旗体验中心",
    company_name: "孝感祥沃汽车销售服务有限公司",
    store_code: "CHB606",
    大区: "中南区",
    "省份-城市": "湖北省-孝感市",
    "所选分组编号/分组名称": "-",
    fans_count: "107",
    fans_count_total: "13931",
    aweme_count: "36",
    aweme_like_count: "66",
    aweme_comment_count: "12",
    aweme_share_count: "20",
    aweme_play_count: "12122",
    aweme_activation: "0.7667",
    live_count: "25",
    live_time: "1573",
    live_watch_count: 6583,
    live_watch_time: 7242,
    live_like_count: "9763",
    live_comment_count: "350",
    live_activation: "0.9",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "西昌璞瑞一汽红旗店",
    company_name: "西昌璞瑞汽车销售服务有限责任公司",
    store_code: "WSC617",
    大区: "西部区",
    "省份-城市": "四川省-凉山彝族自治州",
    "所选分组编号/分组名称": "-",
    fans_count: "865",
    fans_count_total: "3292",
    aweme_count: "22",
    aweme_like_count: "121",
    aweme_comment_count: "50",
    aweme_share_count: 0,
    aweme_play_count: "7414",
    aweme_activation: "0.6667",
    live_count: "35",
    live_time: "2641",
    live_watch_count: 116458,
    live_watch_time: 128104,
    live_like_count: "2651",
    live_comment_count: "155",
    live_activation: "0.8667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "扬州广成扬旗",
    company_name: "扬州广成扬旗汽车有限公司",
    store_code: "EJS614",
    大区: "华东区",
    "省份-城市": "江苏省-扬州市",
    "所选分组编号/分组名称": "-",
    fans_count: "-16",
    fans_count_total: "4122",
    aweme_count: "3",
    aweme_like_count: "45",
    aweme_comment_count: "7",
    aweme_share_count: 0,
    aweme_play_count: "9331",
    aweme_activation: "0.1333",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "上海岳宏泰红旗",
    company_name: "上海岳宏泰红旗",
    store_code: "ESH610",
    大区: "华东区",
    "省份-城市": "上海市-上海市",
    "所选分组编号/分组名称": "-",
    fans_count: "489",
    fans_count_total: "35196",
    aweme_count: "65",
    aweme_like_count: "281",
    aweme_comment_count: "77",
    aweme_share_count: "32",
    aweme_play_count: "43089",
    aweme_activation: "0.9333",
    live_count: "37",
    live_time: "2347",
    live_watch_count: 384876,
    live_watch_time: 423364,
    live_like_count: "49952",
    live_comment_count: "402",
    live_activation: "0.8",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "平顶山盛大红旗体验中心",
    company_name: "平顶山市盛大汽车销售服务有限公司",
    store_code: "NYU617",
    大区: "华北区",
    "省份-城市": "河南省-平顶山市",
    "所选分组编号/分组名称": "-",
    fans_count: "253",
    fans_count_total: "4582",
    aweme_count: "33",
    aweme_like_count: "149",
    aweme_comment_count: "44",
    aweme_share_count: "2",
    aweme_play_count: "9693",
    aweme_activation: "0.7667",
    live_count: "1",
    live_time: "74",
    live_watch_count: 1,
    live_watch_time: 2,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.1667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "唐山岳泰宏旗",
    company_name: "唐山岳泰宏旗汽车销售服务有限公司",
    store_code: "NJI605",
    大区: "华北区",
    "省份-城市": "河北省-唐山市",
    "所选分组编号/分组名称": "-",
    fans_count: "3148",
    fans_count_total: "120129",
    aweme_count: "67",
    aweme_like_count: "29362",
    aweme_comment_count: "270",
    aweme_share_count: "4558",
    aweme_play_count: "2800627",
    aweme_activation: "0.9333",
    live_count: "63",
    live_time: "3977",
    live_watch_count: 679980,
    live_watch_time: 747979,
    live_like_count: "353664",
    live_comment_count: "47753",
    live_activation: "0.8667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "凯里凯通",
    company_name: "凯里市凯通汽车贸易有限公司",
    store_code: "WGZ610",
    大区: "西部区",
    "省份-城市": "贵州省-黔东南苗族侗族自治州",
    "所选分组编号/分组名称": "-",
    fans_count: "1",
    fans_count_total: "17",
    aweme_count: 0,
    aweme_like_count: "11",
    aweme_comment_count: "1",
    aweme_share_count: 0,
    aweme_play_count: "34",
    aweme_activation: "0.0333",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "常德时茂红旗",
    company_name: "常德时茂汽车销售服务有限公司",
    store_code: "CHN610",
    大区: "中南区",
    "省份-城市": "湖南省-常德市",
    "所选分组编号/分组名称": "-",
    fans_count: "23",
    fans_count_total: "328",
    aweme_count: "19",
    aweme_like_count: "133",
    aweme_comment_count: "33",
    aweme_share_count: "2",
    aweme_play_count: "13155",
    aweme_activation: "0.6",
    live_count: "14",
    live_time: "931",
    live_watch_count: 78,
    live_watch_time: 86,
    live_like_count: "1389",
    live_comment_count: "21",
    live_activation: "0.5",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "十堰亨运红晟",
    company_name: "十堰亨运红晟汽车销售服务有限公司",
    store_code: "CHB609",
    大区: "中南区",
    "省份-城市": "湖北省-十堰市",
    "所选分组编号/分组名称": "-",
    fans_count: 0,
    fans_count_total: "20",
    aweme_count: 0,
    aweme_like_count: 0,
    aweme_comment_count: 0,
    aweme_share_count: 0,
    aweme_play_count: 0,
    aweme_activation: "0.0",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "南昌美乘红旗体验中心",
    company_name: "南昌美乘红旗体验中心",
    store_code: "CJX604",
    大区: "中南区",
    "省份-城市": "江西省-南昌市",
    "所选分组编号/分组名称": "-",
    fans_count: "11",
    fans_count_total: "3736",
    aweme_count: "39",
    aweme_like_count: "199",
    aweme_comment_count: "34",
    aweme_share_count: "16",
    aweme_play_count: "115220",
    aweme_activation: "0.9",
    live_count: "24",
    live_time: "1885",
    live_watch_count: 540,
    live_watch_time: 594,
    live_like_count: "25",
    live_comment_count: "12",
    live_activation: "0.4333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "普洱海伟宏亦红旗体验中心",
    company_name: "普洱海伟宏亦汽车销售有限公司",
    store_code: "WYN608",
    大区: "西部区",
    "省份-城市": "云南省-普洱市",
    "所选分组编号/分组名称": "-",
    fans_count: "-1",
    fans_count_total: "213",
    aweme_count: "18",
    aweme_like_count: "10",
    aweme_comment_count: 0,
    aweme_share_count: "19",
    aweme_play_count: "693",
    aweme_activation: "0.5",
    live_count: "25",
    live_time: "1714",
    live_watch_count: 474,
    live_watch_time: 522,
    live_like_count: "1589",
    live_comment_count: "51",
    live_activation: "0.7667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "福州华奥红旗",
    company_name: "福州华奥鸿旗汽车销售有限公司",
    store_code: "SFJ607",
    大区: "华南区",
    "省份-城市": "福建省-福州市",
    "所选分组编号/分组名称": "-",
    fans_count: "-17",
    fans_count_total: "299",
    aweme_count: "14",
    aweme_like_count: "215",
    aweme_comment_count: "34",
    aweme_share_count: "4",
    aweme_play_count: "114099",
    aweme_activation: "0.5",
    live_count: "21",
    live_time: "1305",
    live_watch_count: 218,
    live_watch_time: 240,
    live_like_count: "24",
    live_comment_count: "6",
    live_activation: "0.6",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "株洲宏旗",
    company_name: "株洲宏旗汽车销售服务有限公司",
    store_code: "CHN609",
    大区: "中南区",
    "省份-城市": "湖南省-株洲市",
    "所选分组编号/分组名称": "-",
    fans_count: "-2",
    fans_count_total: "10447",
    aweme_count: "27",
    aweme_like_count: "76",
    aweme_comment_count: "10",
    aweme_share_count: "4",
    aweme_play_count: "19213",
    aweme_activation: "0.4333",
    live_count: "8",
    live_time: "518",
    live_watch_count: 103,
    live_watch_time: 114,
    live_like_count: "1354",
    live_comment_count: "5",
    live_activation: "0.2333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "马鞍山金福联",
    company_name: "马鞍山金福联汽车销售服务有限公司",
    store_code: "EAH609",
    大区: "华东区",
    "省份-城市": "安徽省-马鞍山市",
    "所选分组编号/分组名称": "-",
    fans_count: "-38",
    fans_count_total: "7974",
    aweme_count: "2",
    aweme_like_count: "28",
    aweme_comment_count: "3",
    aweme_share_count: 0,
    aweme_play_count: "8805",
    aweme_activation: "0.0667",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "黄冈旗胜",
    company_name: "黄冈旗胜汽车服务有限公司",
    store_code: "CHB607",
    大区: "中南区",
    "省份-城市": "湖北省-黄冈市",
    "所选分组编号/分组名称": "-",
    fans_count: "6",
    fans_count_total: "28",
    aweme_count: "7",
    aweme_like_count: "25",
    aweme_comment_count: "3",
    aweme_share_count: 0,
    aweme_play_count: "2833",
    aweme_activation: "0.0667",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "牡丹江中信恒安",
    company_name: "牡丹江中信恒安汽车销售服务有限公司",
    store_code: "DHL602",
    大区: "东北区",
    "省份-城市": "黑龙江省-牡丹江市",
    "所选分组编号/分组名称": "-",
    fans_count: "-71",
    fans_count_total: "30520",
    aweme_count: "21",
    aweme_like_count: "119",
    aweme_comment_count: "11",
    aweme_share_count: "30",
    aweme_play_count: "10726",
    aweme_activation: "0.7",
    live_count: "13",
    live_time: "790",
    live_watch_count: 751,
    live_watch_time: 827,
    live_like_count: "369",
    live_comment_count: "189",
    live_activation: "0.4667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "漳州宏旗",
    company_name: "漳州市宏旗汽车销售服务有限公司",
    store_code: "SFJ606",
    大区: "华南区",
    "省份-城市": "福建省-漳州市",
    "所选分组编号/分组名称": "-",
    fans_count: "-4",
    fans_count_total: "1712",
    aweme_count: "29",
    aweme_like_count: "100",
    aweme_comment_count: "42",
    aweme_share_count: "1",
    aweme_play_count: "26973",
    aweme_activation: "0.6667",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "鄂尔多斯红旗",
    company_name: "鄂尔多斯市宏旗汽车销售有限公司",
    store_code: "DNM605",
    大区: "华北区",
    "省份-城市": "内蒙古自治区-鄂尔多斯市",
    "所选分组编号/分组名称": "-",
    fans_count: "777",
    fans_count_total: "19841",
    aweme_count: "49",
    aweme_like_count: "243",
    aweme_comment_count: "24",
    aweme_share_count: "81",
    aweme_play_count: "18704",
    aweme_activation: "1.0",
    live_count: "61",
    live_time: "5215",
    live_watch_count: 64856,
    live_watch_time: 71342,
    live_like_count: "120958",
    live_comment_count: "12686",
    live_activation: "0.9667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "诸暨悦旗",
    company_name: "诸暨悦旗汽车有限公司",
    store_code: "EZJ618",
    大区: "华东区",
    "省份-城市": "浙江省-绍兴市",
    "所选分组编号/分组名称": "-",
    fans_count: "11",
    fans_count_total: "606",
    aweme_count: "64",
    aweme_like_count: "168",
    aweme_comment_count: "39",
    aweme_share_count: "12",
    aweme_play_count: "34340",
    aweme_activation: "1.0",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "西藏泰立",
    company_name: "西藏泰立汽车销售服务有限公司",
    store_code: "WXZ601",
    大区: "西部区",
    "省份-城市": "西藏自治区-拉萨市",
    "所选分组编号/分组名称": "-",
    fans_count: "-3",
    fans_count_total: "184",
    aweme_count: "7",
    aweme_like_count: "1",
    aweme_comment_count: "2",
    aweme_share_count: "7",
    aweme_play_count: "105",
    aweme_activation: "0.2667",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "华奕衡水红旗体验中心",
    company_name: "华奕衡水红旗体验中心",
    store_code: "NJI606",
    大区: "华北区",
    "省份-城市": "河北省-衡水市",
    "所选分组编号/分组名称": "-",
    fans_count: "2417",
    fans_count_total: "113629",
    aweme_count: "25",
    aweme_like_count: "1042",
    aweme_comment_count: "138",
    aweme_share_count: "220",
    aweme_play_count: "268366",
    aweme_activation: "0.6667",
    live_count: "29",
    live_time: "1802",
    live_watch_count: 669281,
    live_watch_time: 736210,
    live_like_count: "16021",
    live_comment_count: "1346",
    live_activation: "0.5667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "济南民福红旗体验中心",
    company_name: "济南民福汽车服务有限公司",
    store_code: "NSD616",
    大区: "东北区",
    "省份-城市": "山东省-济南市",
    "所选分组编号/分组名称": "-",
    fans_count: "162",
    fans_count_total: "74890",
    aweme_count: "37",
    aweme_like_count: "210",
    aweme_comment_count: "72",
    aweme_share_count: "15",
    aweme_play_count: "11278",
    aweme_activation: "1.0",
    live_count: "51",
    live_time: "3407",
    live_watch_count: 172138,
    live_watch_time: 189352,
    live_like_count: "6766",
    live_comment_count: "2514",
    live_activation: "0.8667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "四平通立",
    company_name: "四平通立汽车销售服务有限公司",
    store_code: "DJL607",
    大区: "东北区",
    "省份-城市": "吉林省-四平市",
    "所选分组编号/分组名称": "-",
    fans_count: "460",
    fans_count_total: "20494",
    aweme_count: "31",
    aweme_like_count: "71",
    aweme_comment_count: "36",
    aweme_share_count: "18",
    aweme_play_count: "5662",
    aweme_activation: "0.8667",
    live_count: "44",
    live_time: "2752",
    live_watch_count: 61868,
    live_watch_time: 68055,
    live_like_count: "61705",
    live_comment_count: "11245",
    live_activation: "0.8667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "黔南州大雍汇盛",
    company_name: "黔南州大雍汇盛汽车销售服务有限公司",
    store_code: "WGZ609",
    大区: "西部区",
    "省份-城市": "贵州省-黔南布依族苗族自治州",
    "所选分组编号/分组名称": "-",
    fans_count: "19",
    fans_count_total: "76",
    aweme_count: "3",
    aweme_like_count: "74",
    aweme_comment_count: "9",
    aweme_share_count: 0,
    aweme_play_count: "18202",
    aweme_activation: "0.1333",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "广安祥龙",
    company_name: "广安祥龙车业有限公司",
    store_code: "WSC619",
    大区: "西部区",
    "省份-城市": "四川省-广安市",
    "所选分组编号/分组名称": "-",
    fans_count: "-4",
    fans_count_total: "119",
    aweme_count: "54",
    aweme_like_count: "89",
    aweme_comment_count: "10",
    aweme_share_count: "112",
    aweme_play_count: "6215",
    aweme_activation: "0.9667",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "通辽大鹏泰达",
    company_name: "通辽市大鹏泰达汽车销售服务有限公司",
    store_code: "DNM606",
    大区: "东北区",
    "省份-城市": "内蒙古自治区-通辽市",
    "所选分组编号/分组名称": "-",
    fans_count: "148",
    fans_count_total: "97219",
    aweme_count: "44",
    aweme_like_count: "2141",
    aweme_comment_count: "198",
    aweme_share_count: "131",
    aweme_play_count: "258891",
    aweme_activation: "1.0",
    live_count: "26",
    live_time: "1599",
    live_watch_count: 116736,
    live_watch_time: 128410,
    live_like_count: "71213",
    live_comment_count: "1877",
    live_activation: "0.7",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "邯郸鸿博红旗体验中心",
    company_name: "邯郸市鸿博汽车销售服务有限公司",
    store_code: "NJI608",
    大区: "华北区",
    "省份-城市": "河北省-邯郸市",
    "所选分组编号/分组名称": "-",
    fans_count: "110",
    fans_count_total: "19402",
    aweme_count: "6",
    aweme_like_count: "241",
    aweme_comment_count: "56",
    aweme_share_count: "1",
    aweme_play_count: "11185",
    aweme_activation: "0.1333",
    live_count: "33",
    live_time: "2061",
    live_watch_count: 151096,
    live_watch_time: 166206,
    live_like_count: "3870",
    live_comment_count: "293",
    live_activation: "0.8",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "肇庆诚利",
    company_name: "肇庆市诚利汽车销售服务有限公司",
    store_code: "SGD615",
    大区: "华南区",
    "省份-城市": "广东省-肇庆市",
    "所选分组编号/分组名称": "-",
    fans_count: "-44",
    fans_count_total: "343",
    aweme_count: "34",
    aweme_like_count: "47",
    aweme_comment_count: "9",
    aweme_share_count: 0,
    aweme_play_count: "15154",
    aweme_activation: "0.7333",
    live_count: "21",
    live_time: "1462",
    live_watch_count: 239,
    live_watch_time: 263,
    live_like_count: 0,
    live_comment_count: "2",
    live_activation: "0.7",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "四川融裕",
    company_name: "四川融裕汽车贸易有限责任公司",
    store_code: "WSC618",
    大区: "西部区",
    "省份-城市": "四川省-眉山市",
    "所选分组编号/分组名称": "-",
    fans_count: "-15",
    fans_count_total: "4653",
    aweme_count: "22",
    aweme_like_count: "10",
    aweme_comment_count: "3",
    aweme_share_count: "23",
    aweme_play_count: "7457",
    aweme_activation: "0.5667",
    live_count: "20",
    live_time: "1252",
    live_watch_count: 1903,
    live_watch_time: 2094,
    live_like_count: "9921",
    live_comment_count: "104",
    live_activation: "0.7",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "亳州远景特润红旗",
    company_name: "亳州市远景特润汽车销售服务有限责任公司",
    store_code: "EAH608",
    大区: "华东区",
    "省份-城市": "安徽省-亳州市",
    "所选分组编号/分组名称": "-",
    fans_count: "3543",
    fans_count_total: "130843",
    aweme_count: "14",
    aweme_like_count: "77778",
    aweme_comment_count: "2237",
    aweme_share_count: "3335",
    aweme_play_count: "1769782",
    aweme_activation: "0.5",
    live_count: "43",
    live_time: "3033",
    live_watch_count: 199805,
    live_watch_time: 219786,
    live_like_count: "10582",
    live_comment_count: "876",
    live_activation: "0.9",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "绵阳红旗体验中心",
    company_name: "绵阳红旗体验中心",
    store_code: "WSC611",
    大区: "西部区",
    "省份-城市": "四川省-绵阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "-40",
    fans_count_total: "7645",
    aweme_count: "45",
    aweme_like_count: "66",
    aweme_comment_count: "29",
    aweme_share_count: "25",
    aweme_play_count: "10173",
    aweme_activation: "0.9",
    live_count: "12",
    live_time: "650",
    live_watch_count: 277,
    live_watch_time: 305,
    live_like_count: "443",
    live_comment_count: "13",
    live_activation: "0.2667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "承德天晟",
    company_name: "承德天美",
    store_code: "NJI618",
    大区: "华北区",
    "省份-城市": "河北省-承德市",
    "所选分组编号/分组名称": "-",
    fans_count: "1358",
    fans_count_total: "22025",
    aweme_count: "43",
    aweme_like_count: "138",
    aweme_comment_count: "22",
    aweme_share_count: "14",
    aweme_play_count: "9660",
    aweme_activation: "0.8667",
    live_count: "50",
    live_time: "3178",
    live_watch_count: 262357,
    live_watch_time: 288593,
    live_like_count: "10570",
    live_comment_count: "1135",
    live_activation: "0.8667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "贵州星尊程悦航",
    company_name: "贵州星尊程悦航",
    store_code: "WGZ611",
    大区: "西部区",
    "省份-城市": "贵州省-六盘水市",
    "所选分组编号/分组名称": "-",
    fans_count: 0,
    fans_count_total: "14873",
    aweme_count: "29",
    aweme_like_count: "423",
    aweme_comment_count: "81",
    aweme_share_count: "66",
    aweme_play_count: "15645",
    aweme_activation: "0.6667",
    live_count: "41",
    live_time: "2575",
    live_watch_count: 4399,
    live_watch_time: 4839,
    live_like_count: "22697",
    live_comment_count: "746",
    live_activation: "0.8",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "湛江宝旗",
    company_name: "湛江市宝旗汽车销售服务有限公司",
    store_code: "SGD616",
    大区: "华南区",
    "省份-城市": "广东省-湛江市",
    "所选分组编号/分组名称": "-",
    fans_count: "-8",
    fans_count_total: "2894",
    aweme_count: "24",
    aweme_like_count: "42",
    aweme_comment_count: "18",
    aweme_share_count: "1",
    aweme_play_count: "10563",
    aweme_activation: "0.6667",
    live_count: "6",
    live_time: "363",
    live_watch_count: 157,
    live_watch_time: 173,
    live_like_count: "158",
    live_comment_count: "53",
    live_activation: "0.2",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "赤峰天永红旗体验中心",
    company_name: "赤峰天永汽车销售服务有限公司",
    store_code: "DNM604",
    大区: "东北区",
    "省份-城市": "内蒙古自治区-赤峰市",
    "所选分组编号/分组名称": "-",
    fans_count: "-449",
    fans_count_total: "415090",
    aweme_count: "8",
    aweme_like_count: "512",
    aweme_comment_count: "22",
    aweme_share_count: "16",
    aweme_play_count: "49797",
    aweme_activation: "0.1667",
    live_count: "2",
    live_time: "125",
    live_watch_count: 111463,
    live_watch_time: 122610,
    live_like_count: "25914",
    live_comment_count: "653",
    live_activation: "0.1",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "郴州恒晨",
    company_name: "郴州市恒晨汽车销售服务有限公司",
    store_code: "CHN612",
    大区: "中南区",
    "省份-城市": "湖南省-郴州市",
    "所选分组编号/分组名称": "-",
    fans_count: "692",
    fans_count_total: "14572",
    aweme_count: "45",
    aweme_like_count: "381",
    aweme_comment_count: "27",
    aweme_share_count: "87",
    aweme_play_count: "266979",
    aweme_activation: "0.9333",
    live_count: "33",
    live_time: "2107",
    live_watch_count: 41512,
    live_watch_time: 45664,
    live_like_count: "69933",
    live_comment_count: "9869",
    live_activation: "0.7333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "荆州旗阳红旗体验中心",
    company_name: "荆州旗阳汽车销售服务有限公司",
    store_code: "CHB608",
    大区: "中南区",
    "省份-城市": "湖北省-荆州市",
    "所选分组编号/分组名称": "-",
    fans_count: "50",
    fans_count_total: "106",
    aweme_count: "39",
    aweme_like_count: "125",
    aweme_comment_count: "26",
    aweme_share_count: "20",
    aweme_play_count: "23718",
    aweme_activation: "0.7333",
    live_count: "27",
    live_time: "1641",
    live_watch_count: 368,
    live_watch_time: 405,
    live_like_count: "104",
    live_comment_count: "15",
    live_activation: "0.8",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "岳阳广宸",
    company_name: "岳阳广宸汽车销售服务有限公司",
    store_code: "CHN611",
    大区: "中南区",
    "省份-城市": "湖南省-岳阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "-13",
    fans_count_total: "1342",
    aweme_count: "2",
    aweme_like_count: "22",
    aweme_comment_count: "3",
    aweme_share_count: 0,
    aweme_play_count: "10320",
    aweme_activation: "0.1",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "江门裕立",
    company_name: "江门市裕立汽车销售服务有限公司",
    store_code: "SGD617",
    大区: "华南区",
    "省份-城市": "广东省-江门市",
    "所选分组编号/分组名称": "-",
    fans_count: "25",
    fans_count_total: "245",
    aweme_count: "38",
    aweme_like_count: "120",
    aweme_comment_count: "32",
    aweme_share_count: "7",
    aweme_play_count: "23741",
    aweme_activation: "0.7667",
    live_count: "17",
    live_time: "969",
    live_watch_count: 196,
    live_watch_time: 216,
    live_like_count: "1",
    live_comment_count: "1",
    live_activation: "0.6",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "汕头众驰红旗4S店",
    company_name: "汕头市众驰汽车有限公司",
    store_code: "SGD623",
    大区: "华南区",
    "省份-城市": "广东省-汕头市",
    "所选分组编号/分组名称": "-",
    fans_count: "12",
    fans_count_total: "117",
    aweme_count: "3",
    aweme_like_count: "77",
    aweme_comment_count: "10",
    aweme_share_count: 0,
    aweme_play_count: "11617",
    aweme_activation: "0.0667",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "资阳清巍茂美",
    company_name: "资阳市清巍茂美汽车销售服务有限公司",
    store_code: "WSC621",
    大区: "西部区",
    "省份-城市": "四川省-资阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "-1",
    fans_count_total: "59",
    aweme_count: 0,
    aweme_like_count: 0,
    aweme_comment_count: 0,
    aweme_share_count: 0,
    aweme_play_count: 0,
    aweme_activation: "0.0",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "广物红旗广州鸿福",
    company_name: "广东广物鸿福汽车销售服务有限公司",
    store_code: "SGD618",
    大区: "华南区",
    "省份-城市": "广东省-广州市",
    "所选分组编号/分组名称": "-",
    fans_count: "23",
    fans_count_total: "96",
    aweme_count: "22",
    aweme_like_count: "66",
    aweme_comment_count: "12",
    aweme_share_count: 0,
    aweme_play_count: "36517",
    aweme_activation: "0.3",
    live_count: "12",
    live_time: "710",
    live_watch_count: 370,
    live_watch_time: 408,
    live_like_count: "1856",
    live_comment_count: 0,
    live_activation: "0.2",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "齐齐哈尔粤华红旗",
    company_name: "齐齐哈尔粤华汽贸集团有限公司",
    store_code: "DHL603",
    大区: "东北区",
    "省份-城市": "黑龙江省-齐齐哈尔市",
    "所选分组编号/分组名称": "-",
    fans_count: "-20",
    fans_count_total: "33057",
    aweme_count: "112",
    aweme_like_count: "109",
    aweme_comment_count: "18",
    aweme_share_count: "21",
    aweme_play_count: "11189",
    aweme_activation: "0.9",
    live_count: "27",
    live_time: "1646",
    live_watch_count: 61135,
    live_watch_time: 67249,
    live_like_count: "4392",
    live_comment_count: "348",
    live_activation: "0.9",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "合肥和旗",
    company_name: "合肥和旗",
    store_code: "EAH624",
    大区: "华东区",
    "省份-城市": "安徽省-合肥市",
    "所选分组编号/分组名称": "-",
    fans_count: "16",
    fans_count_total: "129",
    aweme_count: "38",
    aweme_like_count: "171",
    aweme_comment_count: "30",
    aweme_share_count: 0,
    aweme_play_count: "21776",
    aweme_activation: "0.8333",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "昭通国源",
    company_name: "昭通国源汽车销售服务有限公司",
    store_code: "WYN610",
    大区: "西部区",
    "省份-城市": "云南省-昭通市",
    "所选分组编号/分组名称": "-",
    fans_count: "11",
    fans_count_total: "109",
    aweme_count: "2",
    aweme_like_count: "43",
    aweme_comment_count: "7",
    aweme_share_count: 0,
    aweme_play_count: "11425",
    aweme_activation: "0.0667",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "南京天沃红旗体验中心",
    company_name: "南京天沃汽车销售服务有限公司",
    store_code: "EJS618",
    大区: "华东区",
    "省份-城市": "江苏省-南京市",
    "所选分组编号/分组名称": "-",
    fans_count: "1735",
    fans_count_total: "44903",
    aweme_count: "49",
    aweme_like_count: "4452",
    aweme_comment_count: "877",
    aweme_share_count: "489",
    aweme_play_count: "329712",
    aweme_activation: "0.9",
    live_count: "23",
    live_time: "1440",
    live_watch_count: 77417,
    live_watch_time: 85159,
    live_like_count: "7447",
    live_comment_count: "3099",
    live_activation: "0.8",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "焦作天宏",
    company_name: "焦作市天宏汽车销售服务有限公司",
    store_code: "NYU618",
    大区: "华北区",
    "省份-城市": "河南省-焦作市",
    "所选分组编号/分组名称": "-",
    fans_count: "-28",
    fans_count_total: "10381",
    aweme_count: "10",
    aweme_like_count: "567",
    aweme_comment_count: "143",
    aweme_share_count: "28",
    aweme_play_count: "497503",
    aweme_activation: "0.3",
    live_count: "24",
    live_time: "1318",
    live_watch_count: 1367,
    live_watch_time: 1504,
    live_like_count: "1107",
    live_comment_count: "157",
    live_activation: "0.3333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "连云港海旗",
    company_name: "连云港海旗汽车销售服务有限公司",
    store_code: "EJS617",
    大区: "华东区",
    "省份-城市": "江苏省-连云港市",
    "所选分组编号/分组名称": "-",
    fans_count: "27",
    fans_count_total: "176",
    aweme_count: "42",
    aweme_like_count: "123",
    aweme_comment_count: "15",
    aweme_share_count: "37",
    aweme_play_count: "13680",
    aweme_activation: "0.9",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "西双版纳骏杰红旗体验中心",
    company_name: "西双版纳骏杰汽车销售服务有限公司",
    store_code: "WYN609",
    大区: "西部区",
    "省份-城市": "云南省-西双版纳傣族自治州",
    "所选分组编号/分组名称": "-",
    fans_count: "6",
    fans_count_total: "38",
    aweme_count: "1",
    aweme_like_count: "9",
    aweme_comment_count: "3",
    aweme_share_count: 0,
    aweme_play_count: "3925",
    aweme_activation: "0.0333",
    live_count: "1",
    live_time: "185",
    live_watch_count: 37,
    live_watch_time: 41,
    live_like_count: "378",
    live_comment_count: 0,
    live_activation: "0.0333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "大昌福源红旗智能体验中心",
    company_name: "山西大昌福源汽车销售服务有限公司",
    store_code: "NJN608",
    大区: "华北区",
    "省份-城市": "山西省-太原市",
    "所选分组编号/分组名称": "-",
    fans_count: "-1",
    fans_count_total: "238",
    aweme_count: "2",
    aweme_like_count: "49",
    aweme_comment_count: "6",
    aweme_share_count: "13",
    aweme_play_count: "5005",
    aweme_activation: "0.0667",
    live_count: "58",
    live_time: "3481",
    live_watch_count: 920,
    live_watch_time: 1012,
    live_like_count: "160",
    live_comment_count: "10",
    live_activation: "0.8333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "徐州天捷",
    company_name: "徐州天捷",
    store_code: "EJS616",
    大区: "华东区",
    "省份-城市": "江苏省-徐州市",
    "所选分组编号/分组名称": "-",
    fans_count: "27",
    fans_count_total: "173",
    aweme_count: "33",
    aweme_like_count: "71",
    aweme_comment_count: "38",
    aweme_share_count: "17",
    aweme_play_count: "20118",
    aweme_activation: "0.6667",
    live_count: "27",
    live_time: "1751",
    live_watch_count: 743,
    live_watch_time: 818,
    live_like_count: "2009",
    live_comment_count: "328",
    live_activation: "0.7",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "韶关荣耀",
    company_name: "韶关市荣耀汽车销售服务有限公司",
    store_code: "SGD619",
    大区: "华南区",
    "省份-城市": "广东省-韶关市",
    "所选分组编号/分组名称": "-",
    fans_count: "-153",
    fans_count_total: "49697",
    aweme_count: "3",
    aweme_like_count: "23",
    aweme_comment_count: "3",
    aweme_share_count: 0,
    aweme_play_count: "11100",
    aweme_activation: "0.1",
    live_count: "1",
    live_time: "64",
    live_watch_count: 16,
    live_watch_time: 18,
    live_like_count: "2334",
    live_comment_count: 0,
    live_activation: "0.0667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "黑龙江华之诚万家",
    company_name: "黑龙江省华之诚万家汽车销售服务有限公司",
    store_code: "DHL604",
    大区: "东北区",
    "省份-城市": "黑龙江省-哈尔滨市",
    "所选分组编号/分组名称": "-",
    fans_count: "231",
    fans_count_total: "104313",
    aweme_count: "29",
    aweme_like_count: "641",
    aweme_comment_count: "149",
    aweme_share_count: "172",
    aweme_play_count: "63094",
    aweme_activation: "0.5",
    live_count: "27",
    live_time: "1650",
    live_watch_count: 116427,
    live_watch_time: 128070,
    live_like_count: "14554",
    live_comment_count: "4830",
    live_activation: "0.5667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "深圳通利华红旗(龙岗）",
    company_name: "深圳通利华红旗(龙岗）",
    store_code: "SGD620",
    大区: "华南区",
    "省份-城市": "广东省-深圳市",
    "所选分组编号/分组名称": "-",
    fans_count: "11",
    fans_count_total: "436",
    aweme_count: "22",
    aweme_like_count: "53",
    aweme_comment_count: "15",
    aweme_share_count: "29",
    aweme_play_count: "3512",
    aweme_activation: "0.6",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "湖北骏翔汽车",
    company_name: "湖北骏翔汽车销售服务有限公司",
    store_code: "CHB613",
    大区: "中南区",
    "省份-城市": "湖北省-随州市",
    "所选分组编号/分组名称": "-",
    fans_count: "18",
    fans_count_total: "81",
    aweme_count: "3",
    aweme_like_count: "46",
    aweme_comment_count: "11",
    aweme_share_count: 0,
    aweme_play_count: "13263",
    aweme_activation: "0.1333",
    live_count: "3",
    live_time: "199",
    live_watch_count: 40,
    live_watch_time: 45,
    live_like_count: "1165",
    live_comment_count: 0,
    live_activation: "0.1",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "威海鸿运",
    company_name: "威海鸿运汽车销售服务有限公司",
    store_code: "NSD620",
    大区: "东北区",
    "省份-城市": "山东省-威海市",
    "所选分组编号/分组名称": "-",
    fans_count: "15",
    fans_count_total: "217",
    aweme_count: "8",
    aweme_like_count: "60",
    aweme_comment_count: "9",
    aweme_share_count: 0,
    aweme_play_count: "16663",
    aweme_activation: "0.1667",
    live_count: "28",
    live_time: "1739",
    live_watch_count: 415,
    live_watch_time: 457,
    live_like_count: "27",
    live_comment_count: "22",
    live_activation: "0.7",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "湘西旗胜",
    company_name: "湘西旗胜汽车销售有限责任公司",
    store_code: "CHN614",
    大区: "中南区",
    "省份-城市": "湖南省-湘西土家族苗族自治州",
    "所选分组编号/分组名称": "-",
    fans_count: "247",
    fans_count_total: "12896",
    aweme_count: "32",
    aweme_like_count: "5042",
    aweme_comment_count: "293",
    aweme_share_count: "142",
    aweme_play_count: "1110118",
    aweme_activation: "0.7333",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "滁州红旗4S店",
    company_name: "滁州红旗4S店",
    store_code: "EAH612",
    大区: "华东区",
    "省份-城市": "安徽省-滁州市",
    "所选分组编号/分组名称": "-",
    fans_count: "-7",
    fans_count_total: "388",
    aweme_count: "65",
    aweme_like_count: "85",
    aweme_comment_count: "47",
    aweme_share_count: 0,
    aweme_play_count: "22914",
    aweme_activation: "1.0",
    live_count: "31",
    live_time: "2019",
    live_watch_count: 939,
    live_watch_time: 1033,
    live_like_count: "3237",
    live_comment_count: "98",
    live_activation: "0.7667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "鞍山天美红旗",
    company_name: "鞍山天美汽车销售有限公司",
    store_code: "DLN609",
    大区: "东北区",
    "省份-城市": "辽宁省-鞍山市",
    "所选分组编号/分组名称": "-",
    fans_count: "6185",
    fans_count_total: "62520",
    aweme_count: "33",
    aweme_like_count: "334",
    aweme_comment_count: "120",
    aweme_share_count: "89",
    aweme_play_count: "84404",
    aweme_activation: "0.7667",
    live_count: "45",
    live_time: "2780",
    live_watch_count: 898043,
    live_watch_time: 987848,
    live_like_count: "70164",
    live_comment_count: "2715",
    live_activation: "0.9333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "楚雄安晟",
    company_name: "楚雄安晟汽车销售服务有限公司",
    store_code: "WYN612",
    大区: "西部区",
    "省份-城市": "云南省-楚雄彝族自治州",
    "所选分组编号/分组名称": "-",
    fans_count: 0,
    fans_count_total: "259",
    aweme_count: 0,
    aweme_like_count: "23",
    aweme_comment_count: "2",
    aweme_share_count: 0,
    aweme_play_count: "4140",
    aweme_activation: "0.0333",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "文山鑫桥红旗",
    company_name: "文山市鑫桥汽车销售服务有限公司",
    store_code: "WYN611",
    大区: "西部区",
    "省份-城市": "云南省-文山壮族苗族自治州",
    "所选分组编号/分组名称": "-",
    fans_count: "-66",
    fans_count_total: "18396",
    aweme_count: "7",
    aweme_like_count: "115",
    aweme_comment_count: "14",
    aweme_share_count: "1",
    aweme_play_count: "22503",
    aweme_activation: "0.1333",
    live_count: "2",
    live_time: "125",
    live_watch_count: 33,
    live_watch_time: 37,
    live_like_count: "97",
    live_comment_count: 0,
    live_activation: "0.1",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "深圳锦红红旗",
    company_name: "深圳锦红汽车销售服务有限公司",
    store_code: "SGD621",
    大区: "华南区",
    "省份-城市": "广东省-深圳市",
    "所选分组编号/分组名称": "-",
    fans_count: "-42",
    fans_count_total: "11600",
    aweme_count: "1",
    aweme_like_count: "39",
    aweme_comment_count: "3",
    aweme_share_count: 0,
    aweme_play_count: "8545",
    aweme_activation: "0.0667",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "莆田星奥",
    company_name: "莆田星奥汽车销售服务有限公司",
    store_code: "SFJ609",
    大区: "华南区",
    "省份-城市": "福建省-莆田市",
    "所选分组编号/分组名称": "-",
    fans_count: "35",
    fans_count_total: "339",
    aweme_count: "21",
    aweme_like_count: "99",
    aweme_comment_count: "21",
    aweme_share_count: "1",
    aweme_play_count: "30337",
    aweme_activation: "0.6667",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "枣庄旗尚",
    company_name: "枣庄旗尚汽车销售服务有限公司",
    store_code: "NSD621",
    大区: "东北区",
    "省份-城市": "山东省-枣庄市",
    "所选分组编号/分组名称": "-",
    fans_count: "-22",
    fans_count_total: "7989",
    aweme_count: "30",
    aweme_like_count: "100",
    aweme_comment_count: "29",
    aweme_share_count: "29",
    aweme_play_count: "45757",
    aweme_activation: "0.5",
    live_count: "17",
    live_time: "1130",
    live_watch_count: 584,
    live_watch_time: 643,
    live_like_count: "1344",
    live_comment_count: "2162",
    live_activation: "0.5",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "石家庄中冀华晟红旗",
    company_name: "河北华晟汽车服务有限公司",
    store_code: "NJI609",
    大区: "华北区",
    "省份-城市": "河北省-石家庄市",
    "所选分组编号/分组名称": "-",
    fans_count: "167",
    fans_count_total: "9110",
    aweme_count: "18",
    aweme_like_count: "61",
    aweme_comment_count: "17",
    aweme_share_count: "3",
    aweme_play_count: "7768",
    aweme_activation: "0.5",
    live_count: "35",
    live_time: "2156",
    live_watch_count: 31616,
    live_watch_time: 34778,
    live_like_count: "576",
    live_comment_count: "76",
    live_activation: "0.8333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "张家口龙瀚",
    company_name: "张家口龙瀚",
    store_code: "NJI610",
    大区: "华北区",
    "省份-城市": "河北省-张家口市",
    "所选分组编号/分组名称": "-",
    fans_count: "206",
    fans_count_total: "38953",
    aweme_count: "26",
    aweme_like_count: "108",
    aweme_comment_count: "16",
    aweme_share_count: "4",
    aweme_play_count: "18052",
    aweme_activation: "0.3667",
    live_count: "23",
    live_time: "1525",
    live_watch_count: 220998,
    live_watch_time: 243098,
    live_like_count: "10115",
    live_comment_count: "1004",
    live_activation: "0.6",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "榆林恒盛德岳",
    company_name: "榆林恒盛德岳",
    store_code: "XSS608",
    大区: "西部区",
    "省份-城市": "陕西省-榆林市",
    "所选分组编号/分组名称": "-",
    fans_count: "-217",
    fans_count_total: "280744",
    aweme_count: "113",
    aweme_like_count: "374",
    aweme_comment_count: "63",
    aweme_share_count: "39",
    aweme_play_count: "46606",
    aweme_activation: "0.9",
    live_count: "32",
    live_time: "2092",
    live_watch_count: 62165,
    live_watch_time: 68382,
    live_like_count: "59325",
    live_comment_count: "11414",
    live_activation: "0.8",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "大连汽贸集团华宇",
    company_name: "大连汽贸集团华宇汽车销售服务有限公司",
    store_code: "DLN605",
    大区: "东北区",
    "省份-城市": "辽宁省-大连市",
    "所选分组编号/分组名称": "-",
    fans_count: "-725",
    fans_count_total: "255747",
    aweme_count: "24",
    aweme_like_count: "-3872",
    aweme_comment_count: "24",
    aweme_share_count: "46",
    aweme_play_count: "50156",
    aweme_activation: "0.6",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "荆门英驰-红旗",
    company_name: "荆门英驰汽车销售有限公司",
    store_code: "CHB610",
    大区: "中南区",
    "省份-城市": "湖北省-荆门市",
    "所选分组编号/分组名称": "-",
    fans_count: "64",
    fans_count_total: "110",
    aweme_count: "26",
    aweme_like_count: "169",
    aweme_comment_count: "57",
    aweme_share_count: "1",
    aweme_play_count: "33065",
    aweme_activation: "0.6333",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "恩施英驰红旗",
    company_name: "恩施英驰汽车销售有限公司",
    store_code: "CHB614",
    大区: "中南区",
    "省份-城市": "湖北省-恩施土家族苗族自治州",
    "所选分组编号/分组名称": "-",
    fans_count: "11",
    fans_count_total: "80",
    aweme_count: "11",
    aweme_like_count: "60",
    aweme_comment_count: "13",
    aweme_share_count: 0,
    aweme_play_count: "17255",
    aweme_activation: "0.1333",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "成都岳宏泰红旗",
    company_name: "成都岳宏泰汽车销售服务有限公司",
    store_code: "WSC622",
    大区: "西部区",
    "省份-城市": "四川省-成都市",
    "所选分组编号/分组名称": "-",
    fans_count: "-54",
    fans_count_total: "55925",
    aweme_count: "73",
    aweme_like_count: "3305",
    aweme_comment_count: "48",
    aweme_share_count: "58",
    aweme_play_count: "37968472",
    aweme_activation: "1.0",
    live_count: "46",
    live_time: "2933",
    live_watch_count: 54830,
    live_watch_time: 60314,
    live_like_count: "59655",
    live_comment_count: "1638",
    live_activation: "0.8667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "武汉泰岳宏旗",
    company_name: "武汉泰岳宏旗",
    store_code: "CHB615",
    大区: "中南区",
    "省份-城市": "湖北省-武汉市",
    "所选分组编号/分组名称": "-",
    fans_count: "-33",
    fans_count_total: "11360",
    aweme_count: "29",
    aweme_like_count: "37",
    aweme_comment_count: "2",
    aweme_share_count: "13",
    aweme_play_count: "5416",
    aweme_activation: "0.6667",
    live_count: "35",
    live_time: "2208",
    live_watch_count: 822,
    live_watch_time: 905,
    live_like_count: "5",
    live_comment_count: "67",
    live_activation: "0.8",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "黄石新兴振宇红旗",
    company_name: "黄石市新兴振宇汽车销售有限公司",
    store_code: "CHB611",
    大区: "中南区",
    "省份-城市": "湖北省-黄石市",
    "所选分组编号/分组名称": "-",
    fans_count: 0,
    fans_count_total: "21",
    aweme_count: 0,
    aweme_like_count: "7",
    aweme_comment_count: 0,
    aweme_share_count: 0,
    aweme_play_count: "12",
    aweme_activation: "0.0333",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "舟山旗翔",
    company_name: "舟山旗翔汽车销售服务有限公司",
    store_code: "EZJ620",
    大区: "华东区",
    "省份-城市": "浙江省-舟山市",
    "所选分组编号/分组名称": "-",
    fans_count: "7",
    fans_count_total: "65",
    aweme_count: "2",
    aweme_like_count: "29",
    aweme_comment_count: "5",
    aweme_share_count: 0,
    aweme_play_count: "2771",
    aweme_activation: "0.0333",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "台州星旗",
    company_name: "台州星旗",
    store_code: "EZJ619",
    大区: "华东区",
    "省份-城市": "浙江省-台州市",
    "所选分组编号/分组名称": "-",
    fans_count: "875",
    fans_count_total: "37453",
    aweme_count: "44",
    aweme_like_count: "57",
    aweme_comment_count: "4",
    aweme_share_count: "47",
    aweme_play_count: "1212383",
    aweme_activation: "0.7667",
    live_count: "17",
    live_time: "1023",
    live_watch_count: 110351,
    live_watch_time: 121387,
    live_like_count: "2692",
    live_comment_count: "266",
    live_activation: "0.5",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "锦州新东方红旗",
    company_name: "锦州新东方汽车销售服务有限公司",
    store_code: "DLN607",
    大区: "东北区",
    "省份-城市": "辽宁省-锦州市",
    "所选分组编号/分组名称": "-",
    fans_count: "-150",
    fans_count_total: "40538",
    aweme_count: "48",
    aweme_like_count: "1164",
    aweme_comment_count: "1065",
    aweme_share_count: "38",
    aweme_play_count: "21401",
    aweme_activation: "0.9333",
    live_count: "19",
    live_time: "1180",
    live_watch_count: 2823,
    live_watch_time: 3106,
    live_like_count: "2710",
    live_comment_count: "81",
    live_activation: "0.7333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "佳木斯安盈",
    company_name: "佳木斯安盈汽车销售服务有限公司",
    store_code: "DHL605",
    大区: "东北区",
    "省份-城市": "黑龙江省-佳木斯市",
    "所选分组编号/分组名称": "-",
    fans_count: "-41",
    fans_count_total: "29516",
    aweme_count: "18",
    aweme_like_count: "90",
    aweme_comment_count: "8",
    aweme_share_count: "13",
    aweme_play_count: "17733",
    aweme_activation: "0.3",
    live_count: "22",
    live_time: "1365",
    live_watch_count: 3306,
    live_watch_time: 3637,
    live_like_count: "2368",
    live_comment_count: "52",
    live_activation: "0.6333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "辽宁大地",
    company_name: "辽宁大地汽车销售服务有限公司",
    store_code: "DLN606",
    大区: "东北区",
    "省份-城市": "辽宁省-葫芦岛市",
    "所选分组编号/分组名称": "-",
    fans_count: "-353",
    fans_count_total: "194790",
    aweme_count: "19",
    aweme_like_count: "466",
    aweme_comment_count: "117",
    aweme_share_count: "63",
    aweme_play_count: "37694",
    aweme_activation: "0.3667",
    live_count: "31",
    live_time: "2213",
    live_watch_count: 12667,
    live_watch_time: 13934,
    live_like_count: "89490",
    live_comment_count: "2421",
    live_activation: "0.9",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "松原征途中和",
    company_name: "松原市征途中和汽车销售服务有限公司",
    store_code: "DJL609",
    大区: "东北区",
    "省份-城市": "吉林省-松原市",
    "所选分组编号/分组名称": "-",
    fans_count: "855",
    fans_count_total: "13345",
    aweme_count: "117",
    aweme_like_count: "245",
    aweme_comment_count: "22",
    aweme_share_count: "13",
    aweme_play_count: "19316",
    aweme_activation: "1.0",
    live_count: "119",
    live_time: "7382",
    live_watch_count: 66432,
    live_watch_time: 73076,
    live_like_count: "256620",
    live_comment_count: "15487",
    live_activation: "0.9333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "内江利恒孚",
    company_name: "内江利恒孚车业有限公司",
    store_code: "WSC620",
    大区: "西部区",
    "省份-城市": "四川省-内江市",
    "所选分组编号/分组名称": "-",
    fans_count: "15",
    fans_count_total: "657",
    aweme_count: "15",
    aweme_like_count: "123",
    aweme_comment_count: "27",
    aweme_share_count: "28",
    aweme_play_count: "13967",
    aweme_activation: "0.5",
    live_count: "33",
    live_time: "2004",
    live_watch_count: 173,
    live_watch_time: 191,
    live_like_count: "278",
    live_comment_count: "2",
    live_activation: "0.6333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "沈阳神州川达",
    company_name: "沈阳神州川达汽车销售服务有限责任公司",
    store_code: "DLN608",
    大区: "东北区",
    "省份-城市": "辽宁省-沈阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "780",
    fans_count_total: "34844",
    aweme_count: "30",
    aweme_like_count: "129",
    aweme_comment_count: "21",
    aweme_share_count: "9",
    aweme_play_count: "16484",
    aweme_activation: "0.9",
    live_count: "25",
    live_time: "1556",
    live_watch_count: 115037,
    live_watch_time: 126541,
    live_like_count: "34375",
    live_comment_count: "394",
    live_activation: "0.7667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "永州达美",
    company_name: "永州达美汽车销售服务有限公司",
    store_code: "CHN615",
    大区: "中南区",
    "省份-城市": "湖南省-永州市",
    "所选分组编号/分组名称": "-",
    fans_count: "-10",
    fans_count_total: "202",
    aweme_count: "22",
    aweme_like_count: "110",
    aweme_comment_count: "23",
    aweme_share_count: 0,
    aweme_play_count: "56902",
    aweme_activation: "0.6667",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "保山上通",
    company_name: "保山市上通汽车销售服务有限公司",
    store_code: "WYN613",
    大区: "西部区",
    "省份-城市": "云南省-保山市",
    "所选分组编号/分组名称": "-",
    fans_count: 0,
    fans_count_total: "5",
    aweme_count: "1",
    aweme_like_count: "1",
    aweme_comment_count: 0,
    aweme_share_count: "1",
    aweme_play_count: "150",
    aweme_activation: "0.0667",
    live_count: "1",
    live_time: "61",
    live_watch_count: 27,
    live_watch_time: 30,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "广东腾辉鸿旗体验服务中心",
    company_name: "广东腾辉鸿旗汽车销售服务有限公司",
    store_code: "SGD629",
    大区: "华南区",
    "省份-城市": "广东省-梅州市",
    "所选分组编号/分组名称": "-",
    fans_count: "2415",
    fans_count_total: "33319",
    aweme_count: "34",
    aweme_like_count: "67",
    aweme_comment_count: "5",
    aweme_share_count: "2",
    aweme_play_count: "10048",
    aweme_activation: "0.3333",
    live_count: "27",
    live_time: "1711",
    live_watch_count: 256693,
    live_watch_time: 282363,
    live_like_count: "4590",
    live_comment_count: "364",
    live_activation: "0.6333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "池州鑫瑞",
    company_name: "池州鑫瑞汽车销售服务有限公司",
    store_code: "EAH616",
    大区: "华东区",
    "省份-城市": "安徽省-池州市",
    "所选分组编号/分组名称": "-",
    fans_count: "94",
    fans_count_total: "32142",
    aweme_count: "12",
    aweme_like_count: "64",
    aweme_comment_count: "8",
    aweme_share_count: "4",
    aweme_play_count: "3621",
    aweme_activation: "0.1",
    live_count: "45",
    live_time: "2701",
    live_watch_count: 106993,
    live_watch_time: 117693,
    live_like_count: "1696",
    live_comment_count: "845",
    live_activation: "0.8",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "新疆晨运",
    company_name: "新疆晨运汽车销售有限公司",
    store_code: "XXJ601",
    大区: "西部区",
    "省份-城市": "新疆维吾尔自治区-巴音郭楞蒙古自治州",
    "所选分组编号/分组名称": "-",
    fans_count: "6",
    fans_count_total: "141",
    aweme_count: "121",
    aweme_like_count: "26",
    aweme_comment_count: "7",
    aweme_share_count: "35",
    aweme_play_count: "2646",
    aweme_activation: "0.8667",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "阳泉鼎晟红旗",
    company_name: "阳泉市鼎晟汽车销售服务有限公司",
    store_code: "NJN609",
    大区: "华北区",
    "省份-城市": "山西省-阳泉市",
    "所选分组编号/分组名称": "-",
    fans_count: "8",
    fans_count_total: "10",
    aweme_count: "9",
    aweme_like_count: "49",
    aweme_comment_count: "7",
    aweme_share_count: 0,
    aweme_play_count: "12811",
    aweme_activation: "0.1",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "佛山飞扬红旗",
    company_name: "佛山飞扬红旗汽车销售服务有限公司",
    store_code: "SGD628",
    大区: "华南区",
    "省份-城市": "广东省-佛山市",
    "所选分组编号/分组名称": "-",
    fans_count: "15",
    fans_count_total: "6215",
    aweme_count: "17",
    aweme_like_count: "159",
    aweme_comment_count: "32",
    aweme_share_count: "1",
    aweme_play_count: "30414",
    aweme_activation: "0.3",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "钦州益辰",
    company_name: "钦州益辰汽车销售服务有限公司",
    store_code: "SGX605",
    大区: "华南区",
    "省份-城市": "广西壮族自治区-钦州市",
    "所选分组编号/分组名称": "-",
    fans_count: "-15",
    fans_count_total: "1145",
    aweme_count: "27",
    aweme_like_count: "114",
    aweme_comment_count: "22",
    aweme_share_count: 0,
    aweme_play_count: "29586",
    aweme_activation: "0.6333",
    live_count: "3",
    live_time: "282",
    live_watch_count: 52,
    live_watch_time: 58,
    live_like_count: "28",
    live_comment_count: "3",
    live_activation: "0.0333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "吉林神州红旗",
    company_name: "吉林市神州红旗汽车销售服务有限公司",
    store_code: "DJL611",
    大区: "东北区",
    "省份-城市": "吉林省-吉林市",
    "所选分组编号/分组名称": "-",
    fans_count: "13",
    fans_count_total: "1321",
    aweme_count: "31",
    aweme_like_count: "115",
    aweme_comment_count: "40",
    aweme_share_count: "31",
    aweme_play_count: "28923",
    aweme_activation: "0.9333",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "德宏海伟宏亦",
    company_name: "德宏海伟宏亦汽车销售有限公司",
    store_code: "WYN614",
    大区: "西部区",
    "省份-城市": "云南省-德宏傣族景颇族自治州",
    "所选分组编号/分组名称": "-",
    fans_count: "16",
    fans_count_total: "37",
    aweme_count: "2",
    aweme_like_count: "62",
    aweme_comment_count: "17",
    aweme_share_count: 0,
    aweme_play_count: "10778",
    aweme_activation: "0.1",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "伊犁冠邦",
    company_name: "伊犁冠邦汽车销售服务有限公司",
    store_code: "XXJ602",
    大区: "西部区",
    "省份-城市": "新疆维吾尔自治区-伊犁哈萨克自治州",
    "所选分组编号/分组名称": "-",
    fans_count: "17",
    fans_count_total: "201",
    aweme_count: "109",
    aweme_like_count: "34",
    aweme_comment_count: "37",
    aweme_share_count: "1",
    aweme_play_count: "7280",
    aweme_activation: "1.0",
    live_count: "47",
    live_time: "2810",
    live_watch_count: 691,
    live_watch_time: 761,
    live_like_count: "805",
    live_comment_count: "30",
    live_activation: "0.8333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "广西宝旗",
    company_name: "广西宝旗汽车销售服务有限责任公司",
    store_code: "SGX604",
    大区: "华南区",
    "省份-城市": "广西壮族自治区-柳州市",
    "所选分组编号/分组名称": "-",
    fans_count: "-96",
    fans_count_total: "26918",
    aweme_count: "34",
    aweme_like_count: "50",
    aweme_comment_count: "5",
    aweme_share_count: "37",
    aweme_play_count: "2479",
    aweme_activation: "0.7333",
    live_count: "40",
    live_time: "2626",
    live_watch_count: 1207,
    live_watch_time: 1328,
    live_like_count: "397",
    live_comment_count: "63",
    live_activation: "0.7333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "萍乡兰天嘉华红旗",
    company_name: "萍乡市兰天嘉华汽车销售服务有限公司",
    store_code: "CJX609",
    大区: "中南区",
    "省份-城市": "江西省-萍乡市",
    "所选分组编号/分组名称": "-",
    fans_count: "224",
    fans_count_total: "23850",
    aweme_count: "21",
    aweme_like_count: "251",
    aweme_comment_count: "25",
    aweme_share_count: "25",
    aweme_play_count: "37133",
    aweme_activation: "0.5667",
    live_count: "30",
    live_time: "1872",
    live_watch_count: 169281,
    live_watch_time: 186210,
    live_like_count: "3415",
    live_comment_count: "771",
    live_activation: "0.7",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "三明旗展",
    company_name: "三明旗展",
    store_code: "SFJ610",
    大区: "华南区",
    "省份-城市": "福建省-三明市",
    "所选分组编号/分组名称": "-",
    fans_count: "26",
    fans_count_total: "747",
    aweme_count: "50",
    aweme_like_count: "135",
    aweme_comment_count: "32",
    aweme_share_count: 0,
    aweme_play_count: "67442",
    aweme_activation: "0.3667",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "营口国之信红旗体验中心",
    company_name: "营口市国之信汽车销售服务有限公司",
    store_code: "DLN611",
    大区: "东北区",
    "省份-城市": "辽宁省-营口市",
    "所选分组编号/分组名称": "-",
    fans_count: "-255",
    fans_count_total: "103914",
    aweme_count: "42",
    aweme_like_count: "69",
    aweme_comment_count: "10",
    aweme_share_count: "41",
    aweme_play_count: "8719",
    aweme_activation: "0.8667",
    live_count: "12",
    live_time: "737",
    live_watch_count: 1443,
    live_watch_time: 1588,
    live_like_count: "1315",
    live_comment_count: "149",
    live_activation: "0.4",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "呼伦贝尔大鹏红旗",
    company_name: "呼伦贝尔市大鹏睿达汽车贸易有限公司",
    store_code: "DNM607",
    大区: "东北区",
    "省份-城市": "内蒙古自治区-呼伦贝尔市",
    "所选分组编号/分组名称": "-",
    fans_count: "43",
    fans_count_total: "499",
    aweme_count: "19",
    aweme_like_count: "167",
    aweme_comment_count: "24",
    aweme_share_count: 0,
    aweme_play_count: "49316",
    aweme_activation: "0.5333",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "无锡和旗",
    company_name: "无锡和旗汽车销售服务有限公司",
    store_code: "EJS621",
    大区: "华东区",
    "省份-城市": "江苏省-无锡市",
    "所选分组编号/分组名称": "-",
    fans_count: "17",
    fans_count_total: "1160",
    aweme_count: "26",
    aweme_like_count: "108",
    aweme_comment_count: "35",
    aweme_share_count: "1",
    aweme_play_count: "35748",
    aweme_activation: "0.6667",
    live_count: "18",
    live_time: "1092",
    live_watch_count: 155,
    live_watch_time: 171,
    live_like_count: "17257",
    live_comment_count: "63",
    live_activation: "0.6",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "黑龙江万家祥和",
    company_name: "黑龙江省万家祥和汽车销售服务有限公司",
    store_code: "DHL607",
    大区: "东北区",
    "省份-城市": "黑龙江省-哈尔滨市",
    "所选分组编号/分组名称": "-",
    fans_count: "1413",
    fans_count_total: "183625",
    aweme_count: "31",
    aweme_like_count: "2167",
    aweme_comment_count: "331",
    aweme_share_count: "247",
    aweme_play_count: "168439",
    aweme_activation: "0.6",
    live_count: "42",
    live_time: "3493",
    live_watch_count: 570190,
    live_watch_time: 627209,
    live_like_count: "128599",
    live_comment_count: "6641",
    live_activation: "0.7667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "百色健稳红旗体验中心",
    company_name: "百色健稳红旗体验中心",
    store_code: "SGX606",
    大区: "华南区",
    "省份-城市": "广西壮族自治区-百色市",
    "所选分组编号/分组名称": "-",
    fans_count: "16",
    fans_count_total: "248",
    aweme_count: "19",
    aweme_like_count: "332",
    aweme_comment_count: "36",
    aweme_share_count: "21",
    aweme_play_count: "1497",
    aweme_activation: "0.5333",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "山西吕梁大昌",
    company_name: "山西省吕梁市大昌汽车销售有限公司",
    store_code: "NJN611",
    大区: "华北区",
    "省份-城市": "山西省-吕梁市",
    "所选分组编号/分组名称": "-",
    fans_count: "1395",
    fans_count_total: "41107",
    aweme_count: "31",
    aweme_like_count: "2085",
    aweme_comment_count: "305",
    aweme_share_count: "359",
    aweme_play_count: "303497",
    aweme_activation: "0.7667",
    live_count: "65",
    live_time: "6612",
    live_watch_count: 143364,
    live_watch_time: 157701,
    live_like_count: "59914",
    live_comment_count: "5917",
    live_activation: "0.9333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "白山宝信",
    company_name: "白山市宝信汽车销售服务有限公司",
    store_code: "DJL612",
    大区: "东北区",
    "省份-城市": "吉林省-白山市",
    "所选分组编号/分组名称": "-",
    fans_count: "3",
    fans_count_total: "53",
    aweme_count: "1",
    aweme_like_count: "16",
    aweme_comment_count: "3",
    aweme_share_count: 0,
    aweme_play_count: "2014",
    aweme_activation: "0.0333",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "昌吉亚中机电红旗",
    company_name: "昌吉亚中机电有限公司",
    store_code: "XXJ603",
    大区: "西部区",
    "省份-城市": "新疆维吾尔自治区-昌吉回族自治州",
    "所选分组编号/分组名称": "-",
    fans_count: "19",
    fans_count_total: "342",
    aweme_count: "29",
    aweme_like_count: "123",
    aweme_comment_count: "32",
    aweme_share_count: "1",
    aweme_play_count: "22389",
    aweme_activation: "0.6",
    live_count: "24",
    live_time: "1525",
    live_watch_count: 728,
    live_watch_time: 801,
    live_like_count: "445",
    live_comment_count: "45",
    live_activation: "0.5333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "攀枝花驭马红旗",
    company_name: "攀枝花驭马车业有限公司",
    store_code: "WSC623",
    大区: "西部区",
    "省份-城市": "四川省-攀枝花市",
    "所选分组编号/分组名称": "-",
    fans_count: "-11",
    fans_count_total: "104",
    aweme_count: "21",
    aweme_like_count: "48",
    aweme_comment_count: "11",
    aweme_share_count: 0,
    aweme_play_count: "3123",
    aweme_activation: "0.7",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "庆阳金岛旗胜",
    company_name: "庆阳金岛旗胜汽车销售服务有限公司",
    store_code: "XGS601",
    大区: "西部区",
    "省份-城市": "甘肃省-庆阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "319",
    fans_count_total: "3463",
    aweme_count: "62",
    aweme_like_count: "274",
    aweme_comment_count: "27",
    aweme_share_count: "13",
    aweme_play_count: "58229",
    aweme_activation: "1.0",
    live_count: "63",
    live_time: "3994",
    live_watch_count: 129564,
    live_watch_time: 142521,
    live_like_count: "59321",
    live_comment_count: "1541",
    live_activation: "1.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "雅安国创红旗店",
    company_name: "雅安国创汽车销售服务有限公司",
    store_code: "WSC624",
    大区: "西部区",
    "省份-城市": "四川省-雅安市",
    "所选分组编号/分组名称": "-",
    fans_count: "1",
    fans_count_total: "580",
    aweme_count: "19",
    aweme_like_count: "139",
    aweme_comment_count: "43",
    aweme_share_count: "1",
    aweme_play_count: "66907",
    aweme_activation: "0.5",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "黄山旗胜红旗",
    company_name: "黄山旗胜汽车销售服务有限公司",
    store_code: "EAH617",
    大区: "华东区",
    "省份-城市": "安徽省-黄山市",
    "所选分组编号/分组名称": "-",
    fans_count: "-31",
    fans_count_total: "158977",
    aweme_count: "38",
    aweme_like_count: "3767",
    aweme_comment_count: "541",
    aweme_share_count: "442",
    aweme_play_count: "291969",
    aweme_activation: "0.6667",
    live_count: "36",
    live_time: "2245",
    live_watch_count: 90974,
    live_watch_time: 100072,
    live_like_count: "10879",
    live_comment_count: "2736",
    live_activation: "0.9",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "山西大昌宏顺",
    company_name: "山西大昌宏顺",
    store_code: "NJN612",
    大区: "华北区",
    "省份-城市": "山西省-晋中市",
    "所选分组编号/分组名称": "-",
    fans_count: "28",
    fans_count_total: "257",
    aweme_count: "24",
    aweme_like_count: "9",
    aweme_comment_count: "9",
    aweme_share_count: "5",
    aweme_play_count: "20737",
    aweme_activation: "0.4",
    live_count: "65",
    live_time: "7961",
    live_watch_count: 662,
    live_watch_time: 729,
    live_like_count: "221",
    live_comment_count: "4",
    live_activation: "0.6333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "芜湖红旗体验中心",
    company_name: "芜湖宏祺汽车销售服务有限公司",
    store_code: "EAH618",
    大区: "华东区",
    "省份-城市": "安徽省-芜湖市",
    "所选分组编号/分组名称": "-",
    fans_count: "1",
    fans_count_total: "52",
    aweme_count: "1",
    aweme_like_count: "10",
    aweme_comment_count: 0,
    aweme_share_count: 0,
    aweme_play_count: "1043",
    aweme_activation: "0.0667",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "龙泽红旗",
    company_name: "北京龙泽红旗汽车销售有限公司",
    store_code: "NBJ127",
    大区: "华北区",
    "省份-城市": "北京市-北京市",
    "所选分组编号/分组名称": "-",
    fans_count: "-5",
    fans_count_total: "6",
    aweme_count: "1",
    aweme_like_count: "3",
    aweme_comment_count: "1",
    aweme_share_count: 0,
    aweme_play_count: "523",
    aweme_activation: "0.0333",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "成都三和银杏",
    company_name: "成都三和银杏汽车贸易有限公司",
    store_code: "WSC626",
    大区: "西部区",
    "省份-城市": "四川省-成都市",
    "所选分组编号/分组名称": "-",
    fans_count: "787",
    fans_count_total: "143294",
    aweme_count: "34",
    aweme_like_count: "3066",
    aweme_comment_count: "508",
    aweme_share_count: "465",
    aweme_play_count: "231582",
    aweme_activation: "0.4333",
    live_count: "73",
    live_time: "4400",
    live_watch_count: 461242,
    live_watch_time: 507367,
    live_like_count: "212099",
    live_comment_count: "5550",
    live_activation: "0.9667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "杭州杭旗",
    company_name: "杭州杭旗汽车有限公司",
    store_code: "EZJ608",
    大区: "华东区",
    "省份-城市": "浙江省-杭州市",
    "所选分组编号/分组名称": "-",
    fans_count: "-4",
    fans_count_total: "1098",
    aweme_count: "1",
    aweme_like_count: "9",
    aweme_comment_count: "2",
    aweme_share_count: 0,
    aweme_play_count: "1587",
    aweme_activation: "0.0333",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "贵州毕节丽安",
    company_name: "贵州毕节丽安汽车销售服务有限公司",
    store_code: "WGZ608",
    大区: "西部区",
    "省份-城市": "贵州省-毕节市",
    "所选分组编号/分组名称": "-",
    fans_count: "-81",
    fans_count_total: "27364",
    aweme_count: "7",
    aweme_like_count: "67",
    aweme_comment_count: "12",
    aweme_share_count: "2",
    aweme_play_count: "8945",
    aweme_activation: "0.1667",
    live_count: "26",
    live_time: "1612",
    live_watch_count: 458,
    live_watch_time: 504,
    live_like_count: "311",
    live_comment_count: "9",
    live_activation: "0.8333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "罗村骏耀",
    company_name: "佛山市南海区罗村骏耀汽车销售服务有限公司",
    store_code: "SGD630",
    大区: "华南区",
    "省份-城市": "广东省-佛山市",
    "所选分组编号/分组名称": "-",
    fans_count: "9",
    fans_count_total: "46",
    aweme_count: 0,
    aweme_like_count: "9",
    aweme_comment_count: "1",
    aweme_share_count: 0,
    aweme_play_count: "962",
    aweme_activation: "0.0333",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "苏州和旗",
    company_name: "苏州和旗汽车销售服务有限公司",
    store_code: "EJS620",
    大区: "华东区",
    "省份-城市": "江苏省-苏州市",
    "所选分组编号/分组名称": "-",
    fans_count: "25",
    fans_count_total: "250",
    aweme_count: "23",
    aweme_like_count: "92",
    aweme_comment_count: "25",
    aweme_share_count: 0,
    aweme_play_count: "23557",
    aweme_activation: "0.7",
    live_count: "2",
    live_time: "126",
    live_watch_count: 36,
    live_watch_time: 40,
    live_like_count: "248",
    live_comment_count: "8",
    live_activation: "0.0667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "桐乡裕旗",
    company_name: "桐乡裕旗汽车有限公司",
    store_code: "EZJ621",
    大区: "华东区",
    "省份-城市": "浙江省-嘉兴市",
    "所选分组编号/分组名称": "-",
    fans_count: "-33",
    fans_count_total: "3986",
    aweme_count: "36",
    aweme_like_count: "58",
    aweme_comment_count: "20",
    aweme_share_count: 0,
    aweme_play_count: "10639",
    aweme_activation: "0.9667",
    live_count: "25",
    live_time: "1528",
    live_watch_count: 4604,
    live_watch_time: 5065,
    live_like_count: "136",
    live_comment_count: "21",
    live_activation: "0.4333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "上饶君悦宏旗红旗体验中心",
    company_name: "上饶君悦宏旗红旗体验中心",
    store_code: "CJX607",
    大区: "中南区",
    "省份-城市": "江西省-上饶市",
    "所选分组编号/分组名称": "-",
    fans_count: "23",
    fans_count_total: "141",
    aweme_count: "29",
    aweme_like_count: "113",
    aweme_comment_count: "19",
    aweme_share_count: "7",
    aweme_play_count: "32898",
    aweme_activation: "0.5333",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "张家界旗胜",
    company_name: "张家界旗胜",
    store_code: "CHN617",
    大区: "中南区",
    "省份-城市": "湖南省-张家界市",
    "所选分组编号/分组名称": "-",
    fans_count: "2",
    fans_count_total: "355",
    aweme_count: "23",
    aweme_like_count: "116",
    aweme_comment_count: "25",
    aweme_share_count: 0,
    aweme_play_count: "25976",
    aweme_activation: "0.6333",
    live_count: "11",
    live_time: "692",
    live_watch_count: 89,
    live_watch_time: 98,
    live_like_count: "473",
    live_comment_count: "2",
    live_activation: "0.2667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "延安泽之泰",
    company_name: "延安泽之泰汽贸有限责任公司",
    store_code: "XSS609",
    大区: "西部区",
    "省份-城市": "陕西省-延安市",
    "所选分组编号/分组名称": "-",
    fans_count: "1271",
    fans_count_total: "14308",
    aweme_count: "38",
    aweme_like_count: "139",
    aweme_comment_count: "27",
    aweme_share_count: "38",
    aweme_play_count: "12921",
    aweme_activation: "0.7",
    live_count: "44",
    live_time: "2710",
    live_watch_count: 194730,
    live_watch_time: 214203,
    live_like_count: "12594",
    live_comment_count: "1826",
    live_activation: "0.8333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "张掖金岛旗瑞",
    company_name: "张掖金岛旗瑞",
    store_code: "XGS602",
    大区: "西部区",
    "省份-城市": "甘肃省-张掖市",
    "所选分组编号/分组名称": "-",
    fans_count: "-56",
    fans_count_total: "26316",
    aweme_count: "24",
    aweme_like_count: "326",
    aweme_comment_count: "49",
    aweme_share_count: "39",
    aweme_play_count: "16523",
    aweme_activation: "0.6667",
    live_count: "29",
    live_time: "1933",
    live_watch_count: 4981,
    live_watch_time: 5480,
    live_like_count: "999",
    live_comment_count: "276",
    live_activation: "0.7333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "贵港广利",
    company_name: "贵港广利汽车销售服务有限公司",
    store_code: "SGX608",
    大区: "华南区",
    "省份-城市": "广西壮族自治区-贵港市",
    "所选分组编号/分组名称": "-",
    fans_count: "10",
    fans_count_total: "37",
    aweme_count: "2",
    aweme_like_count: "32",
    aweme_comment_count: "8",
    aweme_share_count: 0,
    aweme_play_count: "9965",
    aweme_activation: "0.1",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "广物鸿福",
    company_name: "广东广物鸿福汽车销售服务有限公司汕尾分公司",
    store_code: "SGD632",
    大区: "华南区",
    "省份-城市": "广东省-汕尾市",
    "所选分组编号/分组名称": "-",
    fans_count: 0,
    fans_count_total: "2",
    aweme_count: 0,
    aweme_like_count: 0,
    aweme_comment_count: 0,
    aweme_share_count: 0,
    aweme_play_count: 0,
    aweme_activation: "0.0",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "武汉大雍冉欣",
    company_name: "武汉大雍冉欣汽车销售服务有限公司",
    store_code: "CHB616",
    大区: "中南区",
    "省份-城市": "湖北省-武汉市",
    "所选分组编号/分组名称": "-",
    fans_count: "24",
    fans_count_total: "747",
    aweme_count: "10",
    aweme_like_count: "82",
    aweme_comment_count: "16",
    aweme_share_count: "1",
    aweme_play_count: "39598",
    aweme_activation: "0.1333",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "酒泉金岛旗信",
    company_name: "酒泉金岛旗信",
    store_code: "XGS603",
    大区: "西部区",
    "省份-城市": "甘肃省-酒泉市",
    "所选分组编号/分组名称": "-",
    fans_count: "27",
    fans_count_total: "4953",
    aweme_count: "61",
    aweme_like_count: "145",
    aweme_comment_count: "19",
    aweme_share_count: "1",
    aweme_play_count: "34925",
    aweme_activation: "0.5667",
    live_count: "27",
    live_time: "1770",
    live_watch_count: 11304,
    live_watch_time: 12435,
    live_like_count: "17832",
    live_comment_count: "361",
    live_activation: "0.7667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "青海嘉佑晟",
    company_name: "青海嘉佑晟汽车销售服务有限公司",
    store_code: "XQH601",
    大区: "西部区",
    "省份-城市": "青海省-海东市",
    "所选分组编号/分组名称": "-",
    fans_count: "129",
    fans_count_total: "18090",
    aweme_count: "56",
    aweme_like_count: "2885",
    aweme_comment_count: "255",
    aweme_share_count: "228",
    aweme_play_count: "133823",
    aweme_activation: "0.8667",
    live_count: "43",
    live_time: "3823",
    live_watch_count: 5612,
    live_watch_time: 6174,
    live_like_count: "19081",
    live_comment_count: "533",
    live_activation: "0.8667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "福州榕泰鸿旗",
    company_name: "福州榕泰鸿旗汽车销售有限公司",
    store_code: "SFJ612",
    大区: "华南区",
    "省份-城市": "福建省-福州市",
    "所选分组编号/分组名称": "-",
    fans_count: "-3",
    fans_count_total: "951",
    aweme_count: "1",
    aweme_like_count: 0,
    aweme_comment_count: 0,
    aweme_share_count: 0,
    aweme_play_count: "170",
    aweme_activation: "0.0333",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "长春盛世九州",
    company_name: "长春盛世九州红旗汽车销售服务有限公司",
    store_code: "DJL613",
    大区: "东北区",
    "省份-城市": "吉林省-长春市",
    "所选分组编号/分组名称": "-",
    fans_count: "819",
    fans_count_total: "8347",
    aweme_count: "71",
    aweme_like_count: "363",
    aweme_comment_count: "89",
    aweme_share_count: "19",
    aweme_play_count: "46473",
    aweme_activation: "0.8667",
    live_count: "44",
    live_time: "2821",
    live_watch_count: 86235,
    live_watch_time: 94859,
    live_like_count: "113467",
    live_comment_count: "22055",
    live_activation: "0.9333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "昆明海伟峻辉红旗体验中心",
    company_name: "昆明海伟峻辉汽车销售有限公司",
    store_code: "WYN615",
    大区: "西部区",
    "省份-城市": "云南省-昆明市",
    "所选分组编号/分组名称": "-",
    fans_count: "110",
    fans_count_total: "680",
    aweme_count: "18",
    aweme_like_count: "635",
    aweme_comment_count: "223",
    aweme_share_count: "30",
    aweme_play_count: "118457",
    aweme_activation: "0.2333",
    live_count: "15",
    live_time: "929",
    live_watch_count: 638,
    live_watch_time: 702,
    live_like_count: "19596",
    live_comment_count: "129",
    live_activation: "0.4667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "常州外汽国豪",
    company_name: "常州外汽国豪汽车销售服务有限公司",
    store_code: "EJS624",
    大区: "华东区",
    "省份-城市": "江苏省-常州市",
    "所选分组编号/分组名称": "-",
    fans_count: "-3",
    fans_count_total: "1726",
    aweme_count: "32",
    aweme_like_count: "69",
    aweme_comment_count: "31",
    aweme_share_count: "9",
    aweme_play_count: "8043",
    aweme_activation: "0.4333",
    live_count: "37",
    live_time: "2439",
    live_watch_count: 1093,
    live_watch_time: 1203,
    live_like_count: "976",
    live_comment_count: "21",
    live_activation: "0.8",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "烟台奥吉通宏源",
    company_name: "烟台奥吉通宏源汽车销售有限公司",
    store_code: "NSD623",
    大区: "东北区",
    "省份-城市": "山东省-烟台市",
    "所选分组编号/分组名称": "-",
    fans_count: "17",
    fans_count_total: "141",
    aweme_count: "44",
    aweme_like_count: "82",
    aweme_comment_count: "16",
    aweme_share_count: "19",
    aweme_play_count: "10289",
    aweme_activation: "0.7",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "苏州益谦红旗体验中心",
    company_name: "苏州益谦汽车销售服务有限公司",
    store_code: "EJS622",
    大区: "华东区",
    "省份-城市": "江苏省-苏州市",
    "所选分组编号/分组名称": "-",
    fans_count: "-22",
    fans_count_total: "468",
    aweme_count: "23",
    aweme_like_count: "202",
    aweme_comment_count: "32",
    aweme_share_count: 0,
    aweme_play_count: "53753",
    aweme_activation: "0.4667",
    live_count: "8",
    live_time: "458",
    live_watch_count: 152,
    live_watch_time: 168,
    live_like_count: "4",
    live_comment_count: "8",
    live_activation: "0.3",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "惠州大雍峻安",
    company_name: "惠州市大雍峻安汽车销售服务有限责任公司",
    store_code: "SGD639",
    大区: "华南区",
    "省份-城市": "广东省-惠州市",
    "所选分组编号/分组名称": "-",
    fans_count: "2",
    fans_count_total: "499",
    aweme_count: 0,
    aweme_like_count: 0,
    aweme_comment_count: 0,
    aweme_share_count: 0,
    aweme_play_count: 0,
    aweme_activation: "0.0",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "中山宝旗红旗体验中心",
    company_name: "中山市宝旗汽车销售服务有限公司",
    store_code: "SGD636",
    大区: "华南区",
    "省份-城市": "广东省-中山市",
    "所选分组编号/分组名称": "-",
    fans_count: "1",
    fans_count_total: "1541",
    aweme_count: "39",
    aweme_like_count: "62",
    aweme_comment_count: "3",
    aweme_share_count: "2",
    aweme_play_count: "2028",
    aweme_activation: "0.8",
    live_count: "7",
    live_time: "448",
    live_watch_count: 30,
    live_watch_time: 33,
    live_like_count: "1",
    live_comment_count: "1",
    live_activation: "0.2667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "朔州领航红旗",
    company_name: "朔州领航红旗汽车销售服务有限公司",
    store_code: "NJN613",
    大区: "华北区",
    "省份-城市": "山西省-朔州市",
    "所选分组编号/分组名称": "-",
    fans_count: "30",
    fans_count_total: "1204",
    aweme_count: "27",
    aweme_like_count: "185",
    aweme_comment_count: "35",
    aweme_share_count: "6",
    aweme_play_count: "49020",
    aweme_activation: "0.8667",
    live_count: "29",
    live_time: "1769",
    live_watch_count: 3160,
    live_watch_time: 3477,
    live_like_count: "24979",
    live_comment_count: "317",
    live_activation: "0.8667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "南昌恒信旗胜",
    company_name: "南昌恒信旗胜汽车销售服务有限公司",
    store_code: "CJX611",
    大区: "中南区",
    "省份-城市": "江西省-南昌市",
    "所选分组编号/分组名称": "-",
    fans_count: "52",
    fans_count_total: "88",
    aweme_count: "45",
    aweme_like_count: "137",
    aweme_comment_count: "34",
    aweme_share_count: "2",
    aweme_play_count: "14628",
    aweme_activation: "0.6",
    live_count: "24",
    live_time: "1470",
    live_watch_count: 467,
    live_watch_time: 514,
    live_like_count: "591",
    live_comment_count: "5",
    live_activation: "0.7667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "绍兴广成柯旗",
    company_name: "绍兴广成柯旗汽车有限公司",
    store_code: "EZJ625",
    大区: "华东区",
    "省份-城市": "浙江省-绍兴市",
    "所选分组编号/分组名称": "-",
    fans_count: "-18",
    fans_count_total: "1770",
    aweme_count: "93",
    aweme_like_count: "60",
    aweme_comment_count: "15",
    aweme_share_count: "3",
    aweme_play_count: "5043",
    aweme_activation: "1.0",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "北京鑫达润通",
    company_name: "北京鑫达润通汽车有限公司",
    store_code: "NBJ609",
    大区: "华北区",
    "省份-城市": "北京市-北京市",
    "所选分组编号/分组名称": "-",
    fans_count: "1",
    fans_count_total: "39",
    aweme_count: "5",
    aweme_like_count: 0,
    aweme_comment_count: 0,
    aweme_share_count: 0,
    aweme_play_count: "563",
    aweme_activation: "0.1",
    live_count: "1",
    live_time: "83",
    live_watch_count: 7,
    live_watch_time: 8,
    live_like_count: "474",
    live_comment_count: 0,
    live_activation: "0.0667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "北京奥吉通旗盛",
    company_name: "北京奥吉通旗盛汽车销售服务有限公司",
    store_code: "NBJ608",
    大区: "华北区",
    "省份-城市": "北京市-北京市",
    "所选分组编号/分组名称": "-",
    fans_count: "1",
    fans_count_total: "168",
    aweme_count: "6",
    aweme_like_count: "58",
    aweme_comment_count: "12",
    aweme_share_count: 0,
    aweme_play_count: "22600",
    aweme_activation: "0.1667",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "东莞神州腾达",
    company_name: "东莞神州腾达",
    store_code: "SGD637",
    大区: "华南区",
    "省份-城市": "广东省-东莞市",
    "所选分组编号/分组名称": "-",
    fans_count: "-1",
    fans_count_total: "1486",
    aweme_count: "5",
    aweme_like_count: "60",
    aweme_comment_count: "3",
    aweme_share_count: 0,
    aweme_play_count: "12179",
    aweme_activation: "0.1",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "盘锦富田",
    company_name: "盘锦富田实业有限公司",
    store_code: "DLN613",
    大区: "东北区",
    "省份-城市": "辽宁省-盘锦市",
    "所选分组编号/分组名称": "-",
    fans_count: "1",
    fans_count_total: "80",
    aweme_count: 0,
    aweme_like_count: 0,
    aweme_comment_count: 0,
    aweme_share_count: 0,
    aweme_play_count: 0,
    aweme_activation: "0.0",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "陕西泰岳",
    company_name: "陕西泰岳汽车销售服务有限公司",
    store_code: "XSS611",
    大区: "西部区",
    "省份-城市": "陕西省-西安市",
    "所选分组编号/分组名称": "-",
    fans_count: "1899",
    fans_count_total: "67410",
    aweme_count: "93",
    aweme_like_count: "1012",
    aweme_comment_count: "22",
    aweme_share_count: "153",
    aweme_play_count: "2466461",
    aweme_activation: "1.0",
    live_count: "55",
    live_time: "3738",
    live_watch_count: 486889,
    live_watch_time: 535578,
    live_like_count: "9959",
    live_comment_count: "691",
    live_activation: "0.9",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "合肥盈旗",
    company_name: "合肥盈旗汽车销售有限公司",
    store_code: "EAH619",
    大区: "华东区",
    "省份-城市": "安徽省-合肥市",
    "所选分组编号/分组名称": "-",
    fans_count: "-17",
    fans_count_total: "399",
    aweme_count: "50",
    aweme_like_count: "106",
    aweme_comment_count: "27",
    aweme_share_count: "38",
    aweme_play_count: "9022942",
    aweme_activation: "0.8",
    live_count: "39",
    live_time: "2667",
    live_watch_count: 656,
    live_watch_time: 722,
    live_like_count: "381",
    live_comment_count: "8",
    live_activation: "0.9",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "安康硕德",
    company_name: "安康硕德汽车销售服务有限公司",
    store_code: "XSS612",
    大区: "西部区",
    "省份-城市": "陕西省-安康市",
    "所选分组编号/分组名称": "-",
    fans_count: "9",
    fans_count_total: "125",
    aweme_count: "31",
    aweme_like_count: "141",
    aweme_comment_count: "33",
    aweme_share_count: 0,
    aweme_play_count: "15824",
    aweme_activation: "0.8667",
    live_count: "29",
    live_time: "1941",
    live_watch_count: 120,
    live_watch_time: 133,
    live_like_count: "4910",
    live_comment_count: "5",
    live_activation: "0.4667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "海宁广成海旗",
    company_name: "海宁广成海旗汽车有限公司",
    store_code: "EZJ626",
    大区: "华东区",
    "省份-城市": "浙江省-嘉兴市",
    "所选分组编号/分组名称": "-",
    fans_count: "6",
    fans_count_total: "198",
    aweme_count: "16",
    aweme_like_count: "105",
    aweme_comment_count: "25",
    aweme_share_count: "1",
    aweme_play_count: "33431",
    aweme_activation: "0.5",
    live_count: "42",
    live_time: "2674",
    live_watch_count: 478,
    live_watch_time: 526,
    live_like_count: "40",
    live_comment_count: "6",
    live_activation: "0.6667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "泉州旗达",
    company_name: "泉州旗达汽车销售服务有限公司",
    store_code: "SFJ615",
    大区: "华南区",
    "省份-城市": "福建省-泉州市",
    "所选分组编号/分组名称": "-",
    fans_count: "-28",
    fans_count_total: "9074",
    aweme_count: "24",
    aweme_like_count: "89",
    aweme_comment_count: "25",
    aweme_share_count: "2",
    aweme_play_count: "15359",
    aweme_activation: "0.7333",
    live_count: "1",
    live_time: "61",
    live_watch_count: 8,
    live_watch_time: 9,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "潮州晟汇",
    company_name: "潮州市晟汇汽车销售有限公司",
    store_code: "SGD635",
    大区: "华南区",
    "省份-城市": "广东省-潮州市",
    "所选分组编号/分组名称": "-",
    fans_count: "2",
    fans_count_total: "800",
    aweme_count: "31",
    aweme_like_count: "136",
    aweme_comment_count: "32",
    aweme_share_count: 0,
    aweme_play_count: "8644",
    aweme_activation: "1.0",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "台州欧龙",
    company_name: "台州欧龙汽车销售服务有限公司",
    store_code: "EZJ627",
    大区: "华东区",
    "省份-城市": "浙江省-台州市",
    "所选分组编号/分组名称": "-",
    fans_count: "2",
    fans_count_total: "1367",
    aweme_count: "2",
    aweme_like_count: "19",
    aweme_comment_count: "3",
    aweme_share_count: 0,
    aweme_play_count: "2209",
    aweme_activation: "0.0333",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "贺州中裕红祺",
    company_name: "贺州中裕红祺汽车销售服务有限公司",
    store_code: "SGX612",
    大区: "华南区",
    "省份-城市": "广西壮族自治区-贺州市",
    "所选分组编号/分组名称": "-",
    fans_count: "4",
    fans_count_total: "242",
    aweme_count: "35",
    aweme_like_count: "97",
    aweme_comment_count: "27",
    aweme_share_count: "1",
    aweme_play_count: "13229",
    aweme_activation: "0.9667",
    live_count: "26",
    live_time: "1604",
    live_watch_count: 475,
    live_watch_time: 523,
    live_like_count: "23098",
    live_comment_count: "9",
    live_activation: "0.7",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "北京鸿旗福瑞",
    company_name: "北京鸿旗福瑞汽车销售服务有限公司",
    store_code: "NBJ606",
    大区: "华北区",
    "省份-城市": "北京市-北京市",
    "所选分组编号/分组名称": "-",
    fans_count: "304",
    fans_count_total: "16279",
    aweme_count: "41",
    aweme_like_count: "120",
    aweme_comment_count: "13",
    aweme_share_count: "22",
    aweme_play_count: "6563",
    aweme_activation: "0.7667",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "辽源歌蓝",
    company_name: "辽源歌蓝汽车销售服务有限公司",
    store_code: "DJL614",
    大区: "东北区",
    "省份-城市": "吉林省-辽源市",
    "所选分组编号/分组名称": "-",
    fans_count: "861",
    fans_count_total: "3057",
    aweme_count: "39",
    aweme_like_count: "333",
    aweme_comment_count: "27",
    aweme_share_count: "9",
    aweme_play_count: "76442",
    aweme_activation: "0.6",
    live_count: "66",
    live_time: "4134",
    live_watch_count: 95787,
    live_watch_time: 105366,
    live_like_count: "45295",
    live_comment_count: "651",
    live_activation: "0.9",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "保定华臻",
    company_name: "保定市华臻汽车服务有限公司",
    store_code: "NJI611",
    大区: "华北区",
    "省份-城市": "河北省-保定市",
    "所选分组编号/分组名称": "-",
    fans_count: "1604",
    fans_count_total: "38323",
    aweme_count: "46",
    aweme_like_count: "1032",
    aweme_comment_count: "105",
    aweme_share_count: "77",
    aweme_play_count: "151682",
    aweme_activation: "0.6333",
    live_count: "41",
    live_time: "2495",
    live_watch_count: 382254,
    live_watch_time: 420480,
    live_like_count: "185133",
    live_comment_count: "33200",
    live_activation: "0.9",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "长沙旗颂",
    company_name: "长沙旗颂汽车销售有限公司",
    store_code: "CHN618",
    大区: "中南区",
    "省份-城市": "湖南省-长沙市",
    "所选分组编号/分组名称": "-",
    fans_count: "1637",
    fans_count_total: "128633",
    aweme_count: "21",
    aweme_like_count: "5002",
    aweme_comment_count: "568",
    aweme_share_count: "435",
    aweme_play_count: "276812",
    aweme_activation: "0.6333",
    live_count: "19",
    live_time: "1233",
    live_watch_count: 103721,
    live_watch_time: 114094,
    live_like_count: "46067",
    live_comment_count: "9689",
    live_activation: "0.7667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "东莞神州弘达",
    company_name: "东莞神州弘达",
    store_code: "SGD633",
    大区: "华南区",
    "省份-城市": "广东省-东莞市",
    "所选分组编号/分组名称": "-",
    fans_count: "-8",
    fans_count_total: "2482",
    aweme_count: "17",
    aweme_like_count: "11",
    aweme_comment_count: 0,
    aweme_share_count: 0,
    aweme_play_count: "7178",
    aweme_activation: "0.1667",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "河北龙泽",
    company_name: "河北龙泽红旗汽车销售服务有限公司",
    store_code: "NJI612",
    大区: "华北区",
    "省份-城市": "河北省-廊坊市",
    "所选分组编号/分组名称": "-",
    fans_count: "5",
    fans_count_total: "7",
    aweme_count: "2",
    aweme_like_count: "20",
    aweme_comment_count: "2",
    aweme_share_count: 0,
    aweme_play_count: "2447",
    aweme_activation: "0.0667",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "北海鸿福鸿福分公司",
    company_name: "北海广物汽车销售服务有限公司鸿福分公司",
    store_code: "SGX609",
    大区: "华南区",
    "省份-城市": "广西壮族自治区-北海市",
    "所选分组编号/分组名称": "-",
    fans_count: "-3",
    fans_count_total: "21",
    aweme_count: "12",
    aweme_like_count: "1",
    aweme_comment_count: 0,
    aweme_share_count: "11",
    aweme_play_count: "506",
    aweme_activation: "0.4",
    live_count: "1",
    live_time: "65",
    live_watch_count: 6,
    live_watch_time: 7,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "丹东鸿祺",
    company_name: "丹东鸿祺",
    store_code: "DLN614",
    大区: "东北区",
    "省份-城市": "辽宁省-丹东市",
    "所选分组编号/分组名称": "-",
    fans_count: "36",
    fans_count_total: "144",
    aweme_count: "11",
    aweme_like_count: "150",
    aweme_comment_count: "22",
    aweme_share_count: "1",
    aweme_play_count: "35451",
    aweme_activation: "0.3667",
    live_count: "17",
    live_time: "1056",
    live_watch_count: 160,
    live_watch_time: 176,
    live_like_count: "1359",
    live_comment_count: "37",
    live_activation: "0.5",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "玉林同人",
    company_name: "玉林同人汽车销售服务有限公司",
    store_code: "SGX610",
    大区: "华南区",
    "省份-城市": "广西壮族自治区-玉林市",
    "所选分组编号/分组名称": "-",
    fans_count: "5",
    fans_count_total: "210",
    aweme_count: "42",
    aweme_like_count: "22",
    aweme_comment_count: "4",
    aweme_share_count: "24",
    aweme_play_count: "5149",
    aweme_activation: "0.7667",
    live_count: "26",
    live_time: "1558",
    live_watch_count: 277,
    live_watch_time: 305,
    live_like_count: "341",
    live_comment_count: "21",
    live_activation: "0.6",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "海南博通",
    company_name: "海南博通",
    store_code: "SHN601",
    大区: "华南区",
    "省份-城市": "海南省-海口市",
    "所选分组编号/分组名称": "-",
    fans_count: "-1",
    fans_count_total: "149",
    aweme_count: "19",
    aweme_like_count: "114",
    aweme_comment_count: "22",
    aweme_share_count: 0,
    aweme_play_count: "32046",
    aweme_activation: "0.4333",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "铜陵鑫福瑞",
    company_name: "铜陵鑫福瑞汽车销售服务有限公司",
    store_code: "EAH620",
    大区: "华东区",
    "省份-城市": "安徽省-铜陵市",
    "所选分组编号/分组名称": "-",
    fans_count: "-423",
    fans_count_total: "34337",
    aweme_count: "27",
    aweme_like_count: "27",
    aweme_comment_count: "8",
    aweme_share_count: "27",
    aweme_play_count: "3566",
    aweme_activation: "0.6333",
    live_count: "1",
    live_time: "65",
    live_watch_count: 1038,
    live_watch_time: 1142,
    live_like_count: "174",
    live_comment_count: "47",
    live_activation: "0.1",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "南宁达美",
    company_name: "南宁达美汽车销售服务有限公司",
    store_code: "SGX613",
    大区: "华南区",
    "省份-城市": "广西壮族自治区-南宁市",
    "所选分组编号/分组名称": "-",
    fans_count: "14",
    fans_count_total: "408",
    aweme_count: "26",
    aweme_like_count: "74",
    aweme_comment_count: "16",
    aweme_share_count: "1",
    aweme_play_count: "8511",
    aweme_activation: "0.8333",
    live_count: "1",
    live_time: "60",
    live_watch_count: 25,
    live_watch_time: 28,
    live_like_count: 0,
    live_comment_count: "1",
    live_activation: "0.0667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "深圳鸿钧",
    company_name: "深圳鸿钧",
    store_code: "SGD651",
    大区: "华南区",
    "省份-城市": "广东省-深圳市",
    "所选分组编号/分组名称": "-",
    fans_count: "4",
    fans_count_total: "59",
    aweme_count: "25",
    aweme_like_count: "24",
    aweme_comment_count: 0,
    aweme_share_count: "1",
    aweme_play_count: "1455",
    aweme_activation: "0.1",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "广州南菱旗盛",
    company_name: "广州南菱旗盛汽车有限公司",
    store_code: "SGD634",
    大区: "华南区",
    "省份-城市": "广东省-广州市",
    "所选分组编号/分组名称": "-",
    fans_count: "9",
    fans_count_total: "1195",
    aweme_count: "6",
    aweme_like_count: "89",
    aweme_comment_count: "19",
    aweme_share_count: 0,
    aweme_play_count: "33885",
    aweme_activation: "0.2333",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "广州汉旗",
    company_name: "广州汉旗汽车贸易有限公司",
    store_code: "SGD641",
    大区: "华南区",
    "省份-城市": "广东省-广州市",
    "所选分组编号/分组名称": "-",
    fans_count: "20",
    fans_count_total: "483",
    aweme_count: "31",
    aweme_like_count: "101",
    aweme_comment_count: "27",
    aweme_share_count: "11",
    aweme_play_count: "50795",
    aweme_activation: "0.6667",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "上海锦筝",
    company_name: 0,
    store_code: "ESH611",
    大区: "华东区",
    "省份-城市": 0,
    "所选分组编号/分组名称": "-",
    fans_count: 0,
    fans_count_total: 0,
    aweme_count: 0,
    aweme_like_count: 0,
    aweme_comment_count: 0,
    aweme_share_count: 0,
    aweme_play_count: 0,
    aweme_activation: 0,
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: 0,
    live_fans_add: 0,
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "西安博行大展",
    company_name: "西安博行大展汽车销售服务有限公司",
    store_code: "XSS610",
    大区: "西部区",
    "省份-城市": "陕西省-西安市",
    "所选分组编号/分组名称": "-",
    fans_count: "253",
    fans_count_total: "25472",
    aweme_count: "34",
    aweme_like_count: "1171",
    aweme_comment_count: "199",
    aweme_share_count: "34",
    aweme_play_count: "86122",
    aweme_activation: "0.5667",
    live_count: "56",
    live_time: "3501",
    live_watch_count: 5349,
    live_watch_time: 5884,
    live_like_count: "412",
    live_comment_count: "161",
    live_activation: "0.9",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "东阳欧龙",
    company_name: "东阳欧龙汽车有限公司",
    store_code: "EZJ628",
    大区: "华东区",
    "省份-城市": "浙江省-金华市",
    "所选分组编号/分组名称": "-",
    fans_count: "3",
    fans_count_total: "610",
    aweme_count: "2",
    aweme_like_count: "30",
    aweme_comment_count: "1",
    aweme_share_count: 0,
    aweme_play_count: "6599",
    aweme_activation: "0.0667",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "天水天升星旗",
    company_name: "天水天升星旗汽车销售服务有限公司",
    store_code: "XGS604",
    大区: "西部区",
    "省份-城市": "甘肃省-天水市",
    "所选分组编号/分组名称": "-",
    fans_count: "95",
    fans_count_total: "3439",
    aweme_count: "51",
    aweme_like_count: "238",
    aweme_comment_count: "48",
    aweme_share_count: "3",
    aweme_play_count: "27901",
    aweme_activation: "0.9",
    live_count: "44",
    live_time: "3547",
    live_watch_count: 17450,
    live_watch_time: 19195,
    live_like_count: "11806",
    live_comment_count: "1650",
    live_activation: "0.8333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "广西宝旗勇昌",
    company_name: "广西宝旗勇昌汽车销售服务有限公司",
    store_code: "SGX614",
    大区: "华南区",
    "省份-城市": "广西壮族自治区-南宁市",
    "所选分组编号/分组名称": "-",
    fans_count: "14",
    fans_count_total: "49",
    aweme_count: "11",
    aweme_like_count: "67",
    aweme_comment_count: "6",
    aweme_share_count: "8",
    aweme_play_count: "9188",
    aweme_activation: "0.2667",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "新余市新征途",
    company_name: "新余市新征途汽车销售服务有限公司",
    store_code: "CJX612",
    大区: "中南区",
    "省份-城市": "江西省-新余市",
    "所选分组编号/分组名称": "-",
    fans_count: "-22",
    fans_count_total: "469",
    aweme_count: "14",
    aweme_like_count: "38",
    aweme_comment_count: "9",
    aweme_share_count: 0,
    aweme_play_count: "12295",
    aweme_activation: "0.4667",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "三亚华奥文源",
    company_name: "三亚华奥文源汽车工贸有限公司",
    store_code: "SHN602",
    大区: "华南区",
    "省份-城市": "海南省-三亚市",
    "所选分组编号/分组名称": "-",
    fans_count: "-34",
    fans_count_total: "22857",
    aweme_count: "17",
    aweme_like_count: "74",
    aweme_comment_count: "12",
    aweme_share_count: "7",
    aweme_play_count: "16560",
    aweme_activation: "0.5",
    live_count: "22",
    live_time: "1250",
    live_watch_count: 360,
    live_watch_time: 397,
    live_like_count: "310",
    live_comment_count: "71",
    live_activation: "0.3333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "贵州星启源",
    company_name: "贵州星启源汽车销售服务有限公司",
    store_code: "WGZ613",
    大区: "西部区",
    "省份-城市": "贵州省-遵义市",
    "所选分组编号/分组名称": "-",
    fans_count: "-2",
    fans_count_total: "280",
    aweme_count: "28",
    aweme_like_count: "82",
    aweme_comment_count: "39",
    aweme_share_count: "1",
    aweme_play_count: "23072",
    aweme_activation: "1.0",
    live_count: "24",
    live_time: "1484",
    live_watch_count: 180,
    live_watch_time: 199,
    live_like_count: "219",
    live_comment_count: "12",
    live_activation: "0.5",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "温州欧龙",
    company_name: "温州欧龙机电有限公司",
    store_code: "EZJ622",
    大区: "华东区",
    "省份-城市": "浙江省-温州市",
    "所选分组编号/分组名称": "-",
    fans_count: "1",
    fans_count_total: "55",
    aweme_count: "1",
    aweme_like_count: "8",
    aweme_comment_count: "1",
    aweme_share_count: 0,
    aweme_play_count: "5121",
    aweme_activation: "0.0333",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "宁德华奥宏旗",
    company_name: "宁德华奥宏旗汽车销售有限公司",
    store_code: "SFJ611",
    大区: "华南区",
    "省份-城市": "福建省-宁德市",
    "所选分组编号/分组名称": "-",
    fans_count: "-7",
    fans_count_total: "803",
    aweme_count: "71",
    aweme_like_count: "25",
    aweme_comment_count: "26",
    aweme_share_count: 0,
    aweme_play_count: "3545",
    aweme_activation: "1.0",
    live_count: "1",
    live_time: "27",
    live_watch_count: 10,
    live_watch_time: 11,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "临沧国源",
    company_name: "临沧国源汽车销售服务有限公司",
    store_code: "WYN616",
    大区: "西部区",
    "省份-城市": "云南省-临沧市",
    "所选分组编号/分组名称": "-",
    fans_count: "54",
    fans_count_total: "126",
    aweme_count: "23",
    aweme_like_count: "179",
    aweme_comment_count: "27",
    aweme_share_count: "1",
    aweme_play_count: "54037",
    aweme_activation: "0.4667",
    live_count: "24",
    live_time: "1640",
    live_watch_count: 716,
    live_watch_time: 788,
    live_like_count: "3108",
    live_comment_count: "35",
    live_activation: "0.6667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "宁夏汽车大世界吴忠",
    company_name: "宁夏汽车大世界吴忠",
    store_code: "XNX601",
    大区: "西部区",
    "省份-城市": "宁夏回族自治区-吴忠市",
    "所选分组编号/分组名称": "-",
    fans_count: "233",
    fans_count_total: "2590",
    aweme_count: "72",
    aweme_like_count: "285",
    aweme_comment_count: "43",
    aweme_share_count: "27",
    aweme_play_count: "71464",
    aweme_activation: "0.8",
    live_count: "135",
    live_time: "8317",
    live_watch_count: 101628,
    live_watch_time: 111791,
    live_like_count: "10776",
    live_comment_count: "2151",
    live_activation: "1.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "厦门欧骋",
    company_name: "厦门欧骋",
    store_code: "SFJ617",
    大区: "华南区",
    "省份-城市": "福建省-厦门市",
    "所选分组编号/分组名称": "-",
    fans_count: "1541",
    fans_count_total: "25724",
    aweme_count: "35",
    aweme_like_count: "204",
    aweme_comment_count: "35",
    aweme_share_count: "50",
    aweme_play_count: "27902",
    aweme_activation: "0.8",
    live_count: "31",
    live_time: "1939",
    live_watch_count: 215669,
    live_watch_time: 237236,
    live_like_count: "4365",
    live_comment_count: "382",
    live_activation: "0.5333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "南京宏众大晟",
    company_name: "南京宏众大晟汽车销售有限公司",
    store_code: "EJS625",
    大区: "华东区",
    "省份-城市": "江苏省-南京市",
    "所选分组编号/分组名称": "-",
    fans_count: "20",
    fans_count_total: "124",
    aweme_count: "8",
    aweme_like_count: "69",
    aweme_comment_count: "13",
    aweme_share_count: "4",
    aweme_play_count: "11364",
    aweme_activation: "0.1667",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "上海岱岳红旗",
    company_name: "上海岱岳汽车销售服务有限公司",
    store_code: "ESH616",
    大区: "华东区",
    "省份-城市": "上海市-上海市",
    "所选分组编号/分组名称": "-",
    fans_count: "4620",
    fans_count_total: "48158",
    aweme_count: "46",
    aweme_like_count: "2840",
    aweme_comment_count: "1071",
    aweme_share_count: "633",
    aweme_play_count: "4297971",
    aweme_activation: "0.9333",
    live_count: "27",
    live_time: "1702",
    live_watch_count: 329504,
    live_watch_time: 362455,
    live_like_count: "238185",
    live_comment_count: "5441",
    live_activation: "0.6333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "赣州鸿旗",
    company_name: "赣州市鸿旗汽车有限公司",
    store_code: "CJX614",
    大区: "中南区",
    "省份-城市": "江西省-赣州市",
    "所选分组编号/分组名称": "-",
    fans_count: "27",
    fans_count_total: "65",
    aweme_count: "20",
    aweme_like_count: "64",
    aweme_comment_count: "7",
    aweme_share_count: "11",
    aweme_play_count: "19544",
    aweme_activation: "0.4",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "沧州华泓",
    company_name: "沧州华泓汽车服务有限公司",
    store_code: "NJI616",
    大区: "华北区",
    "省份-城市": "河北省-沧州市",
    "所选分组编号/分组名称": "-",
    fans_count: "-92",
    fans_count_total: "1807",
    aweme_count: "47",
    aweme_like_count: "165",
    aweme_comment_count: "37",
    aweme_share_count: 0,
    aweme_play_count: "37303",
    aweme_activation: "0.4667",
    live_count: "7",
    live_time: "471",
    live_watch_count: 596,
    live_watch_time: 656,
    live_like_count: "13591",
    live_comment_count: "729",
    live_activation: "0.2333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "唐山泰岳宏旗体验中心",
    company_name: "唐山泰岳宏旗体验中心",
    store_code: "NJI614",
    大区: "华北区",
    "省份-城市": "河北省-唐山市",
    "所选分组编号/分组名称": "-",
    fans_count: "345",
    fans_count_total: "9498",
    aweme_count: "47",
    aweme_like_count: "4138",
    aweme_comment_count: "64",
    aweme_share_count: "93",
    aweme_play_count: "756131",
    aweme_activation: "0.9",
    live_count: "65",
    live_time: "4032",
    live_watch_count: 188882,
    live_watch_time: 207771,
    live_like_count: "13425",
    live_comment_count: "2104",
    live_activation: "1.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "宁夏汽车大世界红旗",
    company_name: "宁夏汽车大世界红旗",
    store_code: "XNX602",
    大区: "西部区",
    "省份-城市": "宁夏回族自治区-银川市",
    "所选分组编号/分组名称": "-",
    fans_count: "1166",
    fans_count_total: "14341",
    aweme_count: "61",
    aweme_like_count: "2298",
    aweme_comment_count: "439",
    aweme_share_count: "143",
    aweme_play_count: "374982",
    aweme_activation: "0.9333",
    live_count: "44",
    live_time: "2750",
    live_watch_count: 146091,
    live_watch_time: 160701,
    live_like_count: "8258",
    live_comment_count: "1986",
    live_activation: "0.8667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "永康正鑫",
    company_name: 0,
    store_code: "EZJ634",
    大区: "华东区",
    "省份-城市": 0,
    "所选分组编号/分组名称": "-",
    fans_count: 0,
    fans_count_total: 0,
    aweme_count: 0,
    aweme_like_count: 0,
    aweme_comment_count: 0,
    aweme_share_count: 0,
    aweme_play_count: 0,
    aweme_activation: 0,
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: 0,
    live_fans_add: 0,
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "哈尔滨森华红旗体验中心",
    company_name: "哈尔滨森华红旗体验中心",
    store_code: "DHL610",
    大区: "东北区",
    "省份-城市": "黑龙江省-哈尔滨市",
    "所选分组编号/分组名称": "-",
    fans_count: "13",
    fans_count_total: "201",
    aweme_count: "21",
    aweme_like_count: "73",
    aweme_comment_count: "11",
    aweme_share_count: "7",
    aweme_play_count: "48766",
    aweme_activation: "0.1",
    live_count: "23",
    live_time: "1810",
    live_watch_count: 409,
    live_watch_time: 450,
    live_like_count: "2082",
    live_comment_count: "23",
    live_activation: "0.5",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "新疆国奥伟鸿",
    company_name: "新疆国奥伟鸿",
    store_code: "XXJ607",
    大区: "西部区",
    "省份-城市": "新疆维吾尔自治区-乌鲁木齐市",
    "所选分组编号/分组名称": "-",
    fans_count: "35",
    fans_count_total: "107",
    aweme_count: "70",
    aweme_like_count: "93",
    aweme_comment_count: "22",
    aweme_share_count: 0,
    aweme_play_count: "33656",
    aweme_activation: "0.7667",
    live_count: "26",
    live_time: "2451",
    live_watch_count: 434,
    live_watch_time: 478,
    live_like_count: "501",
    live_comment_count: "11",
    live_activation: "0.6",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "天津领通",
    company_name: "天津领通",
    store_code: "NTJ606",
    大区: "华北区",
    "省份-城市": "天津市-天津市",
    "所选分组编号/分组名称": "-",
    fans_count: "28",
    fans_count_total: "116",
    aweme_count: "23",
    aweme_like_count: "127",
    aweme_comment_count: "22",
    aweme_share_count: 0,
    aweme_play_count: "32424",
    aweme_activation: "0.4667",
    live_count: "20",
    live_time: "1231",
    live_watch_count: 244,
    live_watch_time: 269,
    live_like_count: "4",
    live_comment_count: 0,
    live_activation: "0.7333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "辽宁福宏旗",
    company_name: "辽宁福宏旗",
    store_code: "DLN618",
    大区: "东北区",
    "省份-城市": "辽宁省-沈阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "24",
    fans_count_total: "149",
    aweme_count: "36",
    aweme_like_count: "34",
    aweme_comment_count: "13",
    aweme_share_count: "6",
    aweme_play_count: "10617",
    aweme_activation: "0.9333",
    live_count: "43",
    live_time: "2686",
    live_watch_count: 710,
    live_watch_time: 781,
    live_like_count: "29",
    live_comment_count: "57",
    live_activation: "0.8333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "聊城北斗泰和",
    company_name: "聊城北斗泰和",
    store_code: "NSD630",
    大区: "东北区",
    "省份-城市": "山东省-聊城市",
    "所选分组编号/分组名称": "-",
    fans_count: "10",
    fans_count_total: "120",
    aweme_count: "15",
    aweme_like_count: "117",
    aweme_comment_count: "16",
    aweme_share_count: "1",
    aweme_play_count: "37360",
    aweme_activation: "0.3667",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "廊坊车朋达",
    company_name: "廊坊车朋达",
    store_code: "NJI617",
    大区: "华北区",
    "省份-城市": "河北省-廊坊市",
    "所选分组编号/分组名称": "-",
    fans_count: "7",
    fans_count_total: "14",
    aweme_count: "3",
    aweme_like_count: "30",
    aweme_comment_count: "4",
    aweme_share_count: 0,
    aweme_play_count: "6713",
    aweme_activation: "0.0667",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "辽宁和奉",
    company_name: "辽宁和奉",
    store_code: "DLN619",
    大区: "东北区",
    "省份-城市": "辽宁省-沈阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "106",
    fans_count_total: "211",
    aweme_count: "22",
    aweme_like_count: "130",
    aweme_comment_count: "35",
    aweme_share_count: "1",
    aweme_play_count: "21636",
    aweme_activation: "0.5667",
    live_count: "32",
    live_time: "2117",
    live_watch_count: 4655,
    live_watch_time: 5121,
    live_like_count: "3770",
    live_comment_count: "792",
    live_activation: "0.8667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "喀什通工宏旗",
    company_name: "喀什通工宏旗",
    store_code: "XXJ606",
    大区: "西部区",
    "省份-城市": "新疆维吾尔自治区-喀什地区",
    "所选分组编号/分组名称": "-",
    fans_count: "-5",
    fans_count_total: "57",
    aweme_count: "9",
    aweme_like_count: "77",
    aweme_comment_count: "5",
    aweme_share_count: "3",
    aweme_play_count: "20605",
    aweme_activation: "0.0667",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "佛山富华",
    company_name: "佛山富华",
    store_code: "SGD653",
    大区: "华南区",
    "省份-城市": "广东省-佛山市",
    "所选分组编号/分组名称": "-",
    fans_count: "15",
    fans_count_total: "60",
    aweme_count: "14",
    aweme_like_count: "139",
    aweme_comment_count: "43",
    aweme_share_count: 0,
    aweme_play_count: "22695",
    aweme_activation: "0.4333",
    live_count: "2",
    live_time: "131",
    live_watch_count: 102,
    live_watch_time: 113,
    live_like_count: "880",
    live_comment_count: "47",
    live_activation: "0.0667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "蚌埠福顺红旗体验中心",
    company_name: "蚌埠福顺红旗体验中心",
    store_code: "EAH623",
    大区: "华东区",
    "省份-城市": "安徽省-蚌埠市",
    "所选分组编号/分组名称": "-",
    fans_count: "2",
    fans_count_total: "19",
    aweme_count: "4",
    aweme_like_count: "34",
    aweme_comment_count: "3",
    aweme_share_count: 0,
    aweme_play_count: "7070",
    aweme_activation: "0.0667",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "南京朗驰旗胜红旗融合4s店",
    company_name: "南京朗驰旗胜红旗融合4s店",
    store_code: "EJS635",
    大区: "华东区",
    "省份-城市": "江苏省-南京市",
    "所选分组编号/分组名称": "-",
    fans_count: "-16",
    fans_count_total: "62",
    aweme_count: 0,
    aweme_like_count: "18",
    aweme_comment_count: "1",
    aweme_share_count: 0,
    aweme_play_count: "42",
    aweme_activation: "0.0333",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "新乡市融之汇",
    company_name: "新乡市融之汇",
    store_code: "NYU626",
    大区: "华北区",
    "省份-城市": "河南省-新乡市",
    "所选分组编号/分组名称": "-",
    fans_count: "15",
    fans_count_total: "126",
    aweme_count: "33",
    aweme_like_count: "33",
    aweme_comment_count: "10",
    aweme_share_count: 0,
    aweme_play_count: "2192",
    aweme_activation: "1.0",
    live_count: "1",
    live_time: "61",
    live_watch_count: 4253,
    live_watch_time: 4679,
    live_like_count: "114",
    live_comment_count: "1",
    live_activation: "0.0333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "北京奥信鸿旗汽车销售服务有限公司",
    company_name: "北京奥信鸿旗汽车销售服务有限公司",
    store_code: "NBJ613",
    大区: "华北区",
    "省份-城市": "北京市-北京市",
    "所选分组编号/分组名称": "-",
    fans_count: "14",
    fans_count_total: "19",
    aweme_count: "3",
    aweme_like_count: "34",
    aweme_comment_count: "6",
    aweme_share_count: 0,
    aweme_play_count: "9438",
    aweme_activation: "0.0667",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "宁波东旗",
    company_name: "宁波东旗",
    store_code: "EZJ635",
    大区: "华东区",
    "省份-城市": "浙江省-宁波市",
    "所选分组编号/分组名称": "-",
    fans_count: "8",
    fans_count_total: "33",
    aweme_count: "90",
    aweme_like_count: "31",
    aweme_comment_count: "5",
    aweme_share_count: "1",
    aweme_play_count: "6258",
    aweme_activation: "1.0",
    live_count: "20",
    live_time: "1223",
    live_watch_count: 71,
    live_watch_time: 79,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.7667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "盐城雅锋",
    company_name: "盐城雅锋",
    store_code: "EJS401",
    大区: "华东区",
    "省份-城市": "江苏省-盐城市",
    "所选分组编号/分组名称": "-",
    fans_count: "26",
    fans_count_total: "110",
    aweme_count: "37",
    aweme_like_count: "124",
    aweme_comment_count: "21",
    aweme_share_count: 0,
    aweme_play_count: "12909",
    aweme_activation: "0.7",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "乌鲁木齐泰岳红旗体验中心",
    company_name: "乌鲁木齐泰岳红旗体验中心",
    store_code: "XXJ604",
    大区: "西部区",
    "省份-城市": "新疆维吾尔自治区-乌鲁木齐市",
    "所选分组编号/分组名称": "-",
    fans_count: "43",
    fans_count_total: "545",
    aweme_count: "30",
    aweme_like_count: "184",
    aweme_comment_count: "34",
    aweme_share_count: "2",
    aweme_play_count: "92271",
    aweme_activation: "0.3",
    live_count: "62",
    live_time: "3932",
    live_watch_count: 4923,
    live_watch_time: 5416,
    live_like_count: "3476",
    live_comment_count: "494",
    live_activation: "0.9333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "郑州博行大展汽车",
    company_name: "郑州博行大展汽车",
    store_code: "NYU622",
    大区: "华北区",
    "省份-城市": "河南省-郑州市",
    "所选分组编号/分组名称": "-",
    fans_count: "-17",
    fans_count_total: "2046",
    aweme_count: "39",
    aweme_like_count: "103",
    aweme_comment_count: "28",
    aweme_share_count: "30",
    aweme_play_count: "32809",
    aweme_activation: "0.6333",
    live_count: "1",
    live_time: "61",
    live_watch_count: 3,
    live_watch_time: 4,
    live_like_count: "8",
    live_comment_count: 0,
    live_activation: "0.0667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "沈阳德联旗骏店",
    company_name: "沈阳德联旗骏店",
    store_code: "DLN617",
    大区: "东北区",
    "省份-城市": "辽宁省-沈阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "14",
    fans_count_total: "45",
    aweme_count: "15",
    aweme_like_count: "67",
    aweme_comment_count: "10",
    aweme_share_count: 0,
    aweme_play_count: "18931",
    aweme_activation: "0.3",
    live_count: "38",
    live_time: "2387",
    live_watch_count: 386,
    live_watch_time: 425,
    live_like_count: "35",
    live_comment_count: "14",
    live_activation: "0.7",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "合肥博融祥之旗",
    company_name: "合肥博融祥之旗",
    store_code: "EAH622",
    大区: "华东区",
    "省份-城市": "安徽省-合肥市",
    "所选分组编号/分组名称": "-",
    fans_count: "20",
    fans_count_total: "223",
    aweme_count: "16",
    aweme_like_count: "104",
    aweme_comment_count: "25",
    aweme_share_count: "7",
    aweme_play_count: "27767",
    aweme_activation: "0.5667",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "驻马店祥聚",
    company_name: "驻马店祥聚",
    store_code: "NYU624",
    大区: "华北区",
    "省份-城市": "河南省-驻马店市",
    "所选分组编号/分组名称": "-",
    fans_count: "1253",
    fans_count_total: "15808",
    aweme_count: "10",
    aweme_like_count: "70",
    aweme_comment_count: "3",
    aweme_share_count: "3",
    aweme_play_count: "15791",
    aweme_activation: "0.4667",
    live_count: "17",
    live_time: "1052",
    live_watch_count: 643,
    live_watch_time: 708,
    live_like_count: "229",
    live_comment_count: "33",
    live_activation: "0.4667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "江苏协众旗瑞",
    company_name: "江苏协众旗瑞",
    store_code: "EJS634",
    大区: "华东区",
    "省份-城市": "江苏省-南京市",
    "所选分组编号/分组名称": "-",
    fans_count: "37",
    fans_count_total: "501",
    aweme_count: "20",
    aweme_like_count: "139",
    aweme_comment_count: "34",
    aweme_share_count: "2",
    aweme_play_count: "25683",
    aweme_activation: "0.3333",
    live_count: "62",
    live_time: "3814",
    live_watch_count: 809,
    live_watch_time: 890,
    live_like_count: "682",
    live_comment_count: "18",
    live_activation: "0.8667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "周口人合元南环",
    company_name: "周口人合元南环",
    store_code: "NYU625",
    大区: "华北区",
    "省份-城市": "河南省-周口市",
    "所选分组编号/分组名称": "-",
    fans_count: "-11",
    fans_count_total: "410",
    aweme_count: "38",
    aweme_like_count: "156",
    aweme_comment_count: "32",
    aweme_share_count: 0,
    aweme_play_count: "27363",
    aweme_activation: "0.8",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "兰州新瑞宏旗体验中心",
    company_name: "兰州新瑞宏旗体验中心",
    store_code: "XGS605",
    大区: "西部区",
    "省份-城市": "甘肃省-兰州市",
    "所选分组编号/分组名称": "-",
    fans_count: "800",
    fans_count_total: "5086",
    aweme_count: "83",
    aweme_like_count: "276",
    aweme_comment_count: "33",
    aweme_share_count: "26",
    aweme_play_count: "26336",
    aweme_activation: "1.0",
    live_count: "87",
    live_time: "5688",
    live_watch_count: 361220,
    live_watch_time: 397342,
    live_like_count: "36658",
    live_comment_count: "1830",
    live_activation: "1.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "上海东创宏旗汽车销售服务有限公司",
    company_name: "上海东创宏旗汽车销售服务有限公司",
    store_code: "ESH618",
    大区: "华东区",
    "省份-城市": "上海市-上海市",
    "所选分组编号/分组名称": "-",
    fans_count: "15",
    fans_count_total: "28",
    aweme_count: "2",
    aweme_like_count: "46",
    aweme_comment_count: "7",
    aweme_share_count: 0,
    aweme_play_count: "5011",
    aweme_activation: "0.1333",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "阿克苏万禾",
    company_name: "阿克苏万禾",
    store_code: "XXJ605",
    大区: "西部区",
    "省份-城市": "新疆维吾尔自治区-阿克苏地区",
    "所选分组编号/分组名称": "-",
    fans_count: "52",
    fans_count_total: "1645",
    aweme_count: "51",
    aweme_like_count: "143",
    aweme_comment_count: "47",
    aweme_share_count: "21",
    aweme_play_count: "25991",
    aweme_activation: "0.8667",
    live_count: "52",
    live_time: "3599",
    live_watch_count: 8909,
    live_watch_time: 9800,
    live_like_count: "32391",
    live_comment_count: "448",
    live_activation: "0.9333",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "郑州威佳红旗",
    company_name: "郑州威佳红旗",
    store_code: "NYU623",
    大区: "华北区",
    "省份-城市": "河南省-郑州市",
    "所选分组编号/分组名称": "-",
    fans_count: "10",
    fans_count_total: "18",
    aweme_count: "2",
    aweme_like_count: "30",
    aweme_comment_count: "6",
    aweme_share_count: 0,
    aweme_play_count: "5699",
    aweme_activation: "0.0667",
    live_count: 0,
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: "0.0",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "滨州国悦",
    company_name: "滨州市国悦汽车销售服务有限公司 ",
    store_code: "NSD401",
    大区: "东北区",
    "省份-城市": "山东省-滨州市",
    "所选分组编号/分组名称": "-",
    fans_count: "169",
    fans_count_total: "373",
    aweme_count: "67",
    aweme_like_count: "296",
    aweme_comment_count: "35",
    aweme_share_count: "6",
    aweme_play_count: "18148",
    aweme_activation: "0.8",
    live_count: "56",
    live_time: 57,
    live_watch_count: 23691,
    live_watch_time: 26034,
    live_like_count: "25093",
    live_comment_count: "1141",
    live_activation: "0.8667",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "淮北宏祺",
    company_name: "淮北宏祺汽车销售服务有限公司",
    store_code: "EAH401",
    大区: "华东区",
    "省份-城市": "安徽省-淮北市",
    "所选分组编号/分组名称": "-",
    fans_count: "-",
    fans_count_total: "-",
    aweme_count: "-",
    aweme_like_count: "-",
    aweme_comment_count: "-",
    aweme_share_count: "-",
    aweme_play_count: "-",
    aweme_activation: "-",
    live_count: "-",
    live_time: "-",
    live_watch_count: null,
    live_watch_time: null,
    live_like_count: "-",
    live_comment_count: "-",
    live_activation: "-",
    live_fans_add: "-",
    统计时间区间: "-",
    "Unnamed: 24": "2025/03/01-2025/03/31",
  },
  {
    平台: "快手",
    dealer_name: "湘潭兰天旗胜",
    company_name: "湘潭兰天旗胜汽车销售有限公司",
    store_code: "CHN403",
    大区: "中南区",
    "省份-城市": "湖南省-长沙市",
    "所选分组编号/分组名称": "-",
    fans_count: "-",
    fans_count_total: "-",
    aweme_count: "-",
    aweme_like_count: "-",
    aweme_comment_count: "-",
    aweme_share_count: "-",
    aweme_play_count: "-",
    aweme_activation: "-",
    live_count: "-",
    live_time: "-",
    live_watch_count: null,
    live_watch_time: null,
    live_like_count: "-",
    live_comment_count: "-",
    live_activation: "-",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "益阳兰天悦旗",
    company_name: "益阳兰天悦旗汽车销售有限公司",
    store_code: "CHN402",
    大区: "中南区",
    "省份-城市": "湖南省-益阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "-",
    fans_count_total: "-",
    aweme_count: "-",
    aweme_like_count: "-",
    aweme_comment_count: "-",
    aweme_share_count: "-",
    aweme_play_count: "-",
    aweme_activation: "-",
    live_count: "-",
    live_time: "-",
    live_watch_count: null,
    live_watch_time: null,
    live_like_count: "-",
    live_comment_count: "-",
    live_activation: "-",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "宿州宏祺",
    company_name: "宿州宏祺汽车销售服务有限公司",
    store_code: "EAH625",
    大区: "华东区",
    "省份-城市": "安徽省-宿州市",
    "所选分组编号/分组名称": "-",
    fans_count: "-",
    fans_count_total: "-",
    aweme_count: "-",
    aweme_like_count: "-",
    aweme_comment_count: "-",
    aweme_share_count: "-",
    aweme_play_count: "-",
    aweme_activation: "-",
    live_count: "-",
    live_time: "-",
    live_watch_count: null,
    live_watch_time: null,
    live_like_count: "-",
    live_comment_count: "-",
    live_activation: "-",
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
    "Unnamed: 24": null,
  },
  {
    平台: "快手",
    dealer_name: "陕西众恒",
    company_name: "陕西众恒宏旗汽车贸易有限公司",
    store_code: "XSS401",
    大区: "西部区",
    "省份-城市": "陕西省-渭南市",
    "所选分组编号/分组名称": "-",
    fans_count: "-",
    fans_count_total: "-",
    aweme_count: "-",
    aweme_like_count: "-",
    aweme_comment_count: "-",
    aweme_share_count: "-",
    aweme_play_count: "-",
    aweme_activation: "-",
    live_count: "-",
    live_time: "-",
    live_watch_count: null,
    live_watch_time: null,
    live_like_count: "-",
    live_comment_count: "-",
    live_activation: "-",
    live_fans_add: "-",
    统计时间区间: "-",
    "Unnamed: 24": "2025/03/01-2025/03/31",
  },
];

export const allData = [
  {
    平台: "全部平台",
    dealer_name: "临沂星光",
    company_name: "临沂星光汽车销售服务有限公司",
    store_code: "NSD624",
    大区: "东北区",
    "省份-城市": "山东省-临沂市",
    "所选分组编号/分组名称": "-",
    fans_count: "-1561",
    fans_count_total: "284782",
    aweme_count: "59",
    aweme_like_count: "111",
    aweme_comment_count: "8",
    aweme_share_count: "3",
    aweme_play_count: 28155,
    aweme_activation: 0.6667,
    live_count: "45",
    live_time: 2721,
    live_watch_count: 4928,
    live_watch_time: 5475,
    live_like_count: "11685",
    live_comment_count: "3076",
    live_activation: 0.8,
    live_fans_add: "9",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "广州红升",
    company_name: "广州红升",
    store_code: "SGD652",
    大区: "华南区",
    "省份-城市": "广东省-广州市",
    "所选分组编号/分组名称": "-",
    fans_count: "123",
    fans_count_total: "11958",
    aweme_count: "91",
    aweme_like_count: "340",
    aweme_comment_count: "28",
    aweme_share_count: "30",
    aweme_play_count: 61734,
    aweme_activation: 0.8,
    live_count: "66",
    live_time: 5815,
    live_watch_count: 16945,
    live_watch_time: 18828,
    live_like_count: "125409",
    live_comment_count: "1877",
    live_activation: 0.8333,
    live_fans_add: "273",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "上海建国弘旗",
    company_name: "上海建国弘旗汽车销售服务有限公司",
    store_code: "ESH612",
    大区: "华东区",
    "省份-城市": 0,
    "所选分组编号/分组名称": "-",
    fans_count: "1558",
    fans_count_total: "20211",
    aweme_count: "25",
    aweme_like_count: "3219",
    aweme_comment_count: "130",
    aweme_share_count: "158",
    aweme_play_count: 145946,
    aweme_activation: 0.9667,
    live_count: "33",
    live_time: 1910,
    live_watch_count: 278427,
    live_watch_time: 309363,
    live_like_count: "189990",
    live_comment_count: "14241",
    live_activation: 0.6333,
    live_fans_add: "1637",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "武汉岳宏泰",
    company_name: "武汉岳宏泰汽车销售服务有限公司",
    store_code: "CHB617",
    大区: "中南区",
    "省份-城市": "湖北省-武汉市",
    "所选分组编号/分组名称": "-",
    fans_count: "121",
    fans_count_total: "23385",
    aweme_count: "94",
    aweme_like_count: "375",
    aweme_comment_count: "74",
    aweme_share_count: "97",
    aweme_play_count: 152185,
    aweme_activation: 0.7667,
    live_count: "73",
    live_time: 4474,
    live_watch_count: 14231,
    live_watch_time: 15806,
    live_like_count: "64659",
    live_comment_count: "3071",
    live_activation: 0.8,
    live_fans_add: "162",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "重庆大雍广峻",
    company_name: "重庆大雍广峻汽车销售服务有限责任公司",
    store_code: "WCQ603",
    大区: "西部区",
    "省份-城市": "重庆市-重庆市",
    "所选分组编号/分组名称": "-",
    fans_count: "-17",
    fans_count_total: "27676",
    aweme_count: "74",
    aweme_like_count: "325",
    aweme_comment_count: "38",
    aweme_share_count: "47",
    aweme_play_count: 113850,
    aweme_activation: 0.9,
    live_count: "49",
    live_time: 3041,
    live_watch_count: 6448,
    live_watch_time: 7164,
    live_like_count: "70779",
    live_comment_count: "5901",
    live_activation: 0.8,
    live_fans_add: "66",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "常熟伟杰红旗",
    company_name: "常熟伟杰红旗汽车销售服务有限公司",
    store_code: "EJS628",
    大区: "华东区",
    "省份-城市": 0,
    "所选分组编号/分组名称": "-",
    fans_count: "74",
    fans_count_total: "5577",
    aweme_count: "22",
    aweme_like_count: "185",
    aweme_comment_count: "14",
    aweme_share_count: "1",
    aweme_play_count: 4145,
    aweme_activation: 0.6,
    live_count: "41",
    live_time: 2404,
    live_watch_count: 5742,
    live_watch_time: 6380,
    live_like_count: "73110",
    live_comment_count: "1231",
    live_activation: 0.7667,
    live_fans_add: "115",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "抚顺千乘",
    company_name: "抚顺千乘汽车销售有限公司",
    store_code: "DLN615",
    大区: "东北区",
    "省份-城市": "辽宁省-抚顺市",
    "所选分组编号/分组名称": "-",
    fans_count: "-13",
    fans_count_total: "2459",
    aweme_count: "47",
    aweme_like_count: "162",
    aweme_comment_count: "33",
    aweme_share_count: "3",
    aweme_play_count: 14734,
    aweme_activation: 0.6333,
    live_count: "52",
    live_time: 3300,
    live_watch_count: 766,
    live_watch_time: 847,
    live_like_count: "3143",
    live_comment_count: "351",
    live_activation: 0.8667,
    live_fans_add: "42",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "通利华红旗（光明）",
    company_name: "通利华红旗（光明）",
    store_code: "SGD644",
    大区: "华南区",
    "省份-城市": "广东省-深圳市",
    "所选分组编号/分组名称": "-",
    fans_count: "1224",
    fans_count_total: "42300",
    aweme_count: "260",
    aweme_like_count: "10661",
    aweme_comment_count: "834",
    aweme_share_count: "824",
    aweme_play_count: 613392,
    aweme_activation: 1,
    live_count: "217",
    live_time: 15241,
    live_watch_count: 72424,
    live_watch_time: 80471,
    live_like_count: "11695",
    live_comment_count: "3120",
    live_activation: 1,
    live_fans_add: "442",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "山西大昌浩瑞",
    company_name: "山西大昌浩瑞汽车销售服务有限公司",
    store_code: "NJN614",
    大区: "华北区",
    "省份-城市": "山西省-太原市",
    "所选分组编号/分组名称": "-",
    fans_count: "197",
    fans_count_total: "5414",
    aweme_count: "56",
    aweme_like_count: "185",
    aweme_comment_count: "39",
    aweme_share_count: "7",
    aweme_play_count: 23774,
    aweme_activation: 0.8667,
    live_count: "74",
    live_time: 4451,
    live_watch_count: 142585,
    live_watch_time: 158423,
    live_like_count: "100650",
    live_comment_count: "2097",
    live_activation: 0.8667,
    live_fans_add: "230",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "乐清红通",
    company_name: "乐清红通汽车销售服务有限公司",
    store_code: "EZJ630",
    大区: "华东区",
    "省份-城市": "浙江省-温州市",
    "所选分组编号/分组名称": "-",
    fans_count: "585",
    fans_count_total: "26798",
    aweme_count: "32",
    aweme_like_count: "263",
    aweme_comment_count: "26",
    aweme_share_count: "21",
    aweme_play_count: 45190,
    aweme_activation: 0.4333,
    live_count: "88",
    live_time: 6016,
    live_watch_count: 63105,
    live_watch_time: 70116,
    live_like_count: "107677",
    live_comment_count: "15545",
    live_activation: 0.8667,
    live_fans_add: "1179",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "宜兴天诚",
    company_name: "宜兴天诚汽车销售服务有限公司",
    store_code: "EJS630",
    大区: "华东区",
    "省份-城市": "江苏省-无锡市",
    "所选分组编号/分组名称": "-",
    fans_count: "168",
    fans_count_total: "3016",
    aweme_count: "60",
    aweme_like_count: "655",
    aweme_comment_count: "76",
    aweme_share_count: "75",
    aweme_play_count: 255839,
    aweme_activation: 0.7333,
    live_count: "57",
    live_time: 3548,
    live_watch_count: 3385,
    live_watch_time: 3761,
    live_like_count: "47051",
    live_comment_count: "1324",
    live_activation: 0.8333,
    live_fans_add: "60",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "贵阳万达汽车红旗体验中心",
    company_name: "贵阳万达汽车科技服务有限公司",
    store_code: "WGZ501",
    大区: "西部区",
    "省份-城市": "贵州省-贵阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "-79",
    fans_count_total: "3219",
    aweme_count: "-",
    aweme_like_count: "-",
    aweme_comment_count: "-",
    aweme_share_count: "-",
    aweme_play_count: 65,
    aweme_activation: 0,
    live_count: "-",
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: "-",
    live_comment_count: "-",
    live_activation: 0,
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "长春泰岳红旗",
    company_name: "长春泰岳红旗",
    store_code: "DJL501",
    大区: "东北区",
    "省份-城市": "吉林省-长春市",
    "所选分组编号/分组名称": "-",
    fans_count: "259",
    fans_count_total: "8488",
    aweme_count: "82",
    aweme_like_count: "918",
    aweme_comment_count: "127",
    aweme_share_count: "155",
    aweme_play_count: 560311,
    aweme_activation: 0.6333,
    live_count: "50",
    live_time: 4112,
    live_watch_count: 7800,
    live_watch_time: 8665,
    live_like_count: "37749",
    live_comment_count: "2491",
    live_activation: 0.8,
    live_fans_add: "184",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "广州路易通",
    company_name: "广州路易通汽车销售服务有限公司",
    store_code: "SGD645",
    大区: "华南区",
    "省份-城市": "广东省-广州市",
    "所选分组编号/分组名称": "-",
    fans_count: "869",
    fans_count_total: "5639",
    aweme_count: "219",
    aweme_like_count: "1167",
    aweme_comment_count: "184",
    aweme_share_count: "49",
    aweme_play_count: 183474,
    aweme_activation: 0.9,
    live_count: "61",
    live_time: 3837,
    live_watch_count: 33455,
    live_watch_time: 37172,
    live_like_count: "20150",
    live_comment_count: "6020",
    live_activation: 0.9333,
    live_fans_add: "464",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "太原泰岳红旗",
    company_name: "太原泰岳红旗",
    store_code: "NJN501",
    大区: "华北区",
    "省份-城市": "山西省-太原市",
    "所选分组编号/分组名称": "-",
    fans_count: "-59",
    fans_count_total: "7243",
    aweme_count: "182",
    aweme_like_count: "341",
    aweme_comment_count: "60",
    aweme_share_count: "3",
    aweme_play_count: 44456,
    aweme_activation: 0.9667,
    live_count: "51",
    live_time: 3746,
    live_watch_count: 1004,
    live_watch_time: 1111,
    live_like_count: "11306",
    live_comment_count: "332",
    live_activation: 0.7667,
    live_fans_add: "1",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "银川岳宏泰",
    company_name: "银川岳宏泰",
    store_code: "XNX501",
    大区: "西部区",
    "省份-城市": "宁夏回族自治区-银川市",
    "所选分组编号/分组名称": "-",
    fans_count: "86",
    fans_count_total: "5489",
    aweme_count: "293",
    aweme_like_count: "1807",
    aweme_comment_count: "158",
    aweme_share_count: "113",
    aweme_play_count: 858282,
    aweme_activation: 1,
    live_count: "156",
    live_time: 9551,
    live_watch_count: 5327,
    live_watch_time: 5880,
    live_like_count: "75898",
    live_comment_count: "2337",
    live_activation: 1,
    live_fans_add: "35",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "深圳奥吉通",
    company_name: "深圳奥吉通汽车销售服务有限公司",
    store_code: "SGD646",
    大区: "华南区",
    "省份-城市": "广东省-深圳市",
    "所选分组编号/分组名称": "-",
    fans_count: "74",
    fans_count_total: "2556",
    aweme_count: "29",
    aweme_like_count: "137",
    aweme_comment_count: "14",
    aweme_share_count: "3",
    aweme_play_count: 26159,
    aweme_activation: 0.6,
    live_count: "55",
    live_time: 3412,
    live_watch_count: 8015,
    live_watch_time: 8905,
    live_like_count: "8330",
    live_comment_count: "2250",
    live_activation: 0.8667,
    live_fans_add: "97",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "慈溪中基",
    company_name: "慈溪中基汽车销售服务有限公司",
    store_code: "EZJ632",
    大区: "华东区",
    "省份-城市": "浙江省-宁波市",
    "所选分组编号/分组名称": "-",
    fans_count: "23",
    fans_count_total: "20741",
    aweme_count: "113",
    aweme_like_count: "494",
    aweme_comment_count: "143",
    aweme_share_count: "39",
    aweme_play_count: 227706,
    aweme_activation: 0.8667,
    live_count: "79",
    live_time: 7608,
    live_watch_count: 27120,
    live_watch_time: 30120,
    live_like_count: "146367",
    live_comment_count: "7258",
    live_activation: 0.9,
    live_fans_add: "250",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "南阳英驰",
    company_name: "南阳英驰汽车销售有限公司",
    store_code: "NYU621",
    大区: "华北区",
    "省份-城市": "河南省-南阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "-926",
    fans_count_total: "107791",
    aweme_count: "91",
    aweme_like_count: "983",
    aweme_comment_count: "109",
    aweme_share_count: "85",
    aweme_play_count: 47205,
    aweme_activation: 0.8333,
    live_count: "106",
    live_time: 6529,
    live_watch_count: 276675,
    live_watch_time: 307408,
    live_like_count: "89640",
    live_comment_count: "2673",
    live_activation: 0.9333,
    live_fans_add: "1930",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "北京博瑞祥浓",
    company_name: "北京博瑞祥浓汽车销售服务有限公司",
    store_code: "NBJ612",
    大区: "华北区",
    "省份-城市": "北京市-北京市",
    "所选分组编号/分组名称": "-",
    fans_count: "3908",
    fans_count_total: "26608",
    aweme_count: "71",
    aweme_like_count: "1295",
    aweme_comment_count: "141",
    aweme_share_count: "117",
    aweme_play_count: 81819,
    aweme_activation: 0.8667,
    live_count: "54",
    live_time: 3299,
    live_watch_count: 185071,
    live_watch_time: 204199,
    live_like_count: "210507",
    live_comment_count: "4527",
    live_activation: 0.7,
    live_fans_add: "483",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "淮安宏众万晟汽",
    company_name: "淮安市宏众万晟汽车销售服务有限公司",
    store_code: "EJS631",
    大区: "华东区",
    "省份-城市": "江苏省-淮安市",
    "所选分组编号/分组名称": "-",
    fans_count: "666",
    fans_count_total: "87082",
    aweme_count: "67",
    aweme_like_count: "694",
    aweme_comment_count: "73",
    aweme_share_count: "45",
    aweme_play_count: 145382,
    aweme_activation: 0.8333,
    live_count: "71",
    live_time: 4718,
    live_watch_count: 68220,
    live_watch_time: 75800,
    live_like_count: "43375",
    live_comment_count: "7884",
    live_activation: 0.8667,
    live_fans_add: "1063",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "白城致诚红旗体验中心",
    company_name: "白城市致诚汽车销售服务有限公司",
    store_code: "DJL616",
    大区: "东北区",
    "省份-城市": "吉林省-白城市",
    "所选分组编号/分组名称": "-",
    fans_count: "1931",
    fans_count_total: "19579",
    aweme_count: "59",
    aweme_like_count: "176",
    aweme_comment_count: "19",
    aweme_share_count: "27",
    aweme_play_count: 42599,
    aweme_activation: 0.6,
    live_count: "94",
    live_time: 7272,
    live_watch_count: 106096,
    live_watch_time: 116914,
    live_like_count: "368658",
    live_comment_count: "6750",
    live_activation: 0.9333,
    live_fans_add: "346",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "江门中升红旗体验中心",
    company_name: "江门市中升汽车销售服务有限公司",
    store_code: "SGD649",
    大区: "华南区",
    "省份-城市": "广东省-江门市",
    "所选分组编号/分组名称": "-",
    fans_count: "-24",
    fans_count_total: "25666",
    aweme_count: "63",
    aweme_like_count: "456",
    aweme_comment_count: "50",
    aweme_share_count: "82",
    aweme_play_count: 140541,
    aweme_activation: 0.8333,
    live_count: "56",
    live_time: 3493,
    live_watch_count: 8289,
    live_watch_time: 9207,
    live_like_count: "3134",
    live_comment_count: "2109",
    live_activation: 0.7333,
    live_fans_add: "114",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "泰州同悦汽车",
    company_name: "泰州同悦汽车销售服务有限公司",
    store_code: "EJS633",
    大区: "华东区",
    "省份-城市": "江苏省-泰州市",
    "所选分组编号/分组名称": "-",
    fans_count: "21",
    fans_count_total: "2815",
    aweme_count: "45",
    aweme_like_count: "214",
    aweme_comment_count: "38",
    aweme_share_count: "31",
    aweme_play_count: 43101,
    aweme_activation: 0.5667,
    live_count: "49",
    live_time: 3818,
    live_watch_count: 937,
    live_watch_time: 1039,
    live_like_count: "3589",
    live_comment_count: "1618",
    live_activation: 0.5667,
    live_fans_add: "16",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "徐州天扬",
    company_name: "徐州天扬",
    store_code: "EJS632",
    大区: "华东区",
    "省份-城市": "江苏省-徐州市",
    "所选分组编号/分组名称": "-",
    fans_count: "368",
    fans_count_total: "6976",
    aweme_count: "90",
    aweme_like_count: "923",
    aweme_comment_count: "80",
    aweme_share_count: "77",
    aweme_play_count: 173334,
    aweme_activation: 0.9667,
    live_count: "65",
    live_time: 4104,
    live_watch_count: 125413,
    live_watch_time: 139347,
    live_like_count: "139760",
    live_comment_count: "4953",
    live_activation: 0.9333,
    live_fans_add: "242",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "贵阳通源源旗",
    company_name: "贵阳通源源旗汽车销售服务有限公司",
    store_code: "WGZ614",
    大区: "西部区",
    "省份-城市": "贵州省-贵阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "187",
    fans_count_total: "40267",
    aweme_count: "43",
    aweme_like_count: "1211",
    aweme_comment_count: "223",
    aweme_share_count: "97",
    aweme_play_count: 454065,
    aweme_activation: 0.5333,
    live_count: "46",
    live_time: 3085,
    live_watch_count: 3409,
    live_watch_time: 3777,
    live_like_count: "11557",
    live_comment_count: "1527",
    live_activation: 0.5667,
    live_fans_add: "32",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "重庆博行大展",
    company_name: "重庆博行大展汽车销售有限公司",
    store_code: "WCQ604",
    大区: "西部区",
    "省份-城市": "重庆市-重庆市",
    "所选分组编号/分组名称": "-",
    fans_count: "152",
    fans_count_total: "32882",
    aweme_count: "56",
    aweme_like_count: "588",
    aweme_comment_count: "105",
    aweme_share_count: "46",
    aweme_play_count: 518717,
    aweme_activation: 0.6333,
    live_count: "33",
    live_time: 2005,
    live_watch_count: 23850,
    live_watch_time: 26500,
    live_like_count: "121631",
    live_comment_count: "6441",
    live_activation: 0.8,
    live_fans_add: "297",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "珠海宝旗",
    company_name: "珠海市宝旗汽车销售服务有限公司",
    store_code: "SGD648",
    大区: "华南区",
    "省份-城市": "广东省-珠海市",
    "所选分组编号/分组名称": "-",
    fans_count: "-66",
    fans_count_total: "6373",
    aweme_count: "26",
    aweme_like_count: "67",
    aweme_comment_count: "9",
    aweme_share_count: "1",
    aweme_play_count: 22339,
    aweme_activation: 0.4667,
    live_count: "53",
    live_time: 3270,
    live_watch_count: 5240,
    live_watch_time: 5822,
    live_like_count: "8589",
    live_comment_count: "384",
    live_activation: 0.7333,
    live_fans_add: "3",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "广东荣洲",
    company_name: "广东荣洲汽车销售服务有限公司",
    store_code: "SGD647",
    大区: "华南区",
    "省份-城市": "广东省-东莞市",
    "所选分组编号/分组名称": "-",
    fans_count: "106",
    fans_count_total: "11315",
    aweme_count: "153",
    aweme_like_count: "495",
    aweme_comment_count: "54",
    aweme_share_count: "14",
    aweme_play_count: 50553,
    aweme_activation: 0.9333,
    live_count: "49",
    live_time: 3133,
    live_watch_count: 29966,
    live_watch_time: 33295,
    live_like_count: "270991",
    live_comment_count: "2983",
    live_activation: 0.7333,
    live_fans_add: "165",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "济宁星光",
    company_name: "济宁星光",
    store_code: "NSD626",
    大区: "东北区",
    "省份-城市": "山东省-济宁市",
    "所选分组编号/分组名称": "-",
    fans_count: "29",
    fans_count_total: "4481",
    aweme_count: "39",
    aweme_like_count: "142",
    aweme_comment_count: "35",
    aweme_share_count: "3",
    aweme_play_count: 23851,
    aweme_activation: 0.4667,
    live_count: "33",
    live_time: 1972,
    live_watch_count: 1197,
    live_watch_time: 1322,
    live_like_count: "12438",
    live_comment_count: "252",
    live_activation: 0.8333,
    live_fans_add: "5",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "遵义通源源旗",
    company_name: "遵义通源源旗汽车销售服务有限公司",
    store_code: "WGZ615",
    大区: "西部区",
    "省份-城市": "贵州省-遵义市",
    "所选分组编号/分组名称": "-",
    fans_count: "3",
    fans_count_total: "7853",
    aweme_count: "81",
    aweme_like_count: "258",
    aweme_comment_count: "19",
    aweme_share_count: "23",
    aweme_play_count: 63555,
    aweme_activation: 0.7667,
    live_count: "48",
    live_time: 2963,
    live_watch_count: 4007,
    live_watch_time: 4452,
    live_like_count: "96656",
    live_comment_count: "1856",
    live_activation: 0.8333,
    live_fans_add: "33",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "菏泽顺祺",
    company_name: "菏泽顺祺",
    store_code: "NSD627",
    大区: "东北区",
    "省份-城市": "山东省-菏泽市",
    "所选分组编号/分组名称": "-",
    fans_count: "598",
    fans_count_total: "19844",
    aweme_count: "102",
    aweme_like_count: "2028",
    aweme_comment_count: "230",
    aweme_share_count: "313",
    aweme_play_count: 487166,
    aweme_activation: 0.6,
    live_count: "110",
    live_time: 6673,
    live_watch_count: 24731,
    live_watch_time: 27478,
    live_like_count: "35290",
    live_comment_count: "8221",
    live_activation: 0.9,
    live_fans_add: "391",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "湖南兰天嘉旗",
    company_name: "湖南兰天嘉旗汽车销售有限公司",
    store_code: "CHN620",
    大区: "中南区",
    "省份-城市": "湖南省-长沙市",
    "所选分组编号/分组名称": "-",
    fans_count: "117",
    fans_count_total: "1903",
    aweme_count: "80",
    aweme_like_count: "514",
    aweme_comment_count: "89",
    aweme_share_count: "37",
    aweme_play_count: 277660,
    aweme_activation: 0.8333,
    live_count: "62",
    live_time: 3672,
    live_watch_count: 7766,
    live_watch_time: 8628,
    live_like_count: "75059",
    live_comment_count: "5888",
    live_activation: 0.8333,
    live_fans_add: "41",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "云南宏胜瑞达",
    company_name: "云南宏胜瑞达汽车销售服务有限公司",
    store_code: "WYN617",
    大区: "西部区",
    "省份-城市": "云南省-昆明市",
    "所选分组编号/分组名称": "-",
    fans_count: "82",
    fans_count_total: "41307",
    aweme_count: "56",
    aweme_like_count: "241",
    aweme_comment_count: "95",
    aweme_share_count: "5",
    aweme_play_count: 79610,
    aweme_activation: 0.8333,
    live_count: "95",
    live_time: 5907,
    live_watch_count: 133216,
    live_watch_time: 147997,
    live_like_count: "171817",
    live_comment_count: "4696",
    live_activation: 0.8667,
    live_fans_add: "382",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "阜阳华奥",
    company_name: "阜阳华奥汽车销售服务有限公司",
    store_code: "EAH621",
    大区: "华东区",
    "省份-城市": "安徽省-阜阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "373",
    fans_count_total: "6094",
    aweme_count: "149",
    aweme_like_count: "1060",
    aweme_comment_count: "103",
    aweme_share_count: "133",
    aweme_play_count: 238710,
    aweme_activation: 1,
    live_count: "110",
    live_time: 6534,
    live_watch_count: 184298,
    live_watch_time: 204772,
    live_like_count: "91815",
    live_comment_count: "5201",
    live_activation: 0.9,
    live_fans_add: "387",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "长春凯胜",
    company_name: "长春凯胜汽车销售服务有限公司",
    store_code: "DJL615",
    大区: "东北区",
    "省份-城市": "吉林省-长春市",
    "所选分组编号/分组名称": "-",
    fans_count: "872",
    fans_count_total: "84454",
    aweme_count: "78",
    aweme_like_count: "861",
    aweme_comment_count: "200",
    aweme_share_count: "86",
    aweme_play_count: 817651,
    aweme_activation: 0.6333,
    live_count: "41",
    live_time: 2858,
    live_watch_count: 167549,
    live_watch_time: 184549,
    live_like_count: "103154",
    live_comment_count: "7282",
    live_activation: 0.7,
    live_fans_add: "421",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "成都泰岳宏旗",
    company_name: "成都泰岳宏旗汽车销售服务有限公司",
    store_code: "WSC627",
    大区: "西部区",
    "省份-城市": "四川省-成都市",
    "所选分组编号/分组名称": "-",
    fans_count: "335",
    fans_count_total: "41234",
    aweme_count: "116",
    aweme_like_count: "856",
    aweme_comment_count: "125",
    aweme_share_count: "171344",
    aweme_play_count: 1655453,
    aweme_activation: 1,
    live_count: "127",
    live_time: 8071,
    live_watch_count: 564577,
    live_watch_time: 626974,
    live_like_count: "350403",
    live_comment_count: "7662",
    live_activation: 0.8667,
    live_fans_add: "619",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "邯郸坤铂",
    company_name: "邯郸市坤铂汽车销售服务有限公司",
    store_code: "NJI615",
    大区: "华北区",
    "省份-城市": "河北省-邯郸市",
    "所选分组编号/分组名称": "-",
    fans_count: "2236",
    fans_count_total: "55632",
    aweme_count: "93",
    aweme_like_count: "1834",
    aweme_comment_count: "262",
    aweme_share_count: "207",
    aweme_play_count: 613687,
    aweme_activation: 0.7667,
    live_count: "168",
    live_time: 9850,
    live_watch_count: 590686,
    live_watch_time: 650470,
    live_like_count: "195780",
    live_comment_count: "10535",
    live_activation: 0.9333,
    live_fans_add: "551",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "天津海润达",
    company_name: "天津海润达",
    store_code: "NTJ605",
    大区: "华北区",
    "省份-城市": "天津市-天津市",
    "所选分组编号/分组名称": "-",
    fans_count: "565",
    fans_count_total: "9520",
    aweme_count: "80",
    aweme_like_count: "845",
    aweme_comment_count: "157",
    aweme_share_count: "150",
    aweme_play_count: 297474,
    aweme_activation: 0.5333,
    live_count: "150",
    live_time: 13061,
    live_watch_count: 183534,
    live_watch_time: 203921,
    live_like_count: "206091",
    live_comment_count: "5328",
    live_activation: 0.8,
    live_fans_add: "618",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "淄博泰岳红旗体验中心",
    company_name: "淄博泰岳宏旗汽车销售服务有限公司",
    store_code: "NSD629",
    大区: "东北区",
    "省份-城市": "山东省-淄博市",
    "所选分组编号/分组名称": "-",
    fans_count: "1384",
    fans_count_total: "47597",
    aweme_count: "86",
    aweme_like_count: "1400",
    aweme_comment_count: "495",
    aweme_share_count: "188",
    aweme_play_count: 876397,
    aweme_activation: 0.7333,
    live_count: "66",
    live_time: 4631,
    live_watch_count: 579118,
    live_watch_time: 641292,
    live_like_count: "161168",
    live_comment_count: "6782",
    live_activation: 0.8333,
    live_fans_add: "866",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "青岛岳宏泰红旗体验中心",
    company_name: "青岛岳宏泰汽车销售服务有限公司",
    store_code: "NSD628",
    大区: "东北区",
    "省份-城市": "山东省-青岛市",
    "所选分组编号/分组名称": "-",
    fans_count: "224",
    fans_count_total: "7736",
    aweme_count: "119",
    aweme_like_count: "879",
    aweme_comment_count: "94",
    aweme_share_count: "116",
    aweme_play_count: 911839,
    aweme_activation: 0.5333,
    live_count: "64",
    live_time: 3917,
    live_watch_count: 3797,
    live_watch_time: 4216,
    live_like_count: "76992",
    live_comment_count: "3217",
    live_activation: 0.6667,
    live_fans_add: "37",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "郑州大展红旗汽车",
    company_name: "郑州大展红旗汽车",
    store_code: "NYU172",
    大区: "华北区",
    "省份-城市": "河南省-郑州市",
    "所选分组编号/分组名称": "-",
    fans_count: "628",
    fans_count_total: "569826",
    aweme_count: "89",
    aweme_like_count: "3759",
    aweme_comment_count: "326",
    aweme_share_count: "427",
    aweme_play_count: 1793580,
    aweme_activation: 0.5333,
    live_count: "168",
    live_time: 11779,
    live_watch_count: 68041,
    live_watch_time: 75601,
    live_like_count: "144674",
    live_comment_count: "8963",
    live_activation: 0.8333,
    live_fans_add: "822",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "银川大世界红旗汽车",
    company_name: "银川大世界红旗汽车销售有限公司",
    store_code: "XNX109",
    大区: "西部区",
    "省份-城市": "宁夏回族自治区-银川市",
    "所选分组编号/分组名称": "-",
    fans_count: "-1489",
    fans_count_total: "706554",
    aweme_count: "140",
    aweme_like_count: "1328",
    aweme_comment_count: "170",
    aweme_share_count: "93",
    aweme_play_count: 393504,
    aweme_activation: 0.9667,
    live_count: "144",
    live_time: 9073,
    live_watch_count: 619253,
    live_watch_time: 681261,
    live_like_count: "42128",
    live_comment_count: "6652",
    live_activation: 1,
    live_fans_add: "43",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "石家庄庞大华旗",
    company_name: "石家庄庞大华旗汽车销售有限公司",
    store_code: "NJI162",
    大区: "华北区",
    "省份-城市": "河北省-石家庄市",
    "所选分组编号/分组名称": "-",
    fans_count: "-3832",
    fans_count_total: "76225",
    aweme_count: "35",
    aweme_like_count: "5603",
    aweme_comment_count: "333",
    aweme_share_count: "270",
    aweme_play_count: 422963,
    aweme_activation: 0.6,
    live_count: "26",
    live_time: 1694,
    live_watch_count: 199498,
    live_watch_time: 221663,
    live_like_count: "341325",
    live_comment_count: "29734",
    live_activation: 0.5333,
    live_fans_add: "627",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "天津奥吉通红韵",
    company_name: "天津奥吉通红韵汽车销售有限公司",
    store_code: "NTJ025",
    大区: "华北区",
    "省份-城市": "天津市-天津市",
    "所选分组编号/分组名称": "-",
    fans_count: "2027",
    fans_count_total: "149529",
    aweme_count: "54",
    aweme_like_count: "736",
    aweme_comment_count: "68",
    aweme_share_count: "68",
    aweme_play_count: 1085762,
    aweme_activation: 0.6667,
    live_count: "73",
    live_time: 4418,
    live_watch_count: 666106,
    live_watch_time: 740117,
    live_like_count: "193675",
    live_comment_count: "10566",
    live_activation: 0.6,
    live_fans_add: "3306",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "重庆万家红旗",
    company_name: "重庆万家红枫汽车销售服务有限公司",
    store_code: "WCQ018",
    大区: "西部区",
    "省份-城市": "重庆市-重庆市",
    "所选分组编号/分组名称": "-",
    fans_count: "-47",
    fans_count_total: "210344",
    aweme_count: "88",
    aweme_like_count: "1224",
    aweme_comment_count: "192",
    aweme_share_count: "226",
    aweme_play_count: 572749,
    aweme_activation: 0.9,
    live_count: "123",
    live_time: 7591,
    live_watch_count: 177234,
    live_watch_time: 196926,
    live_like_count: "96425",
    live_comment_count: "5409",
    live_activation: 0.8667,
    live_fans_add: "655",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "南昌龙和",
    company_name: "南昌龙和汽车销售有限公司",
    store_code: "CJX600",
    大区: "中南区",
    "省份-城市": "江西省-南昌市",
    "所选分组编号/分组名称": "-",
    fans_count: "1440",
    fans_count_total: "29018",
    aweme_count: "78",
    aweme_like_count: "745",
    aweme_comment_count: "81",
    aweme_share_count: "124",
    aweme_play_count: 2133515,
    aweme_activation: 0.7667,
    live_count: "67",
    live_time: 4426,
    live_watch_count: 553295,
    live_watch_time: 610459,
    live_like_count: "150343",
    live_comment_count: "5131",
    live_activation: 0.9,
    live_fans_add: "670",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "长春通立红旗",
    company_name: "长春通立红旗汽车销售服务有限公司",
    store_code: "DJL603",
    大区: "东北区",
    "省份-城市": "吉林省-长春市",
    "所选分组编号/分组名称": "-",
    fans_count: "-1201",
    fans_count_total: "344895",
    aweme_count: "122",
    aweme_like_count: "6510",
    aweme_comment_count: "1605",
    aweme_share_count: "507",
    aweme_play_count: 1096098,
    aweme_activation: 0.9667,
    live_count: "113",
    live_time: 6957,
    live_watch_count: 157974,
    live_watch_time: 173950,
    live_like_count: "714801",
    live_comment_count: "7205",
    live_activation: 0.8333,
    live_fans_add: "208",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "福建华奥红旗",
    company_name: "福建华奥红旗汽车销售有限公司",
    store_code: "SFJ601",
    大区: "华南区",
    "省份-城市": "福建省-福州市",
    "所选分组编号/分组名称": "-",
    fans_count: "-42",
    fans_count_total: "43718",
    aweme_count: "108",
    aweme_like_count: "768",
    aweme_comment_count: "57",
    aweme_share_count: "24",
    aweme_play_count: 116117,
    aweme_activation: 1,
    live_count: "49",
    live_time: 2960,
    live_watch_count: 38232,
    live_watch_time: 42480,
    live_like_count: "29136",
    live_comment_count: "1304",
    live_activation: 0.8667,
    live_fans_add: "132",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "成都新元素红旗",
    company_name: "成都新元素红旗汽车销售服务有限公司",
    store_code: "WSC600",
    大区: "西部区",
    "省份-城市": "四川省-成都市",
    "所选分组编号/分组名称": "-",
    fans_count: "-813",
    fans_count_total: "408273",
    aweme_count: "51",
    aweme_like_count: "1298",
    aweme_comment_count: "205",
    aweme_share_count: "144",
    aweme_play_count: 575188,
    aweme_activation: 0.3667,
    live_count: "191",
    live_time: 11550,
    live_watch_count: 245630,
    live_watch_time: 271066,
    live_like_count: "160064",
    live_comment_count: "6387",
    live_activation: 1,
    live_fans_add: "755",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "北京中润发汽车",
    company_name: "北京中润发汽车",
    store_code: "NBJ601",
    大区: "华北区",
    "省份-城市": "北京市-北京市",
    "所选分组编号/分组名称": "-",
    fans_count: "6328",
    fans_count_total: "389125",
    aweme_count: "73",
    aweme_like_count: "9371",
    aweme_comment_count: "2199",
    aweme_share_count: "1334",
    aweme_play_count: 368049,
    aweme_activation: 0.8333,
    live_count: "99",
    live_time: 6252,
    live_watch_count: 992697,
    live_watch_time: 1092002,
    live_like_count: "1156329",
    live_comment_count: "35807",
    live_activation: 0.8667,
    live_fans_add: "16",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "上海旗泽",
    company_name: "上海旗泽汽车销售服务有限公司",
    store_code: "ESH607",
    大区: "华东区",
    "省份-城市": "上海市-上海市",
    "所选分组编号/分组名称": "-",
    fans_count: "86",
    fans_count_total: "15749",
    aweme_count: "62",
    aweme_like_count: "266",
    aweme_comment_count: "45",
    aweme_share_count: "44",
    aweme_play_count: 72310,
    aweme_activation: 0.7667,
    live_count: "69",
    live_time: 4213,
    live_watch_count: 3645,
    live_watch_time: 4045,
    live_like_count: "159472",
    live_comment_count: "2183",
    live_activation: 0.8,
    live_fans_add: "70",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "湖北长泽红旗",
    company_name: "湖北长泽汽车销售服务有限公司",
    store_code: "CHB600",
    大区: "中南区",
    "省份-城市": "湖北省-武汉市",
    "所选分组编号/分组名称": "-",
    fans_count: "-82",
    fans_count_total: "32027",
    aweme_count: "30",
    aweme_like_count: "101",
    aweme_comment_count: "20",
    aweme_share_count: "19",
    aweme_play_count: 33962,
    aweme_activation: 0.6667,
    live_count: "41",
    live_time: 2448,
    live_watch_count: 4979,
    live_watch_time: 5532,
    live_like_count: "274762",
    live_comment_count: "2350",
    live_activation: 0.8667,
    live_fans_add: "32",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "南通百恒红旗",
    company_name: "南通百恒汽车销售服务有限公司",
    store_code: "EJS602",
    大区: "华东区",
    "省份-城市": "江苏省-南通市",
    "所选分组编号/分组名称": "-",
    fans_count: "-37",
    fans_count_total: "103523",
    aweme_count: "76",
    aweme_like_count: "1018",
    aweme_comment_count: "220",
    aweme_share_count: "82",
    aweme_play_count: 434375,
    aweme_activation: 0.7667,
    live_count: "35",
    live_time: 2309,
    live_watch_count: 55959,
    live_watch_time: 62176,
    live_like_count: "31798",
    live_comment_count: "3902",
    live_activation: 0.7,
    live_fans_add: "197",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "南充明云红旗4S店",
    company_name: "南充明云日月宏新车业有限公司",
    store_code: "WSC603",
    大区: "西部区",
    "省份-城市": "四川省-南充市",
    "所选分组编号/分组名称": "-",
    fans_count: "867",
    fans_count_total: "100521",
    aweme_count: "77",
    aweme_like_count: "999",
    aweme_comment_count: "118",
    aweme_share_count: "73",
    aweme_play_count: 615560,
    aweme_activation: 0.7,
    live_count: "72",
    live_time: 4440,
    live_watch_count: 621237,
    live_watch_time: 683414,
    live_like_count: "31075",
    live_comment_count: "2938",
    live_activation: 0.9,
    live_fans_add: "20",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "兰州金岛红旗",
    company_name: "兰州金岛红旗汽车销售服务有限公司",
    store_code: "XGS600",
    大区: "西部区",
    "省份-城市": "甘肃省-兰州市",
    "所选分组编号/分组名称": "-",
    fans_count: "2890",
    fans_count_total: "101775",
    aweme_count: "247",
    aweme_like_count: "3480",
    aweme_comment_count: "644",
    aweme_share_count: "397",
    aweme_play_count: 1153391,
    aweme_activation: 1,
    live_count: "204",
    live_time: 16701,
    live_watch_count: 620859,
    live_watch_time: 684083,
    live_like_count: "210267",
    live_comment_count: "13126",
    live_activation: 1,
    live_fans_add: "882",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "临汾荣翔",
    company_name: "临汾荣翔汽车销售服务有限公司",
    store_code: "NJN602",
    大区: "华北区",
    "省份-城市": "山西省-临汾市",
    "所选分组编号/分组名称": "-",
    fans_count: "-274",
    fans_count_total: "139902",
    aweme_count: "63",
    aweme_like_count: "408",
    aweme_comment_count: "53",
    aweme_share_count: "12",
    aweme_play_count: 89677,
    aweme_activation: 0.7333,
    live_count: "53",
    live_time: 3161,
    live_watch_count: 5351,
    live_watch_time: 5902,
    live_like_count: "54323",
    live_comment_count: "676",
    live_activation: 0.5,
    live_fans_add: "40",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "达州天裕",
    company_name: "达州天裕汽车服务有限公司",
    store_code: "WSC601",
    大区: "西部区",
    "省份-城市": "四川省-达州市",
    "所选分组编号/分组名称": "-",
    fans_count: "251",
    fans_count_total: "37816",
    aweme_count: "46",
    aweme_like_count: "623",
    aweme_comment_count: "79",
    aweme_share_count: "18",
    aweme_play_count: 105764,
    aweme_activation: 0.7333,
    live_count: "45",
    live_time: 2916,
    live_watch_count: 124072,
    live_watch_time: 137857,
    live_like_count: "149581",
    live_comment_count: "3303",
    live_activation: 0.8667,
    live_fans_add: "231",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "重庆璐菲",
    company_name: "重庆璐菲汽车销售服务有限公司",
    store_code: "WCQ601",
    大区: "西部区",
    "省份-城市": "重庆市-重庆市",
    "所选分组编号/分组名称": "-",
    fans_count: "-3",
    fans_count_total: "2980",
    aweme_count: "60",
    aweme_like_count: "149",
    aweme_comment_count: "33",
    aweme_share_count: "23",
    aweme_play_count: 14125,
    aweme_activation: 0.8333,
    live_count: "21",
    live_time: 1376,
    live_watch_count: 1097,
    live_watch_time: 1218,
    live_like_count: "147",
    live_comment_count: "110",
    live_activation: 0.5667,
    live_fans_add: "4",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "驻马店祥诚红旗体验中心",
    company_name: "驻马店祥诚红旗体验中心",
    store_code: "NYU603",
    大区: "华北区",
    "省份-城市": "河南省-驻马店市",
    "所选分组编号/分组名称": "-",
    fans_count: "1024",
    fans_count_total: "57619",
    aweme_count: "40",
    aweme_like_count: "239",
    aweme_comment_count: "30",
    aweme_share_count: "44",
    aweme_play_count: 153638,
    aweme_activation: 0.8,
    live_count: "46",
    live_time: 2888,
    live_watch_count: 201187,
    live_watch_time: 221340,
    live_like_count: "11778",
    live_comment_count: "1213",
    live_activation: 0.5667,
    live_fans_add: "41",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "昆山联合红旗",
    company_name: "昆山联合红旗汽车销售有限公司",
    store_code: "EJS605",
    大区: "华东区",
    "省份-城市": "江苏省-苏州市",
    "所选分组编号/分组名称": "-",
    fans_count: "407",
    fans_count_total: "27121",
    aweme_count: "43",
    aweme_like_count: "546",
    aweme_comment_count: "78",
    aweme_share_count: "21",
    aweme_play_count: 428208,
    aweme_activation: 1,
    live_count: "42",
    live_time: 2605,
    live_watch_count: 54555,
    live_watch_time: 60617,
    live_like_count: "71204",
    live_comment_count: "4096",
    live_activation: 0.8333,
    live_fans_add: "377",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "陕西奥诚红旗",
    company_name: "陕西奥诚红旗汽车销售服务有限公司",
    store_code: "XSS601",
    大区: "西部区",
    "省份-城市": "陕西省-西安市",
    "所选分组编号/分组名称": "-",
    fans_count: "1522",
    fans_count_total: "18410",
    aweme_count: "181",
    aweme_like_count: "2958",
    aweme_comment_count: "374",
    aweme_share_count: "304",
    aweme_play_count: 975789,
    aweme_activation: 0.8667,
    live_count: "151",
    live_time: 9353,
    live_watch_count: 56573,
    live_watch_time: 62838,
    live_like_count: "17612",
    live_comment_count: "4192",
    live_activation: 0.9667,
    live_fans_add: "499",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "怀化旗通",
    company_name: "怀化市旗通汽车贸易有限公司",
    store_code: "CHN602",
    大区: "中南区",
    "省份-城市": "湖南省-怀化市",
    "所选分组编号/分组名称": "-",
    fans_count: "574",
    fans_count_total: "23084",
    aweme_count: "130",
    aweme_like_count: "1739",
    aweme_comment_count: "352",
    aweme_share_count: "69",
    aweme_play_count: 443396,
    aweme_activation: 0.7333,
    live_count: "63",
    live_time: 5721,
    live_watch_count: 204856,
    live_watch_time: 227617,
    live_like_count: "98636",
    live_comment_count: "3231",
    live_activation: 0.9333,
    live_fans_add: "622",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "巴中先锋恒远",
    company_name: "巴中先锋恒远汽车服务有限公司",
    store_code: "WSC604",
    大区: "西部区",
    "省份-城市": "四川省-巴中市",
    "所选分组编号/分组名称": "-",
    fans_count: "319",
    fans_count_total: "32832",
    aweme_count: "64",
    aweme_like_count: "1132",
    aweme_comment_count: "344",
    aweme_share_count: "53",
    aweme_play_count: 1006048,
    aweme_activation: 0.8333,
    live_count: "86",
    live_time: 5281,
    live_watch_count: 41046,
    live_watch_time: 45601,
    live_like_count: "31589",
    live_comment_count: "8083",
    live_activation: 0.8667,
    live_fans_add: "304",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "济南泊思",
    company_name: "济南泊思",
    store_code: "NSD601",
    大区: "东北区",
    "省份-城市": "山东省-济南市",
    "所选分组编号/分组名称": "-",
    fans_count: "-2",
    fans_count_total: "80736",
    aweme_count: "69",
    aweme_like_count: "607",
    aweme_comment_count: "65",
    aweme_share_count: "70",
    aweme_play_count: 312295,
    aweme_activation: 0.6333,
    live_count: "79",
    live_time: 4364,
    live_watch_count: 27592,
    live_watch_time: 30626,
    live_like_count: "35491",
    live_comment_count: "2277",
    live_activation: 0.6333,
    live_fans_add: "254",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "山西大昌宏源红旗体验中心",
    company_name: "山西大昌宏源红旗体验中心",
    store_code: "NJN603",
    大区: "华北区",
    "省份-城市": "山西省-太原市",
    "所选分组编号/分组名称": "-",
    fans_count: "305",
    fans_count_total: "28106",
    aweme_count: "87",
    aweme_like_count: "477",
    aweme_comment_count: "59",
    aweme_share_count: "28",
    aweme_play_count: 198702,
    aweme_activation: 0.6667,
    live_count: "55",
    live_time: 3431,
    live_watch_count: 97136,
    live_watch_time: 107929,
    live_like_count: "70760",
    live_comment_count: "2283",
    live_activation: 0.5333,
    live_fans_add: "220",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "义乌市正通",
    company_name: "义乌市正通汽车销售服务有限公司",
    store_code: "EZJ602",
    大区: "华东区",
    "省份-城市": "浙江省-金华市",
    "所选分组编号/分组名称": "-",
    fans_count: "-1575",
    fans_count_total: "644729",
    aweme_count: "36",
    aweme_like_count: "266",
    aweme_comment_count: "43",
    aweme_share_count: "29",
    aweme_play_count: 116099,
    aweme_activation: 0.4667,
    live_count: "13",
    live_time: 803,
    live_watch_count: 2548,
    live_watch_time: 2831,
    live_like_count: "34090",
    live_comment_count: "1477",
    live_activation: 0.3333,
    live_fans_add: "35",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "常州外汽红豪",
    company_name: "常州外汽红豪汽车销售服务有限公司",
    store_code: "EJS604",
    大区: "华东区",
    "省份-城市": "江苏省-常州市",
    "所选分组编号/分组名称": "-",
    fans_count: "53",
    fans_count_total: "13831",
    aweme_count: "59",
    aweme_like_count: "576",
    aweme_comment_count: "73",
    aweme_share_count: "22",
    aweme_play_count: 278697,
    aweme_activation: 0.8,
    live_count: "59",
    live_time: 3808,
    live_watch_count: 9086,
    live_watch_time: 10095,
    live_like_count: "84933",
    live_comment_count: "2305",
    live_activation: 0.9333,
    live_fans_add: "90",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "烟台鸿旗",
    company_name: "烟台鸿旗汽车销售服务有限公司",
    store_code: "NSD603",
    大区: "东北区",
    "省份-城市": "山东省-烟台市",
    "所选分组编号/分组名称": "-",
    fans_count: "289",
    fans_count_total: "47401",
    aweme_count: "84",
    aweme_like_count: "452",
    aweme_comment_count: "65",
    aweme_share_count: "44",
    aweme_play_count: 277060,
    aweme_activation: 0.6667,
    live_count: "63",
    live_time: 3840,
    live_watch_count: 20347,
    live_watch_time: 22606,
    live_like_count: "9889",
    live_comment_count: "2578",
    live_activation: 0.7667,
    live_fans_add: "337",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "武汉东瑞红旗体验中心",
    company_name: "武汉市东瑞汽车销售服务有限公司",
    store_code: "CHB604",
    大区: "中南区",
    "省份-城市": "湖北省-武汉市",
    "所选分组编号/分组名称": "-",
    fans_count: "860",
    fans_count_total: "31772",
    aweme_count: "66",
    aweme_like_count: "693",
    aweme_comment_count: "168",
    aweme_share_count: "92",
    aweme_play_count: 482739,
    aweme_activation: 0.7333,
    live_count: "43",
    live_time: 2658,
    live_watch_count: 12092,
    live_watch_time: 13435,
    live_like_count: "64623",
    live_comment_count: "2905",
    live_activation: 0.8667,
    live_fans_add: "301",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "宜宾吉茂",
    company_name: "宜宾吉茂汽车销售服务有限公司",
    store_code: "WSC606",
    大区: "西部区",
    "省份-城市": "四川省-宜宾市",
    "所选分组编号/分组名称": "-",
    fans_count: "-185",
    fans_count_total: "62844",
    aweme_count: "77",
    aweme_like_count: "911",
    aweme_comment_count: "207",
    aweme_share_count: "19",
    aweme_play_count: 144517,
    aweme_activation: 0.5333,
    live_count: "64",
    live_time: 3803,
    live_watch_count: 9596,
    live_watch_time: 10657,
    live_like_count: "24345",
    live_comment_count: "2147",
    live_activation: 0.5667,
    live_fans_add: "47",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "惠州市通利华",
    company_name: "惠州市通利华实业有限公司",
    store_code: "SGD606",
    大区: "华南区",
    "省份-城市": "广东省-惠州市",
    "所选分组编号/分组名称": "-",
    fans_count: "-801",
    fans_count_total: "272617",
    aweme_count: "71",
    aweme_like_count: "322",
    aweme_comment_count: "25",
    aweme_share_count: "58",
    aweme_play_count: 51028,
    aweme_activation: 0.8,
    live_count: "74",
    live_time: 5093,
    live_watch_count: 8561,
    live_watch_time: 9512,
    live_like_count: "64632",
    live_comment_count: "2433",
    live_activation: 1,
    live_fans_add: "54",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "中山市中升红旗",
    company_name: "中山市中升汽车销售服务有限公司",
    store_code: "SGD604",
    大区: "华南区",
    "省份-城市": "广东省-中山市",
    "所选分组编号/分组名称": "-",
    fans_count: "172",
    fans_count_total: "38754",
    aweme_count: "98",
    aweme_like_count: "652",
    aweme_comment_count: "42",
    aweme_share_count: "38",
    aweme_play_count: 59135,
    aweme_activation: 0.9,
    live_count: "69",
    live_time: 4384,
    live_watch_count: 33444,
    live_watch_time: 37156,
    live_like_count: "12753",
    live_comment_count: "3851",
    live_activation: 0.8333,
    live_fans_add: "377",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "昆明海伟宏亦",
    company_name: "昆明海伟宏亦汽车销售有限公司",
    store_code: "WYN603",
    大区: "西部区",
    "省份-城市": "云南省-昆明市",
    "所选分组编号/分组名称": "-",
    fans_count: "599",
    fans_count_total: "146873",
    aweme_count: "44",
    aweme_like_count: "1847",
    aweme_comment_count: "223",
    aweme_share_count: "125",
    aweme_play_count: 595243,
    aweme_activation: 0.6333,
    live_count: "49",
    live_time: 2883,
    live_watch_count: 216033,
    live_watch_time: 240036,
    live_like_count: "307522",
    live_comment_count: "9016",
    live_activation: 0.6667,
    live_fans_add: "1041",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "赣州凯迪红旗体验中心",
    company_name: "赣州市凯迪汽车销售服务有限公司",
    store_code: "CJX601",
    大区: "中南区",
    "省份-城市": "江西省-赣州市",
    "所选分组编号/分组名称": "-",
    fans_count: "256",
    fans_count_total: "24442",
    aweme_count: "60",
    aweme_like_count: "2119",
    aweme_comment_count: "129",
    aweme_share_count: "109",
    aweme_play_count: 227825,
    aweme_activation: 0.8333,
    live_count: "72",
    live_time: 4584,
    live_watch_count: 10554,
    live_watch_time: 11726,
    live_like_count: "244159",
    live_comment_count: "14364",
    live_activation: 0.7333,
    live_fans_add: "108",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "贵州大雍峻辰",
    company_name: "贵州大雍峻辰汽车销售有限公司",
    store_code: "WGZ602",
    大区: "西部区",
    "省份-城市": "贵州省-贵阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "542",
    fans_count_total: "75483",
    aweme_count: "103",
    aweme_like_count: "5327",
    aweme_comment_count: "1566",
    aweme_share_count: "1214",
    aweme_play_count: 1741197,
    aweme_activation: 0.8,
    live_count: "68",
    live_time: 4667,
    live_watch_count: 205409,
    live_watch_time: 228225,
    live_like_count: "353169",
    live_comment_count: "11295",
    live_activation: 0.8667,
    live_fans_add: "882",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "宁波鑫之旗",
    company_name: "宁波鑫之旗汽车有限公司",
    store_code: "EZJ603",
    大区: "华东区",
    "省份-城市": "浙江省-宁波市",
    "所选分组编号/分组名称": "-",
    fans_count: "-125",
    fans_count_total: "179295",
    aweme_count: "145",
    aweme_like_count: "1563",
    aweme_comment_count: "399",
    aweme_share_count: "149",
    aweme_play_count: 2021681,
    aweme_activation: 0.7,
    live_count: "54",
    live_time: 3364,
    live_watch_count: 44777,
    live_watch_time: 49748,
    live_like_count: "62845",
    live_comment_count: "4991",
    live_activation: 0.6333,
    live_fans_add: "244",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "上海东昌宏旗",
    company_name: "上海东昌宏旗汽车服务有限公司",
    store_code: "ESH608",
    大区: "华东区",
    "省份-城市": "上海市-上海市",
    "所选分组编号/分组名称": "-",
    fans_count: "-255",
    fans_count_total: "40661",
    aweme_count: "68",
    aweme_like_count: "267",
    aweme_comment_count: "36",
    aweme_share_count: "17",
    aweme_play_count: 114359,
    aweme_activation: 0.9,
    live_count: "27",
    live_time: 1691,
    live_watch_count: 6754,
    live_watch_time: 7504,
    live_like_count: "125859",
    live_comment_count: "4943",
    live_activation: 0.6,
    live_fans_add: "53",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "遂宁清巍瑞祥",
    company_name: "遂宁清巍瑞祥汽车销售服务有限公司",
    store_code: "WSC608",
    大区: "西部区",
    "省份-城市": "四川省-遂宁市",
    "所选分组编号/分组名称": "-",
    fans_count: "264",
    fans_count_total: "12725",
    aweme_count: "52",
    aweme_like_count: "1423",
    aweme_comment_count: "75",
    aweme_share_count: "67",
    aweme_play_count: 1548943,
    aweme_activation: 0.6667,
    live_count: "69",
    live_time: 4284,
    live_watch_count: 15766,
    live_watch_time: 17513,
    live_like_count: "19086",
    live_comment_count: "1430",
    live_activation: 0.8,
    live_fans_add: "54",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "福建赢宸",
    company_name: "福建赢宸汽车销售服务有限公司",
    store_code: "SFJ602",
    大区: "华南区",
    "省份-城市": "福建省-南平市",
    "所选分组编号/分组名称": "-",
    fans_count: "-62",
    fans_count_total: "17842",
    aweme_count: "52",
    aweme_like_count: "134",
    aweme_comment_count: "40",
    aweme_share_count: "15",
    aweme_play_count: 18998,
    aweme_activation: 0.7667,
    live_count: "48",
    live_time: 2821,
    live_watch_count: 1756,
    live_watch_time: 1951,
    live_like_count: "3458",
    live_comment_count: "744",
    live_activation: 0.8667,
    live_fans_add: "11",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "西宁金岛红旗",
    company_name: "西宁金岛红旗汽车销售服务有限公司",
    store_code: "XQH600",
    大区: "西部区",
    "省份-城市": "青海省-西宁市",
    "所选分组编号/分组名称": "-",
    fans_count: "367",
    fans_count_total: "6859",
    aweme_count: "202",
    aweme_like_count: "1106",
    aweme_comment_count: "143",
    aweme_share_count: "105",
    aweme_play_count: 389368,
    aweme_activation: 0.8,
    live_count: "75",
    live_time: 4676,
    live_watch_count: 15491,
    live_watch_time: 17139,
    live_like_count: "316063",
    live_comment_count: "15824",
    live_activation: 0.9,
    live_fans_add: "306",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "安徽博融众旗",
    company_name: "安徽博融众旗汽车销售服务有限公司",
    store_code: "EAH602",
    大区: "华东区",
    "省份-城市": "安徽省-合肥市",
    "所选分组编号/分组名称": "-",
    fans_count: "-73",
    fans_count_total: "54600",
    aweme_count: "71",
    aweme_like_count: "567",
    aweme_comment_count: "50",
    aweme_share_count: "47",
    aweme_play_count: 196544,
    aweme_activation: 0.8333,
    live_count: "106",
    live_time: 6462,
    live_watch_count: 39354,
    live_watch_time: 43726,
    live_like_count: "10322",
    live_comment_count: "4563",
    live_activation: 1,
    live_fans_add: "203",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "广东鸿粤益嘉店",
    company_name: "广东鸿粤益嘉汽车销售服务有限公司",
    store_code: "SGD603",
    大区: "华南区",
    "省份-城市": "广东省-广州市",
    "所选分组编号/分组名称": "-",
    fans_count: "298",
    fans_count_total: "53292",
    aweme_count: "52",
    aweme_like_count: "1778",
    aweme_comment_count: "215",
    aweme_share_count: "179",
    aweme_play_count: 815391,
    aweme_activation: 0.5,
    live_count: "57",
    live_time: 3499,
    live_watch_count: 19117,
    live_watch_time: 21241,
    live_like_count: "178077",
    live_comment_count: "4874",
    live_activation: 0.8,
    live_fans_add: "165",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "济宁天禧",
    company_name: "济宁天禧汽车贸易有限公司",
    store_code: "NSD600",
    大区: "东北区",
    "省份-城市": "山东省-济宁市",
    "所选分组编号/分组名称": "-",
    fans_count: "-934",
    fans_count_total: "411608",
    aweme_count: "91",
    aweme_like_count: "344",
    aweme_comment_count: "32",
    aweme_share_count: "49",
    aweme_play_count: 102747,
    aweme_activation: 0.9,
    live_count: "75",
    live_time: 4692,
    live_watch_count: 58623,
    live_watch_time: 64560,
    live_like_count: "115313",
    live_comment_count: "2986",
    live_activation: 0.8333,
    live_fans_add: "80",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "宜昌市华健晟旗",
    company_name: "宜昌市华健晟旗汽车销售服务有限责任公司",
    store_code: "CHB605",
    大区: "中南区",
    "省份-城市": "湖北省-宜昌市",
    "所选分组编号/分组名称": "-",
    fans_count: "103",
    fans_count_total: "33933",
    aweme_count: "30",
    aweme_like_count: "568",
    aweme_comment_count: "118",
    aweme_share_count: "36",
    aweme_play_count: 172298,
    aweme_activation: 1,
    live_count: "25",
    live_time: 1598,
    live_watch_count: 1495,
    live_watch_time: 1661,
    live_like_count: "13654",
    live_comment_count: "594",
    live_activation: 0.8667,
    live_fans_add: "20",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "许昌恒旭红旗4s店",
    company_name: "许昌市恒旭汽车销售服务有限公司",
    store_code: "NYU604",
    大区: "华北区",
    "省份-城市": "河南省-许昌市",
    "所选分组编号/分组名称": "-",
    fans_count: "636",
    fans_count_total: "156518",
    aweme_count: "76",
    aweme_like_count: "458",
    aweme_comment_count: "102",
    aweme_share_count: "28",
    aweme_play_count: 93033,
    aweme_activation: 0.7667,
    live_count: "105",
    live_time: 5670,
    live_watch_count: 622023,
    live_watch_time: 684777,
    live_like_count: "30982",
    live_comment_count: "3744",
    live_activation: 0.8667,
    live_fans_add: "437",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "保定中冀华达红旗体验中心",
    company_name: "保定市华达汽车销售服务有限公司",
    store_code: "NJI600",
    大区: "华北区",
    "省份-城市": "河北省-保定市",
    "所选分组编号/分组名称": "-",
    fans_count: "72",
    fans_count_total: "94428",
    aweme_count: "101",
    aweme_like_count: "586",
    aweme_comment_count: "39",
    aweme_share_count: "10",
    aweme_play_count: 54301,
    aweme_activation: 0.5333,
    live_count: "213",
    live_time: 18001,
    live_watch_count: 60903,
    live_watch_time: 67648,
    live_like_count: "102298",
    live_comment_count: "8193",
    live_activation: 0.8333,
    live_fans_add: "382",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "临沂美华红旗",
    company_name: "临沂美华汽车销售服务有限公司",
    store_code: "HSD603",
    大区: "东北区",
    "省份-城市": "山东省-临沂市",
    "所选分组编号/分组名称": "-",
    fans_count: "-3831",
    fans_count_total: "1291248",
    aweme_count: "84",
    aweme_like_count: "1397",
    aweme_comment_count: "182",
    aweme_share_count: "155",
    aweme_play_count: 594872,
    aweme_activation: 0.6,
    live_count: "56",
    live_time: 3543,
    live_watch_count: 44772,
    live_watch_time: 49298,
    live_like_count: "65275",
    live_comment_count: "2888",
    live_activation: 0.8333,
    live_fans_add: "73",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "重庆九禾缘红旗",
    company_name: "重庆九禾缘汽车销售服务有限公司",
    store_code: "WCQ600",
    大区: "西部区",
    "省份-城市": "重庆市-重庆市",
    "所选分组编号/分组名称": "-",
    fans_count: "362",
    fans_count_total: "8240",
    aweme_count: "43",
    aweme_like_count: "519",
    aweme_comment_count: "48",
    aweme_share_count: "8",
    aweme_play_count: 201214,
    aweme_activation: 0.7667,
    live_count: "49",
    live_time: 3123,
    live_watch_count: 8614,
    live_watch_time: 9571,
    live_like_count: "145889",
    live_comment_count: "3924",
    live_activation: 0.8333,
    live_fans_add: "140",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "湖北英驰红旗",
    company_name: "湖北英驰汽车集团有限公司",
    store_code: "CHB601",
    大区: "中南区",
    "省份-城市": "湖北省-襄阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "296",
    fans_count_total: "28806",
    aweme_count: "165",
    aweme_like_count: "1040",
    aweme_comment_count: "191",
    aweme_share_count: "81",
    aweme_play_count: 451291,
    aweme_activation: 0.6,
    live_count: "86",
    live_time: 5501,
    live_watch_count: 28222,
    live_watch_time: 31357,
    live_like_count: "76327",
    live_comment_count: "4830",
    live_activation: 0.8667,
    live_fans_add: "265",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "宝鸡威凯红旗",
    company_name: "宝鸡威凯红旗汽车销售服务有限公司",
    store_code: "XSS604",
    大区: "西部区",
    "省份-城市": "陕西省-宝鸡市",
    "所选分组编号/分组名称": "-",
    fans_count: "188",
    fans_count_total: "7773",
    aweme_count: "252",
    aweme_like_count: "1807",
    aweme_comment_count: "109",
    aweme_share_count: "33",
    aweme_play_count: 299093,
    aweme_activation: 0.9,
    live_count: "58",
    live_time: 3243,
    live_watch_count: 11783,
    live_watch_time: 13092,
    live_like_count: "75819",
    live_comment_count: "1641",
    live_activation: 0.8667,
    live_fans_add: "73",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "云南宏通达红旗体验中心",
    company_name: "云南宏通达汽车销售服务有限公司",
    store_code: "WYN600",
    大区: "西部区",
    "省份-城市": "云南省-昆明市",
    "所选分组编号/分组名称": "-",
    fans_count: "151",
    fans_count_total: "36207",
    aweme_count: "106",
    aweme_like_count: "720",
    aweme_comment_count: "46",
    aweme_share_count: "56",
    aweme_play_count: 187654,
    aweme_activation: 1,
    live_count: "70",
    live_time: 4329,
    live_watch_count: 113553,
    live_watch_time: 126152,
    live_like_count: "65819",
    live_comment_count: "1775",
    live_activation: 0.8,
    live_fans_add: "189",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "东莞德现",
    company_name: "东莞德现汽车销售服务有限公司",
    store_code: "SGD607",
    大区: "华南区",
    "省份-城市": "广东省-东莞市",
    "所选分组编号/分组名称": "-",
    fans_count: "97",
    fans_count_total: "52358",
    aweme_count: "65",
    aweme_like_count: "796",
    aweme_comment_count: "44",
    aweme_share_count: "43",
    aweme_play_count: 60023,
    aweme_activation: 0.7,
    live_count: "29",
    live_time: 1780,
    live_watch_count: 8977,
    live_watch_time: 9974,
    live_like_count: "31569",
    live_comment_count: "2423",
    live_activation: 0.8333,
    live_fans_add: "126",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "商丘市恒美红旗体验中心",
    company_name: "商丘市恒美红旗体验中心",
    store_code: "NYU606",
    大区: "华北区",
    "省份-城市": "河南省-商丘市",
    "所选分组编号/分组名称": "-",
    fans_count: "134",
    fans_count_total: "48674",
    aweme_count: "76",
    aweme_like_count: "378",
    aweme_comment_count: "55",
    aweme_share_count: "68",
    aweme_play_count: 1834621,
    aweme_activation: 0.8,
    live_count: "56",
    live_time: 3411,
    live_watch_count: 100357,
    live_watch_time: 110433,
    live_like_count: "121921",
    live_comment_count: "4168",
    live_activation: 0.8667,
    live_fans_add: "41",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "浙江裕旗",
    company_name: "浙江裕旗汽车有限公司",
    store_code: "EZJ606",
    大区: "华东区",
    "省份-城市": "浙江省-杭州市",
    "所选分组编号/分组名称": "-",
    fans_count: "-1354",
    fans_count_total: "521433",
    aweme_count: "120",
    aweme_like_count: "1156",
    aweme_comment_count: "71",
    aweme_share_count: "81",
    aweme_play_count: 232326,
    aweme_activation: 0.9667,
    live_count: "76",
    live_time: 5179,
    live_watch_count: 74545,
    live_watch_time: 82809,
    live_like_count: "29864",
    live_comment_count: "5091",
    live_activation: 0.8333,
    live_fans_add: "467",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "运城大昌红旗体验中心",
    company_name: "运城大昌宏源汽车销售服务有限公司",
    store_code: "NJN604",
    大区: "华北区",
    "省份-城市": "山西省-运城市",
    "所选分组编号/分组名称": "-",
    fans_count: "15",
    fans_count_total: "9577",
    aweme_count: "93",
    aweme_like_count: "247",
    aweme_comment_count: "36",
    aweme_share_count: "30",
    aweme_play_count: 43961,
    aweme_activation: 1,
    live_count: "60",
    live_time: 3684,
    live_watch_count: 110435,
    live_watch_time: 122702,
    live_like_count: "103598",
    live_comment_count: "4374",
    live_activation: 0.9333,
    live_fans_add: "146",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "湖南兰天天旗",
    company_name: "湖南兰天天旗",
    store_code: "CHN603",
    大区: "中南区",
    "省份-城市": "湖南省-长沙市",
    "所选分组编号/分组名称": "-",
    fans_count: "1243",
    fans_count_total: "33237",
    aweme_count: "71",
    aweme_like_count: "720",
    aweme_comment_count: "154",
    aweme_share_count: "51",
    aweme_play_count: 532356,
    aweme_activation: 0.7333,
    live_count: "62",
    live_time: 3897,
    live_watch_count: 131632,
    live_watch_time: 145134,
    live_like_count: "139059",
    live_comment_count: "4963",
    live_activation: 0.8667,
    live_fans_add: "353",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "内蒙古思旗红旗体验中心",
    company_name: "内蒙古思旗汽车销售有限责任公司",
    store_code: "DNM601",
    大区: "华北区",
    "省份-城市": "内蒙古自治区-呼和浩特市",
    "所选分组编号/分组名称": "-",
    fans_count: "-363",
    fans_count_total: "406412",
    aweme_count: "151",
    aweme_like_count: "7542",
    aweme_comment_count: "7391",
    aweme_share_count: "4632",
    aweme_play_count: 740976,
    aweme_activation: 1,
    live_count: "109",
    live_time: 7351,
    live_watch_count: 536434,
    live_watch_time: 593549,
    live_like_count: "193198",
    live_comment_count: "6293",
    live_activation: 0.9333,
    live_fans_add: "356",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "远达红旗",
    company_name: "聊城远达汽车销售服务有限公司",
    store_code: "NSD602",
    大区: "东北区",
    "省份-城市": "山东省-聊城市",
    "所选分组编号/分组名称": "-",
    fans_count: "-69",
    fans_count_total: "23099",
    aweme_count: "60",
    aweme_like_count: "445",
    aweme_comment_count: "22",
    aweme_share_count: "69",
    aweme_play_count: 52030,
    aweme_activation: 0.8333,
    live_count: "35",
    live_time: 2114,
    live_watch_count: 10946,
    live_watch_time: 12044,
    live_like_count: "1234",
    live_comment_count: "108",
    live_activation: 0.6667,
    live_fans_add: "1",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "衡阳恒宇红旗",
    company_name: "衡阳市恒宇汽车销售服务有限公司",
    store_code: "CHN604",
    大区: "中南区",
    "省份-城市": "湖南省-衡阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "592",
    fans_count_total: "22044",
    aweme_count: "149",
    aweme_like_count: "1206",
    aweme_comment_count: "405",
    aweme_share_count: "128",
    aweme_play_count: 195031,
    aweme_activation: 0.7667,
    live_count: "50",
    live_time: 3113,
    live_watch_count: 136523,
    live_watch_time: 151692,
    live_like_count: "173396",
    live_comment_count: "4022",
    live_activation: 0.9,
    live_fans_add: "447",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "长治大昌红旗体验中心",
    company_name: "长治市大昌汽车销售服务有限公司",
    store_code: "NJN605",
    大区: "华北区",
    "省份-城市": "山西省-长治市",
    "所选分组编号/分组名称": "-",
    fans_count: "315",
    fans_count_total: "25715",
    aweme_count: "99",
    aweme_like_count: "652",
    aweme_comment_count: "105",
    aweme_share_count: "64",
    aweme_play_count: 268252,
    aweme_activation: 0.6667,
    live_count: "56",
    live_time: 3538,
    live_watch_count: 104189,
    live_watch_time: 115765,
    live_like_count: "108912",
    live_comment_count: "3882",
    live_activation: 0.8333,
    live_fans_add: "209",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "邢台邦华",
    company_name: "邢台邦华汽车销售服务有限公司",
    store_code: "NJI601",
    大区: "华北区",
    "省份-城市": "河北省-邢台市",
    "所选分组编号/分组名称": "-",
    fans_count: "468",
    fans_count_total: "23195",
    aweme_count: "98",
    aweme_like_count: "1178",
    aweme_comment_count: "163",
    aweme_share_count: "122",
    aweme_play_count: 248228,
    aweme_activation: 0.7,
    live_count: "190",
    live_time: 16089,
    live_watch_count: 30472,
    live_watch_time: 33807,
    live_like_count: "94109",
    live_comment_count: "10051",
    live_activation: 0.9333,
    live_fans_add: "292",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "大连通洲",
    company_name: "大连通洲汽车销售有限公司",
    store_code: "DLN601",
    大区: "东北区",
    "省份-城市": "辽宁省-大连市",
    "所选分组编号/分组名称": "-",
    fans_count: "-44",
    fans_count_total: "36173",
    aweme_count: "93",
    aweme_like_count: "241",
    aweme_comment_count: "31",
    aweme_share_count: "5",
    aweme_play_count: 26400,
    aweme_activation: 0.8,
    live_count: "66",
    live_time: 4127,
    live_watch_count: 14329,
    live_watch_time: 15914,
    live_like_count: "36981",
    live_comment_count: "1714",
    live_activation: 0.7667,
    live_fans_add: "92",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "包头市宏腾红旗体验中心",
    company_name: "包头市宏腾汽车销售服务有限公司",
    store_code: "DNM602",
    大区: "华北区",
    "省份-城市": "内蒙古自治区-包头市",
    "所选分组编号/分组名称": "-",
    fans_count: "344",
    fans_count_total: "4828",
    aweme_count: "68",
    aweme_like_count: "353",
    aweme_comment_count: "45",
    aweme_share_count: "42",
    aweme_play_count: 387289,
    aweme_activation: 0.7333,
    live_count: "54",
    live_time: 3461,
    live_watch_count: 12427,
    live_watch_time: 13807,
    live_like_count: "11223",
    live_comment_count: "4109",
    live_activation: 0.9333,
    live_fans_add: "146",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "兴安盟华盛",
    company_name: "兴安盟华盛汽车销售服务有限公司",
    store_code: "DNM603",
    大区: "东北区",
    "省份-城市": "内蒙古自治区-兴安盟",
    "所选分组编号/分组名称": "-",
    fans_count: "1026",
    fans_count_total: "56196",
    aweme_count: "117",
    aweme_like_count: "931",
    aweme_comment_count: "199",
    aweme_share_count: "101",
    aweme_play_count: 260456,
    aweme_activation: 0.9333,
    live_count: "56",
    live_time: 2931,
    live_watch_count: 130003,
    live_watch_time: 143033,
    live_like_count: "88348",
    live_comment_count: "4630",
    live_activation: 0.7667,
    live_fans_add: "24",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "大同大昌宏源",
    company_name: "大同大昌宏源汽车销售服务有限公司",
    store_code: "NJN606",
    大区: "华北区",
    "省份-城市": "山西省-大同市",
    "所选分组编号/分组名称": "-",
    fans_count: "232",
    fans_count_total: "11093",
    aweme_count: "63",
    aweme_like_count: "207",
    aweme_comment_count: "23",
    aweme_share_count: "5",
    aweme_play_count: 125629,
    aweme_activation: 0.9667,
    live_count: "64",
    live_time: 3975,
    live_watch_count: 143366,
    live_watch_time: 159235,
    live_like_count: "111692",
    live_comment_count: "2436",
    live_activation: 0.8,
    live_fans_add: "221",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "辽阳红兴红旗4S店",
    company_name: "辽阳红兴汽车销售服务有限公司",
    store_code: "DLN602",
    大区: "东北区",
    "省份-城市": "辽宁省-辽阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "248",
    fans_count_total: "236117",
    aweme_count: "41",
    aweme_like_count: "1142",
    aweme_comment_count: "147",
    aweme_share_count: "69",
    aweme_play_count: 167389,
    aweme_activation: 0.6,
    live_count: "53",
    live_time: 3214,
    live_watch_count: 124897,
    live_watch_time: 137393,
    live_like_count: "83154",
    live_comment_count: "6375",
    live_activation: 0.8,
    live_fans_add: "17",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "新疆天汇华辉",
    company_name: "新疆天汇华辉汽车销售服务有限公司",
    store_code: "XXJ600",
    大区: "西部区",
    "省份-城市": "新疆维吾尔自治区-乌鲁木齐市",
    "所选分组编号/分组名称": "-",
    fans_count: "-1499",
    fans_count_total: "364455",
    aweme_count: "65",
    aweme_like_count: "387",
    aweme_comment_count: "31",
    aweme_share_count: "56",
    aweme_play_count: 48985,
    aweme_activation: 0.5333,
    live_count: "65",
    live_time: 4081,
    live_watch_count: 4355,
    live_watch_time: 4822,
    live_like_count: "13785",
    live_comment_count: "125",
    live_activation: 0.7,
    live_fans_add: "6",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "秦皇岛瑞通嘉禾",
    company_name: "秦皇岛瑞通嘉禾汽车销售服务有限公司",
    store_code: "NJI602",
    大区: "华北区",
    "省份-城市": "河北省-秦皇岛市",
    "所选分组编号/分组名称": "-",
    fans_count: "3108",
    fans_count_total: "200618",
    aweme_count: "51",
    aweme_like_count: "171",
    aweme_comment_count: "31",
    aweme_share_count: "110",
    aweme_play_count: 308952,
    aweme_activation: 0.6667,
    live_count: "92",
    live_time: 6474,
    live_watch_count: 797365,
    live_watch_time: 878186,
    live_like_count: "699077",
    live_comment_count: "19451",
    live_activation: 0.8,
    live_fans_add: "838",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "安庆市天位",
    company_name: "安庆市天位汽车销售服务有限公司",
    store_code: "EAH605",
    大区: "华东区",
    "省份-城市": "安徽省-安庆市",
    "所选分组编号/分组名称": "-",
    fans_count: "-364",
    fans_count_total: "485211",
    aweme_count: "90",
    aweme_like_count: "471",
    aweme_comment_count: "59",
    aweme_share_count: "64",
    aweme_play_count: 263107,
    aweme_activation: 0.6333,
    live_count: "30",
    live_time: 1599,
    live_watch_count: 2507,
    live_watch_time: 2786,
    live_like_count: "3517",
    live_comment_count: "90",
    live_activation: 0.4667,
    live_fans_add: "9",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "泉州同行红旗",
    company_name: "泉州市同行汽车销售有限公司",
    store_code: "SFJ603",
    大区: "华南区",
    "省份-城市": "福建省-泉州市",
    "所选分组编号/分组名称": "-",
    fans_count: "885",
    fans_count_total: "97498",
    aweme_count: "76",
    aweme_like_count: "2768",
    aweme_comment_count: "558",
    aweme_share_count: "337",
    aweme_play_count: 1089811,
    aweme_activation: 0.5667,
    live_count: "77",
    live_time: 5162,
    live_watch_count: 219400,
    live_watch_time: 241741,
    live_like_count: "35522",
    live_comment_count: "9714",
    live_activation: 0.8667,
    live_fans_add: "248",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "宁波中基明瑞",
    company_name: "宁波中基明瑞汽车销售服务有限公司",
    store_code: "EZJ607",
    大区: "华东区",
    "省份-城市": "浙江省-宁波市",
    "所选分组编号/分组名称": "-",
    fans_count: "454",
    fans_count_total: "17887",
    aweme_count: "82",
    aweme_like_count: "1004",
    aweme_comment_count: "208",
    aweme_share_count: "65",
    aweme_play_count: 376321,
    aweme_activation: 0.5667,
    live_count: "63",
    live_time: 3953,
    live_watch_count: 135144,
    live_watch_time: 150156,
    live_like_count: "131685",
    live_comment_count: "3014",
    live_activation: 0.7,
    live_fans_add: "233",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "杭州广旗",
    company_name: "杭州广旗汽车有限公司",
    store_code: "EZJ609",
    大区: "华东区",
    "省份-城市": "浙江省-杭州市",
    "所选分组编号/分组名称": "-",
    fans_count: "40",
    fans_count_total: "36903",
    aweme_count: "104",
    aweme_like_count: "442",
    aweme_comment_count: "47",
    aweme_share_count: "48",
    aweme_play_count: 126917,
    aweme_activation: 0.8,
    live_count: "94",
    live_time: 5766,
    live_watch_count: 10984,
    live_watch_time: 12204,
    live_like_count: "29230",
    live_comment_count: "4803",
    live_activation: 0.9,
    live_fans_add: "72",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "广西钜荣红旗",
    company_name: "广西钜荣红旗汽车销售服务有限公司",
    store_code: "SGX601",
    大区: "华南区",
    "省份-城市": "广西壮族自治区-南宁市",
    "所选分组编号/分组名称": "-",
    fans_count: "-130",
    fans_count_total: "21963",
    aweme_count: "20",
    aweme_like_count: "91",
    aweme_comment_count: "5",
    aweme_share_count: "0",
    aweme_play_count: 9518,
    aweme_activation: 0.6667,
    live_count: "24",
    live_time: 1819,
    live_watch_count: 2533,
    live_watch_time: 2814,
    live_like_count: "14145",
    live_comment_count: "741",
    live_activation: 0.6667,
    live_fans_add: "4",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "北京龙泽百旺红旗",
    company_name: "北京龙泽百旺销售服务有限公司",
    store_code: "NBJ123",
    大区: "华北区",
    "省份-城市": "北京市-北京市",
    "所选分组编号/分组名称": "-",
    fans_count: "6",
    fans_count_total: "3097",
    aweme_count: "37",
    aweme_like_count: "57",
    aweme_comment_count: "2",
    aweme_share_count: "1",
    aweme_play_count: 31981,
    aweme_activation: 0.4,
    live_count: "27",
    live_time: 1625,
    live_watch_count: 5214,
    live_watch_time: 5793,
    live_like_count: "2063",
    live_comment_count: "83",
    live_activation: 0.9333,
    live_fans_add: "3",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "河南圆诺",
    company_name: "河南圆诺汽车销售有限公司",
    store_code: "NYU607",
    大区: "华北区",
    "省份-城市": "河南省-开封市",
    "所选分组编号/分组名称": "-",
    fans_count: "595",
    fans_count_total: "32681",
    aweme_count: "125",
    aweme_like_count: "1581",
    aweme_comment_count: "226",
    aweme_share_count: "165",
    aweme_play_count: 665862,
    aweme_activation: 0.8667,
    live_count: "55",
    live_time: 3282,
    live_watch_count: 42709,
    live_watch_time: 47033,
    live_like_count: "51138",
    live_comment_count: "6601",
    live_activation: 0.7667,
    live_fans_add: "22",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "济南快爱特红旗",
    company_name: "济南快爱特有限公司",
    store_code: "NSD608",
    大区: "东北区",
    "省份-城市": "山东省-济南市",
    "所选分组编号/分组名称": "-",
    fans_count: "3512",
    fans_count_total: "156108",
    aweme_count: "70",
    aweme_like_count: "15102",
    aweme_comment_count: "1634",
    aweme_share_count: "987",
    aweme_play_count: 1160892,
    aweme_activation: 0.9,
    live_count: "75",
    live_time: 4951,
    live_watch_count: 578033,
    live_watch_time: 639503,
    live_like_count: "178096",
    live_comment_count: "39222",
    live_activation: 0.8,
    live_fans_add: "1267",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "成都建国红旗",
    company_name: "成都建国汽车贸易有限公司",
    store_code: "WSC609",
    大区: "西部区",
    "省份-城市": "四川省-成都市",
    "所选分组编号/分组名称": "-",
    fans_count: "2708",
    fans_count_total: "63123",
    aweme_count: "83",
    aweme_like_count: "861",
    aweme_comment_count: "243",
    aweme_share_count: "75",
    aweme_play_count: 348167,
    aweme_activation: 0.8,
    live_count: "286",
    live_time: 18712,
    live_watch_count: 686367,
    live_watch_time: 762613,
    live_like_count: "502068",
    live_comment_count: "185476",
    live_activation: 1,
    live_fans_add: "2906",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "东莞鸿粤益嘉",
    company_name: "东莞鸿粤益嘉汽车销售服务有限公司",
    store_code: "SGD609",
    大区: "华南区",
    "省份-城市": "广东省-东莞市",
    "所选分组编号/分组名称": "-",
    fans_count: "-370",
    fans_count_total: "208388",
    aweme_count: "86",
    aweme_like_count: "1272",
    aweme_comment_count: "232",
    aweme_share_count: "74",
    aweme_play_count: 526081,
    aweme_activation: 0.6333,
    live_count: "54",
    live_time: 3357,
    live_watch_count: 4255,
    live_watch_time: 4727,
    live_like_count: "84780",
    live_comment_count: "5647",
    live_activation: 0.8,
    live_fans_add: "55",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "海南优之杰红旗",
    company_name: "海南优之杰商贸有限公司",
    store_code: "SHN600",
    大区: "华南区",
    "省份-城市": "海南省-海口市",
    "所选分组编号/分组名称": "-",
    fans_count: "-213",
    fans_count_total: "112500",
    aweme_count: "52",
    aweme_like_count: "829",
    aweme_comment_count: "107",
    aweme_share_count: "36",
    aweme_play_count: 290120,
    aweme_activation: 0.8667,
    live_count: "59",
    live_time: 3602,
    live_watch_count: 55699,
    live_watch_time: 61887,
    live_like_count: "99878",
    live_comment_count: "3931",
    live_activation: 0.8333,
    live_fans_add: "197",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "天津汇裕永达",
    company_name: "天津汇裕永达汽车贸易有限公司",
    store_code: "NTJ603",
    大区: "华北区",
    "省份-城市": "天津市-天津市",
    "所选分组编号/分组名称": "-",
    fans_count: "-52",
    fans_count_total: "217715",
    aweme_count: "119",
    aweme_like_count: "581",
    aweme_comment_count: "57",
    aweme_share_count: "95",
    aweme_play_count: 340958,
    aweme_activation: 0.9667,
    live_count: "142",
    live_time: 8631,
    live_watch_count: 122384,
    live_watch_time: 134679,
    live_like_count: "59519",
    live_comment_count: "1753",
    live_activation: 0.9667,
    live_fans_add: "65",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "日照晟瑞红旗",
    company_name: "日照晟瑞汽车销售服务有限公司",
    store_code: "NSD609",
    大区: "东北区",
    "省份-城市": "山东省-日照市",
    "所选分组编号/分组名称": "-",
    fans_count: "2",
    fans_count_total: "9502",
    aweme_count: "72",
    aweme_like_count: "735",
    aweme_comment_count: "58",
    aweme_share_count: "61",
    aweme_play_count: 60577,
    aweme_activation: 0.9333,
    live_count: "132",
    live_time: 8674,
    live_watch_count: 9562,
    live_watch_time: 10624,
    live_like_count: "211680",
    live_comment_count: "6545",
    live_activation: 0.9,
    live_fans_add: "37",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "菏泽兴邦红旗汽车体验中心",
    company_name: "菏泽兴邦汽车销售服务有限公司",
    store_code: "NSD610",
    大区: "东北区",
    "省份-城市": "山东省-菏泽市",
    "所选分组编号/分组名称": "-",
    fans_count: "126",
    fans_count_total: "327914",
    aweme_count: "55",
    aweme_like_count: "586",
    aweme_comment_count: "36",
    aweme_share_count: "114",
    aweme_play_count: 1425276,
    aweme_activation: 0.9,
    live_count: "-",
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: "-",
    live_comment_count: "-",
    live_activation: 0,
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "河北华美红旗体验中心",
    company_name: "河北华美红旗体验中心",
    store_code: "NJI603",
    大区: "华北区",
    "省份-城市": "河北省-石家庄市",
    "所选分组编号/分组名称": "-",
    fans_count: "110",
    fans_count_total: "232853",
    aweme_count: "72",
    aweme_like_count: "538",
    aweme_comment_count: "37",
    aweme_share_count: "35",
    aweme_play_count: 220947,
    aweme_activation: 0.5667,
    live_count: "85",
    live_time: 5250,
    live_watch_count: 172020,
    live_watch_time: 189366,
    live_like_count: "67979",
    live_comment_count: "5087",
    live_activation: 0.7333,
    live_fans_add: "138",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "大理国源",
    company_name: "大理国源汽车销售服务有限公司",
    store_code: "WYN604",
    大区: "西部区",
    "省份-城市": "云南省-大理白族自治州",
    "所选分组编号/分组名称": "-",
    fans_count: "-111",
    fans_count_total: "29029",
    aweme_count: "62",
    aweme_like_count: "375",
    aweme_comment_count: "85",
    aweme_share_count: "13",
    aweme_play_count: 56889,
    aweme_activation: 0.5333,
    live_count: "95",
    live_time: 6172,
    live_watch_count: 6619,
    live_watch_time: 7354,
    live_like_count: "120779",
    live_comment_count: "3286",
    live_activation: 0.7333,
    live_fans_add: "21",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "北京祥龙博瑞红旗体验中心",
    company_name: "北京祥龙博瑞汽车服务(集团)有限公司一分公司",
    store_code: "NBJ603",
    大区: "华北区",
    "省份-城市": "北京市-北京市",
    "所选分组编号/分组名称": "-",
    fans_count: "4123",
    fans_count_total: "35203",
    aweme_count: "72",
    aweme_like_count: "5313",
    aweme_comment_count: "216",
    aweme_share_count: "308",
    aweme_play_count: 438847,
    aweme_activation: 0.6,
    live_count: "67",
    live_time: 4296,
    live_watch_count: 262458,
    live_watch_time: 289936,
    live_like_count: "170948",
    live_comment_count: "7322",
    live_activation: 0.5667,
    live_fans_add: "481",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "无锡红博红旗",
    company_name: "无锡红博汽车销售有限公司",
    store_code: "EJS609",
    大区: "华东区",
    "省份-城市": "江苏省-无锡市",
    "所选分组编号/分组名称": "-",
    fans_count: "98",
    fans_count_total: "8870",
    aweme_count: "82",
    aweme_like_count: "550",
    aweme_comment_count: "64",
    aweme_share_count: "56",
    aweme_play_count: 202241,
    aweme_activation: 0.7333,
    live_count: "76",
    live_time: 4401,
    live_watch_count: 4922,
    live_watch_time: 5468,
    live_like_count: "67903",
    live_comment_count: "3544",
    live_activation: 0.8,
    live_fans_add: "96",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "黔西南州星尊程领航",
    company_name: "黔西南州星尊程领航汽车销售服务有限公司",
    store_code: "WGZ604",
    大区: "西部区",
    "省份-城市": "贵州省-黔西南布依族苗族自治州",
    "所选分组编号/分组名称": "-",
    fans_count: "272",
    fans_count_total: "14405",
    aweme_count: "43",
    aweme_like_count: "598",
    aweme_comment_count: "71",
    aweme_share_count: "48",
    aweme_play_count: 225867,
    aweme_activation: 0.7667,
    live_count: "41",
    live_time: 2600,
    live_watch_count: 1499,
    live_watch_time: 1658,
    live_like_count: "1547",
    live_comment_count: "189",
    live_activation: 0.6,
    live_fans_add: "11",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "德阳冠仑",
    company_name: "德阳冠仑",
    store_code: "WSC613",
    大区: "西部区",
    "省份-城市": "四川省-德阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "77",
    fans_count_total: "29810",
    aweme_count: "67",
    aweme_like_count: "687",
    aweme_comment_count: "166",
    aweme_share_count: "14",
    aweme_play_count: 624722,
    aweme_activation: 0.9667,
    live_count: "66",
    live_time: 4066,
    live_watch_count: 2598,
    live_watch_time: 2882,
    live_like_count: "52178",
    live_comment_count: "708",
    live_activation: 0.7667,
    live_fans_add: "16",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "温州宝旗红旗",
    company_name: "温州宝旗汽车服务有限公司",
    store_code: "EZJ611",
    大区: "华东区",
    "省份-城市": "浙江省-温州市",
    "所选分组编号/分组名称": "-",
    fans_count: "-545",
    fans_count_total: "259563",
    aweme_count: "69",
    aweme_like_count: "1860",
    aweme_comment_count: "180",
    aweme_share_count: "147",
    aweme_play_count: 1014322,
    aweme_activation: 0.9333,
    live_count: "109",
    live_time: 6812,
    live_watch_count: 46522,
    live_watch_time: 51691,
    live_like_count: "86180",
    live_comment_count: "5252",
    live_activation: 1,
    live_fans_add: "265",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "曲靖开源红旗体验中心",
    company_name: "曲靖开源汽车销售服务有限公司",
    store_code: "WYN605",
    大区: "西部区",
    "省份-城市": "云南省-曲靖市",
    "所选分组编号/分组名称": "-",
    fans_count: "-158",
    fans_count_total: "51198",
    aweme_count: "68",
    aweme_like_count: "273",
    aweme_comment_count: "20",
    aweme_share_count: "13",
    aweme_play_count: 39122,
    aweme_activation: 0.9,
    live_count: "61",
    live_time: 3808,
    live_watch_count: 4730,
    live_watch_time: 5255,
    live_like_count: "86573",
    live_comment_count: "1927",
    live_activation: 0.8333,
    live_fans_add: "76",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "厦门亿海红祺",
    company_name: "厦门亿海红祺汽车服务有限公司",
    store_code: "SFJ604",
    大区: "华南区",
    "省份-城市": "福建省-厦门市",
    "所选分组编号/分组名称": "-",
    fans_count: "286",
    fans_count_total: "5766",
    aweme_count: "53",
    aweme_like_count: "552",
    aweme_comment_count: "90",
    aweme_share_count: "73",
    aweme_play_count: 391806,
    aweme_activation: 0.7,
    live_count: "60",
    live_time: 4875,
    live_watch_count: 156567,
    live_watch_time: 173963,
    live_like_count: "38998",
    live_comment_count: "1184",
    live_activation: 0.8667,
    live_fans_add: "149",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "德州润吉汽车",
    company_name: "德州润吉汽车销售服务有限公司",
    store_code: "NSD611",
    大区: "东北区",
    "省份-城市": "山东省-德州市",
    "所选分组编号/分组名称": "-",
    fans_count: "300",
    fans_count_total: "37145",
    aweme_count: "80",
    aweme_like_count: "1255",
    aweme_comment_count: "258",
    aweme_share_count: "74",
    aweme_play_count: 556567,
    aweme_activation: 0.8,
    live_count: "71",
    live_time: 4713,
    live_watch_count: 56586,
    live_watch_time: 62871,
    live_like_count: "196861",
    live_comment_count: "4564",
    live_activation: 0.9667,
    live_fans_add: "328",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "陕西汉中天汉旗胜",
    company_name: "陕西汉中天汉旗胜",
    store_code: "XSS606",
    大区: "西部区",
    "省份-城市": "陕西省-汉中市",
    "所选分组编号/分组名称": "-",
    fans_count: "236",
    fans_count_total: "33355",
    aweme_count: "163",
    aweme_like_count: "1215",
    aweme_comment_count: "185",
    aweme_share_count: "121",
    aweme_play_count: 505016,
    aweme_activation: 0.9333,
    live_count: "110",
    live_time: 9345,
    live_watch_count: 25590,
    live_watch_time: 28433,
    live_like_count: "283644",
    live_comment_count: "4040",
    live_activation: 0.9667,
    live_fans_add: "133",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "泸州明云华盛红旗体验中心",
    company_name: "泸州明云华盛红旗体验中心",
    store_code: "WSC616",
    大区: "西部区",
    "省份-城市": "四川省-泸州市",
    "所选分组编号/分组名称": "-",
    fans_count: "559",
    fans_count_total: "28697",
    aweme_count: "78",
    aweme_like_count: "916",
    aweme_comment_count: "155",
    aweme_share_count: "4",
    aweme_play_count: 128033,
    aweme_activation: 0.9,
    live_count: "40",
    live_time: 2910,
    live_watch_count: 14993,
    live_watch_time: 16658,
    live_like_count: "230167",
    live_comment_count: "9999",
    live_activation: 0.7667,
    live_fans_add: "710",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "吉林长春神州红旗",
    company_name: "吉林省神州红旗汽车销售服务有限公司",
    store_code: "DJL606",
    大区: "东北区",
    "省份-城市": "吉林省-长春市",
    "所选分组编号/分组名称": "-",
    fans_count: "-197",
    fans_count_total: "414765",
    aweme_count: "124",
    aweme_like_count: "667",
    aweme_comment_count: "105",
    aweme_share_count: "155",
    aweme_play_count: 1517649,
    aweme_activation: 0.7,
    live_count: "190",
    live_time: 15995,
    live_watch_count: 137856,
    live_watch_time: 152057,
    live_like_count: "1058107",
    live_comment_count: "9504",
    live_activation: 0.9667,
    live_fans_add: "325",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "广元峰帆红旗体验中心",
    company_name: "广元市峰帆汽车商贸有限公司",
    store_code: "WSC612",
    大区: "西部区",
    "省份-城市": "四川省-广元市",
    "所选分组编号/分组名称": "-",
    fans_count: "-38",
    fans_count_total: "157076",
    aweme_count: "74",
    aweme_like_count: "1281",
    aweme_comment_count: "286",
    aweme_share_count: "132",
    aweme_play_count: 111844,
    aweme_activation: 0.9333,
    live_count: "68",
    live_time: 4167,
    live_watch_count: 80688,
    live_watch_time: 88795,
    live_like_count: "49829",
    live_comment_count: "2520",
    live_activation: 0.9667,
    live_fans_add: "23",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "长春金山红旗",
    company_name: "长春金山红旗汽车销售服务有限公司",
    store_code: "DJL605",
    大区: "东北区",
    "省份-城市": "吉林省-长春市",
    "所选分组编号/分组名称": "-",
    fans_count: "853",
    fans_count_total: "59139",
    aweme_count: "67",
    aweme_like_count: "637",
    aweme_comment_count: "86",
    aweme_share_count: "62",
    aweme_play_count: 220456,
    aweme_activation: 0.5667,
    live_count: "56",
    live_time: 4023,
    live_watch_count: 56827,
    live_watch_time: 63141,
    live_like_count: "379938",
    live_comment_count: "10828",
    live_activation: 0.8,
    live_fans_add: "1031",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "自贡新成红兴",
    company_name: "自贡新成红兴汽车销售服务有限责任公司",
    store_code: "WSC614",
    大区: "西部区",
    "省份-城市": "四川省-自贡市",
    "所选分组编号/分组名称": "-",
    fans_count: "17",
    fans_count_total: "2761",
    aweme_count: "28",
    aweme_like_count: "22",
    aweme_comment_count: "4",
    aweme_share_count: "18",
    aweme_play_count: 3861,
    aweme_activation: 0.6,
    live_count: "29",
    live_time: 1770,
    live_watch_count: 1451,
    live_watch_time: 1610,
    live_like_count: "1606",
    live_comment_count: "393",
    live_activation: 0.5667,
    live_fans_add: "18",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "郑州吉展红旗",
    company_name: "郑州吉展汽车销售服务有限公司",
    store_code: "NYU610",
    大区: "华北区",
    "省份-城市": "河南省-郑州市",
    "所选分组编号/分组名称": "-",
    fans_count: "4152",
    fans_count_total: "200220",
    aweme_count: "96",
    aweme_like_count: "2019",
    aweme_comment_count: "320",
    aweme_share_count: "187",
    aweme_play_count: 370560,
    aweme_activation: 0.7667,
    live_count: "205",
    live_time: 14402,
    live_watch_count: 753868,
    live_watch_time: 833490,
    live_like_count: "80850",
    live_comment_count: "32485",
    live_activation: 0.9,
    live_fans_add: "5538",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "信阳天泓",
    company_name: "信阳天泓汽车销售服务有限公司",
    store_code: "NYU608",
    大区: "华北区",
    "省份-城市": "河南省-信阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "-1172",
    fans_count_total: "421935",
    aweme_count: "118",
    aweme_like_count: "5567",
    aweme_comment_count: "1150",
    aweme_share_count: "315",
    aweme_play_count: 746780,
    aweme_activation: 0.8333,
    live_count: "71",
    live_time: 4353,
    live_watch_count: 54419,
    live_watch_time: 60411,
    live_like_count: "30150",
    live_comment_count: "4601",
    live_activation: 0.8667,
    live_fans_add: "355",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "青岛泰岳宏旗",
    company_name: "青岛泰岳宏旗",
    store_code: "NSD613",
    大区: "东北区",
    "省份-城市": "山东省-青岛市",
    "所选分组编号/分组名称": "-",
    fans_count: "417",
    fans_count_total: "261046",
    aweme_count: "184",
    aweme_like_count: "363",
    aweme_comment_count: "32",
    aweme_share_count: "143",
    aweme_play_count: 189287,
    aweme_activation: 0.6667,
    live_count: "160",
    live_time: 9666,
    live_watch_count: 306762,
    live_watch_time: 339035,
    live_like_count: "81485",
    live_comment_count: "3959",
    live_activation: 0.9333,
    live_fans_add: "494",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "潍坊旗胜红旗4S店",
    company_name: "潍坊广潍旗胜汽车销售服务有限公司",
    store_code: "NSD614",
    大区: "东北区",
    "省份-城市": "山东省-潍坊市",
    "所选分组编号/分组名称": "-",
    fans_count: "-124",
    fans_count_total: "149263",
    aweme_count: "33",
    aweme_like_count: "511",
    aweme_comment_count: "63",
    aweme_share_count: "36",
    aweme_play_count: 241985,
    aweme_activation: 0.2667,
    live_count: "62",
    live_time: 3753,
    live_watch_count: 55734,
    live_watch_time: 61926,
    live_like_count: "125638",
    live_comment_count: "4875",
    live_activation: 0.9,
    live_fans_add: "432",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "吉安凯迪红旗",
    company_name: "吉安市凯迪汽车销售服务有限公司",
    store_code: "CJX602",
    大区: "中南区",
    "省份-城市": "江西省-吉安市",
    "所选分组编号/分组名称": "-",
    fans_count: "263",
    fans_count_total: "19271",
    aweme_count: "67",
    aweme_like_count: "2842",
    aweme_comment_count: "580",
    aweme_share_count: "148",
    aweme_play_count: 254032,
    aweme_activation: 0.9667,
    live_count: "59",
    live_time: 4416,
    live_watch_count: 34021,
    live_watch_time: 37801,
    live_like_count: "289801",
    live_comment_count: "8449",
    live_activation: 0.9,
    live_fans_add: "245",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "湖州湖旗红旗",
    company_name: "湖州湖旗汽车有限公司",
    store_code: "EZJ615",
    大区: "华东区",
    "省份-城市": "浙江省-湖州市",
    "所选分组编号/分组名称": "-",
    fans_count: "193",
    fans_count_total: "7083",
    aweme_count: "70",
    aweme_like_count: "400",
    aweme_comment_count: "12",
    aweme_share_count: "31",
    aweme_play_count: 91838,
    aweme_activation: 0.8667,
    live_count: "67",
    live_time: 4075,
    live_watch_count: 113585,
    live_watch_time: 126205,
    live_like_count: "32543",
    live_comment_count: "1343",
    live_activation: 0.8667,
    live_fans_add: "141",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "沧州华泽红旗店",
    company_name: "沧州市华泽汽车贸易有限公司",
    store_code: "NJI604",
    大区: "华北区",
    "省份-城市": "河北省-沧州市",
    "所选分组编号/分组名称": "-",
    fans_count: "603",
    fans_count_total: "117929",
    aweme_count: "96",
    aweme_like_count: "472",
    aweme_comment_count: "42",
    aweme_share_count: "70",
    aweme_play_count: 279739,
    aweme_activation: 0.7667,
    live_count: "86",
    live_time: 5715,
    live_watch_count: 637075,
    live_watch_time: 703669,
    live_like_count: "135633",
    live_comment_count: "6987",
    live_activation: 0.7667,
    live_fans_add: "539",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "潍坊泰岳红旗4S店",
    company_name: "潍坊泰岳宏旗汽车销售服务有限公司",
    store_code: "NSD617",
    大区: "东北区",
    "省份-城市": "山东省-潍坊市",
    "所选分组编号/分组名称": "-",
    fans_count: "-267",
    fans_count_total: "175740",
    aweme_count: "63",
    aweme_like_count: "521",
    aweme_comment_count: "80",
    aweme_share_count: "52",
    aweme_play_count: 959002,
    aweme_activation: 0.8333,
    live_count: "34",
    live_time: 1914,
    live_watch_count: 89786,
    live_watch_time: 99762,
    live_like_count: "53109",
    live_comment_count: "2323",
    live_activation: 0.8333,
    live_fans_add: "109",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "广东容大红旗体验中心",
    company_name: "广东容大星旗汽车有限公司",
    store_code: "SGD614",
    大区: "华南区",
    "省份-城市": "广东省-揭阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "40",
    fans_count_total: "9136",
    aweme_count: "32",
    aweme_like_count: "128",
    aweme_comment_count: "10",
    aweme_share_count: "13",
    aweme_play_count: 14405,
    aweme_activation: 0.5,
    live_count: "30",
    live_time: 1784,
    live_watch_count: 8010,
    live_watch_time: 8900,
    live_like_count: "161355",
    live_comment_count: "4293",
    live_activation: 0.5667,
    live_fans_add: "120",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "两江璐菲红旗",
    company_name: "重庆两江璐菲汽车销售服务有限公司",
    store_code: "WCQ602",
    大区: "西部区",
    "省份-城市": "重庆市-重庆市",
    "所选分组编号/分组名称": "-",
    fans_count: "-41",
    fans_count_total: "3200",
    aweme_count: "35",
    aweme_like_count: "101",
    aweme_comment_count: "20",
    aweme_share_count: "15",
    aweme_play_count: 25445,
    aweme_activation: 0.6,
    live_count: "28",
    live_time: 1744,
    live_watch_count: 825,
    live_watch_time: 915,
    live_like_count: "6731",
    live_comment_count: "550",
    live_activation: 0.3667,
    live_fans_add: "16",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "珠海中升红旗",
    company_name: "珠海市中升汽车销售服务有限公司",
    store_code: "SGD611",
    大区: "华南区",
    "省份-城市": "广东省-珠海市",
    "所选分组编号/分组名称": "-",
    fans_count: "-54",
    fans_count_total: "31563",
    aweme_count: "50",
    aweme_like_count: "260",
    aweme_comment_count: "33",
    aweme_share_count: "22",
    aweme_play_count: 36512,
    aweme_activation: 0.8,
    live_count: "55",
    live_time: 3428,
    live_watch_count: 7952,
    live_watch_time: 8835,
    live_like_count: "65796",
    live_comment_count: "4102",
    live_activation: 0.9,
    live_fans_add: "44",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "衢州君悦宏旗",
    company_name: "衢州君悦宏旗汽车有限公司",
    store_code: "EZJ612",
    大区: "华东区",
    "省份-城市": "浙江省-衢州市",
    "所选分组编号/分组名称": "-",
    fans_count: "219",
    fans_count_total: "7288",
    aweme_count: "62",
    aweme_like_count: "651",
    aweme_comment_count: "60",
    aweme_share_count: "27",
    aweme_play_count: 299651,
    aweme_activation: 1,
    live_count: "60",
    live_time: 3709,
    live_watch_count: 1980,
    live_watch_time: 2200,
    live_like_count: "41658",
    live_comment_count: "2547",
    live_activation: 0.9333,
    live_fans_add: "9",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "贵州铜仁市星尊程鑫航",
    company_name: "贵州铜仁市星尊程鑫航汽车销售服务有限公司",
    store_code: "WGZ605",
    大区: "西部区",
    "省份-城市": "贵州省-铜仁市",
    "所选分组编号/分组名称": "-",
    fans_count: "0",
    fans_count_total: "6559",
    aweme_count: "60",
    aweme_like_count: "376",
    aweme_comment_count: "15",
    aweme_share_count: "3",
    aweme_play_count: 17315,
    aweme_activation: 1,
    live_count: "74",
    live_time: 4464,
    live_watch_count: 5401,
    live_watch_time: 6001,
    live_like_count: "106904",
    live_comment_count: "1711",
    live_activation: 0.9,
    live_fans_add: "40",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "南京大道",
    company_name: "南京大道汽车销售服务有限公司",
    store_code: "EJS610",
    大区: "华东区",
    "省份-城市": "江苏省-南京市",
    "所选分组编号/分组名称": "-",
    fans_count: "-136",
    fans_count_total: "162067",
    aweme_count: "179",
    aweme_like_count: "677",
    aweme_comment_count: "91",
    aweme_share_count: "142",
    aweme_play_count: 233827,
    aweme_activation: 0.8333,
    live_count: "39",
    live_time: 2338,
    live_watch_count: 106807,
    live_watch_time: 118671,
    live_like_count: "13842",
    live_comment_count: "9032",
    live_activation: 0.6667,
    live_fans_add: "713",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "郑州泰岳宏旗",
    company_name: "郑州泰岳宏旗汽车销售服务有限公司",
    store_code: "NYU611",
    大区: "华北区",
    "省份-城市": "河南省-郑州市",
    "所选分组编号/分组名称": "-",
    fans_count: "543",
    fans_count_total: "129560",
    aweme_count: "128",
    aweme_like_count: "954",
    aweme_comment_count: "128",
    aweme_share_count: "97",
    aweme_play_count: 432660,
    aweme_activation: 0.7667,
    live_count: "101",
    live_time: 6144,
    live_watch_count: 85917,
    live_watch_time: 95463,
    live_like_count: "44180",
    live_comment_count: "12308",
    live_activation: 0.7667,
    live_fans_add: "1945",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "洛阳随诺",
    company_name: "洛阳随诺汽车销售服务有限公司",
    store_code: "NYU609",
    大区: "华北区",
    "省份-城市": "河南省-洛阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "-609",
    fans_count_total: "192059",
    aweme_count: "175",
    aweme_like_count: "963",
    aweme_comment_count: "61",
    aweme_share_count: "110",
    aweme_play_count: 536373,
    aweme_activation: 0.9667,
    live_count: "147",
    live_time: 11708,
    live_watch_count: 51221,
    live_watch_time: 56541,
    live_like_count: "40001",
    live_comment_count: "3272",
    live_activation: 0.9333,
    live_fans_add: "113",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "濮阳德源红旗体验中心",
    company_name: "濮阳德源红旗体验中心",
    store_code: "NYU613",
    大区: "华北区",
    "省份-城市": "河南省-濮阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "202",
    fans_count_total: "49223",
    aweme_count: "60",
    aweme_like_count: "700",
    aweme_comment_count: "110",
    aweme_share_count: "13",
    aweme_play_count: 67705,
    aweme_activation: 0.9333,
    live_count: "90",
    live_time: 5902,
    live_watch_count: 211876,
    live_watch_time: 235401,
    live_like_count: "93545",
    live_comment_count: "5576",
    live_activation: 0.6667,
    live_fans_add: "818",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "晋城中一",
    company_name: "晋城中一汽车有限公司",
    store_code: "NJN607",
    大区: "华北区",
    "省份-城市": "山西省-晋城市",
    "所选分组编号/分组名称": "-",
    fans_count: "182",
    fans_count_total: "31595",
    aweme_count: "66",
    aweme_like_count: "585",
    aweme_comment_count: "33",
    aweme_share_count: "87",
    aweme_play_count: 80353,
    aweme_activation: 1,
    live_count: "41",
    live_time: 2555,
    live_watch_count: 4550,
    live_watch_time: 5055,
    live_like_count: "64158",
    live_comment_count: "1579",
    live_activation: 0.8333,
    live_fans_add: "48",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "六安之道红旗",
    company_name: "六安之道汽车销售服务有限公司",
    store_code: "EAH607",
    大区: "华东区",
    "省份-城市": "安徽省-六安市",
    "所选分组编号/分组名称": "-",
    fans_count: "-1125",
    fans_count_total: "260380",
    aweme_count: "139",
    aweme_like_count: "944",
    aweme_comment_count: "152",
    aweme_share_count: "52",
    aweme_play_count: 90059,
    aweme_activation: 0.8,
    live_count: "51",
    live_time: 3257,
    live_watch_count: 24093,
    live_watch_time: 26769,
    live_like_count: "137434",
    live_comment_count: "2100",
    live_activation: 0.8333,
    live_fans_add: "58",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "南阳宛骏",
    company_name: "南阳宛骏汽车销售服务有限公司",
    store_code: "CHN605",
    大区: "华北区",
    "省份-城市": "河南省-南阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "1227",
    fans_count_total: "22043",
    aweme_count: "142",
    aweme_like_count: "670",
    aweme_comment_count: "107",
    aweme_share_count: "38",
    aweme_play_count: 44737,
    aweme_activation: 1,
    live_count: "113",
    live_time: 7364,
    live_watch_count: 15905,
    live_watch_time: 17618,
    live_like_count: "141193",
    live_comment_count: "4265",
    live_activation: 0.9,
    live_fans_add: "95",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "大汉集团红旗体验中心",
    company_name: "长沙美捷汽车贸易有限公司",
    store_code: "CHN606",
    大区: "中南区",
    "省份-城市": "湖南省-长沙市",
    "所选分组编号/分组名称": "-",
    fans_count: "-472",
    fans_count_total: "252653",
    aweme_count: "73",
    aweme_like_count: "262",
    aweme_comment_count: "16",
    aweme_share_count: "24",
    aweme_play_count: 41863,
    aweme_activation: 0.8667,
    live_count: "98",
    live_time: 9171,
    live_watch_count: 13238,
    live_watch_time: 14632,
    live_like_count: "10129",
    live_comment_count: "763",
    live_activation: 0.8667,
    live_fans_add: "33",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "北京泰岳金港红旗体验中心",
    company_name: "北京泰岳宏旗汽车销售服务有限公司",
    store_code: "NBJ605",
    大区: "华北区",
    "省份-城市": "北京市-北京市",
    "所选分组编号/分组名称": "-",
    fans_count: "-31",
    fans_count_total: "70271",
    aweme_count: "145",
    aweme_like_count: "549",
    aweme_comment_count: "52",
    aweme_share_count: "105",
    aweme_play_count: 190783,
    aweme_activation: 1,
    live_count: "195",
    live_time: 11979,
    live_watch_count: 22510,
    live_watch_time: 24797,
    live_like_count: "18211",
    live_comment_count: "3553",
    live_activation: 1,
    live_fans_add: "31",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "桂林弘帆红旗体验中心",
    company_name: "桂林弘帆桂仕汽车销售服务有限公司",
    store_code: "SGX603",
    大区: "华南区",
    "省份-城市": "广西壮族自治区-桂林市",
    "所选分组编号/分组名称": "-",
    fans_count: "15",
    fans_count_total: "1727",
    aweme_count: "77",
    aweme_like_count: "478",
    aweme_comment_count: "75",
    aweme_share_count: "2",
    aweme_play_count: 33431,
    aweme_activation: 0.8333,
    live_count: "58",
    live_time: 3552,
    live_watch_count: 8306,
    live_watch_time: 9228,
    live_like_count: "66854",
    live_comment_count: "995",
    live_activation: 0.8667,
    live_fans_add: "12",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "阜阳博融亚之旗",
    company_name: "阜阳博融亚之旗汽车销售服务有限公司",
    store_code: "EAH606",
    大区: "华东区",
    "省份-城市": "安徽省-阜阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "168",
    fans_count_total: "337203",
    aweme_count: "92",
    aweme_like_count: "474",
    aweme_comment_count: "46",
    aweme_share_count: "44",
    aweme_play_count: 111333,
    aweme_activation: 0.7667,
    live_count: "82",
    live_time: 5013,
    live_watch_count: 69799,
    live_watch_time: 77554,
    live_like_count: "36735",
    live_comment_count: "8870",
    live_activation: 0.8333,
    live_fans_add: "1718",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "成都东创国城红旗",
    company_name: "成都东创国城实业有限公司",
    store_code: "WSC615",
    大区: "西部区",
    "省份-城市": "四川省-成都市",
    "所选分组编号/分组名称": "-",
    fans_count: "823",
    fans_count_total: "69937",
    aweme_count: "86",
    aweme_like_count: "1468",
    aweme_comment_count: "1656",
    aweme_share_count: "54",
    aweme_play_count: 584058,
    aweme_activation: 1,
    live_count: "49",
    live_time: 3088,
    live_watch_count: 92710,
    live_watch_time: 103011,
    live_like_count: "282513",
    live_comment_count: "46139",
    live_activation: 0.7667,
    live_fans_add: "1295",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "南通百弘红旗",
    company_name: "南通百弘汽车销售服务有限公司",
    store_code: "EJS611",
    大区: "华东区",
    "省份-城市": "江苏省-南通市",
    "所选分组编号/分组名称": "-",
    fans_count: "55",
    fans_count_total: "23829",
    aweme_count: "54",
    aweme_like_count: "214",
    aweme_comment_count: "40",
    aweme_share_count: "23",
    aweme_play_count: 136185,
    aweme_activation: 0.7333,
    live_count: "36",
    live_time: 2246,
    live_watch_count: 3170,
    live_watch_time: 3521,
    live_like_count: "32572",
    live_comment_count: "1076",
    live_activation: 0.6667,
    live_fans_add: "45",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "嘉兴禾旗",
    company_name: "嘉兴禾旗汽车销售服务有限公司",
    store_code: "EZJ616",
    大区: "华东区",
    "省份-城市": "浙江省-嘉兴市",
    "所选分组编号/分组名称": "-",
    fans_count: "776",
    fans_count_total: "25462",
    aweme_count: "114",
    aweme_like_count: "614",
    aweme_comment_count: "261",
    aweme_share_count: "63",
    aweme_play_count: 381545,
    aweme_activation: 0.8,
    live_count: "69",
    live_time: 4381,
    live_watch_count: 83787,
    live_watch_time: 92455,
    live_like_count: "4194",
    live_comment_count: "1754",
    live_activation: 0.7667,
    live_fans_add: "199",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "新乡盛世红旗体验中心",
    company_name: "新乡市盛世汽车销售服务有限公司",
    store_code: "NYU615",
    大区: "华北区",
    "省份-城市": "河南省-新乡市",
    "所选分组编号/分组名称": "-",
    fans_count: "-1138",
    fans_count_total: "272923",
    aweme_count: "54",
    aweme_like_count: "628",
    aweme_comment_count: "43",
    aweme_share_count: "63",
    aweme_play_count: 571426,
    aweme_activation: 0.7,
    live_count: "63",
    live_time: 3859,
    live_watch_count: 19075,
    live_watch_time: 21194,
    live_like_count: "23478",
    live_comment_count: "3963",
    live_activation: 0.8667,
    live_fans_add: "164",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "浙江金华裕旗",
    company_name: "浙江金华裕旗汽车有限公司",
    store_code: "EZJ613",
    大区: "华东区",
    "省份-城市": "浙江省-金华市",
    "所选分组编号/分组名称": "-",
    fans_count: "918",
    fans_count_total: "17878",
    aweme_count: "206",
    aweme_like_count: "623",
    aweme_comment_count: "102",
    aweme_share_count: "167",
    aweme_play_count: 60237,
    aweme_activation: 1,
    live_count: "111",
    live_time: 8111,
    live_watch_count: 61977,
    live_watch_time: 68547,
    live_like_count: "78233",
    live_comment_count: "6549",
    live_activation: 0.8667,
    live_fans_add: "188",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "青岛欣盛红旗中心店",
    company_name: "青岛欣盛汽车销售有限公司",
    store_code: "NSD615",
    大区: "东北区",
    "省份-城市": "山东省-青岛市",
    "所选分组编号/分组名称": "-",
    fans_count: "694",
    fans_count_total: "73730",
    aweme_count: "84",
    aweme_like_count: "307",
    aweme_comment_count: "29",
    aweme_share_count: "34",
    aweme_play_count: 215405,
    aweme_activation: 0.8333,
    live_count: "74",
    live_time: 4645,
    live_watch_count: 142419,
    live_watch_time: 156985,
    live_like_count: "22162",
    live_comment_count: "2676",
    live_activation: 0.8667,
    live_fans_add: "229",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "东营鑫红红旗体验中心",
    company_name: "东营鑫红汽车销售服务有限公司",
    store_code: "NSD612",
    大区: "东北区",
    "省份-城市": "山东省-东营市",
    "所选分组编号/分组名称": "-",
    fans_count: "248",
    fans_count_total: "9617",
    aweme_count: "147",
    aweme_like_count: "1476",
    aweme_comment_count: "255",
    aweme_share_count: "126",
    aweme_play_count: 255755,
    aweme_activation: 0.9667,
    live_count: "67",
    live_time: 4222,
    live_watch_count: 15547,
    live_watch_time: 17275,
    live_like_count: "152391",
    live_comment_count: "3903",
    live_activation: 0.8667,
    live_fans_add: "146",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "瑞安宝合",
    company_name: "瑞安市宝合汽车销售有限公司",
    store_code: "EZJ614",
    大区: "华东区",
    "省份-城市": "浙江省-温州市",
    "所选分组编号/分组名称": "-",
    fans_count: "2158",
    fans_count_total: "134646",
    aweme_count: "289",
    aweme_like_count: "23773",
    aweme_comment_count: "1511",
    aweme_share_count: "853",
    aweme_play_count: 4376343,
    aweme_activation: 1,
    live_count: "171",
    live_time: 15029,
    live_watch_count: 99989,
    live_watch_time: 111098,
    live_like_count: "98437",
    live_comment_count: "8991",
    live_activation: 1,
    live_fans_add: "1093",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "贵州安晟",
    company_name: "贵州安晟汽车销售服务有限公司",
    store_code: "WGZ606",
    大区: "西部区",
    "省份-城市": "贵州省-安顺市",
    "所选分组编号/分组名称": "-",
    fans_count: "209",
    fans_count_total: "13539",
    aweme_count: "51",
    aweme_like_count: "590",
    aweme_comment_count: "123",
    aweme_share_count: "8",
    aweme_play_count: 323656,
    aweme_activation: 1,
    live_count: "36",
    live_time: 2148,
    live_watch_count: 1838,
    live_watch_time: 2042,
    live_like_count: "5445",
    live_comment_count: "1175",
    live_activation: 0.8333,
    live_fans_add: "15",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "安阳世祥红旗体验中心",
    company_name: "安阳世祥汽车销售服务有限公司",
    store_code: "NYU616",
    大区: "华北区",
    "省份-城市": "河南省-安阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "140",
    fans_count_total: "61360",
    aweme_count: "55",
    aweme_like_count: "205",
    aweme_comment_count: "37",
    aweme_share_count: "35",
    aweme_play_count: 784634,
    aweme_activation: 0.4333,
    live_count: "25",
    live_time: 1524,
    live_watch_count: 76678,
    live_watch_time: 84352,
    live_like_count: "33741",
    live_comment_count: "639",
    live_activation: 0.5,
    live_fans_add: "10",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "泰州海沃",
    company_name: "泰州海沃汽车销售服务有限公司",
    store_code: "EJS612",
    大区: "华东区",
    "省份-城市": "江苏省-泰州市",
    "所选分组编号/分组名称": "-",
    fans_count: "155",
    fans_count_total: "5628",
    aweme_count: "89",
    aweme_like_count: "329",
    aweme_comment_count: "75",
    aweme_share_count: "37",
    aweme_play_count: 26437,
    aweme_activation: 0.8,
    live_count: "56",
    live_time: 3425,
    live_watch_count: 10598,
    live_watch_time: 11683,
    live_like_count: "43569",
    live_comment_count: "4575",
    live_activation: 0.6333,
    live_fans_add: "35",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "红河海伟宏亦红旗体验中心",
    company_name: "红河海伟宏亦红旗体验中心",
    store_code: "WYN606",
    大区: "西部区",
    "省份-城市": "云南省-红河哈尼族彝族自治州",
    "所选分组编号/分组名称": "-",
    fans_count: "-2093",
    fans_count_total: "28905",
    aweme_count: "57",
    aweme_like_count: "494",
    aweme_comment_count: "75",
    aweme_share_count: "17",
    aweme_play_count: 62962,
    aweme_activation: 0.8333,
    live_count: "45",
    live_time: 3021,
    live_watch_count: 4455,
    live_watch_time: 4950,
    live_like_count: "79743",
    live_comment_count: "738",
    live_activation: 0.7667,
    live_fans_add: "12",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "晋江同行红旗体验中心",
    company_name: "晋江市同行汽车销售有限公司",
    store_code: "SFJ605",
    大区: "华南区",
    "省份-城市": "福建省-泉州市",
    "所选分组编号/分组名称": "-",
    fans_count: "-229",
    fans_count_total: "136945",
    aweme_count: "66",
    aweme_like_count: "2858",
    aweme_comment_count: "829",
    aweme_share_count: "231",
    aweme_play_count: 589126,
    aweme_activation: 0.7667,
    live_count: "104",
    live_time: 8202,
    live_watch_count: 592735,
    live_watch_time: 658594,
    live_like_count: "636270",
    live_comment_count: "63775",
    live_activation: 0.9333,
    live_fans_add: "2085",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "贵阳冉丰",
    company_name: "贵阳冉丰汽车服务有限公司",
    store_code: "WGZ607",
    大区: "西部区",
    "省份-城市": "贵州省-贵阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "44",
    fans_count_total: "17319",
    aweme_count: "57",
    aweme_like_count: "811",
    aweme_comment_count: "76",
    aweme_share_count: "26",
    aweme_play_count: 2074461,
    aweme_activation: 0.9,
    live_count: "58",
    live_time: 3402,
    live_watch_count: 101977,
    live_watch_time: 113304,
    live_like_count: "52080",
    live_comment_count: "2656",
    live_activation: 0.8,
    live_fans_add: "155",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "娄底宝盛",
    company_name: "娄底市宝盛汽车销售服务有限公司",
    store_code: "CHN608",
    大区: "中南区",
    "省份-城市": "湖南省-娄底市",
    "所选分组编号/分组名称": "-",
    fans_count: "142",
    fans_count_total: "7449",
    aweme_count: "77",
    aweme_like_count: "564",
    aweme_comment_count: "66",
    aweme_share_count: "12",
    aweme_play_count: 105940,
    aweme_activation: 1,
    live_count: "51",
    live_time: 3497,
    live_watch_count: 3971,
    live_watch_time: 4413,
    live_like_count: "94029",
    live_comment_count: "4455",
    live_activation: 0.9333,
    live_fans_add: "49",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "九江华宏一汽红旗",
    company_name: "九江华宏昇汽车有限公司",
    store_code: "CJX605",
    大区: "中南区",
    "省份-城市": "江西省-九江市",
    "所选分组编号/分组名称": "-",
    fans_count: "204",
    fans_count_total: "14625",
    aweme_count: "163",
    aweme_like_count: "1194",
    aweme_comment_count: "104",
    aweme_share_count: "120",
    aweme_play_count: 383161,
    aweme_activation: 0.8667,
    live_count: "59",
    live_time: 3747,
    live_watch_count: 113490,
    live_watch_time: 126098,
    live_like_count: "18667",
    live_comment_count: "579",
    live_activation: 0.8667,
    live_fans_add: "89",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "泰安利华晟旗悦",
    company_name: "泰安利华晟旗悦汽车销售服务有限公司",
    store_code: "NSD619",
    大区: "东北区",
    "省份-城市": "山东省-泰安市",
    "所选分组编号/分组名称": "-",
    fans_count: "479",
    fans_count_total: "20431",
    aweme_count: "166",
    aweme_like_count: "453",
    aweme_comment_count: "58",
    aweme_share_count: "78",
    aweme_play_count: 564750,
    aweme_activation: 1,
    live_count: "56",
    live_time: 3570,
    live_watch_count: 45287,
    live_watch_time: 50317,
    live_like_count: "8617",
    live_comment_count: "3049",
    live_activation: 0.8667,
    live_fans_add: "148",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "周口昱旗红旗4S店",
    company_name: "周口市昱旗汽车销售有限公司",
    store_code: "NYU612",
    大区: "华北区",
    "省份-城市": "河南省-周口市",
    "所选分组编号/分组名称": "-",
    fans_count: "35",
    fans_count_total: "13656",
    aweme_count: "76",
    aweme_like_count: "264",
    aweme_comment_count: "83",
    aweme_share_count: "76",
    aweme_play_count: 32899,
    aweme_activation: 0.9333,
    live_count: "133",
    live_time: 10276,
    live_watch_count: 13041,
    live_watch_time: 14489,
    live_like_count: "7649",
    live_comment_count: "4540",
    live_activation: 0.9,
    live_fans_add: "348",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "红旗体验中心抚州龙旗店",
    company_name: "抚州市龙旗汽车销售有限公司",
    store_code: "CJX603",
    大区: "中南区",
    "省份-城市": "江西省-抚州市",
    "所选分组编号/分组名称": "-",
    fans_count: "-588",
    fans_count_total: "27396",
    aweme_count: "26",
    aweme_like_count: "269",
    aweme_comment_count: "71",
    aweme_share_count: "17",
    aweme_play_count: 21414,
    aweme_activation: 0.7333,
    live_count: "60",
    live_time: 3479,
    live_watch_count: 19677,
    live_watch_time: 21863,
    live_like_count: "80416",
    live_comment_count: "6271",
    live_activation: 0.8333,
    live_fans_add: "131",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "邵阳旗乐",
    company_name: "邵阳旗乐汽车销售服务有限公司",
    store_code: "CHN607",
    大区: "中南区",
    "省份-城市": "湖南省-邵阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "479",
    fans_count_total: "9019",
    aweme_count: "411",
    aweme_like_count: "1063",
    aweme_comment_count: "89",
    aweme_share_count: "56",
    aweme_play_count: 295120,
    aweme_activation: 0.5667,
    live_count: "26",
    live_time: 1498,
    live_watch_count: 54808,
    live_watch_time: 60897,
    live_like_count: "156678",
    live_comment_count: "3405",
    live_activation: 0.7,
    live_fans_add: "268",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "玉溪国臻红旗体验中心",
    company_name: "玉溪国臻汽车销售服务有限公司",
    store_code: "WYN607",
    大区: "西部区",
    "省份-城市": "云南省-玉溪市",
    "所选分组编号/分组名称": "-",
    fans_count: "-12",
    fans_count_total: "27767",
    aweme_count: "58",
    aweme_like_count: "580",
    aweme_comment_count: "98",
    aweme_share_count: "73",
    aweme_play_count: 145568,
    aweme_activation: 0.9,
    live_count: "49",
    live_time: 2976,
    live_watch_count: 2819,
    live_watch_time: 3132,
    live_like_count: "76515",
    live_comment_count: "862",
    live_activation: 0.8,
    live_fans_add: "13",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "苏州华朔红旗体验中心",
    company_name: "苏州华朔汽车销售服务有限公司",
    store_code: "EJS613",
    大区: "华东区",
    "省份-城市": "江苏省-苏州市",
    "所选分组编号/分组名称": "-",
    fans_count: "746",
    fans_count_total: "12978",
    aweme_count: "41",
    aweme_like_count: "426",
    aweme_comment_count: "47",
    aweme_share_count: "44",
    aweme_play_count: 146936,
    aweme_activation: 0.5,
    live_count: "89",
    live_time: 11016,
    live_watch_count: 60082,
    live_watch_time: 66757,
    live_like_count: "51007",
    live_comment_count: "17889",
    live_activation: 0.8667,
    live_fans_add: "961",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "孝感祥沃红旗体验中心",
    company_name: "孝感祥沃汽车销售服务有限公司",
    store_code: "CHB606",
    大区: "中南区",
    "省份-城市": "湖北省-孝感市",
    "所选分组编号/分组名称": "-",
    fans_count: "95",
    fans_count_total: "19555",
    aweme_count: "63",
    aweme_like_count: "224",
    aweme_comment_count: "30",
    aweme_share_count: "34",
    aweme_play_count: 22901,
    aweme_activation: 0.8,
    live_count: "55",
    live_time: 3464,
    live_watch_count: 8589,
    live_watch_time: 9470,
    live_like_count: "69239",
    live_comment_count: "2459",
    live_activation: 0.9,
    live_fans_add: "12",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "西昌璞瑞一汽红旗店",
    company_name: "西昌璞瑞汽车销售服务有限责任公司",
    store_code: "WSC617",
    大区: "西部区",
    "省份-城市": "四川省-凉山彝族自治州",
    "所选分组编号/分组名称": "-",
    fans_count: "945",
    fans_count_total: "12372",
    aweme_count: "42",
    aweme_like_count: "427",
    aweme_comment_count: "82",
    aweme_share_count: "12",
    aweme_play_count: 303953,
    aweme_activation: 0.6667,
    live_count: "71",
    live_time: 5322,
    live_watch_count: 118871,
    live_watch_time: 130785,
    live_like_count: "27876",
    live_comment_count: "938",
    live_activation: 0.8667,
    live_fans_add: "14",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "扬州广成扬旗",
    company_name: "扬州广成扬旗汽车有限公司",
    store_code: "EJS614",
    大区: "华东区",
    "省份-城市": "江苏省-扬州市",
    "所选分组编号/分组名称": "-",
    fans_count: "253",
    fans_count_total: "9560",
    aweme_count: "73",
    aweme_like_count: "496",
    aweme_comment_count: "90",
    aweme_share_count: "58",
    aweme_play_count: 190964,
    aweme_activation: 0.6,
    live_count: "67",
    live_time: 4165,
    live_watch_count: 117725,
    live_watch_time: 130805,
    live_like_count: "84554",
    live_comment_count: "2327",
    live_activation: 0.9,
    live_fans_add: "173",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "上海岳宏泰红旗",
    company_name: "上海岳宏泰汽车销售服务有限公司",
    store_code: "ESH610",
    大区: "华东区",
    "省份-城市": "上海市-上海市",
    "所选分组编号/分组名称": "-",
    fans_count: "683",
    fans_count_total: "105397",
    aweme_count: "133",
    aweme_like_count: "986",
    aweme_comment_count: "273",
    aweme_share_count: "59",
    aweme_play_count: 205385,
    aweme_activation: 0.9333,
    live_count: "98",
    live_time: 6747,
    live_watch_count: 541899,
    live_watch_time: 597834,
    live_like_count: "567002",
    live_comment_count: "26707",
    live_activation: 0.8,
    live_fans_add: "391",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "平顶山盛大红旗体验中心",
    company_name: "平顶山市盛大汽车销售服务有限公司",
    store_code: "NYU617",
    大区: "华北区",
    "省份-城市": "河南省-平顶山市",
    "所选分组编号/分组名称": "-",
    fans_count: "-89",
    fans_count_total: "67442",
    aweme_count: "69",
    aweme_like_count: "223",
    aweme_comment_count: "50",
    aweme_share_count: "5",
    aweme_play_count: 22805,
    aweme_activation: 0.7667,
    live_count: "59",
    live_time: 3808,
    live_watch_count: 5072,
    live_watch_time: 5636,
    live_like_count: "28322",
    live_comment_count: "1327",
    live_activation: 0.8,
    live_fans_add: "39",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "唐山岳泰宏旗",
    company_name: "唐山岳泰宏旗汽车销售服务有限公司",
    store_code: "NJI605",
    大区: "华北区",
    "省份-城市": "河北省-唐山市",
    "所选分组编号/分组名称": "-",
    fans_count: "3681",
    fans_count_total: "163692",
    aweme_count: "172",
    aweme_like_count: "30532",
    aweme_comment_count: "315",
    aweme_share_count: "4649",
    aweme_play_count: 3260050,
    aweme_activation: 1,
    live_count: "127",
    live_time: 7953,
    live_watch_count: 787937,
    live_watch_time: 867931,
    live_like_count: "1044927",
    live_comment_count: "83209",
    live_activation: 0.8667,
    live_fans_add: "749",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "凯里凯通",
    company_name: "凯里市凯通汽车贸易有限公司",
    store_code: "WGZ610",
    大区: "西部区",
    "省份-城市": "贵州省-黔东南苗族侗族自治州",
    "所选分组编号/分组名称": "-",
    fans_count: "199",
    fans_count_total: "2032",
    aweme_count: "33",
    aweme_like_count: "181",
    aweme_comment_count: "11",
    aweme_share_count: "6",
    aweme_play_count: 18472,
    aweme_activation: 0.8667,
    live_count: "47",
    live_time: 3311,
    live_watch_count: 112628,
    live_watch_time: 125142,
    live_like_count: "59872",
    live_comment_count: "1969",
    live_activation: 0.8667,
    live_fans_add: "190",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "常德时茂红旗",
    company_name: "常德时茂汽车销售服务有限公司",
    store_code: "CHN610",
    大区: "中南区",
    "省份-城市": "湖南省-常德市",
    "所选分组编号/分组名称": "-",
    fans_count: "-5",
    fans_count_total: "5942",
    aweme_count: "38",
    aweme_like_count: "181",
    aweme_comment_count: "37",
    aweme_share_count: "2",
    aweme_play_count: 17540,
    aweme_activation: 0.6,
    live_count: "28",
    live_time: 1878,
    live_watch_count: 475,
    live_watch_time: 527,
    live_like_count: "1657",
    live_comment_count: "49",
    live_activation: 0.5,
    live_fans_add: "1",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "十堰亨运红晟",
    company_name: "十堰亨运红晟汽车销售服务有限公司",
    store_code: "CHB609",
    大区: "中南区",
    "省份-城市": "湖北省-十堰市",
    "所选分组编号/分组名称": "-",
    fans_count: "44",
    fans_count_total: "3785",
    aweme_count: "45",
    aweme_like_count: "232",
    aweme_comment_count: "18",
    aweme_share_count: "11",
    aweme_play_count: 133878,
    aweme_activation: 0.9,
    live_count: "44",
    live_time: 2706,
    live_watch_count: 3562,
    live_watch_time: 3957,
    live_like_count: "48357",
    live_comment_count: "3730",
    live_activation: 0.8667,
    live_fans_add: "34",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "南昌美乘红旗体验中心",
    company_name: "南昌美乘汽车销售服务有限公司",
    store_code: "CJX604",
    大区: "中南区",
    "省份-城市": "江西省-南昌市",
    "所选分组编号/分组名称": "-",
    fans_count: "-124",
    fans_count_total: "127310",
    aweme_count: "79",
    aweme_like_count: "913",
    aweme_comment_count: "223",
    aweme_share_count: "240",
    aweme_play_count: 700119,
    aweme_activation: 0.9333,
    live_count: "65",
    live_time: 5325,
    live_watch_count: 560143,
    live_watch_time: 622375,
    live_like_count: "301140",
    live_comment_count: "9001",
    live_activation: 0.8,
    live_fans_add: "850",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "普洱海伟宏亦红旗体验中心",
    company_name: "普洱海伟宏亦汽车销售有限公司",
    store_code: "WYN608",
    大区: "西部区",
    "省份-城市": "云南省-普洱市",
    "所选分组编号/分组名称": "-",
    fans_count: "-11",
    fans_count_total: "12535",
    aweme_count: "66",
    aweme_like_count: "228",
    aweme_comment_count: "11",
    aweme_share_count: "35",
    aweme_play_count: 32153,
    aweme_activation: 0.5,
    live_count: "51",
    live_time: 3435,
    live_watch_count: 1342,
    live_watch_time: 1486,
    live_like_count: "25691",
    live_comment_count: "997",
    live_activation: 0.7667,
    live_fans_add: "15",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "福州华奥红旗",
    company_name: "福州华奥鸿旗汽车销售有限公司",
    store_code: "SFJ607",
    大区: "华南区",
    "省份-城市": "福建省-福州市",
    "所选分组编号/分组名称": "-",
    fans_count: "-9",
    fans_count_total: "16151",
    aweme_count: "28",
    aweme_like_count: "343",
    aweme_comment_count: "54",
    aweme_share_count: "6",
    aweme_play_count: 183656,
    aweme_activation: 0.5,
    live_count: "57",
    live_time: 3416,
    live_watch_count: 4192,
    live_watch_time: 4655,
    live_like_count: "22957",
    live_comment_count: "1718",
    live_activation: 0.7667,
    live_fans_add: "30",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "株洲宏旗",
    company_name: "株洲宏旗汽车销售服务有限公司",
    store_code: "CHN609",
    大区: "中南区",
    "省份-城市": "湖南省-株洲市",
    "所选分组编号/分组名称": "-",
    fans_count: "95",
    fans_count_total: "17749",
    aweme_count: "63",
    aweme_like_count: "277",
    aweme_comment_count: "27",
    aweme_share_count: "26",
    aweme_play_count: 149901,
    aweme_activation: 0.4333,
    live_count: "42",
    live_time: 2564,
    live_watch_count: 1465,
    live_watch_time: 1627,
    live_like_count: "10385",
    live_comment_count: "927",
    live_activation: 0.4667,
    live_fans_add: "17",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "马鞍山金福联",
    company_name: "马鞍山金福联汽车销售服务有限公司",
    store_code: "EAH609",
    大区: "华东区",
    "省份-城市": "安徽省-马鞍山市",
    "所选分组编号/分组名称": "-",
    fans_count: "-169",
    fans_count_total: "71790",
    aweme_count: "78",
    aweme_like_count: "459",
    aweme_comment_count: "41",
    aweme_share_count: "15",
    aweme_play_count: 214936,
    aweme_activation: 1,
    live_count: "52",
    live_time: 3291,
    live_watch_count: 8602,
    live_watch_time: 9557,
    live_like_count: "117675",
    live_comment_count: "3608",
    live_activation: 0.8333,
    live_fans_add: "75",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "黄冈旗胜",
    company_name: "黄冈旗胜汽车服务有限公司",
    store_code: "CHB607",
    大区: "中南区",
    "省份-城市": "湖北省-黄冈市",
    "所选分组编号/分组名称": "-",
    fans_count: "41",
    fans_count_total: "10713",
    aweme_count: "78",
    aweme_like_count: "729",
    aweme_comment_count: "66",
    aweme_share_count: "14",
    aweme_play_count: 164260,
    aweme_activation: 1,
    live_count: "84",
    live_time: 6242,
    live_watch_count: 7962,
    live_watch_time: 8846,
    live_like_count: "53382",
    live_comment_count: "1208",
    live_activation: 1,
    live_fans_add: "19",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "牡丹江中信恒安",
    company_name: "牡丹江中信恒安汽车销售服务有限公司",
    store_code: "DHL602",
    大区: "东北区",
    "省份-城市": "黑龙江省-牡丹江市",
    "所选分组编号/分组名称": "-",
    fans_count: "-57",
    fans_count_total: "35859",
    aweme_count: "42",
    aweme_like_count: "207",
    aweme_comment_count: "11",
    aweme_share_count: "26",
    aweme_play_count: 21953,
    aweme_activation: 0.7,
    live_count: "40",
    live_time: 2409,
    live_watch_count: 5012,
    live_watch_time: 5561,
    live_like_count: "1811",
    live_comment_count: "692",
    live_activation: 1,
    live_fans_add: "20",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "漳州宏旗",
    company_name: "漳州市宏旗汽车销售服务有限公司",
    store_code: "SFJ606",
    大区: "华南区",
    "省份-城市": "福建省-漳州市",
    "所选分组编号/分组名称": "-",
    fans_count: "130",
    fans_count_total: "15497",
    aweme_count: "79",
    aweme_like_count: "367",
    aweme_comment_count: "65",
    aweme_share_count: "19",
    aweme_play_count: 192240,
    aweme_activation: 0.6667,
    live_count: "56",
    live_time: 3497,
    live_watch_count: 115605,
    live_watch_time: 128450,
    live_like_count: "29940",
    live_comment_count: "1488",
    live_activation: 0.8667,
    live_fans_add: "135",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "鄂尔多斯红旗",
    company_name: "鄂尔多斯市宏旗汽车销售有限公司",
    store_code: "DNM605",
    大区: "华北区",
    "省份-城市": "内蒙古自治区-鄂尔多斯市",
    "所选分组编号/分组名称": "-",
    fans_count: "773",
    fans_count_total: "20926",
    aweme_count: "99",
    aweme_like_count: "318",
    aweme_comment_count: "31",
    aweme_share_count: "87",
    aweme_play_count: 25526,
    aweme_activation: 1,
    live_count: "63",
    live_time: 5362,
    live_watch_count: 65245,
    live_watch_time: 71774,
    live_like_count: "123749",
    live_comment_count: "12696",
    live_activation: 0.9667,
    live_fans_add: "1",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "诸暨悦旗",
    company_name: "诸暨悦旗汽车有限公司",
    store_code: "EZJ618",
    大区: "华东区",
    "省份-城市": "浙江省-绍兴市",
    "所选分组编号/分组名称": "-",
    fans_count: "204",
    fans_count_total: "19237",
    aweme_count: "146",
    aweme_like_count: "789",
    aweme_comment_count: "116",
    aweme_share_count: "32",
    aweme_play_count: 358835,
    aweme_activation: 1,
    live_count: "87",
    live_time: 5302,
    live_watch_count: 131545,
    live_watch_time: 146161,
    live_like_count: "116093",
    live_comment_count: "3751",
    live_activation: 0.8667,
    live_fans_add: "196",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "西藏泰立",
    company_name: "西藏泰立汽车销售服务有限公司",
    store_code: "WXZ601",
    大区: "西部区",
    "省份-城市": "西藏自治区-拉萨市",
    "所选分组编号/分组名称": "-",
    fans_count: "-7",
    fans_count_total: "4969",
    aweme_count: "40",
    aweme_like_count: "171",
    aweme_comment_count: "5",
    aweme_share_count: "13",
    aweme_play_count: 14778,
    aweme_activation: 0.8333,
    live_count: "44",
    live_time: 2948,
    live_watch_count: 1655,
    live_watch_time: 1838,
    live_like_count: "17102",
    live_comment_count: "757",
    live_activation: 0.8333,
    live_fans_add: "15",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "华奕衡水红旗体验中心",
    company_name: "华奕衡水红旗体验中心",
    store_code: "NJI606",
    大区: "华北区",
    "省份-城市": "河北省-衡水市",
    "所选分组编号/分组名称": "-",
    fans_count: "2471",
    fans_count_total: "117502",
    aweme_count: "50",
    aweme_like_count: "1017",
    aweme_comment_count: "151",
    aweme_share_count: "238",
    aweme_play_count: 409282,
    aweme_activation: 0.7,
    live_count: "61",
    live_time: 3610,
    live_watch_count: 670172,
    live_watch_time: 737200,
    live_like_count: "20724",
    live_comment_count: "1681",
    live_activation: 0.5667,
    live_fans_add: "15",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "济南民福红旗体验中心",
    company_name: "济南民福汽车服务有限公司",
    store_code: "NSD616",
    大区: "东北区",
    "省份-城市": "山东省-济南市",
    "所选分组编号/分组名称": "-",
    fans_count: "310",
    fans_count_total: "276769",
    aweme_count: "103",
    aweme_like_count: "1334",
    aweme_comment_count: "114",
    aweme_share_count: "81",
    aweme_play_count: 488648,
    aweme_activation: 1,
    live_count: "104",
    live_time: 6851,
    live_watch_count: 205362,
    live_watch_time: 226267,
    live_like_count: "33906",
    live_comment_count: "6680",
    live_activation: 0.8667,
    live_fans_add: "414",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "四平通立",
    company_name: "四平通立汽车销售服务有限公司",
    store_code: "DJL607",
    大区: "东北区",
    "省份-城市": "吉林省-四平市",
    "所选分组编号/分组名称": "-",
    fans_count: "480",
    fans_count_total: "24507",
    aweme_count: "64",
    aweme_like_count: "172",
    aweme_comment_count: "36",
    aweme_share_count: "19",
    aweme_play_count: 14139,
    aweme_activation: 0.8667,
    live_count: "90",
    live_time: 5678,
    live_watch_count: 64814,
    live_watch_time: 71328,
    live_like_count: "77595",
    live_comment_count: "11903",
    live_activation: 0.8667,
    live_fans_add: "49",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "黔南州大雍汇盛",
    company_name: "黔南州大雍汇盛汽车销售服务有限公司",
    store_code: "WGZ609",
    大区: "西部区",
    "省份-城市": "贵州省-黔南布依族苗族自治州",
    "所选分组编号/分组名称": "-",
    fans_count: "6",
    fans_count_total: "4378",
    aweme_count: "53",
    aweme_like_count: "293",
    aweme_comment_count: "33",
    aweme_share_count: "29",
    aweme_play_count: 44882,
    aweme_activation: 0.8,
    live_count: "59",
    live_time: 3929,
    live_watch_count: 1997,
    live_watch_time: 2218,
    live_like_count: "82351",
    live_comment_count: "524",
    live_activation: 0.9,
    live_fans_add: "7",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "广安祥龙",
    company_name: "广安祥龙车业有限公司",
    store_code: "WSC619",
    大区: "西部区",
    "省份-城市": "四川省-广安市",
    "所选分组编号/分组名称": "-",
    fans_count: "19",
    fans_count_total: "1518",
    aweme_count: "108",
    aweme_like_count: "423",
    aweme_comment_count: "86",
    aweme_share_count: "129",
    aweme_play_count: 14145,
    aweme_activation: 0.9667,
    live_count: "56",
    live_time: 4007,
    live_watch_count: 1895,
    live_watch_time: 2105,
    live_like_count: "81329",
    live_comment_count: "5844",
    live_activation: 0.7667,
    live_fans_add: "14",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "通辽大鹏泰达",
    company_name: "通辽市大鹏泰达汽车销售服务有限公司",
    store_code: "DNM606",
    大区: "东北区",
    "省份-城市": "内蒙古自治区-通辽市",
    "所选分组编号/分组名称": "-",
    fans_count: "150",
    fans_count_total: "97912",
    aweme_count: "44",
    aweme_like_count: "1771",
    aweme_comment_count: "147",
    aweme_share_count: "115",
    aweme_play_count: 258891,
    aweme_activation: 1,
    live_count: "26",
    live_time: 1599,
    live_watch_count: 116736,
    live_watch_time: 128410,
    live_like_count: "71213",
    live_comment_count: "1877",
    live_activation: 0.7,
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "邯郸鸿博红旗体验中心",
    company_name: "邯郸市鸿博汽车销售服务有限公司",
    store_code: "NJI608",
    大区: "华北区",
    "省份-城市": "河北省-邯郸市",
    "所选分组编号/分组名称": "-",
    fans_count: "4",
    fans_count_total: "94617",
    aweme_count: "78",
    aweme_like_count: "1000",
    aweme_comment_count: "153",
    aweme_share_count: "61",
    aweme_play_count: 484449,
    aweme_activation: 0.7,
    live_count: "113",
    live_time: 6969,
    live_watch_count: 161453,
    live_watch_time: 177713,
    live_like_count: "149337",
    live_comment_count: "2965",
    live_activation: 0.9,
    live_fans_add: "39",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "肇庆诚利",
    company_name: "肇庆市诚利汽车销售服务有限公司",
    store_code: "SGD615",
    大区: "华南区",
    "省份-城市": "广东省-肇庆市",
    "所选分组编号/分组名称": "-",
    fans_count: "44",
    fans_count_total: "6386",
    aweme_count: "108",
    aweme_like_count: "716",
    aweme_comment_count: "146",
    aweme_share_count: "43",
    aweme_play_count: 269143,
    aweme_activation: 0.7333,
    live_count: "46",
    live_time: 3195,
    live_watch_count: 6856,
    live_watch_time: 7615,
    live_like_count: "64679",
    live_comment_count: "1551",
    live_activation: 0.8,
    live_fans_add: "28",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "四川融裕",
    company_name: "四川融裕汽车贸易有限责任公司",
    store_code: "WSC618",
    大区: "西部区",
    "省份-城市": "四川省-眉山市",
    "所选分组编号/分组名称": "-",
    fans_count: "-101",
    fans_count_total: "64160",
    aweme_count: "107",
    aweme_like_count: "725",
    aweme_comment_count: "96",
    aweme_share_count: "59",
    aweme_play_count: 274721,
    aweme_activation: 0.9667,
    live_count: "54",
    live_time: 3362,
    live_watch_count: 16069,
    live_watch_time: 17834,
    live_like_count: "117060",
    live_comment_count: "1592",
    live_activation: 0.7,
    live_fans_add: "86",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "亳州远景特润红旗",
    company_name: "亳州市远景特润汽车销售服务有限责任公司",
    store_code: "EAH608",
    大区: "华东区",
    "省份-城市": "安徽省-亳州市",
    "所选分组编号/分组名称": "-",
    fans_count: "3626",
    fans_count_total: "176750",
    aweme_count: "70",
    aweme_like_count: "31504",
    aweme_comment_count: "1080",
    aweme_share_count: "1009",
    aweme_play_count: 2335006,
    aweme_activation: 0.8,
    live_count: "55",
    live_time: 3887,
    live_watch_count: 200485,
    live_watch_time: 220541,
    live_like_count: "16658",
    live_comment_count: "1519",
    live_activation: 0.9,
    live_fans_add: "1",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "绵阳红旗体验中心",
    company_name: "绵阳红旗体验中心",
    store_code: "WSC611",
    大区: "西部区",
    "省份-城市": "四川省-绵阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "320",
    fans_count_total: "19046",
    aweme_count: "90",
    aweme_like_count: "381",
    aweme_comment_count: "44",
    aweme_share_count: "25",
    aweme_play_count: 170276,
    aweme_activation: 0.9,
    live_count: "68",
    live_time: 3947,
    live_watch_count: 127098,
    live_watch_time: 141217,
    live_like_count: "150824",
    live_comment_count: "1821",
    live_activation: 0.6667,
    live_fans_add: "169",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "承德天晟",
    company_name: "承德天美",
    store_code: "NJI618",
    大区: "华北区",
    "省份-城市": "河北省-承德市",
    "所选分组编号/分组名称": "-",
    fans_count: "1364",
    fans_count_total: "30206",
    aweme_count: "112",
    aweme_like_count: "461",
    aweme_comment_count: "47",
    aweme_share_count: "19",
    aweme_play_count: 27933,
    aweme_activation: 0.8667,
    live_count: "104",
    live_time: 6377,
    live_watch_count: 266568,
    live_watch_time: 293271,
    live_like_count: "114937",
    live_comment_count: "3148",
    live_activation: 0.8667,
    live_fans_add: "56",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "贵州星尊程悦航",
    company_name: "贵州星尊程悦航",
    store_code: "WGZ611",
    大区: "西部区",
    "省份-城市": "贵州省-六盘水市",
    "所选分组编号/分组名称": "-",
    fans_count: "314",
    fans_count_total: "17314",
    aweme_count: "72",
    aweme_like_count: "473",
    aweme_comment_count: "27",
    aweme_share_count: "37",
    aweme_play_count: 35767,
    aweme_activation: 0.6667,
    live_count: "87",
    live_time: 5347,
    live_watch_count: 10799,
    live_watch_time: 11950,
    live_like_count: "70887",
    live_comment_count: "1874",
    live_activation: 0.8333,
    live_fans_add: "18",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "湛江宝旗",
    company_name: "湛江市宝旗汽车销售服务有限公司",
    store_code: "SGD616",
    大区: "华南区",
    "省份-城市": "广东省-湛江市",
    "所选分组编号/分组名称": "-",
    fans_count: "183",
    fans_count_total: "15726",
    aweme_count: "53",
    aweme_like_count: "220",
    aweme_comment_count: "18",
    aweme_share_count: "11",
    aweme_play_count: 50441,
    aweme_activation: 0.6667,
    live_count: "59",
    live_time: 3610,
    live_watch_count: 8467,
    live_watch_time: 9406,
    live_like_count: "15883",
    live_comment_count: "2628",
    live_activation: 0.9,
    live_fans_add: "310",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "赤峰天永红旗体验中心",
    company_name: "赤峰天永汽车销售服务有限公司",
    store_code: "DNM604",
    大区: "东北区",
    "省份-城市": "内蒙古自治区-赤峰市",
    "所选分组编号/分组名称": "-",
    fans_count: "-437",
    fans_count_total: "415883",
    aweme_count: "62",
    aweme_like_count: "544",
    aweme_comment_count: "73",
    aweme_share_count: "14",
    aweme_play_count: 57153,
    aweme_activation: 0.2333,
    live_count: "35",
    live_time: 1846,
    live_watch_count: 115283,
    live_watch_time: 126854,
    live_like_count: "45952",
    live_comment_count: "728",
    live_activation: 0.6,
    live_fans_add: "1",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "郴州恒晨",
    company_name: "郴州市恒晨汽车销售服务有限公司",
    store_code: "CHN612",
    大区: "中南区",
    "省份-城市": "湖南省-郴州市",
    "所选分组编号/分组名称": "-",
    fans_count: "833",
    fans_count_total: "39145",
    aweme_count: "113",
    aweme_like_count: "944",
    aweme_comment_count: "67",
    aweme_share_count: "64",
    aweme_play_count: 728851,
    aweme_activation: 1,
    live_count: "72",
    live_time: 4449,
    live_watch_count: 47560,
    live_watch_time: 52384,
    live_like_count: "271807",
    live_comment_count: "12321",
    live_activation: 0.8,
    live_fans_add: "52",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "荆州旗阳红旗体验中心",
    company_name: "荆州旗阳汽车销售服务有限公司",
    store_code: "CHB608",
    大区: "中南区",
    "省份-城市": "湖北省-荆州市",
    "所选分组编号/分组名称": "-",
    fans_count: "43",
    fans_count_total: "3399",
    aweme_count: "64",
    aweme_like_count: "229",
    aweme_comment_count: "42",
    aweme_share_count: "18",
    aweme_play_count: 29523,
    aweme_activation: 0.7333,
    live_count: "56",
    live_time: 3461,
    live_watch_count: 2117,
    live_watch_time: 2348,
    live_like_count: "5014",
    live_comment_count: "645",
    live_activation: 0.8,
    live_fans_add: "14",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "岳阳广宸",
    company_name: "岳阳广宸汽车销售服务有限公司",
    store_code: "CHN611",
    大区: "中南区",
    "省份-城市": "湖南省-岳阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "-163",
    fans_count_total: "35473",
    aweme_count: "44",
    aweme_like_count: "422",
    aweme_comment_count: "9",
    aweme_share_count: "0",
    aweme_play_count: 22915,
    aweme_activation: 0.8333,
    live_count: "51",
    live_time: 2863,
    live_watch_count: 2190,
    live_watch_time: 2433,
    live_like_count: "6671",
    live_comment_count: "312",
    live_activation: 0.8333,
    live_fans_add: "6",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "江门裕立",
    company_name: "江门市裕立汽车销售服务有限公司",
    store_code: "SGD617",
    大区: "华南区",
    "省份-城市": "广东省-江门市",
    "所选分组编号/分组名称": "-",
    fans_count: "193",
    fans_count_total: "2284",
    aweme_count: "93",
    aweme_like_count: "413",
    aweme_comment_count: "45",
    aweme_share_count: "21",
    aweme_play_count: 69634,
    aweme_activation: 0.7667,
    live_count: "28",
    live_time: 1528,
    live_watch_count: 479,
    live_watch_time: 530,
    live_like_count: "26565",
    live_comment_count: "665",
    live_activation: 0.6,
    live_fans_add: "1",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "汕头众驰红旗4S店",
    company_name: "汕头市众驰汽车有限公司",
    store_code: "SGD623",
    大区: "华南区",
    "省份-城市": "广东省-汕头市",
    "所选分组编号/分组名称": "-",
    fans_count: "368",
    fans_count_total: "15250",
    aweme_count: "53",
    aweme_like_count: "369",
    aweme_comment_count: "25",
    aweme_share_count: "28",
    aweme_play_count: 120732,
    aweme_activation: 0.6667,
    live_count: "56",
    live_time: 3490,
    live_watch_count: 108482,
    live_watch_time: 120535,
    live_like_count: "96412",
    live_comment_count: "5438",
    live_activation: 0.8333,
    live_fans_add: "389",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "资阳清巍茂美",
    company_name: "资阳市清巍茂美汽车销售服务有限公司",
    store_code: "WSC621",
    大区: "西部区",
    "省份-城市": "四川省-资阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "-17",
    fans_count_total: "7218",
    aweme_count: "-",
    aweme_like_count: "-",
    aweme_comment_count: "-",
    aweme_share_count: "-",
    aweme_play_count: 608,
    aweme_activation: 0.0667,
    live_count: "-",
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: "-",
    live_comment_count: "-",
    live_activation: 0,
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "广物红旗广州鸿福",
    company_name: "广东广物鸿福汽车销售服务有限公司",
    store_code: "SGD618",
    大区: "华南区",
    "省份-城市": "广东省-广州市",
    "所选分组编号/分组名称": "-",
    fans_count: "308",
    fans_count_total: "8447",
    aweme_count: "83",
    aweme_like_count: "632",
    aweme_comment_count: "63",
    aweme_share_count: "29",
    aweme_play_count: 388801,
    aweme_activation: 0.8333,
    live_count: "63",
    live_time: 3858,
    live_watch_count: 20097,
    live_watch_time: 22326,
    live_like_count: "36065",
    live_comment_count: "2159",
    live_activation: 0.8667,
    live_fans_add: "126",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "齐齐哈尔粤华红旗",
    company_name: "齐齐哈尔粤华汽贸集团有限公司",
    store_code: "DHL603",
    大区: "东北区",
    "省份-城市": "黑龙江省-齐齐哈尔市",
    "所选分组编号/分组名称": "-",
    fans_count: "177",
    fans_count_total: "37526",
    aweme_count: "209",
    aweme_like_count: "680",
    aweme_comment_count: "101",
    aweme_share_count: "71",
    aweme_play_count: 35321,
    aweme_activation: 0.9,
    live_count: "55",
    live_time: 3454,
    live_watch_count: 61956,
    live_watch_time: 68161,
    live_like_count: "4923",
    live_comment_count: "771",
    live_activation: 0.9,
    live_fans_add: "10",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "合肥和旗",
    company_name: 0,
    store_code: "EAH624",
    大区: "华东区",
    "省份-城市": "安徽省-合肥市",
    "所选分组编号/分组名称": "-",
    fans_count: 0,
    fans_count_total: 0,
    aweme_count: 0,
    aweme_like_count: 0,
    aweme_comment_count: 0,
    aweme_share_count: 0,
    aweme_play_count: 37031,
    aweme_activation: 0,
    live_count: 0,
    live_time: 3250,
    live_watch_count: 29827,
    live_watch_time: 33141,
    live_like_count: 0,
    live_comment_count: 0,
    live_activation: 0,
    live_fans_add: 0,
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "昭通国源",
    company_name: "昭通国源汽车销售服务有限公司",
    store_code: "WYN610",
    大区: "西部区",
    "省份-城市": "云南省-昭通市",
    "所选分组编号/分组名称": "-",
    fans_count: "-38",
    fans_count_total: "16869",
    aweme_count: "9",
    aweme_like_count: "42",
    aweme_comment_count: "8",
    aweme_share_count: "0",
    aweme_play_count: 19403,
    aweme_activation: 0.1333,
    live_count: "42",
    live_time: 2637,
    live_watch_count: 5224,
    live_watch_time: 5804,
    live_like_count: "1098",
    live_comment_count: "223",
    live_activation: 0.8333,
    live_fans_add: "4",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "南京天沃红旗体验中心",
    company_name: "南京天沃汽车销售服务有限公司",
    store_code: "EJS618",
    大区: "华东区",
    "省份-城市": "江苏省-南京市",
    "所选分组编号/分组名称": "-",
    fans_count: "2084",
    fans_count_total: "639618",
    aweme_count: "136",
    aweme_like_count: "2528",
    aweme_comment_count: "515",
    aweme_share_count: "249",
    aweme_play_count: 486584,
    aweme_activation: 0.9,
    live_count: "124",
    live_time: 10976,
    live_watch_count: 198800,
    live_watch_time: 220029,
    live_like_count: "59415",
    live_comment_count: "30671",
    live_activation: 0.9333,
    live_fans_add: "3331",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "焦作天宏",
    company_name: "焦作市天宏汽车销售服务有限公司",
    store_code: "NYU618",
    大区: "华北区",
    "省份-城市": "河南省-焦作市",
    "所选分组编号/分组名称": "-",
    fans_count: "179",
    fans_count_total: "38902",
    aweme_count: "42",
    aweme_like_count: "828",
    aweme_comment_count: "64",
    aweme_share_count: "125",
    aweme_play_count: 4458958,
    aweme_activation: 0.7,
    live_count: "69",
    live_time: 4068,
    live_watch_count: 4974,
    live_watch_time: 5511,
    live_like_count: "6986",
    live_comment_count: "3912",
    live_activation: 0.8667,
    live_fans_add: "48",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "连云港海旗",
    company_name: "连云港海旗汽车销售服务有限公司",
    store_code: "EJS617",
    大区: "华东区",
    "省份-城市": "江苏省-连云港市",
    "所选分组编号/分组名称": "-",
    fans_count: "8",
    fans_count_total: "2328",
    aweme_count: "64",
    aweme_like_count: "238",
    aweme_comment_count: "22",
    aweme_share_count: "52",
    aweme_play_count: 37799,
    aweme_activation: 0.9,
    live_count: "70",
    live_time: 4127,
    live_watch_count: 2439,
    live_watch_time: 2710,
    live_like_count: "2545",
    live_comment_count: "230",
    live_activation: 0.9667,
    live_fans_add: "5",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "西双版纳骏杰红旗体验中心",
    company_name: "西双版纳骏杰汽车销售服务有限公司",
    store_code: "WYN609",
    大区: "西部区",
    "省份-城市": "云南省-西双版纳傣族自治州",
    "所选分组编号/分组名称": "-",
    fans_count: "118",
    fans_count_total: "5760",
    aweme_count: "135",
    aweme_like_count: "631",
    aweme_comment_count: "80",
    aweme_share_count: "49",
    aweme_play_count: 115712,
    aweme_activation: 0.8333,
    live_count: "47",
    live_time: 3120,
    live_watch_count: 5531,
    live_watch_time: 6145,
    live_like_count: "13251",
    live_comment_count: "585",
    live_activation: 0.6333,
    live_fans_add: "11",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "大昌福源红旗智能体验中心",
    company_name: "山西大昌福源汽车销售服务有限公司",
    store_code: "NJN608",
    大区: "华北区",
    "省份-城市": "山西省-太原市",
    "所选分组编号/分组名称": "-",
    fans_count: "342",
    fans_count_total: "18818",
    aweme_count: "51",
    aweme_like_count: "400",
    aweme_comment_count: "31",
    aweme_share_count: "36",
    aweme_play_count: 453878,
    aweme_activation: 0.6333,
    live_count: "119",
    live_time: 7177,
    live_watch_count: 95975,
    live_watch_time: 106628,
    live_like_count: "100354",
    live_comment_count: "2844",
    live_activation: 0.8333,
    live_fans_add: "158",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "徐州天捷",
    company_name: "徐州天捷",
    store_code: "EJS616",
    大区: "华东区",
    "省份-城市": "江苏省-徐州市",
    "所选分组编号/分组名称": "-",
    fans_count: "265",
    fans_count_total: "10161",
    aweme_count: "84",
    aweme_like_count: "892",
    aweme_comment_count: "145",
    aweme_share_count: "90",
    aweme_play_count: 222632,
    aweme_activation: 0.8,
    live_count: "59",
    live_time: 3741,
    live_watch_count: 123274,
    live_watch_time: 136963,
    live_like_count: "127451",
    live_comment_count: "4017",
    live_activation: 0.8333,
    live_fans_add: "230",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "韶关荣耀",
    company_name: "韶关市荣耀汽车销售服务有限公司",
    store_code: "SGD619",
    大区: "华南区",
    "省份-城市": "广东省-韶关市",
    "所选分组编号/分组名称": "-",
    fans_count: "298",
    fans_count_total: "206837",
    aweme_count: "71",
    aweme_like_count: "3416",
    aweme_comment_count: "155",
    aweme_share_count: "93",
    aweme_play_count: 421543,
    aweme_activation: 0.9333,
    live_count: "34",
    live_time: 3475,
    live_watch_count: 93465,
    live_watch_time: 103850,
    live_like_count: "231095",
    live_comment_count: "16246",
    live_activation: 1,
    live_fans_add: "1369",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "黑龙江华之诚万家",
    company_name: "黑龙江省华之诚万家汽车销售服务有限公司",
    store_code: "DHL604",
    大区: "东北区",
    "省份-城市": "黑龙江省-哈尔滨市",
    "所选分组编号/分组名称": "-",
    fans_count: "860",
    fans_count_total: "132896",
    aweme_count: "73",
    aweme_like_count: "2361",
    aweme_comment_count: "331",
    aweme_share_count: "648",
    aweme_play_count: 1140777,
    aweme_activation: 0.5667,
    live_count: "69",
    live_time: 4373,
    live_watch_count: 162272,
    live_watch_time: 179008,
    live_like_count: "95672",
    live_comment_count: "11480",
    live_activation: 0.7,
    live_fans_add: "370",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "深圳通利华红旗(龙岗）",
    company_name: "深圳通利华红旗(龙岗）",
    store_code: "SGD620",
    大区: "华南区",
    "省份-城市": "广东省-深圳市",
    "所选分组编号/分组名称": "-",
    fans_count: "1140",
    fans_count_total: "23742",
    aweme_count: "58",
    aweme_like_count: "292",
    aweme_comment_count: "35",
    aweme_share_count: "28",
    aweme_play_count: 133168,
    aweme_activation: 0.6,
    live_count: "38",
    live_time: 1428,
    live_watch_count: 62424,
    live_watch_time: 69360,
    live_like_count: "9029",
    live_comment_count: "5330",
    live_activation: 0.4,
    live_fans_add: "926",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "湖北骏翔汽车",
    company_name: "湖北骏翔汽车销售服务有限公司",
    store_code: "CHB613",
    大区: "中南区",
    "省份-城市": "湖北省-随州市",
    "所选分组编号/分组名称": "-",
    fans_count: "22",
    fans_count_total: "311",
    aweme_count: "15",
    aweme_like_count: "85",
    aweme_comment_count: "16",
    aweme_share_count: "11",
    aweme_play_count: 14773,
    aweme_activation: 0.3,
    live_count: "37",
    live_time: 2163,
    live_watch_count: 345,
    live_watch_time: 383,
    live_like_count: "19855",
    live_comment_count: "45",
    live_activation: 0.6333,
    live_fans_add: "3",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "威海鸿运",
    company_name: "威海鸿运汽车销售服务有限公司",
    store_code: "NSD620",
    大区: "东北区",
    "省份-城市": "山东省-威海市",
    "所选分组编号/分组名称": "-",
    fans_count: "79",
    fans_count_total: "35940",
    aweme_count: "75",
    aweme_like_count: "393",
    aweme_comment_count: "30",
    aweme_share_count: "9",
    aweme_play_count: 171292,
    aweme_activation: 0.9,
    live_count: "58",
    live_time: 3535,
    live_watch_count: 1911,
    live_watch_time: 2119,
    live_like_count: "5681",
    live_comment_count: "518",
    live_activation: 0.7,
    live_fans_add: "9",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "湘西旗胜",
    company_name: "湘西旗胜汽车销售有限责任公司",
    store_code: "CHN614",
    大区: "中南区",
    "省份-城市": "湖南省-湘西土家族苗族自治州",
    "所选分组编号/分组名称": "-",
    fans_count: "411",
    fans_count_total: "18851",
    aweme_count: "82",
    aweme_like_count: "3470",
    aweme_comment_count: "261",
    aweme_share_count: "93",
    aweme_play_count: 1311110,
    aweme_activation: 0.8333,
    live_count: "82",
    live_time: 4910,
    live_watch_count: 28741,
    live_watch_time: 31934,
    live_like_count: "118691",
    live_comment_count: "2591",
    live_activation: 0.9,
    live_fans_add: "111",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "滁州红旗4S店",
    company_name: "滁州红旗4S店",
    store_code: "EAH612",
    大区: "华东区",
    "省份-城市": "安徽省-滁州市",
    "所选分组编号/分组名称": "-",
    fans_count: "1237",
    fans_count_total: "8188",
    aweme_count: "130",
    aweme_like_count: "531",
    aweme_comment_count: "107",
    aweme_share_count: "12",
    aweme_play_count: 213067,
    aweme_activation: 1,
    live_count: "63",
    live_time: 4109,
    live_watch_count: 2751,
    live_watch_time: 3046,
    live_like_count: "28208",
    live_comment_count: "1658",
    live_activation: 0.8333,
    live_fans_add: "26",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "鞍山天美红旗",
    company_name: "鞍山天美汽车销售有限公司",
    store_code: "DLN609",
    大区: "东北区",
    "省份-城市": "辽宁省-鞍山市",
    "所选分组编号/分组名称": "-",
    fans_count: "6267",
    fans_count_total: "67677",
    aweme_count: "61",
    aweme_like_count: "315",
    aweme_comment_count: "117",
    aweme_share_count: "100",
    aweme_play_count: 91396,
    aweme_activation: 0.7667,
    live_count: "90",
    live_time: 5462,
    live_watch_count: 902177,
    live_watch_time: 992441,
    live_like_count: "252050",
    live_comment_count: "6602",
    live_activation: 0.9333,
    live_fans_add: "129",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "楚雄安晟",
    company_name: "楚雄安晟汽车销售服务有限公司",
    store_code: "WYN612",
    大区: "西部区",
    "省份-城市": "云南省-楚雄彝族自治州",
    "所选分组编号/分组名称": "-",
    fans_count: "-7",
    fans_count_total: "1673",
    aweme_count: "13",
    aweme_like_count: "58",
    aweme_comment_count: "2",
    aweme_share_count: "6",
    aweme_play_count: 8344,
    aweme_activation: 0.2,
    live_count: "40",
    live_time: 2456,
    live_watch_count: 5492,
    live_watch_time: 6102,
    live_like_count: "19151",
    live_comment_count: "242",
    live_activation: 0.8333,
    live_fans_add: "7",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "文山鑫桥红旗",
    company_name: "文山市鑫桥汽车销售服务有限公司",
    store_code: "WYN611",
    大区: "西部区",
    "省份-城市": "云南省-文山壮族苗族自治州",
    "所选分组编号/分组名称": "-",
    fans_count: "-80",
    fans_count_total: "26583",
    aweme_count: "73",
    aweme_like_count: "647",
    aweme_comment_count: "49",
    aweme_share_count: "15",
    aweme_play_count: 45808,
    aweme_activation: 1,
    live_count: "76",
    live_time: 4733,
    live_watch_count: 4597,
    live_watch_time: 5108,
    live_like_count: "51167",
    live_comment_count: "4130",
    live_activation: 0.9,
    live_fans_add: "25",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "深圳锦红红旗",
    company_name: "深圳锦红汽车销售服务有限公司",
    store_code: "SGD621",
    大区: "华南区",
    "省份-城市": "广东省-深圳市",
    "所选分组编号/分组名称": "-",
    fans_count: "-20",
    fans_count_total: "37271",
    aweme_count: "38",
    aweme_like_count: "170",
    aweme_comment_count: "8",
    aweme_share_count: "15",
    aweme_play_count: 19908,
    aweme_activation: 0.4,
    live_count: "40",
    live_time: 2474,
    live_watch_count: 2929,
    live_watch_time: 3254,
    live_like_count: "109790",
    live_comment_count: "1714",
    live_activation: 0.3667,
    live_fans_add: "74",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "莆田星奥",
    company_name: "莆田星奥汽车销售服务有限公司",
    store_code: "SFJ609",
    大区: "华南区",
    "省份-城市": "福建省-莆田市",
    "所选分组编号/分组名称": "-",
    fans_count: "-7",
    fans_count_total: "4557",
    aweme_count: "42",
    aweme_like_count: "153",
    aweme_comment_count: "40",
    aweme_share_count: "8",
    aweme_play_count: 36579,
    aweme_activation: 0.7,
    live_count: "39",
    live_time: 2685,
    live_watch_count: 2415,
    live_watch_time: 2683,
    live_like_count: "29114",
    live_comment_count: "1688",
    live_activation: 0.7333,
    live_fans_add: "21",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "枣庄旗尚",
    company_name: "枣庄旗尚汽车销售服务有限公司",
    store_code: "NSD621",
    大区: "东北区",
    "省份-城市": "山东省-枣庄市",
    "所选分组编号/分组名称": "-",
    fans_count: "-58",
    fans_count_total: "23580",
    aweme_count: "62",
    aweme_like_count: "220",
    aweme_comment_count: "38",
    aweme_share_count: "36",
    aweme_play_count: 82089,
    aweme_activation: 0.6,
    live_count: "59",
    live_time: 3918,
    live_watch_count: 4374,
    live_watch_time: 4854,
    live_like_count: "31947",
    live_comment_count: "6216",
    live_activation: 0.9,
    live_fans_add: "43",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "石家庄中冀华晟红旗",
    company_name: "河北华晟汽车服务有限公司",
    store_code: "NJI609",
    大区: "华北区",
    "省份-城市": "河北省-石家庄市",
    "所选分组编号/分组名称": "-",
    fans_count: "186",
    fans_count_total: "15977",
    aweme_count: "38",
    aweme_like_count: "179",
    aweme_comment_count: "32",
    aweme_share_count: "5",
    aweme_play_count: 21372,
    aweme_activation: 0.5667,
    live_count: "73",
    live_time: 4556,
    live_watch_count: 38855,
    live_watch_time: 42821,
    live_like_count: "138604",
    live_comment_count: "7987",
    live_activation: 0.8333,
    live_fans_add: "177",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "张家口龙瀚",
    company_name: "张家口龙瀚",
    store_code: "NJI610",
    大区: "华北区",
    "省份-城市": "河北省-张家口市",
    "所选分组编号/分组名称": "-",
    fans_count: "132",
    fans_count_total: "79186",
    aweme_count: "36",
    aweme_like_count: "137",
    aweme_comment_count: "20",
    aweme_share_count: "2",
    aweme_play_count: 19882,
    aweme_activation: 0.3667,
    live_count: "40",
    live_time: 2658,
    live_watch_count: 221593,
    live_watch_time: 243759,
    live_like_count: "31058",
    live_comment_count: "1423",
    live_activation: 0.6,
    live_fans_add: "27",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "榆林恒盛德岳",
    company_name: "榆林恒盛德岳汽车贸易有限公司",
    store_code: "XSS608",
    大区: "西部区",
    "省份-城市": "陕西省-榆林市",
    "所选分组编号/分组名称": "-",
    fans_count: "247",
    fans_count_total: "309101",
    aweme_count: "208",
    aweme_like_count: "2150",
    aweme_comment_count: "296",
    aweme_share_count: "515",
    aweme_play_count: 934895,
    aweme_activation: 0.9667,
    live_count: "103",
    live_time: 7206,
    live_watch_count: 82753,
    live_watch_time: 91257,
    live_like_count: "635745",
    live_comment_count: "22370",
    live_activation: 0.9333,
    live_fans_add: "339",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "大连汽贸集团华宇",
    company_name: "大连汽贸集团华宇汽车销售服务有限公司",
    store_code: "DLN605",
    大区: "东北区",
    "省份-城市": "辽宁省-大连市",
    "所选分组编号/分组名称": "-",
    fans_count: "-536",
    fans_count_total: "329364",
    aweme_count: "70",
    aweme_like_count: "379",
    aweme_comment_count: "76",
    aweme_share_count: "89",
    aweme_play_count: 565397,
    aweme_activation: 0.6,
    live_count: "69",
    live_time: 4031,
    live_watch_count: 66926,
    live_watch_time: 74362,
    live_like_count: "207041",
    live_comment_count: "7997",
    live_activation: 0.8667,
    live_fans_add: "652",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "荆门英驰-红旗",
    company_name: "荆门英驰汽车销售有限公司",
    store_code: "CHB610",
    大区: "中南区",
    "省份-城市": "湖北省-荆门市",
    "所选分组编号/分组名称": "-",
    fans_count: "435",
    fans_count_total: "9946",
    aweme_count: "81",
    aweme_like_count: "598",
    aweme_comment_count: "128",
    aweme_share_count: "18",
    aweme_play_count: 70436,
    aweme_activation: 0.7667,
    live_count: "70",
    live_time: 6197,
    live_watch_count: 59042,
    live_watch_time: 65602,
    live_like_count: "236079",
    live_comment_count: "6353",
    live_activation: 0.8333,
    live_fans_add: "319",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "恩施英驰红旗",
    company_name: "恩施英驰汽车销售有限公司",
    store_code: "CHB614",
    大区: "中南区",
    "省份-城市": "湖北省-恩施土家族苗族自治州",
    "所选分组编号/分组名称": "-",
    fans_count: "170",
    fans_count_total: "3995",
    aweme_count: "56",
    aweme_like_count: "654",
    aweme_comment_count: "68",
    aweme_share_count: "11",
    aweme_play_count: 52962,
    aweme_activation: 0.7333,
    live_count: "54",
    live_time: 3456,
    live_watch_count: 8975,
    live_watch_time: 9972,
    live_like_count: "198871",
    live_comment_count: "4860",
    live_activation: 0.8667,
    live_fans_add: "88",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "成都岳宏泰红旗",
    company_name: "成都岳宏泰汽车销售服务有限公司",
    store_code: "WSC622",
    大区: "西部区",
    "省份-城市": "四川省-成都市",
    "所选分组编号/分组名称": "-",
    fans_count: "138",
    fans_count_total: "134756",
    aweme_count: "143",
    aweme_like_count: "3508",
    aweme_comment_count: "204",
    aweme_share_count: "145",
    aweme_play_count: 38920798,
    aweme_activation: 1,
    live_count: "107",
    live_time: 6760,
    live_watch_count: 457638,
    live_watch_time: 507878,
    live_like_count: "480170",
    live_comment_count: "6602",
    live_activation: 0.8667,
    live_fans_add: "344",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "武汉泰岳宏旗",
    company_name: "武汉泰岳宏旗",
    store_code: "CHB615",
    大区: "中南区",
    "省份-城市": "湖北省-武汉市",
    "所选分组编号/分组名称": "-",
    fans_count: "112",
    fans_count_total: "29119",
    aweme_count: "108",
    aweme_like_count: "510",
    aweme_comment_count: "88",
    aweme_share_count: "74",
    aweme_play_count: 295448,
    aweme_activation: 0.7667,
    live_count: "106",
    live_time: 6521,
    live_watch_count: 125008,
    live_watch_time: 138889,
    live_like_count: "416990",
    live_comment_count: "1787",
    live_activation: 0.8667,
    live_fans_add: "210",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "黄石新兴振宇红旗",
    company_name: "黄石市新兴振宇汽车销售有限公司",
    store_code: "CHB611",
    大区: "中南区",
    "省份-城市": "湖北省-黄石市",
    "所选分组编号/分组名称": "-",
    fans_count: "79",
    fans_count_total: "5429",
    aweme_count: "77",
    aweme_like_count: "478",
    aweme_comment_count: "30",
    aweme_share_count: "14",
    aweme_play_count: 148158,
    aweme_activation: 1,
    live_count: "60",
    live_time: 3613,
    live_watch_count: 2508,
    live_watch_time: 2786,
    live_like_count: "99699",
    live_comment_count: "975",
    live_activation: 0.9667,
    live_fans_add: "92",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "舟山旗翔",
    company_name: "舟山旗翔汽车销售服务有限公司",
    store_code: "EZJ620",
    大区: "华东区",
    "省份-城市": "浙江省-舟山市",
    "所选分组编号/分组名称": "-",
    fans_count: "-33",
    fans_count_total: "13036",
    aweme_count: "58",
    aweme_like_count: "489",
    aweme_comment_count: "33",
    aweme_share_count: "22",
    aweme_play_count: 167858,
    aweme_activation: 0.8667,
    live_count: "56",
    live_time: 3212,
    live_watch_count: 1067,
    live_watch_time: 1185,
    live_like_count: "923",
    live_comment_count: "178",
    live_activation: 0.9,
    live_fans_add: "0",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "台州星旗",
    company_name: "台州星旗汽车销售服务有限公司",
    store_code: "EZJ619",
    大区: "华东区",
    "省份-城市": "浙江省-台州市",
    "所选分组编号/分组名称": "-",
    fans_count: "1049",
    fans_count_total: "56897",
    aweme_count: "78",
    aweme_like_count: "414",
    aweme_comment_count: "51",
    aweme_share_count: "45",
    aweme_play_count: 1359213,
    aweme_activation: 0.7667,
    live_count: "29",
    live_time: 1827,
    live_watch_count: 126022,
    live_watch_time: 138799,
    live_like_count: "72584",
    live_comment_count: "2358",
    live_activation: 0.5,
    live_fans_add: "173",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "锦州新东方红旗",
    company_name: "锦州新东方汽车销售服务有限公司",
    store_code: "DLN607",
    大区: "东北区",
    "省份-城市": "辽宁省-锦州市",
    "所选分组编号/分组名称": "-",
    fans_count: "-264",
    fans_count_total: "66777",
    aweme_count: "96",
    aweme_like_count: "2305",
    aweme_comment_count: "2050",
    aweme_share_count: "85",
    aweme_play_count: 44993,
    aweme_activation: 0.9333,
    live_count: "25",
    live_time: 1566,
    live_watch_count: 4314,
    live_watch_time: 4762,
    live_like_count: "14508",
    live_comment_count: "624",
    live_activation: 0.7333,
    live_fans_add: "50",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "佳木斯安盈",
    company_name: "佳木斯安盈汽车销售服务有限公司",
    store_code: "DHL605",
    大区: "东北区",
    "省份-城市": "黑龙江省-佳木斯市",
    "所选分组编号/分组名称": "-",
    fans_count: "7",
    fans_count_total: "45461",
    aweme_count: "39",
    aweme_like_count: "263",
    aweme_comment_count: "22",
    aweme_share_count: "33",
    aweme_play_count: 191022,
    aweme_activation: 0.3,
    live_count: "46",
    live_time: 2796,
    live_watch_count: 4501,
    live_watch_time: 4964,
    live_like_count: "12626",
    live_comment_count: "272",
    live_activation: 0.6333,
    live_fans_add: "15",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "辽宁大地",
    company_name: "辽宁大地汽车销售服务有限公司",
    store_code: "DLN606",
    大区: "东北区",
    "省份-城市": "辽宁省-葫芦岛市",
    "所选分组编号/分组名称": "-",
    fans_count: "-354",
    fans_count_total: "210067",
    aweme_count: "38",
    aweme_like_count: "469",
    aweme_comment_count: "127",
    aweme_share_count: "52",
    aweme_play_count: 53710,
    aweme_activation: 0.3667,
    live_count: "31",
    live_time: 2213,
    live_watch_count: 12667,
    live_watch_time: 13934,
    live_like_count: "89490",
    live_comment_count: "2421",
    live_activation: 0.9,
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "松原征途中和",
    company_name: "松原市征途中和汽车销售服务有限公司",
    store_code: "DJL609",
    大区: "东北区",
    "省份-城市": "吉林省-松原市",
    "所选分组编号/分组名称": "-",
    fans_count: "858",
    fans_count_total: "14409",
    aweme_count: "235",
    aweme_like_count: "528",
    aweme_comment_count: "38",
    aweme_share_count: "16",
    aweme_play_count: 32750,
    aweme_activation: 1,
    live_count: "237",
    live_time: 14653,
    live_watch_count: 67792,
    live_watch_time: 74587,
    live_like_count: "261082",
    live_comment_count: "15617",
    live_activation: 0.9333,
    live_fans_add: "9",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "内江利恒孚",
    company_name: "内江利恒孚车业有限公司",
    store_code: "WSC620",
    大区: "西部区",
    "省份-城市": "四川省-内江市",
    "所选分组编号/分组名称": "-",
    fans_count: "7",
    fans_count_total: "7806",
    aweme_count: "30",
    aweme_like_count: "136",
    aweme_comment_count: "24",
    aweme_share_count: "18",
    aweme_play_count: 16663,
    aweme_activation: 0.5,
    live_count: "65",
    live_time: 4023,
    live_watch_count: 1005,
    live_watch_time: 1115,
    live_like_count: "6328",
    live_comment_count: "1005",
    live_activation: 0.6333,
    live_fans_add: "6",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "沈阳神州川达",
    company_name: "沈阳神州川达汽车销售服务有限责任公司",
    store_code: "DLN608",
    大区: "东北区",
    "省份-城市": "辽宁省-沈阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "1157",
    fans_count_total: "46143",
    aweme_count: "94",
    aweme_like_count: "213",
    aweme_comment_count: "22",
    aweme_share_count: "15",
    aweme_play_count: 828360,
    aweme_activation: 0.9,
    live_count: "141",
    live_time: 8902,
    live_watch_count: 128707,
    live_watch_time: 141729,
    live_like_count: "279833",
    live_comment_count: "5026",
    live_activation: 0.8667,
    live_fans_add: "128",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "永州达美",
    company_name: "永州达美汽车销售服务有限公司",
    store_code: "CHN615",
    大区: "中南区",
    "省份-城市": "湖南省-永州市",
    "所选分组编号/分组名称": "-",
    fans_count: "-41",
    fans_count_total: "8133",
    aweme_count: "96",
    aweme_like_count: "2942",
    aweme_comment_count: "110",
    aweme_share_count: "192",
    aweme_play_count: 310741,
    aweme_activation: 0.9667,
    live_count: "57",
    live_time: 3419,
    live_watch_count: 6748,
    live_watch_time: 7497,
    live_like_count: "2143",
    live_comment_count: "347",
    live_activation: 0.7667,
    live_fans_add: "4",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "保山上通",
    company_name: "保山市上通汽车销售服务有限公司",
    store_code: "WYN613",
    大区: "西部区",
    "省份-城市": "云南省-保山市",
    "所选分组编号/分组名称": "-",
    fans_count: "104",
    fans_count_total: "8243",
    aweme_count: "66",
    aweme_like_count: "893",
    aweme_comment_count: "51",
    aweme_share_count: "35",
    aweme_play_count: 298576,
    aweme_activation: 0.7,
    live_count: "66",
    live_time: 3961,
    live_watch_count: 7003,
    live_watch_time: 7781,
    live_like_count: "76953",
    live_comment_count: "3322",
    live_activation: 0.8333,
    live_fans_add: "165",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "广东腾辉鸿旗体验服务中心",
    company_name: "广东腾辉鸿旗汽车销售服务有限公司",
    store_code: "SGD629",
    大区: "华南区",
    "省份-城市": "广东省-梅州市",
    "所选分组编号/分组名称": "-",
    fans_count: "2625",
    fans_count_total: "41363",
    aweme_count: "78",
    aweme_like_count: "1005",
    aweme_comment_count: "79",
    aweme_share_count: "82",
    aweme_play_count: 226446,
    aweme_activation: 0.9333,
    live_count: "59",
    live_time: 3743,
    live_watch_count: 271514,
    live_watch_time: 298830,
    live_like_count: "80675",
    live_comment_count: "4282",
    live_activation: 0.6667,
    live_fans_add: "164",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "池州鑫瑞",
    company_name: "池州鑫瑞汽车销售服务有限公司",
    store_code: "EAH616",
    大区: "华东区",
    "省份-城市": "安徽省-池州市",
    "所选分组编号/分组名称": "-",
    fans_count: "522",
    fans_count_total: "58587",
    aweme_count: "139",
    aweme_like_count: "694",
    aweme_comment_count: "111",
    aweme_share_count: "58",
    aweme_play_count: 317182,
    aweme_activation: 0.9,
    live_count: "99",
    live_time: 6208,
    live_watch_count: 200891,
    live_watch_time: 222024,
    live_like_count: "37470",
    live_comment_count: "3745",
    live_activation: 0.8333,
    live_fans_add: "325",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "新疆晨运",
    company_name: "新疆晨运汽车销售有限公司",
    store_code: "XXJ601",
    大区: "西部区",
    "省份-城市": "新疆维吾尔自治区-巴音郭楞蒙古自治州",
    "所选分组编号/分组名称": "-",
    fans_count: "299",
    fans_count_total: "21466",
    aweme_count: "284",
    aweme_like_count: "883",
    aweme_comment_count: "88",
    aweme_share_count: "116",
    aweme_play_count: 227140,
    aweme_activation: 0.8667,
    live_count: "129",
    live_time: 10269,
    live_watch_count: 29386,
    live_watch_time: 32651,
    live_like_count: "158379",
    live_comment_count: "9030",
    live_activation: 0.8333,
    live_fans_add: "274",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "阳泉鼎晟红旗",
    company_name: "阳泉市鼎晟汽车销售服务有限公司",
    store_code: "NJN609",
    大区: "华北区",
    "省份-城市": "山西省-阳泉市",
    "所选分组编号/分组名称": "-",
    fans_count: "-36",
    fans_count_total: "18496",
    aweme_count: "15",
    aweme_like_count: "57",
    aweme_comment_count: "13",
    aweme_share_count: "0",
    aweme_play_count: 15482,
    aweme_activation: 0.1,
    live_count: "29",
    live_time: 1725,
    live_watch_count: 2930,
    live_watch_time: 3255,
    live_like_count: "35382",
    live_comment_count: "297",
    live_activation: 0.7667,
    live_fans_add: "11",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "佛山飞扬红旗",
    company_name: "佛山飞扬红旗汽车销售服务有限公司",
    store_code: "SGD628",
    大区: "华南区",
    "省份-城市": "广东省-佛山市",
    "所选分组编号/分组名称": "-",
    fans_count: "220",
    fans_count_total: "43789",
    aweme_count: "62",
    aweme_like_count: "436",
    aweme_comment_count: "67",
    aweme_share_count: "40",
    aweme_play_count: 183674,
    aweme_activation: 0.8333,
    live_count: "50",
    live_time: 3260,
    live_watch_count: 17892,
    live_watch_time: 19880,
    live_like_count: "101486",
    live_comment_count: "2174",
    live_activation: 1,
    live_fans_add: "106",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "钦州益辰",
    company_name: "钦州益辰汽车销售服务有限公司",
    store_code: "SGX605",
    大区: "华南区",
    "省份-城市": "广西壮族自治区-钦州市",
    "所选分组编号/分组名称": "-",
    fans_count: "467",
    fans_count_total: "17619",
    aweme_count: "67",
    aweme_like_count: "2089",
    aweme_comment_count: "293",
    aweme_share_count: "251",
    aweme_play_count: 1368394,
    aweme_activation: 0.6333,
    live_count: "51",
    live_time: 4403,
    live_watch_count: 25318,
    live_watch_time: 28131,
    live_like_count: "33470",
    live_comment_count: "1398",
    live_activation: 0.7667,
    live_fans_add: "80",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "吉林神州红旗",
    company_name: "吉林市神州红旗汽车销售服务有限公司",
    store_code: "DJL611",
    大区: "东北区",
    "省份-城市": "吉林省-吉林市",
    "所选分组编号/分组名称": "-",
    fans_count: "-60",
    fans_count_total: "16530",
    aweme_count: "68",
    aweme_like_count: "223",
    aweme_comment_count: "41",
    aweme_share_count: "38",
    aweme_play_count: 43404,
    aweme_activation: 0.9333,
    live_count: "47",
    live_time: 2772,
    live_watch_count: 4561,
    live_watch_time: 5067,
    live_like_count: "22876",
    live_comment_count: "899",
    live_activation: 0.8333,
    live_fans_add: "22",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "德宏海伟宏亦",
    company_name: "德宏海伟宏亦汽车销售有限公司",
    store_code: "WYN614",
    大区: "西部区",
    "省份-城市": "云南省-德宏傣族景颇族自治州",
    "所选分组编号/分组名称": "-",
    fans_count: "-7",
    fans_count_total: "6445",
    aweme_count: "51",
    aweme_like_count: "547",
    aweme_comment_count: "69",
    aweme_share_count: "31",
    aweme_play_count: 51053,
    aweme_activation: 1,
    live_count: "52",
    live_time: 3169,
    live_watch_count: 1852,
    live_watch_time: 2057,
    live_like_count: "8163",
    live_comment_count: "1292",
    live_activation: 0.8667,
    live_fans_add: "6",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "伊犁冠邦",
    company_name: "伊犁冠邦汽车销售服务有限公司",
    store_code: "XXJ602",
    大区: "西部区",
    "省份-城市": "新疆维吾尔自治区-伊犁哈萨克自治州",
    "所选分组编号/分组名称": "-",
    fans_count: "41",
    fans_count_total: "1860",
    aweme_count: "219",
    aweme_like_count: "788",
    aweme_comment_count: "218",
    aweme_share_count: "82",
    aweme_play_count: 27761,
    aweme_activation: 1,
    live_count: "110",
    live_time: 6177,
    live_watch_count: 1457,
    live_watch_time: 1612,
    live_like_count: "97548",
    live_comment_count: "258",
    live_activation: 0.9,
    live_fans_add: "2",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "广西宝旗",
    company_name: "广西宝旗汽车销售服务有限责任公司",
    store_code: "SGX604",
    大区: "华南区",
    "省份-城市": "广西壮族自治区-柳州市",
    "所选分组编号/分组名称": "-",
    fans_count: "493",
    fans_count_total: "31809",
    aweme_count: "89",
    aweme_like_count: "2778",
    aweme_comment_count: "262",
    aweme_share_count: "215",
    aweme_play_count: 539422,
    aweme_activation: 0.9667,
    live_count: "89",
    live_time: 5850,
    live_watch_count: 3995,
    live_watch_time: 4425,
    live_like_count: "22840",
    live_comment_count: "2095",
    live_activation: 0.8333,
    live_fans_add: "70",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "萍乡兰天嘉华红旗",
    company_name: "萍乡市兰天嘉华汽车销售服务有限公司",
    store_code: "CJX609",
    大区: "中南区",
    "省份-城市": "江西省-萍乡市",
    "所选分组编号/分组名称": "-",
    fans_count: "239",
    fans_count_total: "62233",
    aweme_count: "44",
    aweme_like_count: "527",
    aweme_comment_count: "92",
    aweme_share_count: "38",
    aweme_play_count: 213774,
    aweme_activation: 0.5667,
    live_count: "46",
    live_time: 2864,
    live_watch_count: 171747,
    live_watch_time: 188950,
    live_like_count: "22691",
    live_comment_count: "1597",
    live_activation: 0.7,
    live_fans_add: "68",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "三明旗展",
    company_name: "三明市旗展汽车销售服务有限公司",
    store_code: "SFJ610",
    大区: "华南区",
    "省份-城市": "福建省-三明市",
    "所选分组编号/分组名称": "-",
    fans_count: "234",
    fans_count_total: "8260",
    aweme_count: "103",
    aweme_like_count: "795",
    aweme_comment_count: "117",
    aweme_share_count: "41",
    aweme_play_count: 398128,
    aweme_activation: 0.6333,
    live_count: "46",
    live_time: 2797,
    live_watch_count: 7128,
    live_watch_time: 7920,
    live_like_count: "106084",
    live_comment_count: "2937",
    live_activation: 0.8667,
    live_fans_add: "256",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "营口国之信红旗体验中心",
    company_name: "营口市国之信汽车销售服务有限公司",
    store_code: "DLN611",
    大区: "东北区",
    "省份-城市": "辽宁省-营口市",
    "所选分组编号/分组名称": "-",
    fans_count: "-259",
    fans_count_total: "108667",
    aweme_count: "84",
    aweme_like_count: "157",
    aweme_comment_count: "13",
    aweme_share_count: "47",
    aweme_play_count: 17969,
    aweme_activation: 0.9667,
    live_count: "50",
    live_time: 2890,
    live_watch_count: 7274,
    live_watch_time: 8066,
    live_like_count: "11360",
    live_comment_count: "3201",
    live_activation: 0.8333,
    live_fans_add: "26",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "呼伦贝尔大鹏红旗",
    company_name: "呼伦贝尔市大鹏睿达汽车贸易有限公司",
    store_code: "DNM607",
    大区: "东北区",
    "省份-城市": "内蒙古自治区-呼伦贝尔市",
    "所选分组编号/分组名称": "-",
    fans_count: "59",
    fans_count_total: "1408",
    aweme_count: "38",
    aweme_like_count: "199",
    aweme_comment_count: "30",
    aweme_share_count: "2",
    aweme_play_count: 53681,
    aweme_activation: 0.5333,
    live_count: "45",
    live_time: 2967,
    live_watch_count: 1098,
    live_watch_time: 1220,
    live_like_count: "8909",
    live_comment_count: "860",
    live_activation: 0.7667,
    live_fans_add: "15",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "无锡和旗",
    company_name: "无锡和旗汽车销售服务有限公司",
    store_code: "EJS621",
    大区: "华东区",
    "省份-城市": "江苏省-无锡市",
    "所选分组编号/分组名称": "-",
    fans_count: "-62",
    fans_count_total: "58387",
    aweme_count: "59",
    aweme_like_count: "722",
    aweme_comment_count: "152",
    aweme_share_count: "29",
    aweme_play_count: 218356,
    aweme_activation: 0.7667,
    live_count: "63",
    live_time: 3767,
    live_watch_count: 15818,
    live_watch_time: 17574,
    live_like_count: "144043",
    live_comment_count: "4245",
    live_activation: 0.7667,
    live_fans_add: "85",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "黑龙江万家祥和",
    company_name: "黑龙江省万家祥和汽车销售服务有限公司",
    store_code: "DHL607",
    大区: "东北区",
    "省份-城市": "黑龙江省-哈尔滨市",
    "所选分组编号/分组名称": "-",
    fans_count: "2181",
    fans_count_total: "198589",
    aweme_count: "83",
    aweme_like_count: "2126",
    aweme_comment_count: "310",
    aweme_share_count: "397",
    aweme_play_count: 932679,
    aweme_activation: 0.6,
    live_count: "98",
    live_time: 7320,
    live_watch_count: 627574,
    live_watch_time: 690969,
    live_like_count: "237265",
    live_comment_count: "12856",
    live_activation: 0.8,
    live_fans_add: "506",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "百色健稳红旗体验中心",
    company_name: "百色市健稳汽车科技有限公司",
    store_code: "SGX606",
    大区: "华南区",
    "省份-城市": "广西壮族自治区-百色市",
    "所选分组编号/分组名称": "-",
    fans_count: "21",
    fans_count_total: "5599",
    aweme_count: "38",
    aweme_like_count: "412",
    aweme_comment_count: "58",
    aweme_share_count: "39",
    aweme_play_count: 44634,
    aweme_activation: 0.5667,
    live_count: "42",
    live_time: 3755,
    live_watch_count: 6902,
    live_watch_time: 7668,
    live_like_count: "19782",
    live_comment_count: "6366",
    live_activation: 0.8,
    live_fans_add: "30",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "山西吕梁大昌",
    company_name: "山西省吕梁市大昌汽车销售有限公司",
    store_code: "NJN611",
    大区: "华北区",
    "省份-城市": "山西省-吕梁市",
    "所选分组编号/分组名称": "-",
    fans_count: "2648",
    fans_count_total: "54912",
    aweme_count: "110",
    aweme_like_count: "3415",
    aweme_comment_count: "471",
    aweme_share_count: "952",
    aweme_play_count: 1012994,
    aweme_activation: 0.8,
    live_count: "169",
    live_time: 15240,
    live_watch_count: 200076,
    live_watch_time: 220714,
    live_like_count: "165066",
    live_comment_count: "10541",
    live_activation: 0.9333,
    live_fans_add: "1448",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "白山宝信",
    company_name: "白山市宝信汽车销售服务有限公司",
    store_code: "DJL612",
    大区: "东北区",
    "省份-城市": "吉林省-白山市",
    "所选分组编号/分组名称": "-",
    fans_count: "-60",
    fans_count_total: "21947",
    aweme_count: "50",
    aweme_like_count: "288",
    aweme_comment_count: "12",
    aweme_share_count: "4",
    aweme_play_count: 7958,
    aweme_activation: 1,
    live_count: "28",
    live_time: 1725,
    live_watch_count: 2466,
    live_watch_time: 2740,
    live_like_count: "6512",
    live_comment_count: "2012",
    live_activation: 0.8333,
    live_fans_add: "17",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "昌吉亚中机电红旗",
    company_name: "昌吉亚中机电有限公司",
    store_code: "XXJ603",
    大区: "西部区",
    "省份-城市": "新疆维吾尔自治区-昌吉回族自治州",
    "所选分组编号/分组名称": "-",
    fans_count: "25",
    fans_count_total: "2557",
    aweme_count: "58",
    aweme_like_count: "211",
    aweme_comment_count: "50",
    aweme_share_count: "7",
    aweme_play_count: 45215,
    aweme_activation: 0.6,
    live_count: "53",
    live_time: 3134,
    live_watch_count: 1377,
    live_watch_time: 1522,
    live_like_count: "1940",
    live_comment_count: "231",
    live_activation: 0.5333,
    live_fans_add: "6",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "攀枝花驭马红旗",
    company_name: "攀枝花驭马车业有限公司",
    store_code: "WSC623",
    大区: "西部区",
    "省份-城市": "四川省-攀枝花市",
    "所选分组编号/分组名称": "-",
    fans_count: "-25",
    fans_count_total: "923",
    aweme_count: "43",
    aweme_like_count: "132",
    aweme_comment_count: "27",
    aweme_share_count: "0",
    aweme_play_count: 7967,
    aweme_activation: 0.7,
    live_count: "30",
    live_time: 1884,
    live_watch_count: 3178,
    live_watch_time: 3531,
    live_like_count: "4150",
    live_comment_count: "1168",
    live_activation: 0.8333,
    live_fans_add: "5",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "庆阳金岛旗胜",
    company_name: "庆阳金岛旗胜汽车销售服务有限公司",
    store_code: "XGS601",
    大区: "西部区",
    "省份-城市": "甘肃省-庆阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "428",
    fans_count_total: "7703",
    aweme_count: "95",
    aweme_like_count: "770",
    aweme_comment_count: "45",
    aweme_share_count: "132",
    aweme_play_count: 142872,
    aweme_activation: 1,
    live_count: "99",
    live_time: 6282,
    live_watch_count: 145114,
    live_watch_time: 159798,
    live_like_count: "101171",
    live_comment_count: "2531",
    live_activation: 1,
    live_fans_add: "95",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "雅安国创红旗店",
    company_name: "雅安国创汽车销售服务有限公司",
    store_code: "WSC624",
    大区: "西部区",
    "省份-城市": "四川省-雅安市",
    "所选分组编号/分组名称": "-",
    fans_count: "-7",
    fans_count_total: "2173",
    aweme_count: "37",
    aweme_like_count: "189",
    aweme_comment_count: "46",
    aweme_share_count: "0",
    aweme_play_count: 70943,
    aweme_activation: 0.5333,
    live_count: "45",
    live_time: 2680,
    live_watch_count: 3707,
    live_watch_time: 4118,
    live_like_count: "92333",
    live_comment_count: "2482",
    live_activation: 0.8333,
    live_fans_add: "10",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "黄山旗胜红旗",
    company_name: "黄山旗胜汽车销售服务有限公司",
    store_code: "EAH617",
    大区: "华东区",
    "省份-城市": "安徽省-黄山市",
    "所选分组编号/分组名称": "-",
    fans_count: "-542",
    fans_count_total: "401896",
    aweme_count: "126",
    aweme_like_count: "4164",
    aweme_comment_count: "401",
    aweme_share_count: "596",
    aweme_play_count: 2317106,
    aweme_activation: 0.7667,
    live_count: "91",
    live_time: 5742,
    live_watch_count: 148271,
    live_watch_time: 163735,
    live_like_count: "64798",
    live_comment_count: "9258",
    live_activation: 0.9,
    live_fans_add: "364",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "山西大昌宏顺",
    company_name: "山西大昌宏顺汽车销售服务有限公司",
    store_code: "NJN612",
    大区: "华北区",
    "省份-城市": "山西省-晋中市",
    "所选分组编号/分组名称": "-",
    fans_count: "179",
    fans_count_total: "3382",
    aweme_count: "49",
    aweme_like_count: "131",
    aweme_comment_count: "25",
    aweme_share_count: "15",
    aweme_play_count: 45972,
    aweme_activation: 0.4,
    live_count: "70",
    live_time: 8278,
    live_watch_count: 152153,
    live_watch_time: 169052,
    live_like_count: "81983",
    live_comment_count: "1082",
    live_activation: 0.6333,
    live_fans_add: "165",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "芜湖红旗体验中心",
    company_name: "芜湖宏祺汽车销售服务有限公司",
    store_code: "EAH618",
    大区: "华东区",
    "省份-城市": "安徽省-芜湖市",
    "所选分组编号/分组名称": "-",
    fans_count: "-212",
    fans_count_total: "38981",
    aweme_count: "51",
    aweme_like_count: "85",
    aweme_comment_count: "3",
    aweme_share_count: "0",
    aweme_play_count: 19142,
    aweme_activation: 0.3667,
    live_count: "43",
    live_time: 2410,
    live_watch_count: 5214,
    live_watch_time: 5793,
    live_like_count: "13686",
    live_comment_count: "887",
    live_activation: 0.5,
    live_fans_add: "10",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "龙泽红旗",
    company_name: "北京龙泽红旗汽车销售有限公司",
    store_code: "NBJ127",
    大区: "华北区",
    "省份-城市": "北京市-北京市",
    "所选分组编号/分组名称": "-",
    fans_count: "3",
    fans_count_total: "3823",
    aweme_count: "41",
    aweme_like_count: "74",
    aweme_comment_count: "5",
    aweme_share_count: "3",
    aweme_play_count: 18579,
    aweme_activation: 0.6,
    live_count: "30",
    live_time: 1679,
    live_watch_count: 1403,
    live_watch_time: 1558,
    live_like_count: "24",
    live_comment_count: "41",
    live_activation: 1,
    live_fans_add: "2",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "成都三和银杏",
    company_name: "成都三和银杏汽车贸易有限公司",
    store_code: "WSC626",
    大区: "西部区",
    "省份-城市": "四川省-成都市",
    "所选分组编号/分组名称": "-",
    fans_count: "-943",
    fans_count_total: "867890",
    aweme_count: "70",
    aweme_like_count: "5327",
    aweme_comment_count: "911",
    aweme_share_count: "525",
    aweme_play_count: 1036911,
    aweme_activation: 0.4333,
    live_count: "253",
    live_time: 18803,
    live_watch_count: 662730,
    live_watch_time: 731242,
    live_like_count: "417411",
    live_comment_count: "22408",
    live_activation: 1,
    live_fans_add: "1773",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "杭州杭旗",
    company_name: "杭州杭旗汽车有限公司",
    store_code: "EZJ608",
    大区: "华东区",
    "省份-城市": "浙江省-杭州市",
    "所选分组编号/分组名称": "-",
    fans_count: "352",
    fans_count_total: "25516",
    aweme_count: "78",
    aweme_like_count: "384",
    aweme_comment_count: "66",
    aweme_share_count: "18",
    aweme_play_count: 649826,
    aweme_activation: 0.8667,
    live_count: "49",
    live_time: 3091,
    live_watch_count: 14931,
    live_watch_time: 16590,
    live_like_count: "23681",
    live_comment_count: "5167",
    live_activation: 0.7333,
    live_fans_add: "313",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "贵州毕节丽安",
    company_name: "贵州毕节丽安汽车销售服务有限公司",
    store_code: "WGZ608",
    大区: "西部区",
    "省份-城市": "贵州省-毕节市",
    "所选分组编号/分组名称": "-",
    fans_count: "-505",
    fans_count_total: "223856",
    aweme_count: "59",
    aweme_like_count: "1115",
    aweme_comment_count: "148",
    aweme_share_count: "73",
    aweme_play_count: 442141,
    aweme_activation: 0.5,
    live_count: "54",
    live_time: 3241,
    live_watch_count: 5210,
    live_watch_time: 5784,
    live_like_count: "4643",
    live_comment_count: "786",
    live_activation: 0.8333,
    live_fans_add: "24",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "罗村骏耀",
    company_name: "佛山市南海区罗村骏耀汽车销售服务有限公司",
    store_code: "SGD630",
    大区: "华南区",
    "省份-城市": "广东省-佛山市",
    "所选分组编号/分组名称": "-",
    fans_count: "319",
    fans_count_total: "34982",
    aweme_count: "50",
    aweme_like_count: "1440",
    aweme_comment_count: "153",
    aweme_share_count: "130",
    aweme_play_count: 141154,
    aweme_activation: 0.9667,
    live_count: "59",
    live_time: 3461,
    live_watch_count: 39504,
    live_watch_time: 43893,
    live_like_count: "159131",
    live_comment_count: "11500",
    live_activation: 0.9,
    live_fans_add: "536",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "苏州和旗",
    company_name: "苏州和旗汽车销售服务有限公司",
    store_code: "EJS620",
    大区: "华东区",
    "省份-城市": "江苏省-苏州市",
    "所选分组编号/分组名称": "-",
    fans_count: "-1339",
    fans_count_total: "361145",
    aweme_count: "66",
    aweme_like_count: "1559",
    aweme_comment_count: "256",
    aweme_share_count: "80",
    aweme_play_count: 156648,
    aweme_activation: 0.7667,
    live_count: "46",
    live_time: 2995,
    live_watch_count: 65755,
    live_watch_time: 73061,
    live_like_count: "148221",
    live_comment_count: "10197",
    live_activation: 0.8,
    live_fans_add: "582",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "桐乡裕旗",
    company_name: "桐乡裕旗汽车有限公司",
    store_code: "EZJ621",
    大区: "华东区",
    "省份-城市": "浙江省-嘉兴市",
    "所选分组编号/分组名称": "-",
    fans_count: "268",
    fans_count_total: "17752",
    aweme_count: "72",
    aweme_like_count: "166",
    aweme_comment_count: "35",
    aweme_share_count: "12",
    aweme_play_count: 52629,
    aweme_activation: 0.9667,
    live_count: "84",
    live_time: 5233,
    live_watch_count: 37196,
    live_watch_time: 41278,
    live_like_count: "11378",
    live_comment_count: "5491",
    live_activation: 0.9333,
    live_fans_add: "225",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "上饶君悦宏旗红旗体验中心",
    company_name: "上饶市君悦宏旗汽车有限公司",
    store_code: "CJX607",
    大区: "中南区",
    "省份-城市": "江西省-上饶市",
    "所选分组编号/分组名称": "-",
    fans_count: "-32",
    fans_count_total: "19091",
    aweme_count: "56",
    aweme_like_count: "303",
    aweme_comment_count: "85",
    aweme_share_count: "11",
    aweme_play_count: 44734,
    aweme_activation: 0.7,
    live_count: "51",
    live_time: 3269,
    live_watch_count: 8425,
    live_watch_time: 9361,
    live_like_count: "66484",
    live_comment_count: "10671",
    live_activation: 0.8333,
    live_fans_add: "48",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "张家界旗胜",
    company_name: "张家界旗胜汽车销售服务有限责任公司",
    store_code: "CHN617",
    大区: "中南区",
    "省份-城市": "湖南省-张家界市",
    "所选分组编号/分组名称": "-",
    fans_count: "924",
    fans_count_total: "7180",
    aweme_count: "85",
    aweme_like_count: "1337",
    aweme_comment_count: "91",
    aweme_share_count: "68",
    aweme_play_count: 362768,
    aweme_activation: 0.9,
    live_count: "57",
    live_time: 3529,
    live_watch_count: 3555,
    live_watch_time: 3949,
    live_like_count: "49662",
    live_comment_count: "1078",
    live_activation: 0.7667,
    live_fans_add: "19",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "延安泽之泰",
    company_name: "延安泽之泰汽贸有限责任公司",
    store_code: "XSS609",
    大区: "西部区",
    "省份-城市": "陕西省-延安市",
    "所选分组编号/分组名称": "-",
    fans_count: "1347",
    fans_count_total: "17803",
    aweme_count: "75",
    aweme_like_count: "406",
    aweme_comment_count: "36",
    aweme_share_count: "53",
    aweme_play_count: 78798,
    aweme_activation: 0.7,
    live_count: "62",
    live_time: 3832,
    live_watch_count: 195800,
    live_watch_time: 215391,
    live_like_count: "19594",
    live_comment_count: "2528",
    live_activation: 0.8333,
    live_fans_add: "16",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "张掖金岛旗瑞",
    company_name: "张掖金岛旗瑞",
    store_code: "XGS602",
    大区: "西部区",
    "省份-城市": "甘肃省-张掖市",
    "所选分组编号/分组名称": "-",
    fans_count: "28",
    fans_count_total: "35370",
    aweme_count: "89",
    aweme_like_count: "805",
    aweme_comment_count: "101",
    aweme_share_count: "46",
    aweme_play_count: 216702,
    aweme_activation: 0.7,
    live_count: "72",
    live_time: 4702,
    live_watch_count: 9599,
    live_watch_time: 10611,
    live_like_count: "18659",
    live_comment_count: "873",
    live_activation: 0.7333,
    live_fans_add: "43",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "贵港广利",
    company_name: "贵港广利汽车销售服务有限公司",
    store_code: "SGX608",
    大区: "华南区",
    "省份-城市": "广西壮族自治区-贵港市",
    "所选分组编号/分组名称": "-",
    fans_count: "-186",
    fans_count_total: "15789",
    aweme_count: "50",
    aweme_like_count: "654",
    aweme_comment_count: "63",
    aweme_share_count: "21",
    aweme_play_count: 30244,
    aweme_activation: 0.7667,
    live_count: "65",
    live_time: 4367,
    live_watch_count: 4931,
    live_watch_time: 5478,
    live_like_count: "56631",
    live_comment_count: "3972",
    live_activation: 0.7667,
    live_fans_add: "15",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "广物鸿福",
    company_name: "广东广物鸿福汽车销售服务有限公司汕尾分公司",
    store_code: "SGD632",
    大区: "华南区",
    "省份-城市": "广东省-汕尾市",
    "所选分组编号/分组名称": "-",
    fans_count: "-2",
    fans_count_total: "847",
    aweme_count: "9",
    aweme_like_count: "98",
    aweme_comment_count: "7",
    aweme_share_count: "16",
    aweme_play_count: 9839,
    aweme_activation: 0.4,
    live_count: "1",
    live_time: 51,
    live_watch_count: 93,
    live_watch_time: 103,
    live_like_count: "4347",
    live_comment_count: "-",
    live_activation: 0.0333,
    live_fans_add: "1",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "武汉大雍冉欣",
    company_name: "武汉大雍冉欣汽车销售服务有限公司",
    store_code: "CHB616",
    大区: "中南区",
    "省份-城市": "湖北省-武汉市",
    "所选分组编号/分组名称": "-",
    fans_count: "8",
    fans_count_total: "21748",
    aweme_count: "94",
    aweme_like_count: "603",
    aweme_comment_count: "42",
    aweme_share_count: "37",
    aweme_play_count: 275491,
    aweme_activation: 1,
    live_count: "58",
    live_time: 3604,
    live_watch_count: 16169,
    live_watch_time: 17965,
    live_like_count: "207640",
    live_comment_count: "2054",
    live_activation: 0.8333,
    live_fans_add: "124",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "酒泉金岛旗信",
    company_name: "酒泉金岛旗信汽车销售服务有限公司",
    store_code: "XGS603",
    大区: "西部区",
    "省份-城市": "甘肃省-酒泉市",
    "所选分组编号/分组名称": "-",
    fans_count: "342",
    fans_count_total: "9710",
    aweme_count: "127",
    aweme_like_count: "703",
    aweme_comment_count: "66",
    aweme_share_count: "52",
    aweme_play_count: 431318,
    aweme_activation: 0.6,
    live_count: "76",
    live_time: 4987,
    live_watch_count: 28774,
    live_watch_time: 31846,
    live_like_count: "178222",
    live_comment_count: "7259",
    live_activation: 0.8,
    live_fans_add: "212",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "青海嘉佑晟",
    company_name: "青海嘉佑晟汽车销售服务有限公司",
    store_code: "XQH601",
    大区: "西部区",
    "省份-城市": "青海省-海东市",
    "所选分组编号/分组名称": "-",
    fans_count: "161",
    fans_count_total: "21872",
    aweme_count: "113",
    aweme_like_count: "2962",
    aweme_comment_count: "232",
    aweme_share_count: "246",
    aweme_play_count: 154335,
    aweme_activation: 0.8667,
    live_count: "95",
    live_time: 8005,
    live_watch_count: 10943,
    live_watch_time: 12097,
    live_like_count: "66288",
    live_comment_count: "1113",
    live_activation: 0.8667,
    live_fans_add: "101",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "福州榕泰鸿旗",
    company_name: "福州榕泰鸿旗汽车销售有限公司",
    store_code: "SFJ612",
    大区: "华南区",
    "省份-城市": "福建省-福州市",
    "所选分组编号/分组名称": "-",
    fans_count: "-13",
    fans_count_total: "4793",
    aweme_count: "2",
    aweme_like_count: "1",
    aweme_comment_count: "0",
    aweme_share_count: "0",
    aweme_play_count: 396,
    aweme_activation: 0.0333,
    live_count: "-",
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: "-",
    live_comment_count: "-",
    live_activation: 0.0667,
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "长春盛世九州",
    company_name: "长春盛世九州红旗汽车销售服务有限公司",
    store_code: "DJL613",
    大区: "东北区",
    "省份-城市": "吉林省-长春市",
    "所选分组编号/分组名称": "-",
    fans_count: "1264",
    fans_count_total: "29883",
    aweme_count: "174",
    aweme_like_count: "869",
    aweme_comment_count: "125",
    aweme_share_count: "137",
    aweme_play_count: 462479,
    aweme_activation: 0.9,
    live_count: "111",
    live_time: 8155,
    live_watch_count: 121123,
    live_watch_time: 133623,
    live_like_count: "185792",
    live_comment_count: "28412",
    live_activation: 0.9333,
    live_fans_add: "352",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "昆明海伟峻辉红旗体验中心",
    company_name: "昆明海伟峻辉汽车销售有限公司",
    store_code: "WYN615",
    大区: "西部区",
    "省份-城市": "云南省-昆明市",
    "所选分组编号/分组名称": "-",
    fans_count: "385",
    fans_count_total: "269100",
    aweme_count: "55",
    aweme_like_count: "10178",
    aweme_comment_count: "1028",
    aweme_share_count: "829",
    aweme_play_count: 1640357,
    aweme_activation: 0.7667,
    live_count: "47",
    live_time: 2911,
    live_watch_count: 587036,
    live_watch_time: 652255,
    live_like_count: "413670",
    live_comment_count: "7620",
    live_activation: 0.7,
    live_fans_add: "1085",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "常州外汽国豪",
    company_name: "常州外汽国豪汽车销售服务有限公司",
    store_code: "EJS624",
    大区: "华东区",
    "省份-城市": "江苏省-常州市",
    "所选分组编号/分组名称": "-",
    fans_count: "38",
    fans_count_total: "6547",
    aweme_count: "50",
    aweme_like_count: "170",
    aweme_comment_count: "58",
    aweme_share_count: "17",
    aweme_play_count: 13049,
    aweme_activation: 0.5,
    live_count: "79",
    live_time: 5054,
    live_watch_count: 13485,
    live_watch_time: 14971,
    live_like_count: "187121",
    live_comment_count: "1988",
    live_activation: 0.8333,
    live_fans_add: "121",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "烟台奥吉通宏源",
    company_name: "烟台奥吉通宏源汽车销售有限公司",
    store_code: "NSD623",
    大区: "东北区",
    "省份-城市": "山东省-烟台市",
    "所选分组编号/分组名称": "-",
    fans_count: "313",
    fans_count_total: "8405",
    aweme_count: "101",
    aweme_like_count: "972",
    aweme_comment_count: "130",
    aweme_share_count: "106",
    aweme_play_count: 713583,
    aweme_activation: 0.8333,
    live_count: "56",
    live_time: 3524,
    live_watch_count: 119639,
    live_watch_time: 132932,
    live_like_count: "85453",
    live_comment_count: "2285",
    live_activation: 0.7333,
    live_fans_add: "169",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "苏州益谦红旗体验中心",
    company_name: "苏州益谦汽车销售服务有限公司",
    store_code: "EJS622",
    大区: "华东区",
    "省份-城市": "江苏省-苏州市",
    "所选分组编号/分组名称": "-",
    fans_count: "5",
    fans_count_total: "4116",
    aweme_count: "46",
    aweme_like_count: "381",
    aweme_comment_count: "35",
    aweme_share_count: "4",
    aweme_play_count: 65521,
    aweme_activation: 0.5,
    live_count: "56",
    live_time: 3336,
    live_watch_count: 10550,
    live_watch_time: 11721,
    live_like_count: "68152",
    live_comment_count: "2441",
    live_activation: 0.8333,
    live_fans_add: "170",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "惠州大雍峻安",
    company_name: "惠州市大雍峻安汽车销售服务有限责任公司",
    store_code: "SGD639",
    大区: "华南区",
    "省份-城市": "广东省-惠州市",
    "所选分组编号/分组名称": "-",
    fans_count: "189",
    fans_count_total: "13884",
    aweme_count: "134",
    aweme_like_count: "1379",
    aweme_comment_count: "160",
    aweme_share_count: "72",
    aweme_play_count: 541762,
    aweme_activation: 1,
    live_count: "54",
    live_time: 3086,
    live_watch_count: 8203,
    live_watch_time: 9114,
    live_like_count: "27740",
    live_comment_count: "1761",
    live_activation: 0.8667,
    live_fans_add: "74",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "中山宝旗红旗体验中心",
    company_name: "中山市宝旗汽车销售服务有限公司",
    store_code: "SGD636",
    大区: "华南区",
    "省份-城市": "广东省-中山市",
    "所选分组编号/分组名称": "-",
    fans_count: "-400",
    fans_count_total: "115488",
    aweme_count: "99",
    aweme_like_count: "927",
    aweme_comment_count: "51",
    aweme_share_count: "252",
    aweme_play_count: 118776,
    aweme_activation: 0.8,
    live_count: "109",
    live_time: 6806,
    live_watch_count: 36001,
    live_watch_time: 40000,
    live_like_count: "17285",
    live_comment_count: "4274",
    live_activation: 0.8667,
    live_fans_add: "195",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "朔州领航红旗",
    company_name: "朔州领航红旗汽车销售服务有限公司",
    store_code: "NJN613",
    大区: "华北区",
    "省份-城市": "山西省-朔州市",
    "所选分组编号/分组名称": "-",
    fans_count: "138",
    fans_count_total: "8175",
    aweme_count: "56",
    aweme_like_count: "521",
    aweme_comment_count: "54",
    aweme_share_count: "21",
    aweme_play_count: 82463,
    aweme_activation: 0.9,
    live_count: "55",
    live_time: 3422,
    live_watch_count: 108927,
    live_watch_time: 120995,
    live_like_count: "204644",
    live_comment_count: "6134",
    live_activation: 0.9,
    live_fans_add: "203",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "南昌恒信旗胜",
    company_name: "南昌恒信旗胜汽车销售服务有限公司",
    store_code: "CJX611",
    大区: "中南区",
    "省份-城市": "江西省-南昌市",
    "所选分组编号/分组名称": "-",
    fans_count: "91",
    fans_count_total: "9214",
    aweme_count: "92",
    aweme_like_count: "267",
    aweme_comment_count: "56",
    aweme_share_count: "15",
    aweme_play_count: 61714,
    aweme_activation: 0.8,
    live_count: "50",
    live_time: 3083,
    live_watch_count: 3995,
    live_watch_time: 4434,
    live_like_count: "6083",
    live_comment_count: "1194",
    live_activation: 0.9,
    live_fans_add: "55",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "绍兴广成柯旗",
    company_name: "绍兴广成柯旗汽车有限公司",
    store_code: "EZJ625",
    大区: "华东区",
    "省份-城市": "浙江省-绍兴市",
    "所选分组编号/分组名称": "-",
    fans_count: "275",
    fans_count_total: "11094",
    aweme_count: "187",
    aweme_like_count: "722",
    aweme_comment_count: "56",
    aweme_share_count: "41",
    aweme_play_count: 480114,
    aweme_activation: 1,
    live_count: "45",
    live_time: 2818,
    live_watch_count: 156303,
    live_watch_time: 173670,
    live_like_count: "27620",
    live_comment_count: "2996",
    live_activation: 0.8667,
    live_fans_add: "288",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "北京鑫达润通",
    company_name: "北京鑫达润通汽车有限公司",
    store_code: "NBJ609",
    大区: "华北区",
    "省份-城市": "北京市-北京市",
    "所选分组编号/分组名称": "-",
    fans_count: "62",
    fans_count_total: "2544",
    aweme_count: "69",
    aweme_like_count: "302",
    aweme_comment_count: "11",
    aweme_share_count: "22",
    aweme_play_count: 167886,
    aweme_activation: 0.8,
    live_count: "51",
    live_time: 3068,
    live_watch_count: 1095,
    live_watch_time: 1216,
    live_like_count: "1791",
    live_comment_count: "338",
    live_activation: 0.9,
    live_fans_add: "8",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "北京奥吉通旗盛",
    company_name: "北京奥吉通旗盛汽车销售服务有限公司",
    store_code: "NBJ608",
    大区: "华北区",
    "省份-城市": "北京市-北京市",
    "所选分组编号/分组名称": "-",
    fans_count: "201",
    fans_count_total: "21762",
    aweme_count: "107",
    aweme_like_count: "662",
    aweme_comment_count: "89",
    aweme_share_count: "31",
    aweme_play_count: 252097,
    aweme_activation: 0.7667,
    live_count: "70",
    live_time: 6485,
    live_watch_count: 120130,
    live_watch_time: 133477,
    live_like_count: "148403",
    live_comment_count: "2485",
    live_activation: 0.7667,
    live_fans_add: "252",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "东莞神州腾达",
    company_name: "东莞神州腾达汽车有限公司",
    store_code: "SGD637",
    大区: "华南区",
    "省份-城市": "广东省-东莞市",
    "所选分组编号/分组名称": "-",
    fans_count: "533",
    fans_count_total: "24509",
    aweme_count: "43",
    aweme_like_count: "307",
    aweme_comment_count: "69",
    aweme_share_count: "22",
    aweme_play_count: 114020,
    aweme_activation: 0.6333,
    live_count: "40",
    live_time: 2174,
    live_watch_count: 115560,
    live_watch_time: 128400,
    live_like_count: "81338",
    live_comment_count: "7055",
    live_activation: 0.8,
    live_fans_add: "817",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "盘锦富田",
    company_name: "盘锦富田实业有限公司",
    store_code: "DLN613",
    大区: "东北区",
    "省份-城市": "辽宁省-盘锦市",
    "所选分组编号/分组名称": "-",
    fans_count: "9",
    fans_count_total: "300",
    aweme_count: "31",
    aweme_like_count: "177",
    aweme_comment_count: "21",
    aweme_share_count: "9",
    aweme_play_count: 7475,
    aweme_activation: 0.7,
    live_count: "25",
    live_time: 2846,
    live_watch_count: 3161,
    live_watch_time: 3512,
    live_like_count: "9292",
    live_comment_count: "150",
    live_activation: 0.5,
    live_fans_add: "4",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "陕西泰岳",
    company_name: "陕西泰岳汽车销售服务有限公司",
    store_code: "XSS611",
    大区: "西部区",
    "省份-城市": "陕西省-西安市",
    "所选分组编号/分组名称": "-",
    fans_count: "3688",
    fans_count_total: "105695",
    aweme_count: "183",
    aweme_like_count: "5505",
    aweme_comment_count: "469",
    aweme_share_count: "434",
    aweme_play_count: 4282406,
    aweme_activation: 1,
    live_count: "115",
    live_time: 8052,
    live_watch_count: 593921,
    live_watch_time: 654502,
    live_like_count: "175120",
    live_comment_count: "10728",
    live_activation: 0.9,
    live_fans_add: "440",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "合肥盈旗",
    company_name: "合肥盈旗汽车销售有限公司",
    store_code: "EAH619",
    大区: "华东区",
    "省份-城市": "安徽省-合肥市",
    "所选分组编号/分组名称": "-",
    fans_count: "376",
    fans_count_total: "115664",
    aweme_count: "105",
    aweme_like_count: "3221",
    aweme_comment_count: "319",
    aweme_share_count: "348",
    aweme_play_count: 9876270,
    aweme_activation: 0.9667,
    live_count: "78",
    live_time: 5298,
    live_watch_count: 306489,
    live_watch_time: 340536,
    live_like_count: "233038",
    live_comment_count: "5624",
    live_activation: 0.9,
    live_fans_add: "815",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "安康硕德",
    company_name: "安康硕德汽车销售服务有限公司",
    store_code: "XSS612",
    大区: "西部区",
    "省份-城市": "陕西省-安康市",
    "所选分组编号/分组名称": "-",
    fans_count: "15",
    fans_count_total: "14786",
    aweme_count: "64",
    aweme_like_count: "520",
    aweme_comment_count: "63",
    aweme_share_count: "9",
    aweme_play_count: 39549,
    aweme_activation: 0.9333,
    live_count: "71",
    live_time: 4751,
    live_watch_count: 2033,
    live_watch_time: 2258,
    live_like_count: "133441",
    live_comment_count: "682",
    live_activation: 0.7667,
    live_fans_add: "17",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "海宁广成海旗",
    company_name: "海宁广成海旗汽车有限公司",
    store_code: "EZJ626",
    大区: "华东区",
    "省份-城市": "浙江省-嘉兴市",
    "所选分组编号/分组名称": "-",
    fans_count: "210",
    fans_count_total: "11152",
    aweme_count: "56",
    aweme_like_count: "312",
    aweme_comment_count: "40",
    aweme_share_count: "2",
    aweme_play_count: 58288,
    aweme_activation: 0.9333,
    live_count: "93",
    live_time: 6072,
    live_watch_count: 71744,
    live_watch_time: 79710,
    live_like_count: "82741",
    live_comment_count: "4505",
    live_activation: 0.8667,
    live_fans_add: "255",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "泉州旗达",
    company_name: "泉州旗达汽车销售服务有限公司",
    store_code: "SFJ615",
    大区: "华南区",
    "省份-城市": "福建省-泉州市",
    "所选分组编号/分组名称": "-",
    fans_count: "261",
    fans_count_total: "18704",
    aweme_count: "50",
    aweme_like_count: "344",
    aweme_comment_count: "45",
    aweme_share_count: "15",
    aweme_play_count: 103060,
    aweme_activation: 0.7333,
    live_count: "60",
    live_time: 3627,
    live_watch_count: 4273,
    live_watch_time: 4747,
    live_like_count: "762",
    live_comment_count: "851",
    live_activation: 0.8333,
    live_fans_add: "16",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "潮州晟汇",
    company_name: "潮州市晟汇汽车销售有限公司",
    store_code: "SGD635",
    大区: "华南区",
    "省份-城市": "广东省-潮州市",
    "所选分组编号/分组名称": "-",
    fans_count: "-266",
    fans_count_total: "26665",
    aweme_count: "87",
    aweme_like_count: "1411",
    aweme_comment_count: "177",
    aweme_share_count: "170",
    aweme_play_count: 208995,
    aweme_activation: 1,
    live_count: "53",
    live_time: 3306,
    live_watch_count: 10443,
    live_watch_time: 11603,
    live_like_count: "74847",
    live_comment_count: "2561",
    live_activation: 0.8,
    live_fans_add: "10",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "台州欧龙",
    company_name: "台州欧龙汽车销售服务有限公司",
    store_code: "EZJ627",
    大区: "华东区",
    "省份-城市": "浙江省-台州市",
    "所选分组编号/分组名称": "-",
    fans_count: "85",
    fans_count_total: "5276",
    aweme_count: "69",
    aweme_like_count: "313",
    aweme_comment_count: "32",
    aweme_share_count: "9",
    aweme_play_count: 189655,
    aweme_activation: 0.7,
    live_count: "58",
    live_time: 3510,
    live_watch_count: 3623,
    live_watch_time: 4025,
    live_like_count: "6072",
    live_comment_count: "3139",
    live_activation: 0.8333,
    live_fans_add: "28",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "贺州中裕红祺",
    company_name: "贺州中裕红祺汽车销售服务有限公司",
    store_code: "SGX612",
    大区: "华南区",
    "省份-城市": "广西壮族自治区-贺州市",
    "所选分组编号/分组名称": "-",
    fans_count: "0",
    fans_count_total: "1988",
    aweme_count: "70",
    aweme_like_count: "220",
    aweme_comment_count: "27",
    aweme_share_count: "0",
    aweme_play_count: 18081,
    aweme_activation: 0.9667,
    live_count: "52",
    live_time: 3210,
    live_watch_count: 1143,
    live_watch_time: 1265,
    live_like_count: "115222",
    live_comment_count: "179",
    live_activation: 0.8,
    live_fans_add: "4",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "北京鸿旗福瑞",
    company_name: "北京鸿旗福瑞汽车销售服务有限公司",
    store_code: "NBJ606",
    大区: "华北区",
    "省份-城市": "北京市-北京市",
    "所选分组编号/分组名称": "-",
    fans_count: "883",
    fans_count_total: "64084",
    aweme_count: "90",
    aweme_like_count: "811",
    aweme_comment_count: "93",
    aweme_share_count: "83",
    aweme_play_count: 179322,
    aweme_activation: 0.7667,
    live_count: "72",
    live_time: 4364,
    live_watch_count: 30736,
    live_watch_time: 34151,
    live_like_count: "14259",
    live_comment_count: "5343",
    live_activation: 0.8667,
    live_fans_add: "365",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "辽源歌蓝",
    company_name: "辽源歌蓝汽车销售服务有限公司",
    store_code: "DJL614",
    大区: "东北区",
    "省份-城市": "吉林省-辽源市",
    "所选分组编号/分组名称": "-",
    fans_count: "952",
    fans_count_total: "9574",
    aweme_count: "78",
    aweme_like_count: "553",
    aweme_comment_count: "41",
    aweme_share_count: "23",
    aweme_play_count: 147351,
    aweme_activation: 0.6,
    live_count: "101",
    live_time: 6308,
    live_watch_count: 103867,
    live_watch_time: 114343,
    live_like_count: "116977",
    live_comment_count: "2020",
    live_activation: 0.9,
    live_fans_add: "102",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "保定华臻",
    company_name: "保定市华臻汽车服务有限公司",
    store_code: "NJI611",
    大区: "华北区",
    "省份-城市": "河北省-保定市",
    "所选分组编号/分组名称": "-",
    fans_count: "1826",
    fans_count_total: "57460",
    aweme_count: "97",
    aweme_like_count: "1274",
    aweme_comment_count: "103",
    aweme_share_count: "127",
    aweme_play_count: 569909,
    aweme_activation: 0.6667,
    live_count: "210",
    live_time: 16292,
    live_watch_count: 529211,
    live_watch_time: 583765,
    live_like_count: "259747",
    live_comment_count: "39308",
    live_activation: 1,
    live_fans_add: "331",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "长沙旗颂",
    company_name: "长沙旗颂汽车销售有限公司",
    store_code: "CHN618",
    大区: "中南区",
    "省份-城市": "湖南省-长沙市",
    "所选分组编号/分组名称": "-",
    fans_count: "2469",
    fans_count_total: "189943",
    aweme_count: "137",
    aweme_like_count: "5191",
    aweme_comment_count: "735",
    aweme_share_count: "630",
    aweme_play_count: 1789459,
    aweme_activation: 0.8667,
    live_count: "131",
    live_time: 11101,
    live_watch_count: 159834,
    live_watch_time: 176441,
    live_like_count: "96816",
    live_comment_count: "19683",
    live_activation: 0.9,
    live_fans_add: "1015",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "东莞神州弘达",
    company_name: "东莞神州弘达汽车销售服务有限公司",
    store_code: "SGD633",
    大区: "华南区",
    "省份-城市": "广东省-东莞市",
    "所选分组编号/分组名称": "-",
    fans_count: "128",
    fans_count_total: "10234",
    aweme_count: "47",
    aweme_like_count: "188",
    aweme_comment_count: "10",
    aweme_share_count: "30",
    aweme_play_count: 71294,
    aweme_activation: 0.4,
    live_count: "40",
    live_time: 2719,
    live_watch_count: 8533,
    live_watch_time: 9481,
    live_like_count: "104882",
    live_comment_count: "3409",
    live_activation: 0.7,
    live_fans_add: "95",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "河北龙泽",
    company_name: "河北龙泽红旗汽车销售服务有限公司",
    store_code: "NJI612",
    大区: "华北区",
    "省份-城市": "河北省-廊坊市",
    "所选分组编号/分组名称": "-",
    fans_count: "4",
    fans_count_total: "182",
    aweme_count: "4",
    aweme_like_count: "25",
    aweme_comment_count: "2",
    aweme_share_count: "0",
    aweme_play_count: 3184,
    aweme_activation: 0.0667,
    live_count: "4",
    live_time: 152,
    live_watch_count: 21,
    live_watch_time: 23,
    live_like_count: "2",
    live_comment_count: "0",
    live_activation: 0.1,
    live_fans_add: "0",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "北海鸿福鸿福分公司",
    company_name: "北海广物汽车销售服务有限公司鸿福分公司",
    store_code: "SGX609",
    大区: "华南区",
    "省份-城市": "广西壮族自治区-北海市",
    "所选分组编号/分组名称": "-",
    fans_count: "10",
    fans_count_total: "3601",
    aweme_count: "44",
    aweme_like_count: "179",
    aweme_comment_count: "36",
    aweme_share_count: "20",
    aweme_play_count: 44461,
    aweme_activation: 0.5667,
    live_count: "33",
    live_time: 1996,
    live_watch_count: 1214,
    live_watch_time: 1349,
    live_like_count: "12380",
    live_comment_count: "2082",
    live_activation: 0.9667,
    live_fans_add: "3",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "丹东鸿祺",
    company_name: "丹东鸿祺",
    store_code: "DLN614",
    大区: "东北区",
    "省份-城市": "辽宁省-丹东市",
    "所选分组编号/分组名称": "-",
    fans_count: "31",
    fans_count_total: "2451",
    aweme_count: "27",
    aweme_like_count: "195",
    aweme_comment_count: "30",
    aweme_share_count: "7",
    aweme_play_count: 47484,
    aweme_activation: 0.5333,
    live_count: "27",
    live_time: 1626,
    live_watch_count: 1384,
    live_watch_time: 1536,
    live_like_count: "14921",
    live_comment_count: "859",
    live_activation: 0.5,
    live_fans_add: "5",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "玉林同人",
    company_name: "玉林同人汽车销售服务有限公司",
    store_code: "SGX610",
    大区: "华南区",
    "省份-城市": "广西壮族自治区-玉林市",
    "所选分组编号/分组名称": "-",
    fans_count: "19",
    fans_count_total: "4878",
    aweme_count: "71",
    aweme_like_count: "149",
    aweme_comment_count: "26",
    aweme_share_count: "28",
    aweme_play_count: 17718,
    aweme_activation: 0.7667,
    live_count: "63",
    live_time: 3839,
    live_watch_count: 12679,
    live_watch_time: 14085,
    live_like_count: "42511",
    live_comment_count: "1557",
    live_activation: 0.8667,
    live_fans_add: "50",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "海南博通",
    company_name: "海南博通汽车服务有限公司",
    store_code: "SHN601",
    大区: "华南区",
    "省份-城市": "海南省-海口市",
    "所选分组编号/分组名称": "-",
    fans_count: "3",
    fans_count_total: "204",
    aweme_count: "37",
    aweme_like_count: "149",
    aweme_comment_count: "22",
    aweme_share_count: "1",
    aweme_play_count: 33670,
    aweme_activation: 0.4333,
    live_count: "1",
    live_time: 78,
    live_watch_count: 249,
    live_watch_time: 276,
    live_like_count: "0",
    live_comment_count: "-",
    live_activation: 0.0333,
    live_fans_add: "0",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "铜陵鑫福瑞",
    company_name: "铜陵鑫福瑞汽车销售服务有限公司",
    store_code: "EAH620",
    大区: "华东区",
    "省份-城市": "安徽省-铜陵市",
    "所选分组编号/分组名称": "-",
    fans_count: "-347",
    fans_count_total: "44331",
    aweme_count: "117",
    aweme_like_count: "545",
    aweme_comment_count: "27",
    aweme_share_count: "52",
    aweme_play_count: 257104,
    aweme_activation: 0.8333,
    live_count: "26",
    live_time: 1592,
    live_watch_count: 23241,
    live_watch_time: 25812,
    live_like_count: "36740",
    live_comment_count: "934",
    live_activation: 0.4667,
    live_fans_add: "74",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "南宁达美",
    company_name: "南宁达美汽车销售服务有限公司",
    store_code: "SGX613",
    大区: "华南区",
    "省份-城市": "广西壮族自治区-南宁市",
    "所选分组编号/分组名称": "-",
    fans_count: "336",
    fans_count_total: "11167",
    aweme_count: "98",
    aweme_like_count: "578",
    aweme_comment_count: "104",
    aweme_share_count: "8",
    aweme_play_count: 183164,
    aweme_activation: 1,
    live_count: "35",
    live_time: 2148,
    live_watch_count: 14765,
    live_watch_time: 16405,
    live_like_count: "56984",
    live_comment_count: "4868",
    live_activation: 0.8667,
    live_fans_add: "245",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "深圳鸿钧",
    company_name: "深圳鸿钧",
    store_code: "SGD651",
    大区: "华南区",
    "省份-城市": "广东省-深圳市",
    "所选分组编号/分组名称": "-",
    fans_count: "17",
    fans_count_total: "2662",
    aweme_count: "48",
    aweme_like_count: "41",
    aweme_comment_count: "0",
    aweme_share_count: "2",
    aweme_play_count: 6352,
    aweme_activation: 0.1667,
    live_count: "18",
    live_time: 1136,
    live_watch_count: 570,
    live_watch_time: 633,
    live_like_count: "3000",
    live_comment_count: "134",
    live_activation: 0.2667,
    live_fans_add: "3",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "广州南菱旗盛",
    company_name: "广州南菱旗盛汽车有限公司",
    store_code: "SGD634",
    大区: "华南区",
    "省份-城市": "广东省-广州市",
    "所选分组编号/分组名称": "-",
    fans_count: "241",
    fans_count_total: "11843",
    aweme_count: "90",
    aweme_like_count: "307",
    aweme_comment_count: "43",
    aweme_share_count: "24",
    aweme_play_count: 345104,
    aweme_activation: 0.8333,
    live_count: "74",
    live_time: 4531,
    live_watch_count: 48813,
    live_watch_time: 54236,
    live_like_count: "95790",
    live_comment_count: "2283",
    live_activation: 0.8333,
    live_fans_add: "176",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "广州汉旗",
    company_name: "广州汉旗汽车贸易有限公司",
    store_code: "SGD641",
    大区: "华南区",
    "省份-城市": "广东省-广州市",
    "所选分组编号/分组名称": "-",
    fans_count: "1102",
    fans_count_total: "38010",
    aweme_count: "90",
    aweme_like_count: "496",
    aweme_comment_count: "73",
    aweme_share_count: "45",
    aweme_play_count: 317479,
    aweme_activation: 0.8,
    live_count: "59",
    live_time: 4423,
    live_watch_count: 566192,
    live_watch_time: 629102,
    live_like_count: "94559",
    live_comment_count: "12603",
    live_activation: 0.8333,
    live_fans_add: "659",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "上海锦筝",
    company_name: "上海锦筝汽车销售服务有限公司",
    store_code: "ESH611",
    大区: "华东区",
    "省份-城市": 0,
    "所选分组编号/分组名称": "-",
    fans_count: "-413",
    fans_count_total: "28879",
    aweme_count: "-",
    aweme_like_count: "-",
    aweme_comment_count: "-",
    aweme_share_count: "-",
    aweme_play_count: 0,
    aweme_activation: 0,
    live_count: "-",
    live_time: 0,
    live_watch_count: 0,
    live_watch_time: 0,
    live_like_count: "-",
    live_comment_count: "-",
    live_activation: 0,
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "西安博行大展",
    company_name: "西安博行大展汽车销售服务有限公司",
    store_code: "XSS610",
    大区: "西部区",
    "省份-城市": "陕西省-西安市",
    "所选分组编号/分组名称": "-",
    fans_count: "756",
    fans_count_total: "74789",
    aweme_count: "98",
    aweme_like_count: "1037",
    aweme_comment_count: "115",
    aweme_share_count: "116",
    aweme_play_count: 570936,
    aweme_activation: 0.8667,
    live_count: "123",
    live_time: 7633,
    live_watch_count: 121437,
    live_watch_time: 134870,
    live_like_count: "27381",
    live_comment_count: "8746",
    live_activation: 0.9333,
    live_fans_add: "940",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "东阳欧龙",
    company_name: "东阳欧龙汽车有限公司",
    store_code: "EZJ628",
    大区: "华东区",
    "省份-城市": "浙江省-金华市",
    "所选分组编号/分组名称": "-",
    fans_count: "300",
    fans_count_total: "9417",
    aweme_count: "98",
    aweme_like_count: "474",
    aweme_comment_count: "84",
    aweme_share_count: "34",
    aweme_play_count: 833885,
    aweme_activation: 0.8333,
    live_count: "49",
    live_time: 3085,
    live_watch_count: 5668,
    live_watch_time: 6297,
    live_like_count: "41769",
    live_comment_count: "3052",
    live_activation: 0.8,
    live_fans_add: "69",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "天水天升星旗",
    company_name: "天水天升星旗汽车销售服务有限公司",
    store_code: "XGS604",
    大区: "西部区",
    "省份-城市": "甘肃省-天水市",
    "所选分组编号/分组名称": "-",
    fans_count: "157",
    fans_count_total: "5493",
    aweme_count: "104",
    aweme_like_count: "759",
    aweme_comment_count: "59",
    aweme_share_count: "9",
    aweme_play_count: 54505,
    aweme_activation: 0.9333,
    live_count: "93",
    live_time: 7164,
    live_watch_count: 21584,
    live_watch_time: 23788,
    live_like_count: "250457",
    live_comment_count: "3083",
    live_activation: 0.8333,
    live_fans_add: "75",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "广西宝旗勇昌",
    company_name: "广西宝旗勇昌汽车销售服务有限公司",
    store_code: "SGX614",
    大区: "华南区",
    "省份-城市": "广西壮族自治区-南宁市",
    "所选分组编号/分组名称": "-",
    fans_count: "126",
    fans_count_total: "3188",
    aweme_count: "45",
    aweme_like_count: "432",
    aweme_comment_count: "49",
    aweme_share_count: "106",
    aweme_play_count: 52030,
    aweme_activation: 0.9,
    live_count: "42",
    live_time: 2589,
    live_watch_count: 9313,
    live_watch_time: 10347,
    live_like_count: "117986",
    live_comment_count: "4318",
    live_activation: 0.8,
    live_fans_add: "86",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "新余市新征途",
    company_name: "新余市新征途汽车销售服务有限公司",
    store_code: "CJX612",
    大区: "中南区",
    "省份-城市": "江西省-新余市",
    "所选分组编号/分组名称": "-",
    fans_count: "54",
    fans_count_total: "13926",
    aweme_count: "33",
    aweme_like_count: "324",
    aweme_comment_count: "54",
    aweme_share_count: "18",
    aweme_play_count: 125301,
    aweme_activation: 0.5667,
    live_count: "34",
    live_time: 2108,
    live_watch_count: 20650,
    live_watch_time: 22944,
    live_like_count: "277057",
    live_comment_count: "8439",
    live_activation: 0.8333,
    live_fans_add: "246",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "三亚华奥文源",
    company_name: "三亚华奥文源汽车工贸有限公司",
    store_code: "SHN602",
    大区: "华南区",
    "省份-城市": "海南省-三亚市",
    "所选分组编号/分组名称": "-",
    fans_count: "-40",
    fans_count_total: "36398",
    aweme_count: "57",
    aweme_like_count: "246",
    aweme_comment_count: "27",
    aweme_share_count: "29",
    aweme_play_count: 32959,
    aweme_activation: 0.7333,
    live_count: "54",
    live_time: 3110,
    live_watch_count: 4813,
    live_watch_time: 5344,
    live_like_count: "123116",
    live_comment_count: "2066",
    live_activation: 0.5333,
    live_fans_add: "23",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "贵州星启源",
    company_name: "贵州星启源汽车销售服务有限公司",
    store_code: "WGZ613",
    大区: "西部区",
    "省份-城市": "贵州省-遵义市",
    "所选分组编号/分组名称": "-",
    fans_count: "2",
    fans_count_total: "11918",
    aweme_count: "73",
    aweme_like_count: "520",
    aweme_comment_count: "95",
    aweme_share_count: "30",
    aweme_play_count: 52755,
    aweme_activation: 1,
    live_count: "65",
    live_time: 4022,
    live_watch_count: 6960,
    live_watch_time: 7732,
    live_like_count: "30465",
    live_comment_count: "4348",
    live_activation: 0.8667,
    live_fans_add: "76",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "温州欧龙",
    company_name: "温州欧龙机电有限公司",
    store_code: "EZJ622",
    大区: "华东区",
    "省份-城市": "浙江省-温州市",
    "所选分组编号/分组名称": "-",
    fans_count: "302",
    fans_count_total: "19300",
    aweme_count: "83",
    aweme_like_count: "333",
    aweme_comment_count: "52",
    aweme_share_count: "12",
    aweme_play_count: 154537,
    aweme_activation: 1,
    live_count: "55",
    live_time: 3289,
    live_watch_count: 128919,
    live_watch_time: 143243,
    live_like_count: "165138",
    live_comment_count: "3309",
    live_activation: 0.8333,
    live_fans_add: "271",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "宁德华奥宏旗",
    company_name: "宁德华奥宏旗汽车销售有限公司",
    store_code: "SFJ611",
    大区: "华南区",
    "省份-城市": "福建省-宁德市",
    "所选分组编号/分组名称": "-",
    fans_count: "112",
    fans_count_total: "13288",
    aweme_count: "227",
    aweme_like_count: "733",
    aweme_comment_count: "116",
    aweme_share_count: "53",
    aweme_play_count: 69593,
    aweme_activation: 1,
    live_count: "64",
    live_time: 3792,
    live_watch_count: 3783,
    live_watch_time: 4203,
    live_like_count: "67681",
    live_comment_count: "2512",
    live_activation: 0.9667,
    live_fans_add: "35",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "临沧国源",
    company_name: "临沧国源汽车销售服务有限公司",
    store_code: "WYN616",
    大区: "西部区",
    "省份-城市": "云南省-临沧市",
    "所选分组编号/分组名称": "-",
    fans_count: "10",
    fans_count_total: "8750",
    aweme_count: "47",
    aweme_like_count: "273",
    aweme_comment_count: "34",
    aweme_share_count: "8",
    aweme_play_count: 82510,
    aweme_activation: 0.5,
    live_count: "58",
    live_time: 4002,
    live_watch_count: 3392,
    live_watch_time: 3761,
    live_like_count: "130576",
    live_comment_count: "4421",
    live_activation: 0.8,
    live_fans_add: "17",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "宁夏汽车大世界吴忠",
    company_name: "宁夏汽车大世界吴忠销售服务有限责任公司",
    store_code: "XNX601",
    大区: "西部区",
    "省份-城市": "宁夏回族自治区-吴忠市",
    "所选分组编号/分组名称": "-",
    fans_count: "368",
    fans_count_total: "5080",
    aweme_count: "157",
    aweme_like_count: "853",
    aweme_comment_count: "91",
    aweme_share_count: "44",
    aweme_play_count: 495153,
    aweme_activation: 0.8,
    live_count: "244",
    live_time: 14941,
    live_watch_count: 109528,
    live_watch_time: 120568,
    live_like_count: "20076",
    live_comment_count: "3775",
    live_activation: 1,
    live_fans_add: "12",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "厦门欧骋",
    company_name: "厦门欧骋汽车有限公司",
    store_code: "SFJ617",
    大区: "华南区",
    "省份-城市": "福建省-厦门市",
    "所选分组编号/分组名称": "-",
    fans_count: "1582",
    fans_count_total: "84292",
    aweme_count: "70",
    aweme_like_count: "321",
    aweme_comment_count: "47",
    aweme_share_count: "60",
    aweme_play_count: 82059,
    aweme_activation: 0.9333,
    live_count: "76",
    live_time: 4535,
    live_watch_count: 250487,
    live_watch_time: 275922,
    live_like_count: "62110",
    live_comment_count: "5622",
    live_activation: 0.7667,
    live_fans_add: "579",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "南京宏众大晟",
    company_name: "南京宏众大晟汽车销售有限公司",
    store_code: "EJS625",
    大区: "华东区",
    "省份-城市": "江苏省-南京市",
    "所选分组编号/分组名称": "-",
    fans_count: "180",
    fans_count_total: "33293",
    aweme_count: "79",
    aweme_like_count: "322",
    aweme_comment_count: "27",
    aweme_share_count: "13",
    aweme_play_count: 51522,
    aweme_activation: 0.6333,
    live_count: "52",
    live_time: 4512,
    live_watch_count: 139156,
    live_watch_time: 154617,
    live_like_count: "33198",
    live_comment_count: "1619",
    live_activation: 0.8333,
    live_fans_add: "401",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "上海岱岳红旗",
    company_name: "上海岱岳汽车销售服务有限公司",
    store_code: "ESH616",
    大区: "华东区",
    "省份-城市": "上海市-上海市",
    "所选分组编号/分组名称": "-",
    fans_count: "4943",
    fans_count_total: "59766",
    aweme_count: "113",
    aweme_like_count: "2165",
    aweme_comment_count: "538",
    aweme_share_count: "410",
    aweme_play_count: 4404571,
    aweme_activation: 1,
    live_count: "81",
    live_time: 5094,
    live_watch_count: 478309,
    live_watch_time: 527793,
    live_like_count: "651652",
    live_comment_count: "21580",
    live_activation: 0.6333,
    live_fans_add: "480",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "赣州鸿旗",
    company_name: "赣州市鸿旗汽车有限公司",
    store_code: "CJX614",
    大区: "中南区",
    "省份-城市": "江西省-赣州市",
    "所选分组编号/分组名称": "-",
    fans_count: "43",
    fans_count_total: "5285",
    aweme_count: "33",
    aweme_like_count: "94",
    aweme_comment_count: "9",
    aweme_share_count: "16",
    aweme_play_count: 125366,
    aweme_activation: 0.4,
    live_count: "37",
    live_time: 2178,
    live_watch_count: 3120,
    live_watch_time: 3466,
    live_like_count: "11733",
    live_comment_count: "1027",
    live_activation: 0.8333,
    live_fans_add: "11",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "沧州华泓",
    company_name: "沧州华泓汽车服务有限公司",
    store_code: "NJI616",
    大区: "华北区",
    "省份-城市": "河北省-沧州市",
    "所选分组编号/分组名称": "-",
    fans_count: "-48",
    fans_count_total: "8744",
    aweme_count: "90",
    aweme_like_count: "248",
    aweme_comment_count: "41",
    aweme_share_count: "12",
    aweme_play_count: 145758,
    aweme_activation: 0.5333,
    live_count: "51",
    live_time: 3047,
    live_watch_count: 4642,
    live_watch_time: 5151,
    live_like_count: "48493",
    live_comment_count: "3633",
    live_activation: 0.8333,
    live_fans_add: "34",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "唐山泰岳宏旗体验中心",
    company_name: "唐山泰岳宏旗体验中心",
    store_code: "NJI614",
    大区: "华北区",
    "省份-城市": "河北省-唐山市",
    "所选分组编号/分组名称": "-",
    fans_count: "1178",
    fans_count_total: "22954",
    aweme_count: "103",
    aweme_like_count: "4417",
    aweme_comment_count: "254",
    aweme_share_count: "1801",
    aweme_play_count: 792244,
    aweme_activation: 0.9,
    live_count: "124",
    live_time: 7701,
    live_watch_count: 271945,
    live_watch_time: 300063,
    live_like_count: "1767194",
    live_comment_count: "38519",
    live_activation: 1,
    live_fans_add: "1431",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "宁夏汽车大世界红旗",
    company_name: "宁夏汽车大世界红旗",
    store_code: "XNX602",
    大区: "西部区",
    "省份-城市": "宁夏回族自治区-银川市",
    "所选分组编号/分组名称": "-",
    fans_count: "1340",
    fans_count_total: "17357",
    aweme_count: "176",
    aweme_like_count: "3329",
    aweme_comment_count: "538",
    aweme_share_count: "199",
    aweme_play_count: 580074,
    aweme_activation: 0.9667,
    live_count: "116",
    live_time: 7277,
    live_watch_count: 153818,
    live_watch_time: 169286,
    live_like_count: "22921",
    live_comment_count: "3897",
    live_activation: 0.8667,
    live_fans_add: "93",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "永康正鑫",
    company_name: "永康正鑫",
    store_code: "EZJ634",
    大区: "华东区",
    "省份-城市": 0,
    "所选分组编号/分组名称": "-",
    fans_count: "114",
    fans_count_total: "2358",
    aweme_count: "47",
    aweme_like_count: "312",
    aweme_comment_count: "32",
    aweme_share_count: "13",
    aweme_play_count: 210293,
    aweme_activation: 0.7,
    live_count: "48",
    live_time: 3007,
    live_watch_count: 2844,
    live_watch_time: 3160,
    live_like_count: "5303",
    live_comment_count: "6215",
    live_activation: 0.9333,
    live_fans_add: "40",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "哈尔滨森华红旗体验中心",
    company_name: "哈尔滨森华红旗体验中心",
    store_code: "DHL610",
    大区: "东北区",
    "省份-城市": "黑龙江省-哈尔滨市",
    "所选分组编号/分组名称": "-",
    fans_count: "628",
    fans_count_total: "3608",
    aweme_count: "81",
    aweme_like_count: "177",
    aweme_comment_count: "39",
    aweme_share_count: "9",
    aweme_play_count: 74947,
    aweme_activation: 0.5667,
    live_count: "72",
    live_time: 5165,
    live_watch_count: 63220,
    live_watch_time: 70240,
    live_like_count: "433827",
    live_comment_count: "11333",
    live_activation: 0.7333,
    live_fans_add: "694",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "新疆国奥伟鸿",
    company_name: "新疆国奥伟鸿",
    store_code: "XXJ607",
    大区: "西部区",
    "省份-城市": "新疆维吾尔自治区-乌鲁木齐市",
    "所选分组编号/分组名称": "-",
    fans_count: "40",
    fans_count_total: "640",
    aweme_count: "116",
    aweme_like_count: "172",
    aweme_comment_count: "28",
    aweme_share_count: "19",
    aweme_play_count: 38886,
    aweme_activation: 0.8333,
    live_count: "66",
    live_time: 5552,
    live_watch_count: 4600,
    live_watch_time: 5106,
    live_like_count: "22107",
    live_comment_count: "2992",
    live_activation: 0.6667,
    live_fans_add: "26",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "天津领通",
    company_name: "天津领通",
    store_code: "NTJ606",
    大区: "华北区",
    "省份-城市": "天津市-天津市",
    "所选分组编号/分组名称": "-",
    fans_count: "163",
    fans_count_total: "13586",
    aweme_count: "49",
    aweme_like_count: "254",
    aweme_comment_count: "36",
    aweme_share_count: "16",
    aweme_play_count: 124227,
    aweme_activation: 0.5667,
    live_count: "43",
    live_time: 2590,
    live_watch_count: 91996,
    live_watch_time: 102215,
    live_like_count: "62658",
    live_comment_count: "1471",
    live_activation: 0.8333,
    live_fans_add: "180",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "辽宁福宏旗",
    company_name: "辽宁福宏旗",
    store_code: "DLN618",
    大区: "东北区",
    "省份-城市": "辽宁省-沈阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "179",
    fans_count_total: "651",
    aweme_count: "89",
    aweme_like_count: "163",
    aweme_comment_count: "32",
    aweme_share_count: "41",
    aweme_play_count: 53145,
    aweme_activation: 0.9333,
    live_count: "88",
    live_time: 5503,
    live_watch_count: 6456,
    live_watch_time: 7165,
    live_like_count: "13844",
    live_comment_count: "848",
    live_activation: 0.8333,
    live_fans_add: "41",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "聊城北斗泰和",
    company_name: "聊城北斗泰和",
    store_code: "NSD630",
    大区: "东北区",
    "省份-城市": "山东省-聊城市",
    "所选分组编号/分组名称": "-",
    fans_count: "58",
    fans_count_total: "575",
    aweme_count: "67",
    aweme_like_count: "272",
    aweme_comment_count: "38",
    aweme_share_count: "14",
    aweme_play_count: 46604,
    aweme_activation: 0.9333,
    live_count: "52",
    live_time: 3168,
    live_watch_count: 6579,
    live_watch_time: 7310,
    live_like_count: "61616",
    live_comment_count: "1208",
    live_activation: 0.9333,
    live_fans_add: "32",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "廊坊车朋达",
    company_name: "廊坊车朋达",
    store_code: "NJI617",
    大区: "华北区",
    "省份-城市": "河北省-廊坊市",
    "所选分组编号/分组名称": "-",
    fans_count: "28",
    fans_count_total: "180",
    aweme_count: "53",
    aweme_like_count: "174",
    aweme_comment_count: "14",
    aweme_share_count: "13",
    aweme_play_count: 14424,
    aweme_activation: 0.6333,
    live_count: "67",
    live_time: 4011,
    live_watch_count: 6212,
    live_watch_time: 6902,
    live_like_count: "52465",
    live_comment_count: "93",
    live_activation: 0.9667,
    live_fans_add: "8",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "辽宁和奉",
    company_name: "辽宁和奉",
    store_code: "DLN619",
    大区: "东北区",
    "省份-城市": "辽宁省-沈阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "242",
    fans_count_total: "904",
    aweme_count: "48",
    aweme_like_count: "189",
    aweme_comment_count: "36",
    aweme_share_count: "5",
    aweme_play_count: 30677,
    aweme_activation: 0.6667,
    live_count: "46",
    live_time: 2933,
    live_watch_count: 5272,
    live_watch_time: 5806,
    live_like_count: "8053",
    live_comment_count: "1246",
    live_activation: 0.8667,
    live_fans_add: "29",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "喀什通工宏旗",
    company_name: "喀什通工宏旗",
    store_code: "XXJ606",
    大区: "西部区",
    "省份-城市": "新疆维吾尔自治区-喀什地区",
    "所选分组编号/分组名称": "-",
    fans_count: "168",
    fans_count_total: "3499",
    aweme_count: "55",
    aweme_like_count: "793",
    aweme_comment_count: "98",
    aweme_share_count: "169",
    aweme_play_count: 458983,
    aweme_activation: 0.9,
    live_count: "56",
    live_time: 3354,
    live_watch_count: 3156,
    live_watch_time: 3506,
    live_like_count: "124284",
    live_comment_count: "2755",
    live_activation: 0.9333,
    live_fans_add: "36",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "佛山富华",
    company_name: "佛山富华",
    store_code: "SGD653",
    大区: "华南区",
    "省份-城市": "广东省-佛山市",
    "所选分组编号/分组名称": "-",
    fans_count: "953",
    fans_count_total: "3241",
    aweme_count: "61",
    aweme_like_count: "1101",
    aweme_comment_count: "143",
    aweme_share_count: "105",
    aweme_play_count: 308876,
    aweme_activation: 0.7333,
    live_count: "92",
    live_time: 5648,
    live_watch_count: 13206,
    live_watch_time: 14673,
    live_like_count: "34605",
    live_comment_count: "3999",
    live_activation: 0.8667,
    live_fans_add: "536",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "蚌埠福顺红旗体验中心",
    company_name: "蚌埠福顺红旗体验中心",
    store_code: "EAH623",
    大区: "华东区",
    "省份-城市": "安徽省-蚌埠市",
    "所选分组编号/分组名称": "-",
    fans_count: "204",
    fans_count_total: "1058",
    aweme_count: "53",
    aweme_like_count: "429",
    aweme_comment_count: "58",
    aweme_share_count: "21",
    aweme_play_count: 92455,
    aweme_activation: 0.8667,
    live_count: "66",
    live_time: 4101,
    live_watch_count: 5288,
    live_watch_time: 5875,
    live_like_count: "46973",
    live_comment_count: "4227",
    live_activation: 0.8667,
    live_fans_add: "169",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "南京朗驰旗胜红旗融合4s店",
    company_name: "南京朗驰旗胜红旗融合4s店",
    store_code: "EJS635",
    大区: "华东区",
    "省份-城市": "江苏省-南京市",
    "所选分组编号/分组名称": "-",
    fans_count: "75",
    fans_count_total: "387",
    aweme_count: "73",
    aweme_like_count: "241",
    aweme_comment_count: "15",
    aweme_share_count: "6",
    aweme_play_count: 10113,
    aweme_activation: 0.4667,
    live_count: "50",
    live_time: 3194,
    live_watch_count: 13384,
    live_watch_time: 14871,
    live_like_count: "33723",
    live_comment_count: "1292",
    live_activation: 0.8333,
    live_fans_add: "65",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "新乡市融之汇",
    company_name: "新乡市融之汇",
    store_code: "NYU626",
    大区: "华北区",
    "省份-城市": "河南省-新乡市",
    "所选分组编号/分组名称": "-",
    fans_count: "740",
    fans_count_total: "4416",
    aweme_count: "61",
    aweme_like_count: "299",
    aweme_comment_count: "36",
    aweme_share_count: "28",
    aweme_play_count: 16854,
    aweme_activation: 1,
    live_count: "59",
    live_time: 3378,
    live_watch_count: 10506,
    live_watch_time: 11626,
    live_like_count: "9462",
    live_comment_count: "1467",
    live_activation: 0.9,
    live_fans_add: "236",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "北京奥信鸿旗汽车销售服务有限公司",
    company_name: "北京奥信鸿旗汽车销售服务有限公司",
    store_code: "NBJ613",
    大区: "华北区",
    "省份-城市": "北京市-北京市",
    "所选分组编号/分组名称": "-",
    fans_count: "24",
    fans_count_total: "841",
    aweme_count: "33",
    aweme_like_count: "198",
    aweme_comment_count: "21",
    aweme_share_count: "15",
    aweme_play_count: 14715,
    aweme_activation: 0.6,
    live_count: "75",
    live_time: 5569,
    live_watch_count: 6070,
    live_watch_time: 6744,
    live_like_count: "116583",
    live_comment_count: "1525",
    live_activation: 0.8667,
    live_fans_add: "11",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "宁波东旗",
    company_name: "宁波东旗",
    store_code: "EZJ635",
    大区: "华东区",
    "省份-城市": "浙江省-宁波市",
    "所选分组编号/分组名称": "-",
    fans_count: "117",
    fans_count_total: "404",
    aweme_count: "178",
    aweme_like_count: "565",
    aweme_comment_count: "40",
    aweme_share_count: "55",
    aweme_play_count: 244831,
    aweme_activation: 1,
    live_count: "43",
    live_time: 2417,
    live_watch_count: 571,
    live_watch_time: 634,
    live_like_count: "1454",
    live_comment_count: "179",
    live_activation: 0.7667,
    live_fans_add: "19",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "盐城雅锋",
    company_name: "盐城雅锋",
    store_code: "EJS401",
    大区: "华东区",
    "省份-城市": "江苏省-盐城市",
    "所选分组编号/分组名称": "-",
    fans_count: "339",
    fans_count_total: "423",
    aweme_count: "72",
    aweme_like_count: "261",
    aweme_comment_count: "26",
    aweme_share_count: "2",
    aweme_play_count: 19829,
    aweme_activation: 0.7,
    live_count: "41",
    live_time: 2559,
    live_watch_count: 5164,
    live_watch_time: 5737,
    live_like_count: "8340",
    live_comment_count: "3983",
    live_activation: 0.8667,
    live_fans_add: "105",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "乌鲁木齐泰岳红旗体验中心",
    company_name: "乌鲁木齐泰岳红旗体验中心",
    store_code: "XXJ604",
    大区: "西部区",
    "省份-城市": "新疆维吾尔自治区-乌鲁木齐市",
    "所选分组编号/分组名称": "-",
    fans_count: "264",
    fans_count_total: "8188",
    aweme_count: "71",
    aweme_like_count: "428",
    aweme_comment_count: "49",
    aweme_share_count: "21",
    aweme_play_count: 280778,
    aweme_activation: 0.3,
    live_count: "132",
    live_time: 8214,
    live_watch_count: 12072,
    live_watch_time: 13359,
    live_like_count: "43024",
    live_comment_count: "2042",
    live_activation: 0.9333,
    live_fans_add: "72",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "郑州博行大展汽车",
    company_name: "郑州博行大展汽车",
    store_code: "NYU622",
    大区: "华北区",
    "省份-城市": "河南省-郑州市",
    "所选分组编号/分组名称": "-",
    fans_count: "2803",
    fans_count_total: "27077",
    aweme_count: "112",
    aweme_like_count: "803",
    aweme_comment_count: "129",
    aweme_share_count: "126",
    aweme_play_count: 256207,
    aweme_activation: 0.7333,
    live_count: "72",
    live_time: 3831,
    live_watch_count: 97201,
    live_watch_time: 108001,
    live_like_count: "32124",
    live_comment_count: "11082",
    live_activation: 0.7667,
    live_fans_add: "1098",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "沈阳德联旗骏店",
    company_name: "沈阳德联旗骏店",
    store_code: "DLN617",
    大区: "东北区",
    "省份-城市": "辽宁省-沈阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "174",
    fans_count_total: "1941",
    aweme_count: "49",
    aweme_like_count: "91",
    aweme_comment_count: "9",
    aweme_share_count: "7",
    aweme_play_count: 74910,
    aweme_activation: 0.4667,
    live_count: "81",
    live_time: 4908,
    live_watch_count: 10360,
    live_watch_time: 11507,
    live_like_count: "33280",
    live_comment_count: "2078",
    live_activation: 0.7333,
    live_fans_add: "148",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "合肥博融祥之旗",
    company_name: "合肥博融祥之旗",
    store_code: "EAH622",
    大区: "华东区",
    "省份-城市": "安徽省-合肥市",
    "所选分组编号/分组名称": "-",
    fans_count: "475",
    fans_count_total: "6392",
    aweme_count: "84",
    aweme_like_count: "374",
    aweme_comment_count: "32",
    aweme_share_count: "43",
    aweme_play_count: 80871,
    aweme_activation: 0.9,
    live_count: "98",
    live_time: 6158,
    live_watch_count: 24339,
    live_watch_time: 27043,
    live_like_count: "7867",
    live_comment_count: "4430",
    live_activation: 1,
    live_fans_add: "452",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "驻马店祥聚",
    company_name: "驻马店祥聚",
    store_code: "NYU624",
    大区: "华北区",
    "省份-城市": "河南省-驻马店市",
    "所选分组编号/分组名称": "-",
    fans_count: "1371",
    fans_count_total: "17474",
    aweme_count: "20",
    aweme_like_count: "689",
    aweme_comment_count: "63",
    aweme_share_count: "88",
    aweme_play_count: 324293,
    aweme_activation: 0.4667,
    live_count: "34",
    live_time: 2109,
    live_watch_count: 2991,
    live_watch_time: 3316,
    live_like_count: "470",
    live_comment_count: "437",
    live_activation: 0.4667,
    live_fans_add: "14",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "江苏协众旗瑞",
    company_name: "江苏协众旗瑞",
    store_code: "EJS634",
    大区: "华东区",
    "省份-城市": "江苏省-南京市",
    "所选分组编号/分组名称": "-",
    fans_count: "330",
    fans_count_total: "4549",
    aweme_count: "61",
    aweme_like_count: "517",
    aweme_comment_count: "85",
    aweme_share_count: "28",
    aweme_play_count: 143071,
    aweme_activation: 0.7333,
    live_count: "129",
    live_time: 7875,
    live_watch_count: 26960,
    live_watch_time: 29946,
    live_like_count: "69493",
    live_comment_count: "4330",
    live_activation: 0.8667,
    live_fans_add: "270",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "周口人合元南环",
    company_name: "周口人合元南环",
    store_code: "NYU625",
    大区: "华北区",
    "省份-城市": "河南省-周口市",
    "所选分组编号/分组名称": "-",
    fans_count: "231",
    fans_count_total: "8549",
    aweme_count: "111",
    aweme_like_count: "613",
    aweme_comment_count: "68",
    aweme_share_count: "30",
    aweme_play_count: 226282,
    aweme_activation: 0.9333,
    live_count: "87",
    live_time: 5367,
    live_watch_count: 19978,
    live_watch_time: 22197,
    live_like_count: "321229",
    live_comment_count: "5537",
    live_activation: 0.8667,
    live_fans_add: "213",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "兰州新瑞宏旗体验中心",
    company_name: "兰州新瑞宏旗体验中心",
    store_code: "XGS605",
    大区: "西部区",
    "省份-城市": "甘肃省-兰州市",
    "所选分组编号/分组名称": "-",
    fans_count: "1280",
    fans_count_total: "12009",
    aweme_count: "159",
    aweme_like_count: "738",
    aweme_comment_count: "49",
    aweme_share_count: "75",
    aweme_play_count: 216378,
    aweme_activation: 1,
    live_count: "183",
    live_time: 11908,
    live_watch_count: 546361,
    live_watch_time: 603054,
    live_like_count: "98170",
    live_comment_count: "4518",
    live_activation: 1,
    live_fans_add: "630",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "上海东创宏旗汽车销售服务有限公司",
    company_name: "上海东创宏旗汽车销售服务有限公司",
    store_code: "ESH618",
    大区: "华东区",
    "省份-城市": "上海市-上海市",
    "所选分组编号/分组名称": "-",
    fans_count: "2165",
    fans_count_total: "17514",
    aweme_count: "46",
    aweme_like_count: "2070",
    aweme_comment_count: "119",
    aweme_share_count: "81",
    aweme_play_count: 251491,
    aweme_activation: 0.9667,
    live_count: "42",
    live_time: 2490,
    live_watch_count: 590112,
    live_watch_time: 655680,
    live_like_count: "204769",
    live_comment_count: "14081",
    live_activation: 0.7,
    live_fans_add: "1942",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "阿克苏万禾",
    company_name: "阿克苏万禾",
    store_code: "XXJ605",
    大区: "西部区",
    "省份-城市": "新疆维吾尔自治区-阿克苏地区",
    "所选分组编号/分组名称": "-",
    fans_count: "2488",
    fans_count_total: "17246",
    aweme_count: "268",
    aweme_like_count: "7763",
    aweme_comment_count: "1281",
    aweme_share_count: "1254",
    aweme_play_count: 1767383,
    aweme_activation: 1,
    live_count: "193",
    live_time: 13582,
    live_watch_count: 23737,
    live_watch_time: 26275,
    live_like_count: "445355",
    live_comment_count: "8184",
    live_activation: 0.9333,
    live_fans_add: "182",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "郑州威佳红旗",
    company_name: "郑州威佳红旗",
    store_code: "NYU623",
    大区: "华北区",
    "省份-城市": "河南省-郑州市",
    "所选分组编号/分组名称": "-",
    fans_count: "3507",
    fans_count_total: "6904",
    aweme_count: "66",
    aweme_like_count: "765",
    aweme_comment_count: "64",
    aweme_share_count: "88",
    aweme_play_count: 172115,
    aweme_activation: 0.5333,
    live_count: "196",
    live_time: 17108,
    live_watch_count: 55955,
    live_watch_time: 62172,
    live_like_count: "39019",
    live_comment_count: "5756",
    live_activation: 0.8333,
    live_fans_add: "451",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "滨州国悦",
    company_name: "滨州市国悦汽车销售服务有限公司 ",
    store_code: "NSD401",
    大区: "东北区",
    "省份-城市": "山东省-滨州市",
    "所选分组编号/分组名称": "-",
    fans_count: "169",
    fans_count_total: "373",
    aweme_count: "67",
    aweme_like_count: "296",
    aweme_comment_count: "35",
    aweme_share_count: "6",
    aweme_play_count: "18148",
    aweme_activation: 0.8,
    live_count: "56",
    live_time: null,
    live_watch_count: null,
    live_watch_time: null,
    live_like_count: "25093",
    live_comment_count: "1141",
    live_activation: 0.8667,
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "淮北宏祺",
    company_name: "淮北宏祺汽车销售服务有限公司",
    store_code: "CHN403",
    大区: "中南区",
    "省份-城市": "湖南省-长沙市",
    "所选分组编号/分组名称": "-",
    fans_count: "0",
    fans_count_total: "0",
    aweme_count: "48",
    aweme_like_count: "405",
    aweme_comment_count: "66",
    aweme_share_count: "16",
    aweme_play_count: "40267",
    aweme_activation: 0.8333,
    live_count: "-",
    live_time: null,
    live_watch_count: null,
    live_watch_time: null,
    live_like_count: "-",
    live_comment_count: "-",
    live_activation: 0,
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "湘潭兰天旗胜",
    company_name: "湘潭兰天旗胜汽车销售有限公司",
    store_code: "CHN402",
    大区: "中南区",
    "省份-城市": "湖南省-益阳市",
    "所选分组编号/分组名称": "-",
    fans_count: "-",
    fans_count_total: "-",
    aweme_count: "-",
    aweme_like_count: "-",
    aweme_comment_count: "-",
    aweme_share_count: "-",
    aweme_play_count: "-",
    aweme_activation: 0,
    live_count: "-",
    live_time: null,
    live_watch_count: null,
    live_watch_time: null,
    live_like_count: "-",
    live_comment_count: "-",
    live_activation: 0,
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "益阳兰天悦旗",
    company_name: "益阳兰天悦旗汽车销售有限公司",
    store_code: "EAH625",
    大区: "华东区",
    "省份-城市": "安徽省-宿州市",
    "所选分组编号/分组名称": "-",
    fans_count: "-",
    fans_count_total: "-",
    aweme_count: "-",
    aweme_like_count: "-",
    aweme_comment_count: "-",
    aweme_share_count: "-",
    aweme_play_count: "-",
    aweme_activation: 0,
    live_count: "-",
    live_time: null,
    live_watch_count: null,
    live_watch_time: null,
    live_like_count: "-",
    live_comment_count: "-",
    live_activation: 0,
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "宿州宏祺",
    company_name: "宿州宏祺汽车销售服务有限公司",
    store_code: "EAH625",
    大区: "华东区",
    "省份-城市": "安徽省-宿州市",
    "所选分组编号/分组名称": "-",
    fans_count: "-",
    fans_count_total: "-",
    aweme_count: "-",
    aweme_like_count: "-",
    aweme_comment_count: "-",
    aweme_share_count: "-",
    aweme_play_count: "-",
    aweme_activation: 0,
    live_count: "-",
    live_time: null,
    live_watch_count: null,
    live_watch_time: null,
    live_like_count: "-",
    live_comment_count: "-",
    live_activation: 0,
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
  },
  {
    平台: "全部平台",
    dealer_name: "陕西众恒",
    company_name: "陕西众恒宏旗汽车贸易有限公司",
    store_code: "XSS401",
    大区: "西部区",
    "省份-城市": "陕西省-渭南市",
    "所选分组编号/分组名称": "-",
    fans_count: "-",
    fans_count_total: "-",
    aweme_count: "-",
    aweme_like_count: "-",
    aweme_comment_count: "-",
    aweme_share_count: "-",
    aweme_play_count: "-",
    aweme_activation: 0,
    live_count: "-",
    live_time: null,
    live_watch_count: null,
    live_watch_time: null,
    live_like_count: "-",
    live_comment_count: "-",
    live_activation: 0,
    live_fans_add: "-",
    统计时间区间: "2025/03/01-2025/03/31",
  },
];
